export const baseUrl = import.meta.url

export const styleLocations = {
    "academy-of-management-perspectives": "./styles/c01.json.gz",
    "academy-of-management-review": "./styles/c02.json.gz",
    "accident-analysis-and-prevention": "./styles/c03.json.gz",
    "aci-materials-journal": "./styles/c04.json.gz",
    "acm-sig-proceedings-long-author-list": "./styles/c05.json.gz",
    "acm-sig-proceedings": "./styles/c06.json.gz",
    "acm-sigchi-proceedings-extended-abstract-format": "./styles/c07.json.gz",
    "acm-sigchi-proceedings": "./styles/c08.json.gz",
    "acm-siggraph": "./styles/c09.json.gz",
    "acme-an-international-journal-for-critical-geographies": "./styles/c10.json.gz",
    "acta-adriatica": "./styles/c11.json.gz",
    "acta-amazonica": "./styles/c12.json.gz",
    "acta-anaesthesiologica-scandinavica": "./styles/c13.json.gz",
    "acta-anaesthesiologica-taiwanica": "./styles/c14.json.gz",
    "acta-botanica-croatica": "./styles/c15.json.gz",
    "acta-chiropterologica": "./styles/c16.json.gz",
    "acta-chirurgiae-orthopaedicae-et-traumatologiae-cechoslovaca": "./styles/c17.json.gz",
    "acta-hydrotechnica": "./styles/c18.json.gz",
    "acta-medica-peruana": "./styles/c19.json.gz",
    "acta-medica-portuguesa": "./styles/c20.json.gz",
    "acta-naturae": "./styles/c21.json.gz",
    "acta-neurobiologiae-experimentalis": "./styles/c22.json.gz",
    "acta-neurochirurgica": "./styles/c23.json.gz",
    "acta-ophthalmologica": "./styles/c24.json.gz",
    "acta-ornithologica": "./styles/c25.json.gz",
    "acta-orthopaedica-belgica": "./styles/c01.json.gz",
    "acta-orthopaedica": "./styles/c02.json.gz",
    "acta-paediatrica": "./styles/c03.json.gz",
    "acta-palaeontologica-polonica": "./styles/c04.json.gz",
    "acta-pharmaceutica-sinica-b": "./styles/c05.json.gz",
    "acta-pharmaceutica": "./styles/c06.json.gz",
    "acta-philosophica": "./styles/c07.json.gz",
    "acta-physica-sinica": "./styles/c08.json.gz",
    "acta-physiologica": "./styles/c09.json.gz",
    "acta-polytechnica": "./styles/c10.json.gz",
    "acta-radiologica": "./styles/c11.json.gz",
    "acta-scientiae-veterinariae": "./styles/c12.json.gz",
    "acta-societatis-botanicorum-poloniae": "./styles/c13.json.gz",
    "acta-universitatis-agriculturae-et-silviculturae-mendelianae-brunensis": "./styles/c14.json.gz",
    "acta-universitatis-agriculturae-sueciae": "./styles/c15.json.gz",
    "acta-zoologica-academiae-scientiarum-hungaricae": "./styles/c16.json.gz",
    "administrative-science-quarterly": "./styles/c17.json.gz",
    "advanced-engineering-materials": "./styles/c18.json.gz",
    "advanced-functional-materials": "./styles/c19.json.gz",
    "advanced-healthcare-materials": "./styles/c20.json.gz",
    "advanced-materials": "./styles/c21.json.gz",
    "advanced-optical-materials": "./styles/c22.json.gz",
    "advanced-pharmaceutical-bulletin": "./styles/c23.json.gz",
    "advanced-science": "./styles/c24.json.gz",
    "advances-in-alzheimers-disease": "./styles/c25.json.gz",
    "advances-in-complex-systems": "./styles/c01.json.gz",
    "aerosol-and-air-quality-research": "./styles/c02.json.gz",
    "aerosol-science-and-technology": "./styles/c03.json.gz",
    "aerospace-medicine-and-human-performance": "./styles/c04.json.gz",
    "african-journal-of-food-agriculture-nutrition-development": "./styles/c05.json.gz",
    "african-journal-of-marine-science": "./styles/c06.json.gz",
    "african-online-scientific-information-systems-harvard": "./styles/c07.json.gz",
    "african-online-scientific-information-systems-vancouver": "./styles/c08.json.gz",
    "african-zoology": "./styles/c09.json.gz",
    "afro-asia": "./styles/c10.json.gz",
    "ageing-and-society": "./styles/c11.json.gz",
    "aging-and-disease": "./styles/c12.json.gz",
    "aging-cell": "./styles/c13.json.gz",
    "aging": "./styles/c14.json.gz",
    "agora": "./styles/c15.json.gz",
    "agriculturae-conspectus-scientificus": "./styles/c16.json.gz",
    "aib-studi": "./styles/c17.json.gz",
    "aids": "./styles/c18.json.gz",
    "aims-press": "./styles/c19.json.gz",
    "aix-marseille-universite-departement-d-etudes-asiatiques": "./styles/c20.json.gz",
    "al-jamiah-journal-of-islamic-studies": "./styles/c21.json.gz",
    "alcohol-and-alcoholism": "./styles/c22.json.gz",
    "alcoholism-clinical-and-experimental-research": "./styles/c23.json.gz",
    "alkoholizmus-a-drogove-zavislosti": "./styles/c24.json.gz",
    "allergology-international": "./styles/c25.json.gz",
    "allergy": "./styles/c01.json.gz",
    "alternatif-politika": "./styles/c02.json.gz",
    "alternatives-to-animal-experimentation": "./styles/c03.json.gz",
    "ambio": "./styles/c04.json.gz",
    "ameghiniana": "./styles/c05.json.gz",
    "american-anthropological-association": "./styles/c06.json.gz",
    "american-association-for-cancer-research": "./styles/c07.json.gz",
    "american-association-of-petroleum-geologists": "./styles/c08.json.gz",
    "american-chemical-society": "./styles/c09.json.gz",
    "american-college-of-clinical-pharmacy": "./styles/c10.json.gz",
    "american-fisheries-society": "./styles/c11.json.gz",
    "american-geophysical-union": "./styles/c12.json.gz",
    "american-heart-association": "./styles/c13.json.gz",
    "american-institute-of-aeronautics-and-astronautics": "./styles/c14.json.gz",
    "american-institute-of-physics": "./styles/c15.json.gz",
    "american-journal-of-archaeology": "./styles/c16.json.gz",
    "american-journal-of-botany": "./styles/c17.json.gz",
    "american-journal-of-cancer-research": "./styles/c18.json.gz",
    "american-journal-of-climate-change": "./styles/c19.json.gz",
    "american-journal-of-clinical-pathology": "./styles/c20.json.gz",
    "american-journal-of-enology-and-viticulture": "./styles/c21.json.gz",
    "american-journal-of-health-behavior": "./styles/c22.json.gz",
    "american-journal-of-medical-genetics": "./styles/c23.json.gz",
    "american-journal-of-neuroradiology": "./styles/c24.json.gz",
    "american-journal-of-orthodontics-and-dentofacial-orthopedics": "./styles/c25.json.gz",
    "american-journal-of-plant-sciences": "./styles/c01.json.gz",
    "american-journal-of-political-science": "./styles/c02.json.gz",
    "american-journal-of-respiratory-and-critical-care-medicine": "./styles/c03.json.gz",
    "american-journal-of-roentgenology": "./styles/c04.json.gz",
    "american-journal-of-science": "./styles/c05.json.gz",
    "american-journal-of-sociology": "./styles/c06.json.gz",
    "american-journal-of-sonography": "./styles/c07.json.gz",
    "american-journal-of-surgical-pathology": "./styles/c08.json.gz",
    "american-journal-of-translational-research": "./styles/c09.json.gz",
    "american-marketing-association": "./styles/c10.json.gz",
    "american-mathematical-society-label": "./styles/c11.json.gz",
    "american-mathematical-society-numeric": "./styles/c12.json.gz",
    "american-medical-association-10th-edition": "./styles/c13.json.gz",
    "american-medical-association-alphabetical": "./styles/c14.json.gz",
    "american-medical-association-brackets": "./styles/c15.json.gz",
    "american-medical-association-no-et-al": "./styles/c16.json.gz",
    "american-medical-association-no-url-alphabetical": "./styles/c17.json.gz",
    "american-medical-association-no-url": "./styles/c18.json.gz",
    "american-medical-association-parentheses": "./styles/c19.json.gz",
    "american-medical-association": "./styles/c20.json.gz",
    "american-meteorological-society": "./styles/c21.json.gz",
    "american-mineralogist": "./styles/c22.json.gz",
    "american-nuclear-society": "./styles/c23.json.gz",
    "american-physical-society-et-al": "./styles/c24.json.gz",
    "american-physics-society-without-titles": "./styles/c25.json.gz",
    "american-physics-society": "./styles/c01.json.gz",
    "american-physiological-society": "./styles/c02.json.gz",
    "american-phytopathological-society": "./styles/c03.json.gz",
    "american-political-science-association": "./styles/c04.json.gz",
    "american-school-of-classical-studies-at-athens": "./styles/c05.json.gz",
    "american-society-for-horticultural-science": "./styles/c06.json.gz",
    "american-society-for-microbiology": "./styles/c07.json.gz",
    "american-society-for-pharmacology-and-experimental-therapeutics": "./styles/c08.json.gz",
    "american-society-of-agricultural-and-biological-engineers": "./styles/c09.json.gz",
    "american-society-of-civil-engineers": "./styles/c10.json.gz",
    "american-society-of-mechanical-engineers": "./styles/c11.json.gz",
    "american-sociological-association": "./styles/c12.json.gz",
    "american-statistical-association": "./styles/c13.json.gz",
    "american-veterinary-medical-association": "./styles/c14.json.gz",
    "amerindia": "./styles/c15.json.gz",
    "amphibia-reptilia": "./styles/c16.json.gz",
    "anabases": "./styles/c17.json.gz",
    "anaesthesia": "./styles/c18.json.gz",
    "anais-da-academia-brasileira-de-ciencias": "./styles/c19.json.gz",
    "analytical-sciences": "./styles/c20.json.gz",
    "anatomical-sciences-education": "./styles/c21.json.gz",
    "ancilla-iuris": "./styles/c22.json.gz",
    "andean-geology": "./styles/c23.json.gz",
    "anesthesia-and-analgesia": "./styles/c24.json.gz",
    "anesthesiology": "./styles/c25.json.gz",
    "angewandte-chemie": "./styles/c01.json.gz",
    "angiologia": "./styles/c02.json.gz",
    "angiology": "./styles/c03.json.gz",
    "anglia": "./styles/c04.json.gz",
    "animal-conservation": "./styles/c05.json.gz",
    "animal-migration": "./styles/c06.json.gz",
    "animal-welfare": "./styles/c07.json.gz",
    "animal": "./styles/c08.json.gz",
    "ankara-universitesi-sosyal-bilimler-enstitusu-hukuk-fakultesi": "./styles/c09.json.gz",
    "annalen-des-naturhistorischen-museums-in-wien": "./styles/c10.json.gz",
    "annales-de-demographie-historique": "./styles/c11.json.gz",
    "annales": "./styles/c12.json.gz",
    "annals-of-allergy-asthma-and-immunology": "./styles/c13.json.gz",
    "annals-of-applied-biology": "./styles/c14.json.gz",
    "annals-of-behavioral-medicine": "./styles/c15.json.gz",
    "annals-of-biomedical-engineering": "./styles/c16.json.gz",
    "annals-of-botany": "./styles/c17.json.gz",
    "annals-of-eye-science": "./styles/c18.json.gz",
    "annals-of-joint": "./styles/c19.json.gz",
    "annals-of-laboratory-medicine": "./styles/c20.json.gz",
    "annals-of-neurology": "./styles/c21.json.gz",
    "annals-of-oncology": "./styles/c22.json.gz",
    "annals-of-public-and-cooperative-economics": "./styles/c23.json.gz",
    "annals-of-surgery": "./styles/c24.json.gz",
    "annals-of-the-association-of-american-geographers": "./styles/c25.json.gz",
    "annals-of-the-new-york-academy-of-sciences": "./styles/c01.json.gz",
    "annual-review-of-astronomy-and-astrophysics": "./styles/c02.json.gz",
    "annual-review-of-linguistics": "./styles/c03.json.gz",
    "annual-review-of-medicine": "./styles/c04.json.gz",
    "annual-review-of-nuclear-and-particle-science": "./styles/c05.json.gz",
    "annual-reviews-alphabetical": "./styles/c06.json.gz",
    "annual-reviews-author-date": "./styles/c07.json.gz",
    "annual-reviews-without-titles": "./styles/c08.json.gz",
    "annual-reviews": "./styles/c09.json.gz",
    "antarctic-science": "./styles/c10.json.gz",
    "anthropologie-et-societes": "./styles/c11.json.gz",
    "anti-trafficking-review": "./styles/c12.json.gz",
    "anticancer-research": "./styles/c13.json.gz",
    "antipode": "./styles/c14.json.gz",
    "antiquites-africaines": "./styles/c15.json.gz",
    "antiquity": "./styles/c16.json.gz",
    "apa-6th-edition": "./styles/c17.json.gz",
    "apa-annotated-bibliography": "./styles/c18.json.gz",
    "apa-cv": "./styles/c19.json.gz",
    "apa-eu": "./styles/c20.json.gz",
    "apa-fr-provost": "./styles/c21.json.gz",
    "apa-no-ampersand": "./styles/c22.json.gz",
    "apa-no-initials": "./styles/c23.json.gz",
    "apa-numeric-superscript-brackets": "./styles/c24.json.gz",
    "apa-numeric-superscript": "./styles/c25.json.gz",
    "apa-single-spaced": "./styles/c01.json.gz",
    "apa-tr": "./styles/c02.json.gz",
    "apa-with-abstract": "./styles/c03.json.gz",
    "apa": "./styles/c04.json.gz",
    "aporia-the-nursing-journal": "./styles/c05.json.gz",
    "applications-in-plant-sciences": "./styles/c06.json.gz",
    "applied-clay-science": "./styles/c07.json.gz",
    "applied-spectroscopy-reviews": "./styles/c08.json.gz",
    "applied-spectroscopy": "./styles/c09.json.gz",
    "aquatic-conservation": "./styles/c10.json.gz",
    "aquatic-invasions": "./styles/c11.json.gz",
    "aquatic-living-resources": "./styles/c12.json.gz",
    "aquitania": "./styles/c13.json.gz",
    "arachne": "./styles/c14.json.gz",
    "arachnologische-mitteilungen": "./styles/c15.json.gz",
    "arachnology": "./styles/c16.json.gz",
    "arbok-hins-islenzka-fornleifafelags": "./styles/c17.json.gz",
    "arcadia-science": "./styles/c18.json.gz",
    "archaeologia-austriaca": "./styles/c19.json.gz",
    "archaeometry": "./styles/c20.json.gz",
    "archaeonautica": "./styles/c21.json.gz",
    "archeologia-classica": "./styles/c22.json.gz",
    "archeologia-e-calcolatori": "./styles/c23.json.gz",
    "archeologicke-rozhledy": "./styles/c24.json.gz",
    "archeologie-medievale": "./styles/c25.json.gz",
    "archeologies-et-sciences-de-lantiquite": "./styles/c01.json.gz",
    "archeosciences": "./styles/c02.json.gz",
    "archimede-archeologie-et-histoire-ancienne": "./styles/c03.json.gz",
    "archiv-fur-die-civilistische-praxis": "./styles/c04.json.gz",
    "archiv-fur-geschichte-der-philosophie": "./styles/c05.json.gz",
    "archives-of-hand-and-microsurgery": "./styles/c06.json.gz",
    "archives-of-medical-research": "./styles/c07.json.gz",
    "archives-of-physical-medicine-and-rehabilitation": "./styles/c08.json.gz",
    "archivos-de-bronconeumologia": "./styles/c09.json.gz",
    "archivos-de-la-sociedad-espanola-de-oftalmologia": "./styles/c10.json.gz",
    "archivos-peruanos-de-cardiologia-y-cirugia-cardiovascular": "./styles/c11.json.gz",
    "archivum-latinitatis-medii-aevi": "./styles/c12.json.gz",
    "arctic-antarctic-and-alpine-research": "./styles/c13.json.gz",
    "arctic": "./styles/c14.json.gz",
    "arhiv-za-higijenu-rada-i-toksikologiju": "./styles/c15.json.gz",
    "arkivoc": "./styles/c16.json.gz",
    "art-history": "./styles/c17.json.gz",
    "art-libraries-society-of-north-america-arlisna-reviews": "./styles/c18.json.gz",
    "artery-research": "./styles/c19.json.gz",
    "arthritis-and-rheumatism": "./styles/c20.json.gz",
    "arthropod-systematics-and-phylogeny": "./styles/c21.json.gz",
    "arts-university-bournemouth": "./styles/c22.json.gz",
    "arzneimitteltherapie": "./styles/c23.json.gz",
    "asa-cssa-sssa": "./styles/c24.json.gz",
    "asaio-journal": "./styles/c25.json.gz",
    "asia-and-the-pacific-policy-studies": "./styles/c01.json.gz",
    "asia-pacific-journal-of-human-resources": "./styles/c02.json.gz",
    "asian-journal-of-neurosurgery": "./styles/c03.json.gz",
    "asian-myrmecology": "./styles/c04.json.gz",
    "asian-studies-review": "./styles/c05.json.gz",
    "associacao-brasileira-de-normas-tecnicas-eceme": "./styles/c06.json.gz",
    "associacao-brasileira-de-normas-tecnicas-instituto-meira-mattos": "./styles/c07.json.gz",
    "associacao-brasileira-de-normas-tecnicas-ipea": "./styles/c08.json.gz",
    "associacao-brasileira-de-normas-tecnicas-note": "./styles/c09.json.gz",
    "associacao-brasileira-de-normas-tecnicas-numerico": "./styles/c10.json.gz",
    "associacao-brasileira-de-normas-tecnicas-ufmg-face-full": "./styles/c11.json.gz",
    "associacao-brasileira-de-normas-tecnicas-ufmg-face-initials": "./styles/c12.json.gz",
    "associacao-brasileira-de-normas-tecnicas-ufpr": "./styles/c13.json.gz",
    "associacao-brasileira-de-normas-tecnicas-ufrgs-initials": "./styles/c14.json.gz",
    "associacao-brasileira-de-normas-tecnicas-ufrgs-note-initials-with-ibid": "./styles/c15.json.gz",
    "associacao-brasileira-de-normas-tecnicas-ufrgs": "./styles/c16.json.gz",
    "associacao-brasileira-de-normas-tecnicas-ufs": "./styles/c17.json.gz",
    "associacao-brasileira-de-normas-tecnicas-unirio-eipp": "./styles/c18.json.gz",
    "associacao-brasileira-de-normas-tecnicas-usp-fmvz": "./styles/c19.json.gz",
    "associacao-brasileira-de-normas-tecnicas": "./styles/c20.json.gz",
    "associacao-nacional-de-pesquisa-e-ensino-em-transportes": "./styles/c21.json.gz",
    "association-de-science-regionale-de-langue-francaise": "./styles/c22.json.gz",
    "association-for-computational-linguistics": "./styles/c23.json.gz",
    "association-for-computing-machinery": "./styles/c24.json.gz",
    "atlande": "./styles/c25.json.gz",
    "atlas-of-genetics-and-cytogenetics-in-oncology-and-haematology": "./styles/c01.json.gz",
    "auci": "./styles/c02.json.gz",
    "ausonius-editions": "./styles/c03.json.gz",
    "austral-ecology": "./styles/c04.json.gz",
    "austral-entomology": "./styles/c05.json.gz",
    "australasian-journal-of-philosophy": "./styles/c06.json.gz",
    "australian-archaeology": "./styles/c07.json.gz",
    "australian-critical-care": "./styles/c08.json.gz",
    "australian-dental-journal": "./styles/c09.json.gz",
    "australian-guide-to-legal-citation-3rd-edition": "./styles/c10.json.gz",
    "australian-guide-to-legal-citation": "./styles/c11.json.gz",
    "australian-historical-studies": "./styles/c12.json.gz",
    "australian-journal-of-earth-sciences": "./styles/c13.json.gz",
    "australian-journal-of-grape-and-wine-research": "./styles/c14.json.gz",
    "australian-road-research-board": "./styles/c15.json.gz",
    "australian-veterinary-journal": "./styles/c16.json.gz",
    "austrian-journal-of-development-studies": "./styles/c17.json.gz",
    "austrian-legal": "./styles/c18.json.gz",
    "aves": "./styles/c19.json.gz",
    "avian-conservation-and-ecology": "./styles/c20.json.gz",
    "avian-diseases": "./styles/c21.json.gz",
    "avian-pathology": "./styles/c22.json.gz",
    "avocetta-journal-of-ornithology": "./styles/c23.json.gz",
    "ayer": "./styles/c24.json.gz",
    "azr-abkurzungs-und-zitierregeln-der-osterreichischen-rechtssprache-und-europarechtlicher-rechtsquellen": "./styles/c25.json.gz",
    "babes-bolyai-university-faculty-of-orthodox-theology": "./styles/c01.json.gz",
    "babesch-annual-papers-on-mediterranean-archaeology": "./styles/c02.json.gz",
    "baghdad-science-journal": "./styles/c03.json.gz",
    "baishideng-publishing-group": "./styles/c04.json.gz",
    "bakhtiniana-journal-of-discourse-studies": "./styles/c05.json.gz",
    "barbara-budrich": "./styles/c06.json.gz",
    "begell-house-apa": "./styles/c07.json.gz",
    "begell-house-chicago-author-date": "./styles/c08.json.gz",
    "behaviour": "./styles/c09.json.gz",
    "beilstein-journal-of-organic-chemistry": "./styles/c10.json.gz",
    "beltz-padagogik": "./styles/c11.json.gz",
    "berghahn-books-author-date-en-gb": "./styles/c12.json.gz",
    "berlin-school-of-economics-and-law-international-marketing-management": "./styles/c13.json.gz",
    "bern-university-of-applied-sciences-school-of-agricultural-forest-and-food-sciences-hafl": "./styles/c14.json.gz",
    "betriebswirtschaftliche-forschung-und-praxis": "./styles/c15.json.gz",
    "biblio-3w": "./styles/c16.json.gz",
    "bibliotheca-hertziana-max-planck-institute-for-art-history": "./styles/c17.json.gz",
    "bibliothecae-it": "./styles/c18.json.gz",
    "bibliothek-forschung-und-praxis": "./styles/c19.json.gz",
    "bibliothek-fur-bildungsgeschichtliche-forschung": "./styles/c20.json.gz",
    "bibliotheque-d-archeologie-mediterraneenne-et-africaine-biama": "./styles/c21.json.gz",
    "bibliotheque-universitaire-de-medecine-vancouver": "./styles/c22.json.gz",
    "bibtex": "./styles/c23.json.gz",
    "biens-symboliques-symbolic-goods": "./styles/c24.json.gz",
    "bio-protocol": "./styles/c25.json.gz",
    "bioarchaeology-international": "./styles/c01.json.gz",
    "bioarchaeology-of-the-near-east": "./styles/c02.json.gz",
    "biochemical-journal": "./styles/c03.json.gz",
    "biochemical-society-transactions": "./styles/c04.json.gz",
    "biochemistry-and-molecular-biology-education": "./styles/c05.json.gz",
    "biochemistry": "./styles/c06.json.gz",
    "biochimica-et-biophysica-acta": "./styles/c07.json.gz",
    "bioelectromagnetics": "./styles/c08.json.gz",
    "bioethics": "./styles/c09.json.gz",
    "biofuel-research-journal": "./styles/c10.json.gz",
    "biologia": "./styles/c11.json.gz",
    "biological-and-pharmaceutical-bulletin": "./styles/c12.json.gz",
    "biological-journal-of-the-linnean-society": "./styles/c13.json.gz",
    "biological-psychiatry": "./styles/c14.json.gz",
    "biological-reviews": "./styles/c15.json.gz",
    "biologiceskie-membrany": "./styles/c16.json.gz",
    "biology-of-reproduction": "./styles/c17.json.gz",
    "biomarkers": "./styles/c18.json.gz",
    "biomed-central": "./styles/c19.json.gz",
    "biomed-research-international": "./styles/c20.json.gz",
    "biometrics": "./styles/c21.json.gz",
    "biomolecular-concepts": "./styles/c22.json.gz",
    "biophysical-journal": "./styles/c23.json.gz",
    "biophysics-and-physicobiology": "./styles/c24.json.gz",
    "biopolymers": "./styles/c25.json.gz",
    "bioresources": "./styles/c01.json.gz",
    "bioscience": "./styles/c02.json.gz",
    "biosocieties": "./styles/c03.json.gz",
    "biostatistics": "./styles/c04.json.gz",
    "biota-neotropica": "./styles/c05.json.gz",
    "biotechniques": "./styles/c06.json.gz",
    "biotechnology-and-bioengineering": "./styles/c07.json.gz",
    "biotechnology-and-bioprocess-engineering": "./styles/c08.json.gz",
    "biotropica": "./styles/c09.json.gz",
    "bitonline": "./styles/c10.json.gz",
    "biuletyn-polskiego-towarzystwa-jezykoznawczego": "./styles/c11.json.gz",
    "bloomsbury-academic": "./styles/c12.json.gz",
    "bluebook-inline": "./styles/c13.json.gz",
    "bluebook-law-review-with-abstract": "./styles/c14.json.gz",
    "bluebook-law-review": "./styles/c15.json.gz",
    "bmj": "./styles/c16.json.gz",
    "body-and-society": "./styles/c17.json.gz",
    "boletin-de-la-sociedad-geologica-mexicana": "./styles/c18.json.gz",
    "boletin-de-pediatria": "./styles/c19.json.gz",
    "bollettino-d-archeologia-online": "./styles/c20.json.gz",
    "bollettino-della-societa-italiana-di-paleontologia": "./styles/c21.json.gz",
    "boreal-environment-research": "./styles/c22.json.gz",
    "boreas": "./styles/c23.json.gz",
    "borgyogyaszati-es-venerologiai-szemle": "./styles/c24.json.gz",
    "botanical-journal-of-the-linnean-society": "./styles/c25.json.gz",
    "bourgogne-franche-comte-nature": "./styles/c01.json.gz",
    "brachytherapy": "./styles/c02.json.gz",
    "brain-behavior-and-evolution": "./styles/c03.json.gz",
    "brazilian-journal-of-experimental-design-data-analysis-and-inferential-statistics": "./styles/c04.json.gz",
    "brazilian-journal-of-infectious-diseases": "./styles/c05.json.gz",
    "brazilian-journal-of-psychiatry": "./styles/c06.json.gz",
    "brazilian-journal-of-veterinary-research-and-animal-science": "./styles/c07.json.gz",
    "brazilian-oral-research": "./styles/c08.json.gz",
    "brewingscience": "./styles/c09.json.gz",
    "bristol-university-press": "./styles/c10.json.gz",
    "british-journal-of-anaesthesia": "./styles/c11.json.gz",
    "british-journal-of-cancer": "./styles/c12.json.gz",
    "british-journal-of-dermatology": "./styles/c13.json.gz",
    "british-journal-of-haematology": "./styles/c14.json.gz",
    "british-journal-of-industrial-relations": "./styles/c15.json.gz",
    "british-journal-of-nutrition": "./styles/c16.json.gz",
    "british-journal-of-pharmacology": "./styles/c17.json.gz",
    "british-journal-of-political-science": "./styles/c18.json.gz",
    "british-journal-of-surgery": "./styles/c19.json.gz",
    "british-psychological-society": "./styles/c20.json.gz",
    "brumaire-verlag": "./styles/c21.json.gz",
    "budownictwo-i-architektura-pl": "./styles/c22.json.gz",
    "building-structure": "./styles/c23.json.gz",
    "buletin-agrohorti": "./styles/c24.json.gz",
    "bulletin-de-correspondance-hellenique": "./styles/c25.json.gz",
    "bulletin-de-la-societe-entomologique-de-france": "./styles/c01.json.gz",
    "bulletin-de-la-societe-prehistorique-francaise": "./styles/c02.json.gz",
    "bulletin-du-centre-detudes-medievales-dauxerre": "./styles/c03.json.gz",
    "bulletin-of-applied-glycoscience": "./styles/c04.json.gz",
    "bulletin-of-geosciences": "./styles/c05.json.gz",
    "bulletin-of-insectology": "./styles/c06.json.gz",
    "bulletin-of-marine-science": "./styles/c07.json.gz",
    "bulletin-of-the-american-schools-of-oriental-research": "./styles/c08.json.gz",
    "bulletin-of-the-seismological-society-of-america": "./styles/c09.json.gz",
    "bursa-uludag-universitesi-egitim-bilimleri-enstitusu": "./styles/c10.json.gz",
    "bursa-uludag-universitesi-saglik-bilimleri-enstitusu": "./styles/c11.json.gz",
    "business-and-human-rights-journal": "./styles/c12.json.gz",
    "business-ethics-a-european-review": "./styles/c13.json.gz",
    "byzantina-symmeikta": "./styles/c14.json.gz",
    "byzantine-and-modern-greek-studies": "./styles/c15.json.gz",
    "cahiers-d-ethnomusicologie": "./styles/c16.json.gz",
    "cahiers-du-centre-gustave-glotz": "./styles/c17.json.gz",
    "cahiers-mondes-anciens": "./styles/c18.json.gz",
    "california-agriculture": "./styles/c19.json.gz",
    "cambridge-journal-of-economics": "./styles/c20.json.gz",
    "cambridge-quarterly-of-healthcare-ethics": "./styles/c21.json.gz",
    "cambridge-university-press-author-date-cambridge-a": "./styles/c22.json.gz",
    "cambridge-university-press-author-date": "./styles/c23.json.gz",
    "cambridge-university-press-law-note": "./styles/c24.json.gz",
    "cambridge-university-press-note": "./styles/c25.json.gz",
    "cambridge-university-press-numeric": "./styles/c01.json.gz",
    "campus-adventiste-du-saleve-faculte-adventiste-de-theologie": "./styles/c02.json.gz",
    "canadian-biosystems-engineering": "./styles/c03.json.gz",
    "canadian-geotechnical-journal": "./styles/c04.json.gz",
    "canadian-journal-of-chemistry": "./styles/c05.json.gz",
    "canadian-journal-of-criminology-and-criminal-justice": "./styles/c06.json.gz",
    "canadian-journal-of-dietetic-practice-and-research": "./styles/c07.json.gz",
    "canadian-journal-of-earth-sciences": "./styles/c08.json.gz",
    "canadian-journal-of-economics": "./styles/c09.json.gz",
    "canadian-journal-of-fisheries-and-aquatic-sciences": "./styles/c10.json.gz",
    "canadian-journal-of-mineralogy-and-petrology": "./styles/c11.json.gz",
    "canadian-journal-of-physics": "./styles/c12.json.gz",
    "canadian-journal-of-public-health": "./styles/c13.json.gz",
    "canadian-journal-of-remote-sensing": "./styles/c14.json.gz",
    "canadian-journal-of-soil-science": "./styles/c15.json.gz",
    "canadian-public-policy": "./styles/c16.json.gz",
    "canadian-urological-association-journal": "./styles/c17.json.gz",
    "cancer-biomarkers": "./styles/c18.json.gz",
    "cancer-drug-resistance": "./styles/c19.json.gz",
    "cancer-translational-medicine": "./styles/c20.json.gz",
    "cardiff-university-harvard": "./styles/c21.json.gz",
    "cardiff-university-vancouver": "./styles/c22.json.gz",
    "cardiocore": "./styles/c23.json.gz",
    "carolinea": "./styles/c24.json.gz",
    "casopis-pro-pravni-vedu-a-praxi": "./styles/c25.json.gz",
    "cath-lab-digest": "./styles/c01.json.gz",
    "catholic-biblical-association": "./styles/c02.json.gz",
    "cell-numeric": "./styles/c03.json.gz",
    "cell-research": "./styles/c04.json.gz",
    "cell-structure-and-function": "./styles/c05.json.gz",
    "cell-transplantation": "./styles/c06.json.gz",
    "cell": "./styles/c07.json.gz",
    "cellular-and-molecular-bioengineering": "./styles/c08.json.gz",
    "cellular-and-molecular-gastroenterology-and-hepatology": "./styles/c09.json.gz",
    "centaurus": "./styles/c10.json.gz",
    "centre-de-recherche-sur-les-civilisations-de-l-asie-orientale-auteur-date": "./styles/c11.json.gz",
    "centre-de-recherche-sur-les-civilisations-de-l-asie-orientale": "./styles/c12.json.gz",
    "centro-regional-de-estudios-teologicos-de-aragon": "./styles/c13.json.gz",
    "ceska-zemedelska-univerzita-v-praze-fakulta-agrobiologie-potravinovych-a-prirodnich-zdroju": "./styles/c14.json.gz",
    "changer-d-epoque": "./styles/c15.json.gz",
    "chemical-and-pharmaceutical-bulletin": "./styles/c16.json.gz",
    "chemical-biology-and-drug-design": "./styles/c17.json.gz",
    "chemical-engineering-progress": "./styles/c18.json.gz",
    "chemical-engineering-technology": "./styles/c19.json.gz",
    "chemie-ingenieur-technik": "./styles/c20.json.gz",
    "chemistry-education-research-and-practice": "./styles/c21.json.gz",
    "chest": "./styles/c22.json.gz",
    "chicago-author-date-16th-edition": "./styles/c23.json.gz",
    "chicago-author-date-17th-edition": "./styles/c24.json.gz",
    "chicago-author-date-access-dates": "./styles/c25.json.gz",
    "chicago-author-date-archive-place-first-no-url": "./styles/c01.json.gz",
    "chicago-author-date-archive-place-first": "./styles/c02.json.gz",
    "chicago-author-date-basque": "./styles/c03.json.gz",
    "chicago-author-date-classic-no-url": "./styles/c04.json.gz",
    "chicago-author-date-classic": "./styles/c05.json.gz",
    "chicago-author-date-de": "./styles/c06.json.gz",
    "chicago-author-date-fr": "./styles/c07.json.gz",
    "chicago-author-date-no-url": "./styles/c08.json.gz",
    "chicago-author-date": "./styles/c09.json.gz",
    "chicago-in-text-full-no-url": "./styles/c10.json.gz",
    "chicago-in-text-full": "./styles/c11.json.gz",
    "chicago-in-text-shortened-author-no-url": "./styles/c12.json.gz",
    "chicago-in-text-shortened-author-title-no-url": "./styles/c13.json.gz",
    "chicago-in-text-shortened-author-title": "./styles/c14.json.gz",
    "chicago-in-text-shortened-author": "./styles/c15.json.gz",
    "chicago-notes-archive-place-first-no-url": "./styles/c16.json.gz",
    "chicago-notes-archive-place-first": "./styles/c17.json.gz",
    "chicago-notes-bibliography-16th-edition": "./styles/c18.json.gz",
    "chicago-notes-bibliography-17th-edition": "./styles/c19.json.gz",
    "chicago-notes-bibliography-access-dates": "./styles/c20.json.gz",
    "chicago-notes-bibliography-annotated-abstract": "./styles/c21.json.gz",
    "chicago-notes-bibliography-annotated": "./styles/c22.json.gz",
    "chicago-notes-bibliography-archive-place-first-no-url": "./styles/c23.json.gz",
    "chicago-notes-bibliography-archive-place-first": "./styles/c24.json.gz",
    "chicago-notes-bibliography-classic-archive-place-first-no-url": "./styles/c25.json.gz",
    "chicago-notes-bibliography-classic-archive-place-first": "./styles/c01.json.gz",
    "chicago-notes-bibliography-classic-no-url": "./styles/c02.json.gz",
    "chicago-notes-bibliography-classic": "./styles/c03.json.gz",
    "chicago-notes-bibliography-fr": "./styles/c04.json.gz",
    "chicago-notes-bibliography-no-url": "./styles/c05.json.gz",
    "chicago-notes-bibliography-subsequent-author-classic-no-url": "./styles/c06.json.gz",
    "chicago-notes-bibliography-subsequent-author-classic": "./styles/c07.json.gz",
    "chicago-notes-bibliography-subsequent-author-no-url": "./styles/c08.json.gz",
    "chicago-notes-bibliography-subsequent-author-title-17th-edition": "./styles/c09.json.gz",
    "chicago-notes-bibliography-subsequent-author": "./styles/c10.json.gz",
    "chicago-notes-bibliography-subsequent-ibid-17th-edition": "./styles/c11.json.gz",
    "chicago-notes-bibliography-subsequent-ibid-classic-no-url": "./styles/c12.json.gz",
    "chicago-notes-bibliography-subsequent-ibid-classic": "./styles/c13.json.gz",
    "chicago-notes-bibliography-subsequent-ibid-no-url": "./styles/c14.json.gz",
    "chicago-notes-bibliography-subsequent-ibid": "./styles/c15.json.gz",
    "chicago-notes-bibliography-subsequent-title-no-url": "./styles/c16.json.gz",
    "chicago-notes-bibliography-subsequent-title": "./styles/c17.json.gz",
    "chicago-notes-bibliography": "./styles/c18.json.gz",
    "chicago-notes-classic-archive-place-first-no-url": "./styles/c19.json.gz",
    "chicago-notes-classic-archive-place-first": "./styles/c20.json.gz",
    "chicago-notes-classic-no-url": "./styles/c21.json.gz",
    "chicago-notes-classic": "./styles/c22.json.gz",
    "chicago-notes-no-url": "./styles/c23.json.gz",
    "chicago-notes-publisher-place-archive-place-first-no-url": "./styles/c24.json.gz",
    "chicago-notes-publisher-place-archive-place-first": "./styles/c25.json.gz",
    "chicago-notes-publisher-place-label-page-archive-place-first-no-url": "./styles/c01.json.gz",
    "chicago-notes-publisher-place-label-page-archive-place-first": "./styles/c02.json.gz",
    "chicago-notes-publisher-place-no-url": "./styles/c03.json.gz",
    "chicago-notes-publisher-place": "./styles/c04.json.gz",
    "chicago-notes": "./styles/c05.json.gz",
    "chicago-shortened-notes-bibliography-16th-edition": "./styles/c06.json.gz",
    "chicago-shortened-notes-bibliography-17th-edition": "./styles/c07.json.gz",
    "chicago-shortened-notes-bibliography-access-dates": "./styles/c08.json.gz",
    "chicago-shortened-notes-bibliography-archive-place-first-no-url": "./styles/c09.json.gz",
    "chicago-shortened-notes-bibliography-archive-place-first": "./styles/c10.json.gz",
    "chicago-shortened-notes-bibliography-classic-archive-place-first-no-url": "./styles/c11.json.gz",
    "chicago-shortened-notes-bibliography-classic-archive-place-first": "./styles/c12.json.gz",
    "chicago-shortened-notes-bibliography-classic-no-url": "./styles/c13.json.gz",
    "chicago-shortened-notes-bibliography-classic": "./styles/c14.json.gz",
    "chicago-shortened-notes-bibliography-no-url": "./styles/c15.json.gz",
    "chicago-shortened-notes-bibliography-subsequent-author-classic-no-url": "./styles/c16.json.gz",
    "chicago-shortened-notes-bibliography-subsequent-author-classic": "./styles/c17.json.gz",
    "chicago-shortened-notes-bibliography-subsequent-author-no-url": "./styles/c18.json.gz",
    "chicago-shortened-notes-bibliography-subsequent-author-title-17th-edition": "./styles/c19.json.gz",
    "chicago-shortened-notes-bibliography-subsequent-author": "./styles/c20.json.gz",
    "chicago-shortened-notes-bibliography-subsequent-ibid-17th-edition": "./styles/c21.json.gz",
    "chicago-shortened-notes-bibliography-subsequent-ibid-classic-no-url": "./styles/c22.json.gz",
    "chicago-shortened-notes-bibliography-subsequent-ibid-classic": "./styles/c23.json.gz",
    "chicago-shortened-notes-bibliography-subsequent-ibid-no-url": "./styles/c24.json.gz",
    "chicago-shortened-notes-bibliography-subsequent-ibid": "./styles/c25.json.gz",
    "chicago-shortened-notes-bibliography-subsequent-title-no-url": "./styles/c01.json.gz",
    "chicago-shortened-notes-bibliography-subsequent-title": "./styles/c02.json.gz",
    "chicago-shortened-notes-bibliography": "./styles/c03.json.gz",
    "chimia": "./styles/c04.json.gz",
    "china-information": "./styles/c05.json.gz",
    "china-national-standard-gb-t-7714-2015-author-date": "./styles/c06.json.gz",
    "china-national-standard-gb-t-7714-2015-note": "./styles/c07.json.gz",
    "china-national-standard-gb-t-7714-2015-numeric": "./styles/c08.json.gz",
    "china-national-standard-gb-t-7714-2025-author-date": "./styles/c09.json.gz",
    "china-national-standard-gb-t-7714-2025-note": "./styles/c10.json.gz",
    "china-national-standard-gb-t-7714-2025-numeric": "./styles/c11.json.gz",
    "chinese-gb7714-1987-numeric": "./styles/c12.json.gz",
    "chinese-gb7714-2005-author-date": "./styles/c13.json.gz",
    "chinese-gb7714-2005-numeric": "./styles/c14.json.gz",
    "chinese-journal-of-aeronautics": "./styles/c15.json.gz",
    "chinese-medical-journal": "./styles/c16.json.gz",
    "chinese-science-bulletin": "./styles/c17.json.gz",
    "chroniques-des-activites-archeologiques-de-l-ecole-francaise-de-rome": "./styles/c18.json.gz",
    "chungara-revista-de-antropologia-chilena": "./styles/c19.json.gz",
    "circulation-journal": "./styles/c20.json.gz",
    "cirugia-cardiovascular": "./styles/c21.json.gz",
    "citation-compass-apa-note": "./styles/c22.json.gz",
    "citizen-science-theory-and-practice": "./styles/c23.json.gz",
    "civil-engineering-journal": "./styles/c24.json.gz",
    "civilta-italiana": "./styles/c25.json.gz",
    "civitas-revista-de-ciencias-sociais": "./styles/c01.json.gz",
    "cladistics": "./styles/c02.json.gz",
    "clara-architecture-recherche": "./styles/c03.json.gz",
    "clay-minerals": "./styles/c04.json.gz",
    "clays-and-clay-minerals": "./styles/c05.json.gz",
    "climate-change-economics": "./styles/c06.json.gz",
    "clinica-e-investigacion-en-arteriosclerosis": "./styles/c07.json.gz",
    "clinical-anatomy": "./styles/c08.json.gz",
    "clinical-dysmorphology": "./styles/c09.json.gz",
    "clinical-gastroenterology-and-hepatology": "./styles/c10.json.gz",
    "clinical-hemorheology-and-microcirculation": "./styles/c11.json.gz",
    "clinical-infectious-diseases": "./styles/c12.json.gz",
    "clinical-journal-of-sport-medicine": "./styles/c13.json.gz",
    "clinical-journal-of-the-american-society-of-nephrology": "./styles/c14.json.gz",
    "clinical-management-issues": "./styles/c15.json.gz",
    "clinical-nuclear-medicine": "./styles/c16.json.gz",
    "clinical-oral-implants-research": "./styles/c17.json.gz",
    "clinical-orthopaedics-and-related-research": "./styles/c18.json.gz",
    "clinical-otolaryngology": "./styles/c19.json.gz",
    "clinical-pharmacology-and-therapeutics": "./styles/c20.json.gz",
    "clinical-physiology-and-functional-imaging": "./styles/c21.json.gz",
    "clinical-radiology": "./styles/c22.json.gz",
    "clinical-spine-surgery": "./styles/c23.json.gz",
    "clio-medica": "./styles/c24.json.gz",
    "cns-and-neurological-disorders-drug-targets": "./styles/c25.json.gz",
    "cns-spectrums": "./styles/c01.json.gz",
    "cold-spring-harbor-laboratory-press": "./styles/c02.json.gz",
    "collection-de-l-ecole-francaise-de-rome-full-note": "./styles/c03.json.gz",
    "collection-de-l-ecole-francaise-de-rome-note": "./styles/c04.json.gz",
    "collection-du-centre-jean-berard": "./styles/c05.json.gz",
    "collections-electroniques-de-l-inha-author-date": "./styles/c06.json.gz",
    "collections-electroniques-de-l-inha-full-note": "./styles/c07.json.gz",
    "college-montmorency": "./styles/c08.json.gz",
    "college-of-naturopathic-medicine": "./styles/c09.json.gz",
    "colombian-journal-of-anesthesiology": "./styles/c10.json.gz",
    "colorado-state-university-school-of-biomedical-engineering": "./styles/c11.json.gz",
    "comision-economica-para-america-latina-y-el-caribe": "./styles/c12.json.gz",
    "common-market-law-review": "./styles/c13.json.gz",
    "communication-et-langages": "./styles/c14.json.gz",
    "comparativ": "./styles/c15.json.gz",
    "comparative-parasitology": "./styles/c16.json.gz",
    "comparative-politics": "./styles/c17.json.gz",
    "comparative-population-studies": "./styles/c18.json.gz",
    "comptes-rendus-author-date": "./styles/c19.json.gz",
    "comptes-rendus-numeric": "./styles/c20.json.gz",
    "computer-supported-cooperative-work": "./styles/c21.json.gz",
    "computer-und-recht": "./styles/c22.json.gz",
    "conservation-and-society": "./styles/c23.json.gz",
    "conservation-biology": "./styles/c24.json.gz",
    "conservation-letters": "./styles/c25.json.gz",
    "conservation-physiology": "./styles/c01.json.gz",
    "constructivist-foundations": "./styles/c02.json.gz",
    "contemporary-accounting-research": "./styles/c03.json.gz",
    "continuity-and-change": "./styles/c04.json.gz",
    "contributions-to-the-archaeology-of-egypt-nubia-and-the-levant": "./styles/c05.json.gz",
    "copeia": "./styles/c06.json.gz",
    "copenhagen-university-legal-proper-attribution": "./styles/c07.json.gz",
    "copernicus-publications": "./styles/c08.json.gz",
    "coral-reefs": "./styles/c09.json.gz",
    "cornea": "./styles/c10.json.gz",
    "corrosion": "./styles/c11.json.gz",
    "cranfield-university-numeric": "./styles/c12.json.gz",
    "creativity-and-innovation-management": "./styles/c13.json.gz",
    "critical-care-medicine": "./styles/c14.json.gz",
    "critical-reviews-in-plant-sciences": "./styles/c15.json.gz",
    "critical-reviews-in-solid-state-and-materials-sciences": "./styles/c16.json.gz",
    "cronache-di-archeologia": "./styles/c17.json.gz",
    "crop-breeding-and-applied-biotechnology": "./styles/c18.json.gz",
    "crustaceana": "./styles/c19.json.gz",
    "cse-citation-name-8th-edition": "./styles/c20.json.gz",
    "cse-citation-name": "./styles/c21.json.gz",
    "cse-citation-sequence-8th-edition": "./styles/c22.json.gz",
    "cse-citation-sequence-brackets-8th-edition": "./styles/c23.json.gz",
    "cse-citation-sequence": "./styles/c24.json.gz",
    "cse-name-year-8th-edition": "./styles/c25.json.gz",
    "cse-name-year": "./styles/c01.json.gz",
    "cuadernos-de-filologia-clasica": "./styles/c02.json.gz",
    "cultivos-tropicales": "./styles/c03.json.gz",
    "cultural-geographies": "./styles/c04.json.gz",
    "cultural-studies-of-science-education": "./styles/c05.json.gz",
    "culture-medicine-and-psychiatry": "./styles/c06.json.gz",
    "cumhuriyet-universitesi-fen-bilimleri-enstitusu": "./styles/c07.json.gz",
    "cureus": "./styles/c08.json.gz",
    "current-alzheimer-research": "./styles/c09.json.gz",
    "current-gene-therapy": "./styles/c10.json.gz",
    "current-neurology-aktualnosci-neurologiczne": "./styles/c11.json.gz",
    "current-opinion-in-endocrinology-diabetes-and-obesity": "./styles/c12.json.gz",
    "current-opinion": "./styles/c13.json.gz",
    "current-organic-synthesis": "./styles/c14.json.gz",
    "current-pharmaceutical-design": "./styles/c15.json.gz",
    "current-proteomics": "./styles/c16.json.gz",
    "current-protocols": "./styles/c17.json.gz",
    "current-science": "./styles/c18.json.gz",
    "current-topics-in-medicinal-chemistry": "./styles/c19.json.gz",
    "currents-in-biblical-research": "./styles/c20.json.gz",
    "cybium": "./styles/c21.json.gz",
    "cytometry": "./styles/c22.json.gz",
    "czech-journal-of-international-relations": "./styles/c23.json.gz",
    "data-science-journal": "./styles/c24.json.gz",
    "database": "./styles/c25.json.gz",
    "de-buck": "./styles/c01.json.gz",
    "decision-sciences": "./styles/c02.json.gz",
    "degruyter-american-chemical-society": "./styles/c03.json.gz",
    "demographic-research": "./styles/c04.json.gz",
    "der-moderne-staat": "./styles/c05.json.gz",
    "dermatology-online-journal": "./styles/c06.json.gz",
    "deutsche-gesellschaft-fur-psychologie": "./styles/c07.json.gz",
    "deutsche-sprache": "./styles/c08.json.gz",
    "deutsche-zeitschrift-fur-sportmedizin": "./styles/c09.json.gz",
    "deutsches-archaologisches-institut-romisch-germanische-kommission-author-date": "./styles/c10.json.gz",
    "deutsches-archaologisches-institut": "./styles/c11.json.gz",
    "deutsches-arzteblatt": "./styles/c12.json.gz",
    "developing-world-bioethics": "./styles/c13.json.gz",
    "development-and-change": "./styles/c14.json.gz",
    "development-policy-review": "./styles/c15.json.gz",
    "developmental-dynamics": "./styles/c16.json.gz",
    "developmental-medicine-and-child-neurology": "./styles/c17.json.gz",
    "developmental-neurobiology": "./styles/c18.json.gz",
    "diabetologia": "./styles/c19.json.gz",
    "diagnostico-prenatal": "./styles/c20.json.gz",
    "dialisis-y-trasplante": "./styles/c21.json.gz",
    "diatom-research": "./styles/c22.json.gz",
    "die-bachelorarbeit-samac-et-al-in-text": "./styles/c23.json.gz",
    "die-bachelorarbeit-samac-et-al-note": "./styles/c24.json.gz",
    "digestive-and-liver-disease": "./styles/c25.json.gz",
    "digital-humanities-im-deutschsprachigen-raum": "./styles/c01.json.gz",
    "din-1505-2-alphanumeric": "./styles/c02.json.gz",
    "din-1505-2-numeric-alphabetical": "./styles/c03.json.gz",
    "din-1505-2-numeric": "./styles/c04.json.gz",
    "din-1505-2": "./styles/c05.json.gz",
    "diplo": "./styles/c06.json.gz",
    "disability-and-rehabilitation": "./styles/c07.json.gz",
    "discover-food": "./styles/c08.json.gz",
    "discovery-medicine": "./styles/c09.json.gz",
    "documents-d-archeologie-francaise": "./styles/c10.json.gz",
    "donau-universitat-krems-department-fur-e-governance-in-wirthschaft-und-verwaltung": "./styles/c11.json.gz",
    "drug-development-research": "./styles/c12.json.gz",
    "drug-testing-and-analysis": "./styles/c13.json.gz",
    "drugs-of-today": "./styles/c14.json.gz",
    "duale-hochschule-baden-wurttemberg-department-of-international-business": "./styles/c15.json.gz",
    "duale-hochschule-baden-wurttemberg-villingen-schwenningen-roter-grubert-mattern": "./styles/c16.json.gz",
    "durban-university-of-technology-harvard": "./styles/c17.json.gz",
    "e3s-web-of-conferences": "./styles/c18.json.gz",
    "ear-and-hearing": "./styles/c19.json.gz",
    "early-christianity": "./styles/c20.json.gz",
    "early-medieval-europe": "./styles/c21.json.gz",
    "earth-surface-processes-and-landforms": "./styles/c22.json.gz",
    "earthquake-engineering-and-structural-dynamics": "./styles/c23.json.gz",
    "earthquake-spectra": "./styles/c24.json.gz",
    "ecclesial-practices": "./styles/c25.json.gz",
    "ecole-de-technologie-superieure-apa": "./styles/c01.json.gz",
    "ecole-pratique-des-hautes-etudes-sciences-historiques-et-philologiques": "./styles/c02.json.gz",
    "ecological-entomology": "./styles/c03.json.gz",
    "ecological-restoration": "./styles/c04.json.gz",
    "ecology-and-society": "./styles/c05.json.gz",
    "ecology-letters": "./styles/c06.json.gz",
    "ecology-of-freshwater-fish": "./styles/c07.json.gz",
    "ecology": "./styles/c08.json.gz",
    "econometrica": "./styles/c09.json.gz",
    "economia-y-politica": "./styles/c10.json.gz",
    "economic-commission-for-latin-america-and-the-caribbean": "./styles/c11.json.gz",
    "economic-geology": "./styles/c12.json.gz",
    "economie-et-statistique": "./styles/c13.json.gz",
    "ecoscience": "./styles/c14.json.gz",
    "ecosistemas": "./styles/c15.json.gz",
    "ecosystems": "./styles/c16.json.gz",
    "edward-elgar-business-and-social-sciences": "./styles/c17.json.gz",
    "effective-altruism-wiki": "./styles/c18.json.gz",
    "egretta": "./styles/c19.json.gz",
    "einaudi": "./styles/c20.json.gz",
    "eksploatacja-i-niezawodnosc": "./styles/c21.json.gz",
    "el-profesional-de-la-informacion": "./styles/c22.json.gz",
    "electrophoresis": "./styles/c23.json.gz",
    "elementa": "./styles/c24.json.gz",
    "elife": "./styles/c25.json.gz",
    "elsevier-american-chemical-society": "./styles/c01.json.gz",
    "elsevier-harvard-without-titles": "./styles/c02.json.gz",
    "elsevier-harvard": "./styles/c03.json.gz",
    "elsevier-harvard2": "./styles/c04.json.gz",
    "elsevier-vancouver-author-date-alphabetical": "./styles/c05.json.gz",
    "elsevier-vancouver-author-date": "./styles/c06.json.gz",
    "elsevier-vancouver-no-et-al": "./styles/c07.json.gz",
    "elsevier-vancouver-short-author-list": "./styles/c08.json.gz",
    "elsevier-vancouver": "./styles/c09.json.gz",
    "elsevier-with-titles-alphabetical": "./styles/c10.json.gz",
    "elsevier-with-titles": "./styles/c11.json.gz",
    "elsevier-without-titles": "./styles/c12.json.gz",
    "em-normandie-business-school-harvard-english": "./styles/c13.json.gz",
    "em-normandie-business-school-harvard-francais": "./styles/c14.json.gz",
    "embnet-journal": "./styles/c15.json.gz",
    "embo-press": "./styles/c16.json.gz",
    "emerald-harvard": "./styles/c17.json.gz",
    "emu-austral-ornithology": "./styles/c18.json.gz",
    "endocrine-connections": "./styles/c19.json.gz",
    "endocrine-journal": "./styles/c20.json.gz",
    "endocrine-press": "./styles/c21.json.gz",
    "endoscopia": "./styles/c22.json.gz",
    "energy-research-and-social-science": "./styles/c23.json.gz",
    "eneuro": "./styles/c24.json.gz",
    "enfances-familles-generations": "./styles/c25.json.gz",
    "enfermeria-clinica": "./styles/c01.json.gz",
    "enfermeria-intensiva": "./styles/c02.json.gz",
    "engineered-regeneration": "./styles/c03.json.gz",
    "engineering-in-life-sciences": "./styles/c04.json.gz",
    "engineering-technology-and-applied-science-research": "./styles/c05.json.gz",
    "ens-de-lyon-centre-d-ingenierie-documentaire": "./styles/c06.json.gz",
    "entecho": "./styles/c07.json.gz",
    "entomologia-experimentalis-et-applicata": "./styles/c08.json.gz",
    "entomological-review": "./styles/c09.json.gz",
    "entomological-society-of-america": "./styles/c10.json.gz",
    "environment-and-planning": "./styles/c11.json.gz",
    "environment-and-urbanization": "./styles/c12.json.gz",
    "environmental-and-engineering-geoscience": "./styles/c13.json.gz",
    "environmental-chemistry": "./styles/c14.json.gz",
    "environmental-conservation": "./styles/c15.json.gz",
    "environmental-health-perspectives": "./styles/c16.json.gz",
    "environmental-microbiology": "./styles/c17.json.gz",
    "environmental-values": "./styles/c18.json.gz",
    "environnement-risques-et-sante": "./styles/c19.json.gz",
    "ephemerides-theologicae-lovanienses": "./styles/c20.json.gz",
    "epidemiologie-et-sante-animale": "./styles/c21.json.gz",
    "epidemiology-and-infection": "./styles/c22.json.gz",
    "epidemiology-psychiatric-sciences": "./styles/c23.json.gz",
    "epilepsia": "./styles/c24.json.gz",
    "equine-veterinary-education": "./styles/c25.json.gz",
    "equine-veterinary-journal": "./styles/c01.json.gz",
    "ergo": "./styles/c02.json.gz",
    "ergoscience": "./styles/c03.json.gz",
    "errata": "./styles/c04.json.gz",
    "escuela-nacional-de-antropologia-e-historia-author-date": "./styles/c05.json.gz",
    "escuela-nacional-de-antropologia-e-historia-full-note": "./styles/c06.json.gz",
    "escuela-nacional-de-antropologia-e-historia-short-note": "./styles/c07.json.gz",
    "estonian-journal-of-archaeology": "./styles/c08.json.gz",
    "estonian-journal-of-earth-sciences": "./styles/c09.json.gz",
    "estudios-de-cultura-maya": "./styles/c10.json.gz",
    "estudios-de-fonetica-experimental": "./styles/c11.json.gz",
    "estudios-hispanicos": "./styles/c12.json.gz",
    "ethics-book-reviews": "./styles/c13.json.gz",
    "ethnobiology-and-conservation": "./styles/c14.json.gz",
    "ethnobiology-letters": "./styles/c15.json.gz",
    "ethnographiques-org": "./styles/c16.json.gz",
    "ethnologie-francaise": "./styles/c17.json.gz",
    "ethnomusicology": "./styles/c18.json.gz",
    "etri-journal": "./styles/c19.json.gz",
    "ets-ecole-de-technologie-superieure": "./styles/c20.json.gz",
    "etudes-chinoises": "./styles/c21.json.gz",
    "etudes-francaises": "./styles/c22.json.gz",
    "eu-interinstitutional-style": "./styles/c23.json.gz",
    "eunomia-revista-en-cultura-de-la-legalidad": "./styles/c24.json.gz",
    "eurasian-journal-of-medical-investigation": "./styles/c25.json.gz",
    "eurasian-journal-of-medicine-and-oncology": "./styles/c01.json.gz",
    "eurointervention": "./styles/c02.json.gz",
    "europace": "./styles/c03.json.gz",
    "european-cells-and-materials": "./styles/c04.json.gz",
    "european-environment-agency-numeric": "./styles/c05.json.gz",
    "european-environment-agency": "./styles/c06.json.gz",
    "european-journal-for-philosophy-of-religion": "./styles/c07.json.gz",
    "european-journal-of-anaesthesiology": "./styles/c08.json.gz",
    "european-journal-of-clinical-microbiology-and-infectious-diseases": "./styles/c09.json.gz",
    "european-journal-of-emergency-medicine": "./styles/c10.json.gz",
    "european-journal-of-endocrinology": "./styles/c11.json.gz",
    "european-journal-of-entomology": "./styles/c12.json.gz",
    "european-journal-of-human-genetics": "./styles/c13.json.gz",
    "european-journal-of-immunology": "./styles/c14.json.gz",
    "european-journal-of-information-systems": "./styles/c15.json.gz",
    "european-journal-of-international-law": "./styles/c16.json.gz",
    "european-journal-of-lipid-science-and-technology": "./styles/c17.json.gz",
    "european-journal-of-microbiology-and-immunology": "./styles/c18.json.gz",
    "european-journal-of-neuroscience": "./styles/c19.json.gz",
    "european-journal-of-ophthalmology": "./styles/c20.json.gz",
    "european-journal-of-paediatric-neurology": "./styles/c21.json.gz",
    "european-journal-of-pain": "./styles/c22.json.gz",
    "european-journal-of-political-research": "./styles/c23.json.gz",
    "european-journal-of-public-health": "./styles/c24.json.gz",
    "european-journal-of-soil-science": "./styles/c25.json.gz",
    "european-journal-of-taxonomy": "./styles/c01.json.gz",
    "european-journal-of-theology": "./styles/c02.json.gz",
    "european-journal-of-ultrasound": "./styles/c03.json.gz",
    "european-journal-of-vascular-and-endovascular-surgery": "./styles/c04.json.gz",
    "european-journal-physical-medicine-and-rehabilitation": "./styles/c05.json.gz",
    "european-respiratory-journal": "./styles/c06.json.gz",
    "european-retail-research": "./styles/c07.json.gz",
    "european-review-of-agricultural-economics": "./styles/c08.json.gz",
    "european-review-of-international-studies": "./styles/c09.json.gz",
    "european-society-of-cardiology": "./styles/c10.json.gz",
    "european-union-interinstitutional-style-guide-author-date": "./styles/c11.json.gz",
    "european-union-interinstitutional-style-guide": "./styles/c12.json.gz",
    "eva-berlin-konferenz": "./styles/c13.json.gz",
    "evangelikus-hittudomanyi-egyetem": "./styles/c14.json.gz",
    "evidence-based-complementary-and-alternative-medicine": "./styles/c15.json.gz",
    "evolution-and-development": "./styles/c16.json.gz",
    "evolution-letters": "./styles/c17.json.gz",
    "evolution": "./styles/c18.json.gz",
    "evolutionary-anthropology": "./styles/c19.json.gz",
    "evolutionary-ecology-research": "./styles/c20.json.gz",
    "excli-journal": "./styles/c21.json.gz",
    "exercer": "./styles/c22.json.gz",
    "experimental-biology-and-medicine": "./styles/c23.json.gz",
    "experimental-biomedical-research": "./styles/c24.json.gz",
    "expert-reviews-in-molecular-medicine": "./styles/c25.json.gz",
    "exploration-of-targeted-anti-tumor-therapy": "./styles/c01.json.gz",
    "express-polymer-letters": "./styles/c02.json.gz",
    "extracellular-vesicles-and-circulating-nucleic-acids": "./styles/c03.json.gz",
    "eye": "./styles/c04.json.gz",
    "facets": "./styles/c05.json.gz",
    "fachhochschule-kiel-fachbereich-medien": "./styles/c06.json.gz",
    "fachhochschule-sudwestfalen": "./styles/c07.json.gz",
    "fachhochschule-vorarlberg-author-date": "./styles/c08.json.gz",
    "fachhochschule-vorarlberg-note": "./styles/c09.json.gz",
    "facial-plastic-surgery-clinics-of-north-america": "./styles/c10.json.gz",
    "facolta-teologica-dell-italia-settentrionale-milano": "./styles/c11.json.gz",
    "family-business-review": "./styles/c12.json.gz",
    "farmeconomia": "./styles/c13.json.gz",
    "fatigue-and-fracture-of-engineering-materials-and-structures": "./styles/c14.json.gz",
    "feminist-economics": "./styles/c15.json.gz",
    "feminist-theory": "./styles/c16.json.gz",
    "ferdinand-porsche-fern-fachhochschule": "./styles/c17.json.gz",
    "ferdinand-porsche-fernfh-betriebswirtschaft-und-wirtschaftspsychologie-dgps": "./styles/c18.json.gz",
    "fertility-and-sterility": "./styles/c19.json.gz",
    "fh-joanneum-institute-of-software-design-and-security": "./styles/c20.json.gz",
    "finance-and-society": "./styles/c21.json.gz",
    "finanzarchiv": "./styles/c22.json.gz",
    "fine-focus": "./styles/c23.json.gz",
    "firephyschem": "./styles/c24.json.gz",
    "first-break": "./styles/c25.json.gz",
    "first-monday": "./styles/c01.json.gz",
    "fishery-bulletin": "./styles/c02.json.gz",
    "fizyoloji-medical-journal": "./styles/c03.json.gz",
    "flavour-and-fragrance-journal": "./styles/c04.json.gz",
    "florida-entomologist": "./styles/c05.json.gz",
    "flux": "./styles/c06.json.gz",
    "focaal-journal-of-global-and-historical-anthropology": "./styles/c07.json.gz",
    "foerster-geisteswissenschaft": "./styles/c08.json.gz",
    "fold-and-r": "./styles/c09.json.gz",
    "folia-amazonica": "./styles/c10.json.gz",
    "folia-biologica": "./styles/c11.json.gz",
    "folia-malacologica": "./styles/c12.json.gz",
    "folia-morphologia": "./styles/c13.json.gz",
    "food-and-agriculture-organization-of-the-united-nations-numeric": "./styles/c14.json.gz",
    "food-and-agriculture-organization-of-the-united-nations": "./styles/c15.json.gz",
    "food-science-and-biotechnology": "./styles/c16.json.gz",
    "forensic-anthropology": "./styles/c17.json.gz",
    "forensic-science-review": "./styles/c18.json.gz",
    "forest-science": "./styles/c19.json.gz",
    "forestry": "./styles/c20.json.gz",
    "forschungsjournal-soziale-bewegungen-fjsb": "./styles/c21.json.gz",
    "forum-qualitative-social-research": "./styles/c22.json.gz",
    "forum-qualitative-sozialforschung": "./styles/c23.json.gz",
    "frattura-ed-integrita-strutturale-fracture-and-structural-integrity": "./styles/c24.json.gz",
    "free-radical-research": "./styles/c25.json.gz",
    "freie-hochschule-stuttgart": "./styles/c01.json.gz",
    "freie-universitat-berlin-geographische-wissenschaften": "./styles/c02.json.gz",
    "french-politics": "./styles/c03.json.gz",
    "french1": "./styles/c04.json.gz",
    "french2": "./styles/c05.json.gz",
    "french3": "./styles/c06.json.gz",
    "french4": "./styles/c07.json.gz",
    "freshwater-biology": "./styles/c08.json.gz",
    "freshwater-crayfish": "./styles/c09.json.gz",
    "freshwater-science": "./styles/c10.json.gz",
    "friedrich-schiller-universitat-jena-medizinische-fakultat": "./styles/c11.json.gz",
    "frontiers-in-bioscience": "./styles/c12.json.gz",
    "frontiers-in-ecology-and-the-environment": "./styles/c13.json.gz",
    "frontiers-in-optics": "./styles/c14.json.gz",
    "frontiers-in-physics": "./styles/c15.json.gz",
    "frontiers-medical-journals": "./styles/c16.json.gz",
    "frontiers": "./styles/c17.json.gz",
    "fundamental-and-applied-limnology": "./styles/c18.json.gz",
    "future-medicine": "./styles/c19.json.gz",
    "future-science-group": "./styles/c20.json.gz",
    "g-giappichelli-editore": "./styles/c21.json.gz",
    "gaceta-sanitaria": "./styles/c22.json.gz",
    "gaia": "./styles/c23.json.gz",
    "gait-and-posture": "./styles/c24.json.gz",
    "galatasaray-universitesi-sosyal-bilimler-enstitusu": "./styles/c25.json.gz",
    "gallia-prehistoire": "./styles/c01.json.gz",
    "gallia": "./styles/c02.json.gz",
    "gastroenterology": "./styles/c03.json.gz",
    "gastrointestinal-endoscopy-clinics-of-north-america": "./styles/c04.json.gz",
    "gastrointestinal-intervention": "./styles/c05.json.gz",
    "gayana-botanica": "./styles/c06.json.gz",
    "gayana": "./styles/c07.json.gz",
    "gazeta-medica": "./styles/c08.json.gz",
    "geistes-und-kulturwissenschaften-heilmann": "./styles/c09.json.gz",
    "gender-and-society": "./styles/c10.json.gz",
    "gender-zeitschrift-fur-geschlecht-kultur-und-gesellschaft": "./styles/c11.json.gz",
    "generic-style-rules-for-linguistics": "./styles/c12.json.gz",
    "genes-brain-and-behavior": "./styles/c13.json.gz",
    "genes-to-cells": "./styles/c14.json.gz",
    "geneses": "./styles/c15.json.gz",
    "genetics-and-molecular-biology": "./styles/c16.json.gz",
    "gengo-kenkyu-journal-of-the-linguistic-society-of-japan": "./styles/c17.json.gz",
    "genomics-and-informatics": "./styles/c18.json.gz",
    "geoarchaeology": "./styles/c19.json.gz",
    "geobiology": "./styles/c20.json.gz",
    "geochemical-perspectives-letters": "./styles/c21.json.gz",
    "geochimica-et-cosmochimica-acta": "./styles/c22.json.gz",
    "geochronometria": "./styles/c23.json.gz",
    "geografia-fisica-e-dinamica-quaternaria": "./styles/c24.json.gz",
    "geografie-sbornik-cgs": "./styles/c25.json.gz",
    "geographical-analysis": "./styles/c01.json.gz",
    "geographie-et-cultures": "./styles/c02.json.gz",
    "geographische-zeitschrift": "./styles/c03.json.gz",
    "geological-magazine": "./styles/c04.json.gz",
    "geophysical-journal-international": "./styles/c05.json.gz",
    "geophysics": "./styles/c06.json.gz",
    "geopolitics": "./styles/c07.json.gz",
    "georg-august-universitat-gottingen-institut-fur-ethnologie-und-ethnologische-sammlung": "./styles/c08.json.gz",
    "geriatrics-and-gerontology-international": "./styles/c09.json.gz",
    "geriatrie-et-psychologie-neuropsychiatrie-du-vieillissement": "./styles/c10.json.gz",
    "german-council-of-economic-experts": "./styles/c11.json.gz",
    "german-journal-of-agricultural-economics": "./styles/c12.json.gz",
    "german-yearbook-of-international-law": "./styles/c13.json.gz",
    "geschichte-und-gesellschaft": "./styles/c14.json.gz",
    "gesellschaft-fur-popularmusikforschung": "./styles/c15.json.gz",
    "gewerblicher-rechtsschutz-und-urheberrecht": "./styles/c16.json.gz",
    "gigascience": "./styles/c17.json.gz",
    "global-ecology-and-biogeography": "./styles/c18.json.gz",
    "glossa": "./styles/c19.json.gz",
    "gnosis-journal-of-gnostic-studies": "./styles/c20.json.gz",
    "gost-r-7-0-5-2008-numeric-alphabetical": "./styles/c21.json.gz",
    "gost-r-7-0-5-2008-numeric": "./styles/c22.json.gz",
    "gost-r-7-0-5-2008": "./styles/c23.json.gz",
    "government-and-opposition": "./styles/c24.json.gz",
    "grasas-y-aceites": "./styles/c25.json.gz",
    "greek-and-roman-musical-studies": "./styles/c01.json.gz",
    "griffith-college-harvard": "./styles/c02.json.gz",
    "groundwater": "./styles/c03.json.gz",
    "groupe-danthropologie-et-darcheologie-funeraire": "./styles/c04.json.gz",
    "guide-des-citations-references-et-abreviations-juridiques": "./styles/c05.json.gz",
    "guide-pour-la-redaction-et-la-presentation-des-theses-a-lusage-des-doctorants": "./styles/c06.json.gz",
    "haaga-helia-university-of-applied-sciences-harvard": "./styles/c07.json.gz",
    "haematologica": "./styles/c08.json.gz",
    "haemophilia": "./styles/c09.json.gz",
    "haffner-style-manual": "./styles/c10.json.gz",
    "hainan-medical-university-journal-publisher": "./styles/c11.json.gz",
    "hamburg-school-of-food-science": "./styles/c12.json.gz",
    "hand": "./styles/c13.json.gz",
    "handbook-of-clinical-neurology": "./styles/c14.json.gz",
    "harvard-anglia-ruskin-university": "./styles/c15.json.gz",
    "harvard-bournemouth-university": "./styles/c16.json.gz",
    "harvard-cape-peninsula-university-of-technology": "./styles/c17.json.gz",
    "harvard-cite-them-right-10th-edition": "./styles/c18.json.gz",
    "harvard-cite-them-right-11th-edition": "./styles/c19.json.gz",
    "harvard-cite-them-right-no-et-al": "./styles/c20.json.gz",
    "harvard-cite-them-right": "./styles/c21.json.gz",
    "harvard-coventry-university": "./styles/c22.json.gz",
    "harvard-cranfield-university": "./styles/c23.json.gz",
    "harvard-deakin-university": "./styles/c24.json.gz",
    "harvard-dundalk-institute-of-technology": "./styles/c25.json.gz",
    "harvard-durham-university-business-school": "./styles/c01.json.gz",
    "harvard-edge-hill-university": "./styles/c02.json.gz",
    "harvard-european-archaeology": "./styles/c03.json.gz",
    "harvard-fachhochschule-salzburg": "./styles/c04.json.gz",
    "harvard-falmouth-university": "./styles/c05.json.gz",
    "harvard-gesellschaft-fur-bildung-und-forschung-in-europa": "./styles/c06.json.gz",
    "harvard-institut-fur-praxisforschung-de": "./styles/c07.json.gz",
    "harvard-kings-college-london": "./styles/c08.json.gz",
    "harvard-leeds-beckett-university": "./styles/c09.json.gz",
    "harvard-leeds-metropolitan-university": "./styles/c10.json.gz",
    "harvard-limerick": "./styles/c11.json.gz",
    "harvard-london-south-bank-university": "./styles/c12.json.gz",
    "harvard-manchester-business-school": "./styles/c13.json.gz",
    "harvard-manchester-metropolitan-university": "./styles/c14.json.gz",
    "harvard-melbourne-polytechnic": "./styles/c15.json.gz",
    "harvard-newcastle-university": "./styles/c16.json.gz",
    "harvard-north-west-university": "./styles/c17.json.gz",
    "harvard-pontificia-universidad-catolica-del-ecuador": "./styles/c18.json.gz",
    "harvard-review-of-psychiatry": "./styles/c19.json.gz",
    "harvard-robert-gordon-university": "./styles/c20.json.gz",
    "harvard-staffordshire-university": "./styles/c21.json.gz",
    "harvard-stellenbosch-university": "./styles/c22.json.gz",
    "harvard-swinburne-university-of-technology": "./styles/c23.json.gz",
    "harvard-the-university-of-northampton": "./styles/c24.json.gz",
    "harvard-the-university-of-sheffield-school-of-east-asian-studies": "./styles/c25.json.gz",
    "harvard-the-university-of-sheffield-town-and-regional-planning": "./styles/c01.json.gz",
    "harvard-theologisches-seminar-adelshofen": "./styles/c02.json.gz",
    "harvard-universiti-teknologi-malaysia": "./styles/c03.json.gz",
    "harvard-universiti-tunku-abdul-rahman": "./styles/c04.json.gz",
    "harvard-university-for-the-creative-arts": "./styles/c05.json.gz",
    "harvard-university-of-abertay-dundee": "./styles/c06.json.gz",
    "harvard-university-of-bath": "./styles/c07.json.gz",
    "harvard-university-of-birmingham": "./styles/c08.json.gz",
    "harvard-university-of-brighton-school-of-environment-and-technology": "./styles/c09.json.gz",
    "harvard-university-of-cape-town": "./styles/c10.json.gz",
    "harvard-university-of-exeter-geography": "./styles/c11.json.gz",
    "harvard-university-of-greenwich": "./styles/c12.json.gz",
    "harvard-university-of-kent": "./styles/c13.json.gz",
    "harvard-university-of-leeds": "./styles/c14.json.gz",
    "harvard-university-of-technology-sydney": "./styles/c15.json.gz",
    "harvard-university-of-the-west-of-england": "./styles/c16.json.gz",
    "harvard-university-of-the-west-of-scotland": "./styles/c17.json.gz",
    "harvard-university-of-westminster": "./styles/c18.json.gz",
    "harvard-university-of-wolverhampton": "./styles/c19.json.gz",
    "harvard-xi-an-jiaotong-liverpool-university": "./styles/c20.json.gz",
    "harvard-york-st-john-university": "./styles/c21.json.gz",
    "haute-ecole-de-gestion-de-geneve-iso-690": "./styles/c22.json.gz",
    "haute-ecole-pedagogique-fribourg": "./styles/c23.json.gz",
    "hawaii-international-conference-on-system-sciences-proceedings": "./styles/c24.json.gz",
    "health-and-human-rights-journal": "./styles/c25.json.gz",
    "health-and-social-care-in-the-community": "./styles/c01.json.gz",
    "health-economics-policy-and-law": "./styles/c02.json.gz",
    "health-economics": "./styles/c03.json.gz",
    "health-education-england-harvard": "./styles/c04.json.gz",
    "health-education-research": "./styles/c05.json.gz",
    "health-physics": "./styles/c06.json.gz",
    "health-reform-observer-observatoire-des-reformes-de-sante": "./styles/c07.json.gz",
    "health-sciences-university-uco-school-of-osteopathy": "./styles/c08.json.gz",
    "health-sports-and-rehabilitation-medicine": "./styles/c09.json.gz",
    "heart-failure-clinics": "./styles/c10.json.gz",
    "heart-rhythm": "./styles/c11.json.gz",
    "heidelberg-university-faculty-of-medicine": "./styles/c12.json.gz",
    "heiliger-dienst": "./styles/c13.json.gz",
    "helvetica-chimica-acta": "./styles/c14.json.gz",
    "hematology-oncology-clinics-of-north-america": "./styles/c15.json.gz",
    "hemijska-industrija": "./styles/c16.json.gz",
    "henoch": "./styles/c17.json.gz",
    "hepatology": "./styles/c18.json.gz",
    "heredity": "./styles/c19.json.gz",
    "herpetologica": "./styles/c20.json.gz",
    "hiob-ludolf-centre-for-ethiopian-studies-long-names": "./styles/c21.json.gz",
    "hiob-ludolf-centre-for-ethiopian-studies-with-url-doi": "./styles/c22.json.gz",
    "hiob-ludolf-centre-for-ethiopian-studies": "./styles/c23.json.gz",
    "hipertension-y-riesgo-vascular": "./styles/c24.json.gz",
    "histoire-at-politique": "./styles/c25.json.gz",
    "histoire-et-mesure": "./styles/c01.json.gz",
    "histopathology": "./styles/c02.json.gz",
    "historia-scribere": "./styles/c03.json.gz",
    "historical-materialism": "./styles/c04.json.gz",
    "historio-plus": "./styles/c05.json.gz",
    "history-and-theory": "./styles/c06.json.gz",
    "history-of-the-human-sciences": "./styles/c07.json.gz",
    "hochschule-bonn-rhein-sieg": "./styles/c08.json.gz",
    "hochschule-der-kunste-bern-musikforschung": "./styles/c09.json.gz",
    "hochschule-fur-soziale-arbeit-fhnw": "./styles/c10.json.gz",
    "hochschule-fur-wirtschaft-und-recht-berlin": "./styles/c11.json.gz",
    "hochschule-hannover-soziale-arbeit": "./styles/c12.json.gz",
    "hochschule-munchen-fakultat-fur-angewandte-sozialwissenschaften": "./styles/c13.json.gz",
    "hochschule-osnabruck-fakultat-agrarwissenschaften-und-landschaftsarchitektur": "./styles/c14.json.gz",
    "hochschule-pforzheim-fakultat-fur-wirtschaft-und-recht": "./styles/c15.json.gz",
    "hochschule-rheinmain-wiesbaden-business-school-gesundheitsokonomie": "./styles/c16.json.gz",
    "homeopathy-thieme": "./styles/c17.json.gz",
    "hong-kong-journal-of-radiology": "./styles/c18.json.gz",
    "hospital-a-domicilio": "./styles/c19.json.gz",
    "housing-studies": "./styles/c20.json.gz",
    "howard-hughes-medical-institute": "./styles/c21.json.gz",
    "hpb": "./styles/c22.json.gz",
    "hue-university-of-medicine-and-pharmacy": "./styles/c23.json.gz",
    "human-brain-mapping": "./styles/c24.json.gz",
    "human-ecology": "./styles/c25.json.gz",
    "human-molecular-genetics": "./styles/c01.json.gz",
    "human-mutation": "./styles/c02.json.gz",
    "human-reproduction-update": "./styles/c03.json.gz",
    "human-reproduction": "./styles/c04.json.gz",
    "human-resource-management-journal": "./styles/c05.json.gz",
    "human-rights-law-review": "./styles/c06.json.gz",
    "human-wildlife-interactions": "./styles/c07.json.gz",
    "humboldt-state-university-environmental-resources-engineering": "./styles/c08.json.gz",
    "hydrobiologia": "./styles/c09.json.gz",
    "hydrological-processes": "./styles/c10.json.gz",
    "hydrological-sciences-journal": "./styles/c11.json.gz",
    "hypertension-research": "./styles/c12.json.gz",
    "hypotheses-in-the-life-sciences": "./styles/c13.json.gz",
    "hystrix-the-italian-journal-of-mammalogy": "./styles/c14.json.gz",
    "iainutuban": "./styles/c15.json.gz",
    "iawa-journal": "./styles/c16.json.gz",
    "ib-tauris-note": "./styles/c17.json.gz",
    "ibis": "./styles/c18.json.gz",
    "idojaras-quarterly-journal-of-the-hungarian-meteorological-service": "./styles/c19.json.gz",
    "ie-comunicaciones": "./styles/c20.json.gz",
    "ieee-transactions-on-medical-imaging": "./styles/c21.json.gz",
    "ieee": "./styles/c22.json.gz",
    "iforest": "./styles/c23.json.gz",
    "igaku-toshokan": "./styles/c24.json.gz",
    "iica-catie": "./styles/c25.json.gz",
    "ilahiyat-studies": "./styles/c01.json.gz",
    "im-gesprach": "./styles/c02.json.gz",
    "imperial-college-london-author-date": "./styles/c03.json.gz",
    "imperial-college-london-numerical": "./styles/c04.json.gz",
    "incontext-studies-in-translation-and-interculturalism": "./styles/c05.json.gz",
    "indian-dermatology-online-journal": "./styles/c06.json.gz",
    "indian-journal-of-agricultural-sciences": "./styles/c07.json.gz",
    "indian-journal-of-medical-research": "./styles/c08.json.gz",
    "indian-journal-of-orthopaedics": "./styles/c09.json.gz",
    "indian-journal-of-physics": "./styles/c10.json.gz",
    "indian-journal-of-traditional-knowledge": "./styles/c11.json.gz",
    "indian-journal-of-veterinary-and-animal-sciences-research": "./styles/c12.json.gz",
    "indiana": "./styles/c13.json.gz",
    "indoor-air": "./styles/c14.json.gz",
    "infectio": "./styles/c15.json.gz",
    "infectious-disease-clinics-of-north-america": "./styles/c16.json.gz",
    "inflammatory-bowel-diseases": "./styles/c17.json.gz",
    "influenza-and-other-respiratory-viruses": "./styles/c18.json.gz",
    "infoclio-de-kurzbelege": "./styles/c19.json.gz",
    "infoclio-de": "./styles/c20.json.gz",
    "infoclio-fr-nocaps": "./styles/c21.json.gz",
    "infoclio-fr-smallcaps": "./styles/c22.json.gz",
    "infomin": "./styles/c23.json.gz",
    "informal-logic": "./styles/c24.json.gz",
    "informationswissenschaft-theorie-methode-praxis": "./styles/c25.json.gz",
    "ingenieria-agricola": "./styles/c01.json.gz",
    "innovations-therapeutiques-en-oncologie": "./styles/c02.json.gz",
    "instap-academic-press": "./styles/c03.json.gz",
    "institut-francais-darcheologie-orientale-arab-studies": "./styles/c04.json.gz",
    "institut-francais-darcheologie-orientale-en": "./styles/c05.json.gz",
    "institut-francais-darcheologie-orientale-etudes-arabes": "./styles/c06.json.gz",
    "institut-francais-darcheologie-orientale": "./styles/c07.json.gz",
    "institut-fur-geschichte-des-landlichen-raums": "./styles/c08.json.gz",
    "institut-national-de-la-recherche-scientifique-sciences-sociales": "./styles/c09.json.gz",
    "institut-national-de-recherches-archeologiques-preventives": "./styles/c10.json.gz",
    "institut-national-de-sante-publique-du-quebec-napp": "./styles/c11.json.gz",
    "institut-national-de-sante-publique-du-quebec-topo": "./styles/c12.json.gz",
    "institut-pertanian-bogor": "./styles/c13.json.gz",
    "institut-teknologi-bandung-sekolah-pascasarjana": "./styles/c14.json.gz",
    "institute-for-operations-research-and-the-management-sciences": "./styles/c15.json.gz",
    "institute-of-mathematical-statistics": "./styles/c16.json.gz",
    "institute-of-mathematics-and-its-applications": "./styles/c17.json.gz",
    "institute-of-physics-harvard": "./styles/c18.json.gz",
    "institute-of-physics-numeric": "./styles/c19.json.gz",
    "instituto-brasileiro-de-informacao-em-ciencia-e-tecnologia-abnt-initials": "./styles/c20.json.gz",
    "instituto-brasileiro-de-informacao-em-ciencia-e-tecnologia-abnt": "./styles/c21.json.gz",
    "instituto-de-investigaciones-sobre-la-universidad-y-la-educacion-moderno": "./styles/c22.json.gz",
    "instituto-de-pesquisas-energeticas-e-nucleares": "./styles/c23.json.gz",
    "instituto-de-pesquisas-tecnologicas": "./styles/c24.json.gz",
    "instituto-superior-de-teologia-de-las-islas-canarias": "./styles/c25.json.gz",
    "instituto-universitario-militar": "./styles/c01.json.gz",
    "instrumenta-patristica-et-mediaevalia": "./styles/c02.json.gz",
    "integrated-science-publishing-journals": "./styles/c03.json.gz",
    "integrative-and-comparative-biology": "./styles/c04.json.gz",
    "intellect-newgen-books": "./styles/c05.json.gz",
    "inter-research-science-center": "./styles/c06.json.gz",
    "inter-ro": "./styles/c07.json.gz",
    "interaction-design-and-architectures": "./styles/c08.json.gz",
    "interactive-cardiovascular-and-thoracic-surgery": "./styles/c09.json.gz",
    "interdisziplinare-anthropologie": "./styles/c10.json.gz",
    "interdisziplinare-zeitschrift-fur-technologie-und-lernen": "./styles/c11.json.gz",
    "interkulturelle-germanistik-gottingen": "./styles/c12.json.gz",
    "international-affairs": "./styles/c13.json.gz",
    "international-atomic-energy-agency": "./styles/c14.json.gz",
    "international-biodeterioration-and-biodegradation": "./styles/c15.json.gz",
    "international-brazilian-journal-of-urology": "./styles/c16.json.gz",
    "international-conference-on-information-systems-development": "./styles/c17.json.gz",
    "international-development-policy": "./styles/c18.json.gz",
    "international-energy-agency-organisation-for-economic-co-operation-and-development": "./styles/c19.json.gz",
    "international-islamic-university-malaysia-ahmad-ibrahim-kulliyyah-of-laws": "./styles/c20.json.gz",
    "international-journal-for-numerical-methods-in-biomedical-engineering": "./styles/c21.json.gz",
    "international-journal-of-audiology": "./styles/c22.json.gz",
    "international-journal-of-automotive-technology": "./styles/c23.json.gz",
    "international-journal-of-cancer": "./styles/c24.json.gz",
    "international-journal-of-circuit-theory-and-applications": "./styles/c25.json.gz",
    "international-journal-of-climatology": "./styles/c01.json.gz",
    "international-journal-of-clinical-research": "./styles/c02.json.gz",
    "international-journal-of-cosmetic-science": "./styles/c03.json.gz",
    "international-journal-of-electrochemical-science": "./styles/c04.json.gz",
    "international-journal-of-electronic-commerce": "./styles/c05.json.gz",
    "international-journal-of-epidemiology": "./styles/c06.json.gz",
    "international-journal-of-exercise-science": "./styles/c07.json.gz",
    "international-journal-of-food-science-and-technology": "./styles/c08.json.gz",
    "international-journal-of-geriatric-psychiatry": "./styles/c09.json.gz",
    "international-journal-of-humanoid-robotics": "./styles/c10.json.gz",
    "international-journal-of-language-and-communication-disorders": "./styles/c11.json.gz",
    "international-journal-of-management-reviews": "./styles/c12.json.gz",
    "international-journal-of-nuclear-security": "./styles/c13.json.gz",
    "international-journal-of-obstetric-anesthesia": "./styles/c14.json.gz",
    "international-journal-of-occupational-medicine-and-environmental-health": "./styles/c15.json.gz",
    "international-journal-of-oral-and-maxillofacial-surgery": "./styles/c16.json.gz",
    "international-journal-of-osteoarchaeology": "./styles/c17.json.gz",
    "international-journal-of-plant-sciences": "./styles/c18.json.gz",
    "international-journal-of-polymer-analysis-and-characterization": "./styles/c19.json.gz",
    "international-journal-of-polymeric-materials-and-polymeric-biomaterials": "./styles/c20.json.gz",
    "international-journal-of-population-data-science": "./styles/c21.json.gz",
    "international-journal-of-quantum-chemistry": "./styles/c22.json.gz",
    "international-journal-of-radiation-oncology-biology-physics": "./styles/c23.json.gz",
    "international-journal-of-research-in-exercise-physiology": "./styles/c24.json.gz",
    "international-journal-of-simulation-modelling": "./styles/c25.json.gz",
    "international-journal-of-spatial-data-infrastructures-research": "./styles/c01.json.gz",
    "international-journal-of-sports-medicine": "./styles/c02.json.gz",
    "international-journal-of-urban-and-regional-research": "./styles/c03.json.gz",
    "international-journal-of-wildland-fire": "./styles/c04.json.gz",
    "international-microbiology": "./styles/c05.json.gz",
    "international-organization": "./styles/c06.json.gz",
    "international-pig-veterinary-society-congress-proceedings": "./styles/c07.json.gz",
    "international-relations": "./styles/c08.json.gz",
    "international-review-of-the-red-cross": "./styles/c09.json.gz",
    "international-security": "./styles/c10.json.gz",
    "international-studies-association": "./styles/c11.json.gz",
    "international-union-of-crystallography": "./styles/c12.json.gz",
    "international-union-of-forest-research-organizations-headquarters": "./styles/c13.json.gz",
    "internet-archaeology": "./styles/c14.json.gz",
    "interpreting": "./styles/c15.json.gz",
    "inventaire-general-du-patrimoine-culturel-iso-690-full-note-with-ibid": "./styles/c16.json.gz",
    "inventaire-general-du-patrimoine-culturel-iso-690-full-note": "./styles/c17.json.gz",
    "inventaire-general-du-patrimoine-culturel-iso-690-note": "./styles/c18.json.gz",
    "invertebrate-biology": "./styles/c19.json.gz",
    "investigative-radiology": "./styles/c20.json.gz",
    "invisu": "./styles/c21.json.gz",
    "ios-press-books": "./styles/c22.json.gz",
    "ipag-business-school-apa": "./styles/c23.json.gz",
    "iran-manual-of-style": "./styles/c24.json.gz",
    "iranian-journal-of-basic-medical-sciences": "./styles/c25.json.gz",
    "iranian-journal-of-pharmaceutical-research": "./styles/c01.json.gz",
    "irish-historical-studies": "./styles/c02.json.gz",
    "isabella-stewart-gardner-museum": "./styles/c03.json.gz",
    "isara-iso-690": "./styles/c04.json.gz",
    "isnad-dipnotlu": "./styles/c05.json.gz",
    "isnad-metinici": "./styles/c06.json.gz",
    "isnad": "./styles/c07.json.gz",
    "iso690-author-date-cat": "./styles/c08.json.gz",
    "iso690-author-date-cs": "./styles/c09.json.gz",
    "iso690-author-date-de": "./styles/c10.json.gz",
    "iso690-author-date-en": "./styles/c11.json.gz",
    "iso690-author-date-es": "./styles/c12.json.gz",
    "iso690-author-date-fr-no-abstract": "./styles/c13.json.gz",
    "iso690-author-date-fr": "./styles/c14.json.gz",
    "iso690-author-date-pt-br": "./styles/c15.json.gz",
    "iso690-author-date-sk": "./styles/c16.json.gz",
    "iso690-full-note-cs": "./styles/c17.json.gz",
    "iso690-full-note-en": "./styles/c18.json.gz",
    "iso690-full-note-es": "./styles/c19.json.gz",
    "iso690-full-note-sk": "./styles/c20.json.gz",
    "iso690-full-note-with-ibid-ro": "./styles/c21.json.gz",
    "iso690-note-cs": "./styles/c22.json.gz",
    "iso690-note-fr": "./styles/c23.json.gz",
    "iso690-numeric-brackets-cs": "./styles/c24.json.gz",
    "iso690-numeric-cat": "./styles/c25.json.gz",
    "iso690-numeric-cs": "./styles/c01.json.gz",
    "iso690-numeric-en": "./styles/c02.json.gz",
    "iso690-numeric-fr": "./styles/c03.json.gz",
    "iso690-numeric-lt": "./styles/c04.json.gz",
    "iso690-numeric-sk": "./styles/c05.json.gz",
    "israel-medical-association-journal": "./styles/c06.json.gz",
    "istanbul-bilgi-universitesi-lisansustu-programlar-enstitusu-hukuk": "./styles/c07.json.gz",
    "istanbul-medical-journal": "./styles/c08.json.gz",
    "istanbul-universitesi-sosyal-bilimler-enstitusu": "./styles/c09.json.gz",
    "istanus-journal-on-applied-and-biological-sciences": "./styles/c10.json.gz",
    "italian-journal-of-agronomy": "./styles/c11.json.gz",
    "italus-hortus": "./styles/c12.json.gz",
    "ithaque": "./styles/c13.json.gz",
    "iubmb-life": "./styles/c14.json.gz",
    "ius-ecclesiae": "./styles/c15.json.gz",
    "izmir-katip-celebi-universitesi-sosyal-bilimler-enstitusu": "./styles/c16.json.gz",
    "jacc-cardiovascular-imaging": "./styles/c17.json.gz",
    "jacc-cardiovascular-interventions": "./styles/c18.json.gz",
    "jahrbuch-der-osterreichischen-byzantinischen-gesellschaft": "./styles/c19.json.gz",
    "jahrbuch-fur-evangelikale-theologie": "./styles/c20.json.gz",
    "japanese-journal-of-applied-physics": "./styles/c21.json.gz",
    "javnost-the-public": "./styles/c22.json.gz",
    "jbi-evidence-synthesis": "./styles/c23.json.gz",
    "jcom-journal-of-science-communication": "./styles/c24.json.gz",
    "john-benjamins-publishing-company-iconicity-in-language-and-literature": "./styles/c25.json.gz",
    "john-benjamins-publishing-company-linguistik-aktuell-linguistics-today": "./styles/c01.json.gz",
    "johnson-matthey-technology-review": "./styles/c02.json.gz",
    "journal-and-proceedings-of-the-royal-society-of-new-south-wales": "./styles/c03.json.gz",
    "journal-de-la-societe-des-americanistes": "./styles/c04.json.gz",
    "journal-de-la-societe-des-oceanistes": "./styles/c05.json.gz",
    "journal-der-deutschen-dermatologischen-gesellschaft": "./styles/c06.json.gz",
    "journal-for-the-history-of-astronomy": "./styles/c07.json.gz",
    "journal-for-the-study-of-the-new-testament": "./styles/c08.json.gz",
    "journal-for-veterinary-medicine-biotechnology-and-biosafety": "./styles/c09.json.gz",
    "journal-fur-kulturpflanzen-journal-of-cultivated-plants": "./styles/c10.json.gz",
    "journal-fur-kunstgeschichte": "./styles/c11.json.gz",
    "journal-fur-medienlinguistik": "./styles/c12.json.gz",
    "journal-of-accounting-research": "./styles/c13.json.gz",
    "journal-of-acoustics": "./styles/c14.json.gz",
    "journal-of-adolescent-health": "./styles/c15.json.gz",
    "journal-of-advanced-ceramics": "./styles/c16.json.gz",
    "journal-of-advertising-research": "./styles/c17.json.gz",
    "journal-of-agricultural-and-applied-economics": "./styles/c18.json.gz",
    "journal-of-agricultural-and-resource-economics": "./styles/c19.json.gz",
    "journal-of-alzheimers-disease": "./styles/c20.json.gz",
    "journal-of-anatomy": "./styles/c21.json.gz",
    "journal-of-animal-and-feed-sciences": "./styles/c22.json.gz",
    "journal-of-animal-physiology-and-animal-nutrition": "./styles/c23.json.gz",
    "journal-of-animal-science": "./styles/c24.json.gz",
    "journal-of-antimicrobial-chemotherapy": "./styles/c25.json.gz",
    "journal-of-aoac-international": "./styles/c01.json.gz",
    "journal-of-applied-animal-science": "./styles/c02.json.gz",
    "journal-of-applied-clinical-medical-physics": "./styles/c03.json.gz",
    "journal-of-applied-engineering-sciences-technology": "./styles/c04.json.gz",
    "journal-of-applied-entomology": "./styles/c05.json.gz",
    "journal-of-applied-glycoscience": "./styles/c06.json.gz",
    "journal-of-applied-pharmaceutical-research": "./styles/c07.json.gz",
    "journal-of-applied-philosophy": "./styles/c08.json.gz",
    "journal-of-applied-polymer-science": "./styles/c09.json.gz",
    "journal-of-archaeological-research": "./styles/c10.json.gz",
    "journal-of-atrial-fibrillation": "./styles/c11.json.gz",
    "journal-of-australian-strength-and-conditioning": "./styles/c12.json.gz",
    "journal-of-avian-biology": "./styles/c13.json.gz",
    "journal-of-basic-microbiology": "./styles/c14.json.gz",
    "journal-of-behavioral-health-and-psychology": "./styles/c15.json.gz",
    "journal-of-biological-chemistry": "./styles/c16.json.gz",
    "journal-of-biological-regulators-and-homeostatic-agents": "./styles/c17.json.gz",
    "journal-of-biomedical-materials-research-part-a": "./styles/c18.json.gz",
    "journal-of-bioscience-and-bioengineering": "./styles/c19.json.gz",
    "journal-of-biosciences": "./styles/c20.json.gz",
    "journal-of-bone-and-mineral-research": "./styles/c21.json.gz",
    "journal-of-brachial-plexus-and-peripheral-nerve-injury": "./styles/c22.json.gz",
    "journal-of-breast-cancer": "./styles/c23.json.gz",
    "journal-of-burn-care-and-research": "./styles/c24.json.gz",
    "journal-of-business-logistics": "./styles/c25.json.gz",
    "journal-of-cachexia-sarcopenia-and-muscle": "./styles/c01.json.gz",
    "journal-of-cardiothoracic-and-vascular-anesthesia": "./styles/c02.json.gz",
    "journal-of-cellular-and-molecular-medicine": "./styles/c03.json.gz",
    "journal-of-cellular-biochemistry": "./styles/c04.json.gz",
    "journal-of-chemistry-and-chemical-engineering": "./styles/c05.json.gz",
    "journal-of-chemometrics": "./styles/c06.json.gz",
    "journal-of-clinical-and-translational-science": "./styles/c07.json.gz",
    "journal-of-clinical-neurology": "./styles/c08.json.gz",
    "journal-of-clinical-neurophysiology": "./styles/c09.json.gz",
    "journal-of-clinical-oncology": "./styles/c10.json.gz",
    "journal-of-clinical-rheumatology": "./styles/c11.json.gz",
    "journal-of-clinical-sleep-medicine": "./styles/c12.json.gz",
    "journal-of-combinatorics": "./styles/c13.json.gz",
    "journal-of-common-market-studies": "./styles/c14.json.gz",
    "journal-of-comparative-pathology": "./styles/c15.json.gz",
    "journal-of-computational-chemistry": "./styles/c16.json.gz",
    "journal-of-computer-applications-in-archaeology": "./styles/c17.json.gz",
    "journal-of-computer-assisted-tomography": "./styles/c18.json.gz",
    "journal-of-computer-information-systems": "./styles/c19.json.gz",
    "journal-of-conchology": "./styles/c20.json.gz",
    "journal-of-consumer-research": "./styles/c21.json.gz",
    "journal-of-contemporary-medicine": "./styles/c22.json.gz",
    "journal-of-contemporary-water-research-and-education": "./styles/c23.json.gz",
    "journal-of-crohns-and-colitis-supplements": "./styles/c24.json.gz",
    "journal-of-crohns-and-colitis": "./styles/c25.json.gz",
    "journal-of-dairy-research": "./styles/c01.json.gz",
    "journal-of-dairy-science": "./styles/c02.json.gz",
    "journal-of-demographic-economics": "./styles/c03.json.gz",
    "journal-of-dental-research": "./styles/c04.json.gz",
    "journal-of-dental-traumatology": "./styles/c05.json.gz",
    "journal-of-early-christian-studies": "./styles/c06.json.gz",
    "journal-of-economic-impact": "./styles/c07.json.gz",
    "journal-of-egyptian-history": "./styles/c08.json.gz",
    "journal-of-elections-public-opinion-and-parties": "./styles/c09.json.gz",
    "journal-of-emerging-investigators": "./styles/c10.json.gz",
    "journal-of-endodontics": "./styles/c11.json.gz",
    "journal-of-environmental-science-and-health-part-b": "./styles/c12.json.gz",
    "journal-of-ethnobiology": "./styles/c13.json.gz",
    "journal-of-european-public-policy": "./styles/c14.json.gz",
    "journal-of-evolution-and-health": "./styles/c15.json.gz",
    "journal-of-evolutionary-biology": "./styles/c16.json.gz",
    "journal-of-experimental-botany": "./styles/c17.json.gz",
    "journal-of-field-ornithology": "./styles/c18.json.gz",
    "journal-of-finance": "./styles/c19.json.gz",
    "journal-of-financial-and-quantitative-analysis": "./styles/c20.json.gz",
    "journal-of-fish-biology": "./styles/c21.json.gz",
    "journal-of-food-protection": "./styles/c22.json.gz",
    "journal-of-foraminiferal-research": "./styles/c23.json.gz",
    "journal-of-forensic-sciences": "./styles/c24.json.gz",
    "journal-of-frailty-and-aging": "./styles/c25.json.gz",
    "journal-of-geriatric-psychiatry-and-neurology": "./styles/c01.json.gz",
    "journal-of-glaciology": "./styles/c02.json.gz",
    "journal-of-global-health": "./styles/c03.json.gz",
    "journal-of-hazardous-materials": "./styles/c04.json.gz",
    "journal-of-health-care-for-the-poor-and-underserved": "./styles/c05.json.gz",
    "journal-of-hearing-science": "./styles/c06.json.gz",
    "journal-of-historical-linguistics": "./styles/c07.json.gz",
    "journal-of-human-evolution": "./styles/c08.json.gz",
    "journal-of-human-nutrition-and-dietetics": "./styles/c09.json.gz",
    "journal-of-human-rights": "./styles/c10.json.gz",
    "journal-of-hypertension": "./styles/c11.json.gz",
    "journal-of-industrial-and-engineering-chemistry": "./styles/c12.json.gz",
    "journal-of-industrial-ecology": "./styles/c13.json.gz",
    "journal-of-infection": "./styles/c14.json.gz",
    "journal-of-infectious-diseases": "./styles/c15.json.gz",
    "journal-of-information-technology": "./styles/c16.json.gz",
    "journal-of-innovation-economics-and-management": "./styles/c17.json.gz",
    "journal-of-institutional-and-theoretical-economics": "./styles/c18.json.gz",
    "journal-of-instrumentation": "./styles/c19.json.gz",
    "journal-of-integrated-omics": "./styles/c20.json.gz",
    "journal-of-interactive-marketing": "./styles/c21.json.gz",
    "journal-of-interactive-media-in-education-harvard": "./styles/c22.json.gz",
    "journal-of-intercultural-studies": "./styles/c23.json.gz",
    "journal-of-internal-medicine": "./styles/c24.json.gz",
    "journal-of-international-business-studies": "./styles/c25.json.gz",
    "journal-of-international-peacekeeping": "./styles/c01.json.gz",
    "journal-of-international-relations-and-development": "./styles/c02.json.gz",
    "journal-of-investigative-dermatology": "./styles/c03.json.gz",
    "journal-of-jewish-studies": "./styles/c04.json.gz",
    "journal-of-juridical-sciences": "./styles/c05.json.gz",
    "journal-of-korean-neurosurgical-society": "./styles/c06.json.gz",
    "journal-of-law-medicine-ethics": "./styles/c07.json.gz",
    "journal-of-leukocyte-biology": "./styles/c08.json.gz",
    "journal-of-limnology": "./styles/c09.json.gz",
    "journal-of-linguistics": "./styles/c10.json.gz",
    "journal-of-lipid-research": "./styles/c11.json.gz",
    "journal-of-lithic-studies": "./styles/c12.json.gz",
    "journal-of-magnetic-resonance-imaging": "./styles/c13.json.gz",
    "journal-of-mammalogy": "./styles/c14.json.gz",
    "journal-of-management-information-systems": "./styles/c15.json.gz",
    "journal-of-management-studies": "./styles/c16.json.gz",
    "journal-of-management": "./styles/c17.json.gz",
    "journal-of-materials-research": "./styles/c18.json.gz",
    "journal-of-mechanical-science-and-technology": "./styles/c19.json.gz",
    "journal-of-medical-genetics": "./styles/c20.json.gz",
    "journal-of-medical-internet-research": "./styles/c21.json.gz",
    "journal-of-microbiology-and-biotechnology": "./styles/c22.json.gz",
    "journal-of-microbiology": "./styles/c23.json.gz",
    "journal-of-microscopy": "./styles/c24.json.gz",
    "journal-of-midwifery-science": "./styles/c25.json.gz",
    "journal-of-minimally-invasive-gynecology": "./styles/c01.json.gz",
    "journal-of-molecular-cell-biology": "./styles/c02.json.gz",
    "journal-of-molecular-endocrinology": "./styles/c03.json.gz",
    "journal-of-molecular-recognition": "./styles/c04.json.gz",
    "journal-of-molecular-signaling": "./styles/c05.json.gz",
    "journal-of-move-and-therapeutic-science": "./styles/c06.json.gz",
    "journal-of-multidisciplinary-applied-natural-science": "./styles/c07.json.gz",
    "journal-of-musculoskeletal-research": "./styles/c08.json.gz",
    "journal-of-music-technology-and-education": "./styles/c09.json.gz",
    "journal-of-nanoscience-and-nanotechnology": "./styles/c10.json.gz",
    "journal-of-natural-history": "./styles/c11.json.gz",
    "journal-of-neolithic-archaeology": "./styles/c12.json.gz",
    "journal-of-neurochemistry": "./styles/c13.json.gz",
    "journal-of-neuroendocrinology": "./styles/c14.json.gz",
    "journal-of-neuroimaging": "./styles/c15.json.gz",
    "journal-of-neurological-disorders": "./styles/c16.json.gz",
    "journal-of-neurophysiology": "./styles/c17.json.gz",
    "journal-of-neuroscience-and-neuroengineering": "./styles/c18.json.gz",
    "journal-of-new-zealand-grasslands": "./styles/c19.json.gz",
    "journal-of-nutrition": "./styles/c20.json.gz",
    "journal-of-obstetrics-and-gynaecology-canada": "./styles/c21.json.gz",
    "journal-of-occupational-and-environmental-medicine": "./styles/c22.json.gz",
    "journal-of-oil-palm-research": "./styles/c23.json.gz",
    "journal-of-open-research-software": "./styles/c24.json.gz",
    "journal-of-oral-and-maxillofacial-surgery": "./styles/c25.json.gz",
    "journal-of-orthopaedic-research": "./styles/c01.json.gz",
    "journal-of-orthopaedic-trauma": "./styles/c02.json.gz",
    "journal-of-orthopaedics-trauma-and-rehabilitation": "./styles/c03.json.gz",
    "journal-of-pain-and-symptom-management": "./styles/c04.json.gz",
    "journal-of-paleontology": "./styles/c05.json.gz",
    "journal-of-peace-research": "./styles/c06.json.gz",
    "journal-of-pediatric-gastroenterology-and-nutrition": "./styles/c07.json.gz",
    "journal-of-pediatric-surgery": "./styles/c08.json.gz",
    "journal-of-peptide-science": "./styles/c09.json.gz",
    "journal-of-perinatal-medicine": "./styles/c10.json.gz",
    "journal-of-periodontal-research": "./styles/c11.json.gz",
    "journal-of-pharmacy-and-pharmacology": "./styles/c12.json.gz",
    "journal-of-phycology": "./styles/c13.json.gz",
    "journal-of-physical-therapy-science": "./styles/c14.json.gz",
    "journal-of-plankton-research": "./styles/c15.json.gz",
    "journal-of-plant-ecology": "./styles/c16.json.gz",
    "journal-of-plant-nutrition-and-soil-science": "./styles/c17.json.gz",
    "journal-of-plant-protection-research": "./styles/c18.json.gz",
    "journal-of-political-ideologies": "./styles/c19.json.gz",
    "journal-of-political-philosophy": "./styles/c20.json.gz",
    "journal-of-pollination-ecology": "./styles/c21.json.gz",
    "journal-of-polymer-science-part-a-polymer-chemistry": "./styles/c22.json.gz",
    "journal-of-porphyrins-and-phthalocyanines": "./styles/c23.json.gz",
    "journal-of-product-innovation-management": "./styles/c24.json.gz",
    "journal-of-prosthodontics": "./styles/c25.json.gz",
    "journal-of-psychiatric-and-mental-health-nursing": "./styles/c01.json.gz",
    "journal-of-psychiatry-and-neuroscience": "./styles/c02.json.gz",
    "journal-of-raman-spectroscopy": "./styles/c03.json.gz",
    "journal-of-reconstructive-microsurgery": "./styles/c04.json.gz",
    "journal-of-refugee-studies": "./styles/c05.json.gz",
    "journal-of-rehabilitation-medicine": "./styles/c06.json.gz",
    "journal-of-remote-sensing": "./styles/c07.json.gz",
    "journal-of-retailing": "./styles/c08.json.gz",
    "journal-of-rheumatology": "./styles/c09.json.gz",
    "journal-of-roman-archaeology-a": "./styles/c10.json.gz",
    "journal-of-roman-archaeology-b": "./styles/c11.json.gz",
    "journal-of-science-and-medicine-in-sport": "./styles/c12.json.gz",
    "journal-of-separation-science": "./styles/c13.json.gz",
    "journal-of-shoulder-and-elbow-surgery": "./styles/c14.json.gz",
    "journal-of-simulation": "./styles/c15.json.gz",
    "journal-of-sleep-research": "./styles/c16.json.gz",
    "journal-of-small-animal-practice": "./styles/c17.json.gz",
    "journal-of-small-business-management": "./styles/c18.json.gz",
    "journal-of-social-archaeology": "./styles/c19.json.gz",
    "journal-of-social-philosophy": "./styles/c20.json.gz",
    "journal-of-soil-and-water-conservation": "./styles/c21.json.gz",
    "journal-of-soil-science-and-plant-nutrition": "./styles/c22.json.gz",
    "journal-of-sport-and-health-science": "./styles/c23.json.gz",
    "journal-of-sports-science-and-medicine": "./styles/c24.json.gz",
    "journal-of-strength-and-conditioning-research": "./styles/c25.json.gz",
    "journal-of-stroke": "./styles/c01.json.gz",
    "journal-of-structural-geology": "./styles/c02.json.gz",
    "journal-of-studies-on-alcohol-and-drugs": "./styles/c03.json.gz",
    "journal-of-surgery-and-medicine": "./styles/c04.json.gz",
    "journal-of-surgical-oncology": "./styles/c05.json.gz",
    "journal-of-systematic-palaeontology": "./styles/c06.json.gz",
    "journal-of-systematics-and-evolution": "./styles/c07.json.gz",
    "journal-of-the-air-and-waste-management-association": "./styles/c08.json.gz",
    "journal-of-the-american-academy-of-audiology": "./styles/c09.json.gz",
    "journal-of-the-american-academy-of-orthopaedic-surgeons": "./styles/c10.json.gz",
    "journal-of-the-american-animal-hospital-association": "./styles/c11.json.gz",
    "journal-of-the-american-association-of-laboratory-animal-science": "./styles/c12.json.gz",
    "journal-of-the-american-ceramic-society": "./styles/c13.json.gz",
    "journal-of-the-american-college-of-cardiology": "./styles/c14.json.gz",
    "journal-of-the-american-college-of-surgeons": "./styles/c15.json.gz",
    "journal-of-the-american-heart-association": "./styles/c16.json.gz",
    "journal-of-the-american-philosophical-association": "./styles/c17.json.gz",
    "journal-of-the-american-society-of-brewing-chemists": "./styles/c18.json.gz",
    "journal-of-the-american-society-of-nephrology": "./styles/c19.json.gz",
    "journal-of-the-american-water-resources-association": "./styles/c20.json.gz",
    "journal-of-the-association-for-information-systems": "./styles/c21.json.gz",
    "journal-of-the-association-of-environmental-and-resource-economists": "./styles/c22.json.gz",
    "journal-of-the-botanical-research-institute-of-texas": "./styles/c23.json.gz",
    "journal-of-the-brazilian-chemical-society": "./styles/c24.json.gz",
    "journal-of-the-electrochemical-society": "./styles/c25.json.gz",
    "journal-of-the-european-academy-of-dermatology-and-venereology": "./styles/c01.json.gz",
    "journal-of-the-history-of-collections": "./styles/c02.json.gz",
    "journal-of-the-indian-law-institute": "./styles/c03.json.gz",
    "journal-of-the-korean-society-of-civil-engineers": "./styles/c04.json.gz",
    "journal-of-the-marine-biological-association-of-the-united-kingdom": "./styles/c05.json.gz",
    "journal-of-the-royal-anthropological-institute": "./styles/c06.json.gz",
    "journal-of-the-royal-society-of-western-australia": "./styles/c07.json.gz",
    "journal-of-the-royal-statistical-society": "./styles/c08.json.gz",
    "journal-of-the-science-of-food-and-agriculture": "./styles/c09.json.gz",
    "journal-of-the-serbian-chemical-society": "./styles/c10.json.gz",
    "journal-of-the-warburg-and-courtauld-institutes": "./styles/c11.json.gz",
    "journal-of-thermal-spray-technology": "./styles/c12.json.gz",
    "journal-of-threatened-taxa": "./styles/c13.json.gz",
    "journal-of-thrombosis-and-haemostasis": "./styles/c14.json.gz",
    "journal-of-tropical-ecology": "./styles/c15.json.gz",
    "journal-of-tropical-life-science": "./styles/c16.json.gz",
    "journal-of-universal-computer-science": "./styles/c17.json.gz",
    "journal-of-urban-and-environmental-engineering": "./styles/c18.json.gz",
    "journal-of-urban-technology": "./styles/c19.json.gz",
    "journal-of-value-inquiry": "./styles/c20.json.gz",
    "journal-of-vegetation-science": "./styles/c21.json.gz",
    "journal-of-vertebrate-biology": "./styles/c22.json.gz",
    "journal-of-vertebrate-paleontology": "./styles/c23.json.gz",
    "journal-of-vestibular-research": "./styles/c24.json.gz",
    "journal-of-veterinary-diagnostic-investigation": "./styles/c25.json.gz",
    "journal-of-visualized-experiments": "./styles/c01.json.gz",
    "journal-of-water-sanitation-and-hygiene-for-development": "./styles/c02.json.gz",
    "journal-of-wildlife-diseases": "./styles/c03.json.gz",
    "journal-of-zoo-and-wildlife-medicine": "./styles/c04.json.gz",
    "journal-of-zoo-biology": "./styles/c05.json.gz",
    "journal-of-zoology": "./styles/c06.json.gz",
    "journal-on-efficiency-and-responsibility-in-education-and-science": "./styles/c07.json.gz",
    "journalistica": "./styles/c08.json.gz",
    "jurisprudence": "./styles/c09.json.gz",
    "juristische-schulung": "./styles/c10.json.gz",
    "juristische-zitierweise-offentliches-recht": "./styles/c11.json.gz",
    "juristische-zitierweise-schweizer": "./styles/c12.json.gz",
    "juristische-zitierweise": "./styles/c13.json.gz",
    "jurnal-ilmu-dan-teknologi-hasil-ternak": "./styles/c14.json.gz",
    "jurnal-pangan-dan-agroindustri": "./styles/c15.json.gz",
    "jurnal-sains-farmasi-dan-klinis": "./styles/c16.json.gz",
    "jurnal-teknik-mesin-indonesia": "./styles/c17.json.gz",
    "jyvaskylan-yliopisto-kemian-laitos": "./styles/c18.json.gz",
    "karabuk-university-graduate-school-of-natural-and-applied-sciences": "./styles/c19.json.gz",
    "karger-journals-author-date": "./styles/c20.json.gz",
    "karger-journals": "./styles/c21.json.gz",
    "karlstad-universitet-harvard": "./styles/c22.json.gz",
    "karstenia": "./styles/c23.json.gz",
    "keel-ja-kirjandus": "./styles/c24.json.gz",
    "keele-university-school-of-allied-health-professions": "./styles/c25.json.gz",
    "kidney-research-and-clinical-practice": "./styles/c01.json.gz",
    "kindheit-und-entwicklung": "./styles/c02.json.gz",
    "kit-karlsruher-institut-fur-technologie-germanistik-ndl-neuere-deutsche-literaturwissenschaft": "./styles/c03.json.gz",
    "klinische-padiatrie": "./styles/c04.json.gz",
    "knee-surgery-and-related-research": "./styles/c05.json.gz",
    "knee-surgery-sports-traumatology-arthroscopy": "./styles/c06.json.gz",
    "knowledge-and-management-of-aquatic-ecosystems": "./styles/c07.json.gz",
    "kolner-zeitschrift-fur-soziologie-und-sozialpsychologie": "./styles/c08.json.gz",
    "kommunikation-und-recht": "./styles/c09.json.gz",
    "kona-powder-and-particle-journal": "./styles/c10.json.gz",
    "korean-journal-of-anesthesiology": "./styles/c11.json.gz",
    "korean-journal-of-radiology": "./styles/c12.json.gz",
    "kritische-ausgabe": "./styles/c13.json.gz",
    "ksce-journal-of-civil-engineering": "./styles/c14.json.gz",
    "kth-royal-institute-of-technology-school-of-computer-science-and-communication-sv": "./styles/c15.json.gz",
    "kth-royal-institute-of-technology-school-of-computer-science-and-communication": "./styles/c16.json.gz",
    "kunstakademie-munster": "./styles/c17.json.gz",
    "l-homme-english": "./styles/c18.json.gz",
    "l-homme": "./styles/c19.json.gz",
    "la-nouvelle-revue-du-travail": "./styles/c20.json.gz",
    "la-revue-des-sciences-de-gestion": "./styles/c21.json.gz",
    "la-trobe-university-apa": "./styles/c22.json.gz",
    "la-trobe-university-harvard": "./styles/c23.json.gz",
    "laboratory-animal-science-professional": "./styles/c24.json.gz",
    "lancaster-university-harvard": "./styles/c25.json.gz",
    "land-degradation-and-development": "./styles/c01.json.gz",
    "landes-bioscience-journals": "./styles/c02.json.gz",
    "language-in-society": "./styles/c03.json.gz",
    "language": "./styles/c04.json.gz",
    "lannee-sociologique": "./styles/c05.json.gz",
    "latin-american-perspectives": "./styles/c06.json.gz",
    "latin-american-research-review": "./styles/c07.json.gz",
    "lauterbornia": "./styles/c08.json.gz",
    "law-and-society-review": "./styles/c09.json.gz",
    "law-citation-manual": "./styles/c10.json.gz",
    "law-technology-and-humans": "./styles/c11.json.gz",
    "lcgc": "./styles/c12.json.gz",
    "le-mouvement-social": "./styles/c13.json.gz",
    "le-tapuscrit-author-date": "./styles/c14.json.gz",
    "le-tapuscrit-note": "./styles/c15.json.gz",
    "leiden-journal-of-international-law": "./styles/c16.json.gz",
    "leidraad-voor-juridische-auteurs": "./styles/c17.json.gz",
    "leonardo": "./styles/c18.json.gz",
    "les-cahiers-du-journalisme": "./styles/c19.json.gz",
    "les-journees-de-la-recherche-avicole": "./styles/c20.json.gz",
    "les-journees-de-la-recherche-porcine": "./styles/c21.json.gz",
    "les-mondes-du-travail": "./styles/c22.json.gz",
    "les-nouvelles-de-l-archeologie": "./styles/c23.json.gz",
    "lethaia": "./styles/c24.json.gz",
    "letters-in-applied-microbiology": "./styles/c25.json.gz",
    "lettres-et-sciences-humaines-fr": "./styles/c01.json.gz",
    "leuphana-universitaet-lueneburg-institut-fuer-produktionstechnik-und-systeme": "./styles/c02.json.gz",
    "leviathan": "./styles/c03.json.gz",
    "lien-social-et-politiques": "./styles/c04.json.gz",
    "life-science-alliance": "./styles/c05.json.gz",
    "limnetica": "./styles/c06.json.gz",
    "limnology-and-oceanography": "./styles/c07.json.gz",
    "linguistica-uralica": "./styles/c08.json.gz",
    "literatura": "./styles/c09.json.gz",
    "liver-international": "./styles/c10.json.gz",
    "liverpool-john-moores-university-harvard": "./styles/c11.json.gz",
    "lluelles-no-ibid": "./styles/c12.json.gz",
    "lluelles": "./styles/c13.json.gz",
    "london-review-of-international-law": "./styles/c14.json.gz",
    "london-south-bank-university-numeric": "./styles/c15.json.gz",
    "lund-university-school-of-economics-and-management": "./styles/c16.json.gz",
    "macromolecular-reaction-engineering": "./styles/c17.json.gz",
    "magnetic-resonance-in-medical-sciences": "./styles/c18.json.gz",
    "magnetic-resonance-materials-in-physics-biology-and-medicine": "./styles/c19.json.gz",
    "maison-de-l-orient-et-de-la-mediterranee-en": "./styles/c20.json.gz",
    "maison-de-l-orient-et-de-la-mediterranee": "./styles/c21.json.gz",
    "malaysian-orthopaedic-journal": "./styles/c22.json.gz",
    "mammal-review": "./styles/c23.json.gz",
    "mammalia": "./styles/c24.json.gz",
    "mammalogy-notes": "./styles/c25.json.gz",
    "management-et-avenir": "./styles/c01.json.gz",
    "management-international": "./styles/c02.json.gz",
    "management-of-biological-invasions": "./styles/c03.json.gz",
    "manchester-university-press-author-date": "./styles/c04.json.gz",
    "manchester-university-press": "./styles/c05.json.gz",
    "marine-biology": "./styles/c06.json.gz",
    "marine-mammal-science": "./styles/c07.json.gz",
    "marine-ornithology": "./styles/c08.json.gz",
    "marine-turtle-newsletter": "./styles/c09.json.gz",
    "marmara-universitesi-turkiyat-arastirmalari-enstitusu": "./styles/c10.json.gz",
    "mary-ann-liebert-harvard": "./styles/c11.json.gz",
    "mary-ann-liebert-vancouver": "./styles/c12.json.gz",
    "masarykova-univerzita-pravnicka-fakulta": "./styles/c13.json.gz",
    "mastozoologia-neotropical": "./styles/c14.json.gz",
    "materials-express": "./styles/c15.json.gz",
    "mathematical-geosciences": "./styles/c16.json.gz",
    "mathematics-and-computers-in-simulation": "./styles/c17.json.gz",
    "mcdonald-institute-monographs": "./styles/c18.json.gz",
    "mcgill-en": "./styles/c19.json.gz",
    "mcgill-fr": "./styles/c20.json.gz",
    "medecine-intensive-reanimation": "./styles/c21.json.gz",
    "medecine-sciences": "./styles/c22.json.gz",
    "media-culture-and-society": "./styles/c23.json.gz",
    "medical-dosimetry": "./styles/c24.json.gz",
    "medical-education-and-clinical-practice": "./styles/c25.json.gz",
    "medical-history": "./styles/c01.json.gz",
    "medicina-clinica": "./styles/c02.json.gz",
    "medicina-delle-dipendenze-italian-journal-of-the-addictions": "./styles/c03.json.gz",
    "medicinal-research-reviews": "./styles/c04.json.gz",
    "medicine-and-science-in-sports-and-exercise": "./styles/c05.json.gz",
    "medicine-publishing": "./styles/c06.json.gz",
    "medicinski-razgledi": "./styles/c07.json.gz",
    "medicinskiy-akademicheskiy-zhurnal": "./styles/c08.json.gz",
    "mediterranean-journal-of-chemistry": "./styles/c09.json.gz",
    "mediterranean-journal-of-infection-microbes-and-antimicrobials": "./styles/c10.json.gz",
    "mediterranean-politics": "./styles/c11.json.gz",
    "medizinische-hochschule-hannover": "./styles/c12.json.gz",
    "medizinische-universitat-innsbruck-vancouver": "./styles/c13.json.gz",
    "melanges-de-linstitut-dominicain-detudes-orientales-en": "./styles/c14.json.gz",
    "melanges-de-linstitut-dominicain-detudes-orientales-fr": "./styles/c15.json.gz",
    "melbourne-school-of-theology": "./styles/c16.json.gz",
    "memorias-do-instituto-oswaldo-cruz": "./styles/c17.json.gz",
    "mercator-institut-fur-sprachforderung-und-deutsch-als-zweitsprache": "./styles/c18.json.gz",
    "mercatus-center": "./styles/c19.json.gz",
    "meta": "./styles/c20.json.gz",
    "metaaltijden": "./styles/c21.json.gz",
    "metallurgical-and-materials-transactions-a": "./styles/c22.json.gz",
    "metallurgical-and-materials-transactions": "./styles/c23.json.gz",
    "meteoritics-and-planetary-science": "./styles/c24.json.gz",
    "meteorological-applications": "./styles/c25.json.gz",
    "method-and-theory-in-the-study-of-religion": "./styles/c01.json.gz",
    "methods-of-information-in-medicine": "./styles/c02.json.gz",
    "metropol-verlag": "./styles/c03.json.gz",
    "metropolia-university-of-applied-sciences-harvard-english": "./styles/c04.json.gz",
    "metropolia-university-of-applied-sciences-harvard": "./styles/c05.json.gz",
    "metropolitiques": "./styles/c06.json.gz",
    "mexicon": "./styles/c07.json.gz",
    "mhra-author-date-no-url": "./styles/c08.json.gz",
    "mhra-author-date-publisher-place-no-url": "./styles/c09.json.gz",
    "mhra-author-date-publisher-place": "./styles/c10.json.gz",
    "mhra-author-date": "./styles/c11.json.gz",
    "mhra-notes-no-url": "./styles/c12.json.gz",
    "mhra-notes-publisher-place-no-url": "./styles/c13.json.gz",
    "mhra-notes-publisher-place": "./styles/c14.json.gz",
    "mhra-notes-subsequent-ibid-no-url": "./styles/c15.json.gz",
    "mhra-notes-subsequent-ibid": "./styles/c16.json.gz",
    "mhra-notes": "./styles/c17.json.gz",
    "mhra-shortened-notes-no-url": "./styles/c18.json.gz",
    "mhra-shortened-notes-publisher-place-no-url": "./styles/c19.json.gz",
    "mhra-shortened-notes-publisher-place": "./styles/c20.json.gz",
    "mhra-shortened-notes": "./styles/c21.json.gz",
    "microbial-cell": "./styles/c22.json.gz",
    "microbiology-society": "./styles/c23.json.gz",
    "microbiome-research-reports": "./styles/c24.json.gz",
    "microcirculation": "./styles/c25.json.gz",
    "microscopy-and-microanalysis": "./styles/c01.json.gz",
    "middle-east-critique": "./styles/c02.json.gz",
    "midwestern-baptist-theological-seminary": "./styles/c03.json.gz",
    "mimbar-hukum": "./styles/c04.json.gz",
    "mimesis-edizioni": "./styles/c05.json.gz",
    "mind-and-language": "./styles/c06.json.gz",
    "mineralogical-magazine": "./styles/c07.json.gz",
    "mis-quarterly": "./styles/c08.json.gz",
    "modern-chinese-literature-and-culture": "./styles/c09.json.gz",
    "modern-language-association-annotated-bibliography": "./styles/c10.json.gz",
    "modern-language-association-no-url": "./styles/c11.json.gz",
    "modern-language-association-notes-no-url": "./styles/c12.json.gz",
    "modern-language-association-notes": "./styles/c13.json.gz",
    "modern-language-association": "./styles/c14.json.gz",
    "modern-pathology": "./styles/c15.json.gz",
    "modern-phytomorphology": "./styles/c16.json.gz",
    "mohr-siebeck-recht": "./styles/c17.json.gz",
    "molecular-and-cellular-proteomics": "./styles/c18.json.gz",
    "molecular-biology-and-evolution": "./styles/c19.json.gz",
    "molecular-biology-of-the-cell": "./styles/c20.json.gz",
    "molecular-biology": "./styles/c21.json.gz",
    "molecular-metabolism": "./styles/c22.json.gz",
    "molecular-microbiology": "./styles/c23.json.gz",
    "molecular-nutrition-and-food-research": "./styles/c24.json.gz",
    "molecular-oncology": "./styles/c25.json.gz",
    "molecular-plant-microbe-interactions": "./styles/c01.json.gz",
    "molecular-plant-pathology": "./styles/c02.json.gz",
    "molecular-plant": "./styles/c03.json.gz",
    "molecular-psychiatry-letters": "./styles/c04.json.gz",
    "molecular-psychiatry": "./styles/c05.json.gz",
    "monash-university-csiro": "./styles/c06.json.gz",
    "mondes-en-developpement": "./styles/c07.json.gz",
    "monographs-of-the-palaeontographical-society": "./styles/c08.json.gz",
    "moorlands-college": "./styles/c09.json.gz",
    "mots": "./styles/c10.json.gz",
    "movement-disorders": "./styles/c11.json.gz",
    "mrs-bulletin": "./styles/c12.json.gz",
    "multidisciplinary-digital-publishing-institute": "./styles/c13.json.gz",
    "multilingual-matters": "./styles/c14.json.gz",
    "multimed": "./styles/c15.json.gz",
    "multiple-sclerosis-journal": "./styles/c16.json.gz",
    "muscle-and-nerve": "./styles/c17.json.gz",
    "museum-national-dhistoire-naturelle": "./styles/c18.json.gz",
    "mutagenesis": "./styles/c19.json.gz",
    "mycobiology": "./styles/c20.json.gz",
    "mycologia": "./styles/c21.json.gz",
    "myrmecological-news": "./styles/c22.json.gz",
    "nano-biomedicine-and-engineering": "./styles/c23.json.gz",
    "natbib-plainnat-author-date": "./styles/c24.json.gz",
    "national-archives-of-australia": "./styles/c25.json.gz",
    "national-institute-of-health-research": "./styles/c01.json.gz",
    "national-institute-of-organisation-dynamics-australia-harvard": "./styles/c02.json.gz",
    "national-institute-of-technology-karnataka": "./styles/c03.json.gz",
    "national-institute-of-technology-tiruchirappalli": "./styles/c04.json.gz",
    "national-marine-fisheries-service-national-environmental-policy-act": "./styles/c05.json.gz",
    "national-natural-science-foundation-of-china": "./styles/c06.json.gz",
    "national-science-foundation-grant-proposals": "./styles/c07.json.gz",
    "national-university-of-singapore-department-of-geography-harvard": "./styles/c08.json.gz",
    "nations-and-nationalism": "./styles/c09.json.gz",
    "natur-und-landschaft": "./styles/c10.json.gz",
    "natura-croatica": "./styles/c11.json.gz",
    "nature-brackets": "./styles/c12.json.gz",
    "nature-neuroscience-brief-communications": "./styles/c13.json.gz",
    "nature-no-et-al": "./styles/c14.json.gz",
    "nature-publishing-group-vancouver": "./styles/c15.json.gz",
    "nature": "./styles/c16.json.gz",
    "natures-sciences-societes": "./styles/c17.json.gz",
    "nauplius": "./styles/c18.json.gz",
    "navigation": "./styles/c19.json.gz",
    "nccr-mediality": "./styles/c20.json.gz",
    "necmettin-erbakan-universitesi-fen-ve-muhendislik-bilimleri-dergisi": "./styles/c21.json.gz",
    "nehet": "./styles/c22.json.gz",
    "nejm-catalyst-innovations-in-care-delivery": "./styles/c23.json.gz",
    "nephrology-dialysis-transplantation": "./styles/c24.json.gz",
    "netherlands-journal-of-geosciences-geologie-en-mijnbouw": "./styles/c25.json.gz",
    "neue-juristische-wochenschrift": "./styles/c01.json.gz",
    "neue-kriminalpolitik": "./styles/c02.json.gz",
    "neues-jahrbuch-fur-geologie-und-palaontologie": "./styles/c03.json.gz",
    "neural-plasticity": "./styles/c04.json.gz",
    "neuroendocrinology-letters": "./styles/c05.json.gz",
    "neuroimaging-clinics-of-north-america": "./styles/c06.json.gz",
    "neurologia-argentina": "./styles/c07.json.gz",
    "neurologia": "./styles/c08.json.gz",
    "neurology-india": "./styles/c09.json.gz",
    "neurology": "./styles/c10.json.gz",
    "neuropsychopharmacology": "./styles/c11.json.gz",
    "neurorehabilitation-and-neural-repair": "./styles/c12.json.gz",
    "neuroreport": "./styles/c13.json.gz",
    "neurospine": "./styles/c14.json.gz",
    "neurosurgery-clinics-of-north-america": "./styles/c15.json.gz",
    "new-harts-rules-author-date-publisher": "./styles/c16.json.gz",
    "new-harts-rules-author-date-space-publisher": "./styles/c17.json.gz",
    "new-harts-rules-author-date": "./styles/c18.json.gz",
    "new-harts-rules-notes-initials-bracket-role-page-range-no-url": "./styles/c19.json.gz",
    "new-harts-rules-notes-initials-bracket-role-page-range": "./styles/c20.json.gz",
    "new-harts-rules-notes-initials-label-page-no-url": "./styles/c21.json.gz",
    "new-harts-rules-notes-initials-label-page": "./styles/c22.json.gz",
    "new-harts-rules-notes-initials-no-url": "./styles/c23.json.gz",
    "new-harts-rules-notes-initials-publisher-no-url": "./styles/c24.json.gz",
    "new-harts-rules-notes-initials-publisher": "./styles/c25.json.gz",
    "new-harts-rules-notes-initials": "./styles/c01.json.gz",
    "new-harts-rules-notes-label-page-no-url": "./styles/c02.json.gz",
    "new-harts-rules-notes-label-page": "./styles/c03.json.gz",
    "new-harts-rules-notes-no-url": "./styles/c04.json.gz",
    "new-harts-rules-notes-publisher-no-url": "./styles/c05.json.gz",
    "new-harts-rules-notes-publisher": "./styles/c06.json.gz",
    "new-harts-rules-notes": "./styles/c07.json.gz",
    "new-harts-rules-numbered": "./styles/c08.json.gz",
    "new-harts-rules-short-notes-no-url": "./styles/c09.json.gz",
    "new-harts-rules-short-notes": "./styles/c10.json.gz",
    "new-phytologist": "./styles/c11.json.gz",
    "new-solutions": "./styles/c12.json.gz",
    "new-testament-studies": "./styles/c13.json.gz",
    "new-zealand-dental-journal": "./styles/c14.json.gz",
    "new-zealand-journal-of-forestry-science": "./styles/c15.json.gz",
    "new-zealand-journal-of-history": "./styles/c16.json.gz",
    "new-zealand-plant-protection": "./styles/c17.json.gz",
    "new-zealand-veterinary-journal": "./styles/c18.json.gz",
    "nist-technical-publication-journal-of-research-of-nist": "./styles/c19.json.gz",
    "nlm-citation-name": "./styles/c20.json.gz",
    "nlm-citation-sequence-brackets-no-et-al": "./styles/c21.json.gz",
    "nlm-citation-sequence-brackets-year-only-no-issue": "./styles/c22.json.gz",
    "nlm-citation-sequence-brackets": "./styles/c23.json.gz",
    "nlm-citation-sequence-superscript-brackets-year-only": "./styles/c24.json.gz",
    "nlm-citation-sequence-superscript-year-only-no-issue": "./styles/c25.json.gz",
    "nlm-citation-sequence-superscript": "./styles/c01.json.gz",
    "nlm-citation-sequence": "./styles/c02.json.gz",
    "nlm-name-year": "./styles/c03.json.gz",
    "nordic-pulp-and-paper-research-journal": "./styles/c04.json.gz",
    "norma-portuguesa-405": "./styles/c05.json.gz",
    "norois": "./styles/c06.json.gz",
    "norsk-apa-manual-note": "./styles/c07.json.gz",
    "norsk-apa-manual": "./styles/c08.json.gz",
    "norsk-henvisningsstandard-for-rettsvitenskapelige-tekster-full-firstnote": "./styles/c09.json.gz",
    "norsk-henvisningsstandard-for-rettsvitenskapelige-tekster": "./styles/c10.json.gz",
    "north-pacific-anadromous-fish-commission-bulletin": "./styles/c11.json.gz",
    "northeastern-naturalist": "./styles/c12.json.gz",
    "nottingham-trent-university-library-harvard": "./styles/c13.json.gz",
    "nouvelles-perspectives-en-sciences-sociales": "./styles/c14.json.gz",
    "nova-univerza": "./styles/c15.json.gz",
    "novasinergia": "./styles/c16.json.gz",
    "nowa-audiofonologia": "./styles/c17.json.gz",
    "nuclear-receptor-signaling": "./styles/c18.json.gz",
    "nucleic-acids-research-web-server-issue": "./styles/c19.json.gz",
    "nucleic-acids-research": "./styles/c20.json.gz",
    "nueva-norma-estudios-de-la-humanidad": "./styles/c21.json.gz",
    "nutrition-research-reviews": "./styles/c22.json.gz",
    "nys-nydanske-sprogstudier": "./styles/c23.json.gz",
    "obafemi-awolowo-university-faculty-of-technology": "./styles/c24.json.gz",
    "obesity": "./styles/c25.json.gz",
    "obstetrics-and-gynecology-science": "./styles/c01.json.gz",
    "occupational-medicine": "./styles/c02.json.gz",
    "ocean-and-coastal-research": "./styles/c03.json.gz",
    "oceanography": "./styles/c04.json.gz",
    "oecologia-australis": "./styles/c05.json.gz",
    "offa": "./styles/c06.json.gz",
    "oikos": "./styles/c07.json.gz",
    "oil-shale": "./styles/c08.json.gz",
    "oncoimmunology": "./styles/c09.json.gz",
    "oncotarget": "./styles/c10.json.gz",
    "open-gender-journal": "./styles/c11.json.gz",
    "open-theology": "./styles/c12.json.gz",
    "open-window": "./styles/c13.json.gz",
    "operative-dentistry": "./styles/c14.json.gz",
    "ophthalmic-genetics": "./styles/c15.json.gz",
    "ophthalmic-plastic-and-reconstructive-surgery": "./styles/c16.json.gz",
    "ophthalmology-retina": "./styles/c17.json.gz",
    "ophthalmology": "./styles/c18.json.gz",
    "optics-express": "./styles/c19.json.gz",
    "optics-letters": "./styles/c20.json.gz",
    "opto-electronic-advances": "./styles/c21.json.gz",
    "optometry-and-vision-science": "./styles/c22.json.gz",
    "opuscula": "./styles/c23.json.gz",
    "oral-diseases": "./styles/c24.json.gz",
    "organic-geochemistry": "./styles/c25.json.gz",
    "organised-sound": "./styles/c01.json.gz",
    "organization-studies": "./styles/c02.json.gz",
    "organization": "./styles/c03.json.gz",
    "organon": "./styles/c04.json.gz",
    "ornitologia-neotropical": "./styles/c05.json.gz",
    "orthopedic-clinics-of-north-america": "./styles/c06.json.gz",
    "oryx": "./styles/c07.json.gz",
    "oscola-journal-abbreviations": "./styles/c08.json.gz",
    "oscola-no-ibid": "./styles/c09.json.gz",
    "oscola": "./styles/c10.json.gz",
    "osterreichische-zeitschrift-fur-politikwissenschaft": "./styles/c11.json.gz",
    "otto-von-guricke-universitat-magdeburg-medizinische-fakultat-numeric": "./styles/c12.json.gz",
    "owbarth-verlag": "./styles/c13.json.gz",
    "oxford-art-journal": "./styles/c14.json.gz",
    "oxford-guide-to-style-notes-initials-article-sentence-case-roman-volume-label-page": "./styles/c15.json.gz",
    "oxford-guide-to-style-notes-initials-label-page-no-url": "./styles/c16.json.gz",
    "oxford-guide-to-style-notes-initials-label-page": "./styles/c17.json.gz",
    "oxford-guide-to-style-notes-initials-no-url": "./styles/c18.json.gz",
    "oxford-guide-to-style-notes-initials": "./styles/c19.json.gz",
    "oxford-guide-to-style-notes-no-url": "./styles/c20.json.gz",
    "oxford-guide-to-style-notes-roman-volume-archive-first-no-url": "./styles/c21.json.gz",
    "oxford-guide-to-style-notes-roman-volume-archive-first": "./styles/c22.json.gz",
    "oxford-guide-to-style-notes": "./styles/c23.json.gz",
    "oxford-journals-scimed-author-date": "./styles/c24.json.gz",
    "oxford-journals-scimed-numeric-parentheses": "./styles/c25.json.gz",
    "oxford-journals-scimed-numeric-superscript": "./styles/c01.json.gz",
    "oxford-journals-scimed-numeric": "./styles/c02.json.gz",
    "oxford-studies-on-the-roman-economy": "./styles/c03.json.gz",
    "oxidation-of-metals": "./styles/c04.json.gz",
    "pacific-conservation-biology": "./styles/c05.json.gz",
    "pacific-science": "./styles/c06.json.gz",
    "padagogische-hochschule-bern-institut-vorschulstufe-und-primarstufe": "./styles/c07.json.gz",
    "padagogische-hochschule-fachhochschule-nordwestschweiz": "./styles/c08.json.gz",
    "padagogische-hochschule-heidelberg": "./styles/c09.json.gz",
    "padagogische-hochschule-vorarlberg": "./styles/c10.json.gz",
    "paediatric-and-perinatal-epidemiology": "./styles/c11.json.gz",
    "pain-medicine": "./styles/c12.json.gz",
    "pain-physician": "./styles/c13.json.gz",
    "pain": "./styles/c14.json.gz",
    "pakistan-journal-of-agricultural-sciences": "./styles/c15.json.gz",
    "pakistani-veterinary-journal": "./styles/c16.json.gz",
    "palaeodiversity": "./styles/c17.json.gz",
    "palaeontographica-abteilung-b-palaeobotany-palaeophytology": "./styles/c18.json.gz",
    "palaeontologia-electronica": "./styles/c19.json.gz",
    "palaeontology": "./styles/c20.json.gz",
    "palaeovertebrata": "./styles/c21.json.gz",
    "palaios": "./styles/c22.json.gz",
    "paleobiology": "./styles/c23.json.gz",
    "pallas": "./styles/c24.json.gz",
    "pamukkale-universitesi-fen-bilimleri-enstitusu": "./styles/c25.json.gz",
    "parasite": "./styles/c01.json.gz",
    "parasitology": "./styles/c02.json.gz",
    "pathogens-and-immunity": "./styles/c03.json.gz",
    "pediatric-allergy-and-immunology": "./styles/c04.json.gz",
    "pediatric-anesthesia": "./styles/c05.json.gz",
    "pediatric-blood-and-cancer": "./styles/c06.json.gz",
    "pediatric-infectious-disease-journal": "./styles/c07.json.gz",
    "pediatric-physical-therapy": "./styles/c08.json.gz",
    "pediatric-practice-and-research": "./styles/c09.json.gz",
    "pediatric-pulmonology": "./styles/c10.json.gz",
    "pediatric-research": "./styles/c11.json.gz",
    "pediatric-urology-case-reports": "./styles/c12.json.gz",
    "pedosphere": "./styles/c13.json.gz",
    "peerj": "./styles/c14.json.gz",
    "pensoft-journals": "./styles/c15.json.gz",
    "periodicum-biologorum": "./styles/c16.json.gz",
    "periodontology-2000": "./styles/c17.json.gz",
    "permafrost-and-periglacial-processes": "./styles/c18.json.gz",
    "perspectives-on-sexual-and-reproductive-health": "./styles/c19.json.gz",
    "pesquisa-agropecuaria-brasileira": "./styles/c20.json.gz",
    "pest-management-science": "./styles/c21.json.gz",
    "peter-lang-social-sciences": "./styles/c22.json.gz",
    "petit-chicago-author-date": "./styles/c23.json.gz",
    "pharmacoepidemiology-and-drug-safety": "./styles/c24.json.gz",
    "philippika": "./styles/c25.json.gz",
    "philippine-journal-of-natural-sciences": "./styles/c01.json.gz",
    "philipps-universitat-marburg-note": "./styles/c02.json.gz",
    "philosophia-scientiae": "./styles/c03.json.gz",
    "philosophiques": "./styles/c04.json.gz",
    "philosophy-and-public-affairs": "./styles/c05.json.gz",
    "photochemistry-and-photobiology": "./styles/c06.json.gz",
    "photogrammetric-engineering-and-remote-sensing": "./styles/c07.json.gz",
    "photosynthetica": "./styles/c08.json.gz",
    "phycological-research": "./styles/c09.json.gz",
    "phyllomedusa": "./styles/c10.json.gz",
    "physiologia-plantarum": "./styles/c11.json.gz",
    "physiological-and-biochemical-zoology": "./styles/c12.json.gz",
    "physiotherapy-theory-and-practice": "./styles/c13.json.gz",
    "phytopathologia-mediterranea": "./styles/c14.json.gz",
    "phytotaxa": "./styles/c15.json.gz",
    "pisa-university-press": "./styles/c16.json.gz",
    "planning-practice-and-research": "./styles/c17.json.gz",
    "plant-and-cell-physiology": "./styles/c18.json.gz",
    "plant-biology": "./styles/c19.json.gz",
    "plant-biotechnology-journal": "./styles/c20.json.gz",
    "plant-cell-and-environment": "./styles/c21.json.gz",
    "plant-genetic-resources-characterization-and-utilization": "./styles/c22.json.gz",
    "plant-pathology": "./styles/c23.json.gz",
    "plant-physiology": "./styles/c24.json.gz",
    "plant-species-biology": "./styles/c25.json.gz",
    "plos": "./styles/c01.json.gz",
    "pnas": "./styles/c02.json.gz",
    "podzemna-voda": "./styles/c03.json.gz",
    "polar-research": "./styles/c04.json.gz",
    "polish-archives-of-internal-medicine": "./styles/c05.json.gz",
    "polish-legal": "./styles/c06.json.gz",
    "politechnika-opolska-wydzial-wychowania-fizycznego-i-fizjoterapii": "./styles/c07.json.gz",
    "politeknik-negeri-manado-jurnal-p3m": "./styles/c08.json.gz",
    "politica-tidsskrift-for-politisk-videnskab": "./styles/c09.json.gz",
    "political-studies": "./styles/c10.json.gz",
    "politique-europeenne": "./styles/c11.json.gz",
    "politische-vierteljahresschrift": "./styles/c12.json.gz",
    "politix": "./styles/c13.json.gz",
    "polygraphia": "./styles/c14.json.gz",
    "polymer-reviews": "./styles/c15.json.gz",
    "polytechnique-montreal-apa": "./styles/c16.json.gz",
    "polytechnique-montreal-ieee": "./styles/c17.json.gz",
    "pontifical-athenaeum-regina-apostolorum": "./styles/c18.json.gz",
    "pontifical-biblical-institute": "./styles/c19.json.gz",
    "pontifical-gregorian-university": "./styles/c20.json.gz",
    "pontificia-universidade-catolica-do-parana-abnt": "./styles/c21.json.gz",
    "population-space-and-place": "./styles/c22.json.gz",
    "population": "./styles/c23.json.gz",
    "postepy-higieny-i-medycyny-doswiadczalnej": "./styles/c24.json.gz",
    "poultry-science": "./styles/c25.json.gz",
    "pour-reussir-note": "./styles/c01.json.gz",
    "pravnik": "./styles/c02.json.gz",
    "pravny-obzor": "./styles/c03.json.gz",
    "praxis": "./styles/c04.json.gz",
    "prehistoires-mediterraneennes": "./styles/c05.json.gz",
    "prehospital-and-disaster-medicine": "./styles/c06.json.gz",
    "prehospital-emergency-care": "./styles/c07.json.gz",
    "preslia": "./styles/c08.json.gz",
    "presses-universitaires-de-paris-nanterre": "./styles/c09.json.gz",
    "presses-universitaires-de-rennes-archeologie-et-culture": "./styles/c10.json.gz",
    "presses-universitaires-de-rennes-author-date": "./styles/c11.json.gz",
    "presses-universitaires-de-rennes": "./styles/c12.json.gz",
    "presses-universitaires-de-strasbourg-note": "./styles/c13.json.gz",
    "preventive-nutrition-and-food-science": "./styles/c14.json.gz",
    "primary-care-clinics-in-office-practice": "./styles/c15.json.gz",
    "proceedings-of-the-estonian-academy-of-sciences-author-date": "./styles/c16.json.gz",
    "proceedings-of-the-estonian-academy-of-sciences-numeric": "./styles/c17.json.gz",
    "proceedings-of-the-joint-international-grassland-and-international-rangeland-congress-2021": "./styles/c18.json.gz",
    "proceedings-of-the-royal-society-b": "./styles/c19.json.gz",
    "processing-and-application-of-ceramics": "./styles/c20.json.gz",
    "production-and-operations-management": "./styles/c21.json.gz",
    "progress-on-chemistry-and-application-of-chitin-and-its-derivatives": "./styles/c22.json.gz",
    "proinflow": "./styles/c23.json.gz",
    "protein-engineering-design-and-selection": "./styles/c24.json.gz",
    "protein-science": "./styles/c25.json.gz",
    "proteomics": "./styles/c01.json.gz",
    "psychiatric-clinics-of-north-america": "./styles/c02.json.gz",
    "psychiatric-services": "./styles/c03.json.gz",
    "psychiatry-and-clinical-neurosciences": "./styles/c04.json.gz",
    "psychosomatic-medicine": "./styles/c05.json.gz",
    "psychosomatics": "./styles/c06.json.gz",
    "public-health-nutrition": "./styles/c07.json.gz",
    "publicatiewijzer-voor-de-archeologie": "./styles/c08.json.gz",
    "pure-and-applied-geophysics": "./styles/c09.json.gz",
    "qeios": "./styles/c10.json.gz",
    "quaderni-degli-avogadro-colloquia": "./styles/c11.json.gz",
    "quaderni-materialisti": "./styles/c12.json.gz",
    "quaderni": "./styles/c13.json.gz",
    "quaternaire": "./styles/c14.json.gz",
    "quaternary-international": "./styles/c15.json.gz",
    "queen-margaret-university-harvard": "./styles/c16.json.gz",
    "r-and-d-management": "./styles/c17.json.gz",
    "radiation-protection-dosimetry": "./styles/c18.json.gz",
    "radiation-research": "./styles/c19.json.gz",
    "radiochimica-acta": "./styles/c20.json.gz",
    "radiographics": "./styles/c21.json.gz",
    "radiography": "./styles/c22.json.gz",
    "radiologic-clinics-of-north-america": "./styles/c23.json.gz",
    "radiology": "./styles/c24.json.gz",
    "radiopaedia": "./styles/c25.json.gz",
    "raffles-bulletin-of-zoology": "./styles/c01.json.gz",
    "raptor-journal": "./styles/c02.json.gz",
    "rassegna-degli-archivi-di-stato-bibliografia-generale": "./styles/c03.json.gz",
    "rassegna-degli-archivi-di-stato": "./styles/c04.json.gz",
    "recent-patents-on-drug-delivery-and-formulation": "./styles/c05.json.gz",
    "recherches-en-sciences-de-gestion": "./styles/c06.json.gz",
    "refugee-survey-quarterly": "./styles/c07.json.gz",
    "register-studies": "./styles/c08.json.gz",
    "religion-in-the-roman-empire": "./styles/c09.json.gz",
    "renewable-agriculture-and-food-systems": "./styles/c10.json.gz",
    "reports-of-practical-oncology-and-radiotherapy": "./styles/c11.json.gz",
    "representation": "./styles/c12.json.gz",
    "reproduction-fertility-and-development": "./styles/c13.json.gz",
    "reproduction": "./styles/c14.json.gz",
    "research-and-education-promotion-association": "./styles/c15.json.gz",
    "research-in-plant-disease": "./styles/c16.json.gz",
    "research-institute-for-nature-and-forest": "./styles/c17.json.gz",
    "research-on-biomedical-engineering": "./styles/c18.json.gz",
    "respiratory-care-journal": "./styles/c19.json.gz",
    "respirology": "./styles/c20.json.gz",
    "restoration-ecology": "./styles/c21.json.gz",
    "retina": "./styles/c22.json.gz",
    "rever-revista-de-estudos-da-religiao": "./styles/c23.json.gz",
    "review-of-international-studies": "./styles/c24.json.gz",
    "review-of-political-economy": "./styles/c25.json.gz",
    "reviews-of-modern-physics-with-titles": "./styles/c01.json.gz",
    "revista-argentina-de-antropologia-biologica": "./styles/c02.json.gz",
    "revista-biblica": "./styles/c03.json.gz",
    "revista-brasileira-de-ciencia-do-solo": "./styles/c04.json.gz",
    "revista-chilena-de-derecho-y-tecnologia": "./styles/c05.json.gz",
    "revista-ciencias-tecnicas-agropecuarias": "./styles/c06.json.gz",
    "revista-cubana-de-meteorologia": "./styles/c07.json.gz",
    "revista-da-sociedade-brasileira-de-medicina-tropical": "./styles/c08.json.gz",
    "revista-de-biologia-marina-y-oceanografia": "./styles/c09.json.gz",
    "revista-de-biologia-tropical": "./styles/c10.json.gz",
    "revista-de-derecho-de-la-universidad-austral-de-chile": "./styles/c11.json.gz",
    "revista-de-filologia-espanola": "./styles/c12.json.gz",
    "revista-do-instituto-de-medicina-tropical-de-sao-paulo": "./styles/c13.json.gz",
    "revista-espanola-de-nutricion-humana-y-dietetica": "./styles/c14.json.gz",
    "revista-fave-seccion-ciencias-agrarias": "./styles/c15.json.gz",
    "revista-ladinia": "./styles/c16.json.gz",
    "revista-latinoamericana-de-metalurgia-y-materiales": "./styles/c17.json.gz",
    "revista-latinoamericana-de-recursos-naturales": "./styles/c18.json.gz",
    "revista-materia": "./styles/c19.json.gz",
    "revista-medica-del-instituto-mexicano-del-seguro-social": "./styles/c20.json.gz",
    "revista-noesis": "./styles/c21.json.gz",
    "revista-peruana-de-medicina-experimental-y-salud-publica": "./styles/c22.json.gz",
    "revista-portuguesa-de-arqueologia": "./styles/c23.json.gz",
    "revista-portuguesa-de-musicologia-author-date": "./styles/c24.json.gz",
    "revista-virtual-de-quimica": "./styles/c25.json.gz",
    "revue-archeologique-de-lest": "./styles/c01.json.gz",
    "revue-archeologique-de-narbonnaise": "./styles/c02.json.gz",
    "revue-archeologique-du-centre-de-la-france": "./styles/c03.json.gz",
    "revue-archeologique": "./styles/c04.json.gz",
    "revue-d-anthropologie-des-connaissances": "./styles/c05.json.gz",
    "revue-d-elevage-et-de-medecine-veterinaire-des-pays-tropicaux": "./styles/c06.json.gz",
    "revue-de-medecine-veterinaire": "./styles/c07.json.gz",
    "revue-de-qumran": "./styles/c08.json.gz",
    "revue-des-etudes-byzantines": "./styles/c09.json.gz",
    "revue-des-nouvelles-technologies-de-l-information": "./styles/c10.json.gz",
    "revue-dhistoire-des-sciences-humaines": "./styles/c11.json.gz",
    "revue-dhistoire-des-sciences": "./styles/c12.json.gz",
    "revue-dhistoire-moderne-et-contemporaine": "./styles/c13.json.gz",
    "revue-europeenne-des-migrations-internationales": "./styles/c14.json.gz",
    "revue-forestiere-francaise": "./styles/c15.json.gz",
    "revue-francaise-d-administration-publique": "./styles/c16.json.gz",
    "revue-francaise-de-gestion": "./styles/c17.json.gz",
    "revue-francaise-de-pedagogie": "./styles/c18.json.gz",
    "revue-francaise-de-sociologie": "./styles/c19.json.gz",
    "revue-francaise-dhistotechnologie": "./styles/c20.json.gz",
    "revue-internationale-durbanisme": "./styles/c21.json.gz",
    "revue-metis": "./styles/c22.json.gz",
    "rhinology": "./styles/c23.json.gz",
    "rhodora": "./styles/c24.json.gz",
    "risk-analysis": "./styles/c25.json.gz",
    "ritid": "./styles/c01.json.gz",
    "rivista-italiana-di-paleontologia-e-stratigrafia": "./styles/c02.json.gz",
    "rmit-university-harvard": "./styles/c03.json.gz",
    "rofo": "./styles/c04.json.gz",
    "romanian-humanities": "./styles/c05.json.gz",
    "roots-monograph-series": "./styles/c06.json.gz",
    "rose-school": "./styles/c07.json.gz",
    "rossiiskii-fiziologicheskii-zhurnal-imeni-i-m-sechenova": "./styles/c08.json.gz",
    "royal-college-of-nursing-harvard": "./styles/c09.json.gz",
    "royal-college-of-surgeons-in-ireland-medical-university-of-bahrain-harvard": "./styles/c10.json.gz",
    "royal-entomological-society": "./styles/c11.json.gz",
    "royal-society-of-chemistry-with-titles": "./styles/c12.json.gz",
    "royal-society-of-chemistry": "./styles/c13.json.gz",
    "rtf-scan": "./styles/c14.json.gz",
    "ruhr-universitat-bochum-lehrstuhl-fur-industrial-sales-and-service-engineering": "./styles/c15.json.gz",
    "ruhr-universitat-bochum-medizinische-fakultat-numeric": "./styles/c16.json.gz",
    "sage-harvard": "./styles/c17.json.gz",
    "sage-vancouver-brackets": "./styles/c18.json.gz",
    "sage-vancouver": "./styles/c19.json.gz",
    "saglik-bilimleri-universitesi": "./styles/c20.json.gz",
    "saint-paul-university-faculty-of-canon-law": "./styles/c21.json.gz",
    "san-francisco-estuary-and-watershed-science": "./styles/c22.json.gz",
    "sanamed": "./styles/c23.json.gz",
    "scandinavian-journal-of-infectious-diseases": "./styles/c24.json.gz",
    "scandinavian-journal-of-information-systems": "./styles/c25.json.gz",
    "scandinavian-journal-of-medicine-and-science-in-sports": "./styles/c01.json.gz",
    "scandinavian-journal-of-rheumatology": "./styles/c02.json.gz",
    "scandinavian-journal-of-work-environment-and-health": "./styles/c03.json.gz",
    "scandinavian-political-studies": "./styles/c04.json.gz",
    "schweizerische-zeitschrift-fur-geschichte": "./styles/c05.json.gz",
    "science-and-technology-for-the-built-environment": "./styles/c06.json.gz",
    "science-china-chemistry": "./styles/c07.json.gz",
    "science-china-earth-sciences": "./styles/c08.json.gz",
    "science-china-life-sciences": "./styles/c09.json.gz",
    "science-china-materials": "./styles/c10.json.gz",
    "science-translational-medicine": "./styles/c11.json.gz",
    "science-without-titles": "./styles/c12.json.gz",
    "science": "./styles/c13.json.gz",
    "scienceasia": "./styles/c14.json.gz",
    "sciences-po-ecole-doctorale-author-date": "./styles/c15.json.gz",
    "sciences-po-ecole-doctorale-note-french": "./styles/c16.json.gz",
    "scientia-agriculturae-bohemica": "./styles/c17.json.gz",
    "scientia-iranica": "./styles/c18.json.gz",
    "scientific-online-letters-on-the-atmosphere": "./styles/c19.json.gz",
    "scientific-review-engineering-and-environmental-sciences": "./styles/c20.json.gz",
    "scrinium": "./styles/c21.json.gz",
    "sedimentology": "./styles/c22.json.gz",
    "seed-science-and-technology": "./styles/c23.json.gz",
    "seed-science-research": "./styles/c24.json.gz",
    "seismological-research-letters": "./styles/c25.json.gz",
    "sekolah-tinggi-meteorologi-klimatologi-dan-geofisika": "./styles/c01.json.gz",
    "seminaire-saint-sulpice-ecole-theologie": "./styles/c02.json.gz",
    "seminars-in-pediatric-neurology": "./styles/c03.json.gz",
    "serbian-archives-of-medicine": "./styles/c04.json.gz",
    "serdica-journal-of-computing": "./styles/c05.json.gz",
    "service-medical-de-l-assurance-maladie": "./styles/c06.json.gz",
    "sexual-development": "./styles/c07.json.gz",
    "sexual-health": "./styles/c08.json.gz",
    "sheffield-hallam-university-history": "./styles/c09.json.gz",
    "shock": "./styles/c10.json.gz",
    "silva-fennica": "./styles/c11.json.gz",
    "sinergie-italian-journal-of-management": "./styles/c12.json.gz",
    "sist02": "./styles/c13.json.gz",
    "skene-journal-of-theatre-and-drama-studies": "./styles/c14.json.gz",
    "skuast-journal-of-research": "./styles/c15.json.gz",
    "slovensko-drustvo-za-medicinsko-informatiko": "./styles/c16.json.gz",
    "small": "./styles/c17.json.gz",
    "smithsonian-institution-scholarly-press-author-date": "./styles/c18.json.gz",
    "smithsonian-institution-scholarly-press-botany": "./styles/c19.json.gz",
    "smithsonian-institution-scholarly-press-note": "./styles/c20.json.gz",
    "smyrna-tip-dergisi": "./styles/c21.json.gz",
    "sn-computer-science": "./styles/c22.json.gz",
    "social-anthropology": "./styles/c23.json.gz",
    "social-cognitive-and-affective-neuroscience": "./styles/c24.json.gz",
    "social-history-of-medicine": "./styles/c25.json.gz",
    "social-history": "./styles/c01.json.gz",
    "social-science-history": "./styles/c02.json.gz",
    "sociedade-brasileira-de-computacao": "./styles/c03.json.gz",
    "societe-archeologique-de-bordeaux": "./styles/c04.json.gz",
    "societe-francaise-degyptologie": "./styles/c05.json.gz",
    "societe-francaise-detude-de-la-ceramique-antique-en-gaule": "./styles/c06.json.gz",
    "societe-nationale-des-groupements-techniques-veterinaires": "./styles/c07.json.gz",
    "societes-contemporaines": "./styles/c08.json.gz",
    "society-for-american-archaeology": "./styles/c09.json.gz",
    "society-for-historical-archaeology": "./styles/c10.json.gz",
    "society-for-laboratory-automation-and-screening": "./styles/c11.json.gz",
    "society-of-automotive-engineers-technical-papers-numeric": "./styles/c12.json.gz",
    "society-of-biblical-literature-author-date": "./styles/c13.json.gz",
    "society-of-biblical-literature-fullnote-bibliography": "./styles/c14.json.gz",
    "sociologia-ruralis": "./styles/c15.json.gz",
    "sociologia-urbana-e-rurale": "./styles/c16.json.gz",
    "sociologie": "./styles/c17.json.gz",
    "sociology-of-health-and-illness": "./styles/c18.json.gz",
    "sodertorns-hogskola-harvard-ibid": "./styles/c19.json.gz",
    "sodertorns-hogskola-harvard": "./styles/c20.json.gz",
    "sodertorns-hogskola-oxford": "./styles/c21.json.gz",
    "soil-biology-and-biochemistry": "./styles/c22.json.gz",
    "soil-science-and-plant-nutrition": "./styles/c23.json.gz",
    "solent-university-harvard": "./styles/c24.json.gz",
    "solutions": "./styles/c25.json.gz",
    "sophiahemmet-hogskola": "./styles/c01.json.gz",
    "sorbonne-student-law-review": "./styles/c02.json.gz",
    "south-african-actuarial-journal": "./styles/c03.json.gz",
    "south-african-journal-of-animal-science": "./styles/c04.json.gz",
    "south-african-journal-of-enology-and-viticulture": "./styles/c05.json.gz",
    "south-african-journal-of-geology": "./styles/c06.json.gz",
    "south-african-law-journal": "./styles/c07.json.gz",
    "south-african-medical-journal": "./styles/c08.json.gz",
    "south-african-theological-seminary": "./styles/c09.json.gz",
    "southeastern-geographer": "./styles/c10.json.gz",
    "southern-african-journal-of-critical-care": "./styles/c11.json.gz",
    "soziale-welt": "./styles/c12.json.gz",
    "sozialpadagogisches-institut-berlin-walter-may": "./styles/c13.json.gz",
    "sozialwissenschaften-heilmann": "./styles/c14.json.gz",
    "soziologie": "./styles/c15.json.gz",
    "soziologiemagazin": "./styles/c16.json.gz",
    "spandidos-publications": "./styles/c17.json.gz",
    "spanish-legal": "./styles/c18.json.gz",
    "spectroscopy-letters": "./styles/c19.json.gz",
    "spie-bios": "./styles/c20.json.gz",
    "spie-journals": "./styles/c21.json.gz",
    "spie-proceedings": "./styles/c22.json.gz",
    "spine": "./styles/c23.json.gz",
    "spip-cite": "./styles/c24.json.gz",
    "spiritual-care": "./styles/c25.json.gz",
    "sports-health": "./styles/c01.json.gz",
    "springer-basic-author-date-no-et-al-with-issue": "./styles/c02.json.gz",
    "springer-basic-author-date-no-et-al": "./styles/c03.json.gz",
    "springer-basic-author-date": "./styles/c04.json.gz",
    "springer-basic-brackets-no-et-al-alphabetical": "./styles/c05.json.gz",
    "springer-basic-brackets-no-et-al": "./styles/c06.json.gz",
    "springer-basic-brackets": "./styles/c07.json.gz",
    "springer-basic-note": "./styles/c08.json.gz",
    "springer-fachzeitschriften-medizin-psychologie": "./styles/c09.json.gz",
    "springer-humanities-author-date": "./styles/c10.json.gz",
    "springer-humanities-brackets": "./styles/c11.json.gz",
    "springer-imis-series-migrationsgesellschaften": "./styles/c12.json.gz",
    "springer-lecture-notes-in-computer-science-alphabetical": "./styles/c13.json.gz",
    "springer-lecture-notes-in-computer-science": "./styles/c14.json.gz",
    "springer-mathphys-author-date": "./styles/c15.json.gz",
    "springer-mathphys-brackets": "./styles/c16.json.gz",
    "springer-physics-author-date": "./styles/c17.json.gz",
    "springer-physics-brackets": "./styles/c18.json.gz",
    "springer-socpsych-author-date": "./styles/c19.json.gz",
    "springer-socpsych-brackets": "./styles/c20.json.gz",
    "springer-vancouver-author-date": "./styles/c21.json.gz",
    "springer-vancouver-brackets": "./styles/c22.json.gz",
    "springer-vancouver": "./styles/c23.json.gz",
    "springer-vs-author-date": "./styles/c24.json.gz",
    "springerprotocols": "./styles/c25.json.gz",
    "st-patricks-college": "./styles/c01.json.gz",
    "stanovnistvo": "./styles/c02.json.gz",
    "statistika-statistics-and-economy-journal": "./styles/c03.json.gz",
    "stavebni-obzor": "./styles/c04.json.gz",
    "steel-research-international": "./styles/c05.json.gz",
    "steinbeis-hochschule-school-of-management-and-innovation": "./styles/c06.json.gz",
    "stellenbosch-law-review": "./styles/c07.json.gz",
    "stem-cell-reports": "./styles/c08.json.gz",
    "stem-cells": "./styles/c09.json.gz",
    "strategic-design-research-journal": "./styles/c10.json.gz",
    "strategic-entrepreneurship-journal": "./styles/c11.json.gz",
    "strategic-management-journal": "./styles/c12.json.gz",
    "stroke": "./styles/c13.json.gz",
    "structural-control-and-health-monitoring": "./styles/c14.json.gz",
    "studi-e-materiali-di-storia-delle-religioni": "./styles/c15.json.gz",
    "studi-slavistici-rivista-dellassociazione-italiana-degli-slavisti": "./styles/c16.json.gz",
    "studia-bas": "./styles/c17.json.gz",
    "studia-historiae-scientiarum": "./styles/c18.json.gz",
    "studia-theologica": "./styles/c19.json.gz",
    "studies-in-the-history-of-gardens-and-designed-landscapes": "./styles/c20.json.gz",
    "studii-teologice": "./styles/c21.json.gz",
    "stuttgart-media-university": "./styles/c22.json.gz",
    "style-manual-australian-government-note": "./styles/c23.json.gz",
    "style-manual-australian-government": "./styles/c24.json.gz",
    "style-manual-for-authors-editors-and-printers-6th-edition-snooks-co": "./styles/c25.json.gz",
    "suburban-zeitschrift-fur-kritische-stadtforschung": "./styles/c01.json.gz",
    "suleyman-demirel-universitesi-fen-bilimleri-enstitusu": "./styles/c02.json.gz",
    "sunway-college-johor-bahru": "./styles/c03.json.gz",
    "suomen-antropologi-journal-of-the-finnish-anthropological-society": "./styles/c04.json.gz",
    "surgical-clinics-of-north-america": "./styles/c05.json.gz",
    "surgical-neurology-international": "./styles/c06.json.gz",
    "surgical-pathology-clinics": "./styles/c07.json.gz",
    "survey-of-ophthalmology": "./styles/c08.json.gz",
    "svensk-exegetisk-arsbok": "./styles/c09.json.gz",
    "swedish-legal": "./styles/c10.json.gz",
    "swiss-political-science-review": "./styles/c11.json.gz",
    "sylwan": "./styles/c12.json.gz",
    "synthesis": "./styles/c13.json.gz",
    "system-dynamics-review": "./styles/c14.json.gz",
    "systematic-and-applied-microbiology": "./styles/c15.json.gz",
    "systematic-biology": "./styles/c16.json.gz",
    "szociologiai-szemle": "./styles/c17.json.gz",
    "tabula": "./styles/c18.json.gz",
    "tagungsberichte-der-historischen-kommission-fur-ost-und-westpreussische-landesforschung": "./styles/c19.json.gz",
    "tapir-conservation": "./styles/c20.json.gz",
    "targetome": "./styles/c21.json.gz",
    "tatup-zeitschrift-fur-technikfolgenabschatzung-in-theorie-und-praxis": "./styles/c22.json.gz",
    "taxon": "./styles/c23.json.gz",
    "taylor-and-francis-acs": "./styles/c24.json.gz",
    "taylor-and-francis-aip": "./styles/c25.json.gz",
    "taylor-and-francis-ama": "./styles/c01.json.gz",
    "taylor-and-francis-chicago-author-date": "./styles/c02.json.gz",
    "taylor-and-francis-chicago-b-author-date": "./styles/c03.json.gz",
    "taylor-and-francis-chicago-f": "./styles/c04.json.gz",
    "taylor-and-francis-council-of-science-editors-author-date": "./styles/c05.json.gz",
    "taylor-and-francis-council-of-science-editors-numeric": "./styles/c06.json.gz",
    "taylor-and-francis-harvard-x": "./styles/c07.json.gz",
    "taylor-and-francis-national-library-of-medicine": "./styles/c08.json.gz",
    "taylor-and-francis-numeric-q": "./styles/c09.json.gz",
    "taylor-and-francis-vancouver-national-library-of-medicine": "./styles/c10.json.gz",
    "techniques-et-culture": "./styles/c11.json.gz",
    "technische-universitat-dortmund-ag-virtual-machining": "./styles/c12.json.gz",
    "technische-universitat-dresden-betriebswirtschaftslehre-logistik-author-date": "./styles/c13.json.gz",
    "technische-universitat-dresden-betriebswirtschaftslehre-marketing": "./styles/c14.json.gz",
    "technische-universitat-dresden-betriebswirtschaftslehre-rechnungswesen-controlling": "./styles/c15.json.gz",
    "technische-universitat-dresden-erziehungswissenschaften-author-date": "./styles/c16.json.gz",
    "technische-universitat-dresden-finanzwirtschaft-und-finanzdienstleistungen-author-date-with-short-titles": "./styles/c17.json.gz",
    "technische-universitat-dresden-finanzwirtschaft-und-finanzdienstleistungen-author-date": "./styles/c18.json.gz",
    "technische-universitat-dresden-finanzwirtschaft-und-finanzdienstleistungen-note": "./styles/c19.json.gz",
    "technische-universitat-dresden-forstwissenschaft": "./styles/c20.json.gz",
    "technische-universitat-dresden-historische-musikwissenschaft-note": "./styles/c21.json.gz",
    "technische-universitat-dresden-kunstgeschichte-note": "./styles/c22.json.gz",
    "technische-universitat-dresden-linguistik": "./styles/c23.json.gz",
    "technische-universitat-dresden-medienwissenschaft-und-neuere-deutsche-literatur-note": "./styles/c24.json.gz",
    "technische-universitat-dresden-wirtschaftswissenschaften": "./styles/c25.json.gz",
    "technische-universitat-hamburg-institut-fur-smarte-entwicklung-und-maschinenelemente": "./styles/c01.json.gz",
    "technische-universitat-munchen-controlling": "./styles/c02.json.gz",
    "technische-universitat-munchen-unternehmensfuhrung": "./styles/c03.json.gz",
    "technische-universitat-wien": "./styles/c04.json.gz",
    "teologia-catalunya": "./styles/c05.json.gz",
    "termedia-neuropsychiatria-i-neuropsychologia-neuropsychiatry-and-neuropsychology": "./styles/c06.json.gz",
    "terra-nova": "./styles/c07.json.gz",
    "tetrahedron-letters": "./styles/c08.json.gz",
    "textual-cultures": "./styles/c09.json.gz",
    "textual-practice": "./styles/c10.json.gz",
    "tgm-wien-diplom": "./styles/c11.json.gz",
    "tgm-wien-diplomarbeit-onorm": "./styles/c12.json.gz",
    "thai-endodontic-journal": "./styles/c13.json.gz",
    "the-accounting-review": "./styles/c14.json.gz",
    "the-american-journal-of-bioethics": "./styles/c15.json.gz",
    "the-american-journal-of-cardiology": "./styles/c16.json.gz",
    "the-american-journal-of-dermatopathology": "./styles/c17.json.gz",
    "the-american-journal-of-gastroenterology": "./styles/c18.json.gz",
    "the-american-journal-of-geriatric-psychiatry": "./styles/c19.json.gz",
    "the-american-journal-of-pathology": "./styles/c20.json.gz",
    "the-american-journal-of-psychiatry": "./styles/c21.json.gz",
    "the-american-journal-of-tropical-medicine-and-hygiene": "./styles/c22.json.gz",
    "the-american-midland-naturalist": "./styles/c23.json.gz",
    "the-american-naturalist": "./styles/c24.json.gz",
    "the-angle-orthodontist": "./styles/c25.json.gz",
    "the-astrophysical-journal": "./styles/c01.json.gz",
    "the-auk": "./styles/c02.json.gz",
    "the-australian-journal-of-agricultural-and-resource-economics": "./styles/c03.json.gz",
    "the-biological-bulletin": "./styles/c04.json.gz",
    "the-bone-and-joint-journal": "./styles/c05.json.gz",
    "the-botanical-review": "./styles/c06.json.gz",
    "the-bovine-practitioner": "./styles/c07.json.gz",
    "the-british-journal-for-the-history-of-science": "./styles/c08.json.gz",
    "the-british-journal-for-the-philosophy-of-science": "./styles/c09.json.gz",
    "the-british-journal-of-cardiology": "./styles/c10.json.gz",
    "the-british-journal-of-criminology": "./styles/c11.json.gz",
    "the-british-journal-of-psychiatry": "./styles/c12.json.gz",
    "the-british-journal-of-social-work": "./styles/c13.json.gz",
    "the-british-journal-of-sociology": "./styles/c14.json.gz",
    "the-canadian-geographer": "./styles/c15.json.gz",
    "the-canadian-journal-of-chemical-engineering": "./styles/c16.json.gz",
    "the-canadian-journal-of-psychiatry": "./styles/c17.json.gz",
    "the-cancer-journal": "./styles/c18.json.gz",
    "the-chemical-society-of-japan": "./styles/c19.json.gz",
    "the-chinese-journal-of-international-politics": "./styles/c20.json.gz",
    "the-coleopterists-bulletin": "./styles/c21.json.gz",
    "the-company-of-biologists": "./styles/c22.json.gz",
    "the-depositional-record": "./styles/c23.json.gz",
    "the-design-journal": "./styles/c24.json.gz",
    "the-economic-history-review": "./styles/c25.json.gz",
    "the-european-research-journal": "./styles/c01.json.gz",
    "the-faseb-journal": "./styles/c02.json.gz",
    "the-febs-journal": "./styles/c03.json.gz",
    "the-geological-society-of-america": "./styles/c04.json.gz",
    "the-geological-society-of-london": "./styles/c05.json.gz",
    "the-hastings-center-report": "./styles/c06.json.gz",
    "the-historical-journal": "./styles/c07.json.gz",
    "the-holocene": "./styles/c08.json.gz",
    "the-horticulture-journal": "./styles/c09.json.gz",
    "the-institute-of-electronics-information-and-communication-engineers": "./styles/c10.json.gz",
    "the-institution-of-engineering-and-technology": "./styles/c11.json.gz",
    "the-international-journal-of-developmental-biology": "./styles/c12.json.gz",
    "the-international-journal-of-psychoanalysis": "./styles/c13.json.gz",
    "the-international-journal-of-tuberculosis-and-lung-disease": "./styles/c14.json.gz",
    "the-international-spectator": "./styles/c15.json.gz",
    "the-isme-journal": "./styles/c16.json.gz",
    "the-journal-of-adhesive-dentistry": "./styles/c17.json.gz",
    "the-journal-of-agricultural-science": "./styles/c18.json.gz",
    "the-journal-of-bone-and-joint-surgery": "./styles/c19.json.gz",
    "the-journal-of-clinical-ethics": "./styles/c20.json.gz",
    "the-journal-of-clinical-investigation": "./styles/c21.json.gz",
    "the-journal-of-comparative-law": "./styles/c22.json.gz",
    "the-journal-of-comparative-neurology": "./styles/c23.json.gz",
    "the-journal-of-ecclesiastical-history": "./styles/c24.json.gz",
    "the-journal-of-egyptian-archaeology": "./styles/c25.json.gz",
    "the-journal-of-eukaryotic-microbiology": "./styles/c01.json.gz",
    "the-journal-of-foot-and-ankle-surgery": "./styles/c02.json.gz",
    "the-journal-of-hand-surgery-asian-pacific-volume": "./styles/c03.json.gz",
    "the-journal-of-hand-surgery-european-volume": "./styles/c04.json.gz",
    "the-journal-of-hellenic-studies": "./styles/c05.json.gz",
    "the-journal-of-immunology": "./styles/c06.json.gz",
    "the-journal-of-infection-in-developing-countries": "./styles/c07.json.gz",
    "the-journal-of-juristic-papyrology": "./styles/c08.json.gz",
    "the-journal-of-laryngology-and-otology": "./styles/c09.json.gz",
    "the-journal-of-molecular-diagnostics": "./styles/c10.json.gz",
    "the-journal-of-nervous-and-mental-disease": "./styles/c11.json.gz",
    "the-journal-of-neuropsychiatry-and-clinical-neurosciences": "./styles/c12.json.gz",
    "the-journal-of-neuroscience": "./styles/c13.json.gz",
    "the-journal-of-nuclear-medicine": "./styles/c14.json.gz",
    "the-journal-of-nutrition-health-and-aging": "./styles/c15.json.gz",
    "the-journal-of-pain": "./styles/c16.json.gz",
    "the-journal-of-parasitology": "./styles/c17.json.gz",
    "the-journal-of-pathology": "./styles/c18.json.gz",
    "the-journal-of-peasant-studies": "./styles/c19.json.gz",
    "the-journal-of-physiology": "./styles/c20.json.gz",
    "the-journal-of-pure-and-applied-chemistry-research": "./styles/c21.json.gz",
    "the-journal-of-roman-studies": "./styles/c22.json.gz",
    "the-journal-of-the-acoustical-society-of-america-numeric": "./styles/c23.json.gz",
    "the-journal-of-the-acoustical-society-of-america": "./styles/c24.json.gz",
    "the-journal-of-the-torrey-botanical-society": "./styles/c25.json.gz",
    "the-journal-of-transport-history": "./styles/c01.json.gz",
    "the-journal-of-trauma-and-acute-care-surgery": "./styles/c02.json.gz",
    "the-journal-of-urology": "./styles/c03.json.gz",
    "the-journal-of-veterinary-medical-science": "./styles/c04.json.gz",
    "the-journal-of-wildlife-management": "./styles/c05.json.gz",
    "the-korean-journal-of-gastroenterology": "./styles/c06.json.gz",
    "the-korean-journal-of-internal-medicine": "./styles/c07.json.gz",
    "the-korean-journal-of-mycology": "./styles/c08.json.gz",
    "the-lancet": "./styles/c09.json.gz",
    "the-lichenologist": "./styles/c10.json.gz",
    "the-national-medical-journal-of-india": "./styles/c11.json.gz",
    "the-neuroscientist": "./styles/c12.json.gz",
    "the-new-england-journal-of-medicine": "./styles/c13.json.gz",
    "the-oncologist": "./styles/c14.json.gz",
    "the-open-university-a251": "./styles/c15.json.gz",
    "the-open-university-harvard": "./styles/c16.json.gz",
    "the-open-university-m801": "./styles/c17.json.gz",
    "the-open-university-numeric-superscript": "./styles/c18.json.gz",
    "the-open-university-numeric": "./styles/c19.json.gz",
    "the-open-university-s390": "./styles/c20.json.gz",
    "the-optical-society": "./styles/c21.json.gz",
    "the-pan-african-medical-journal": "./styles/c22.json.gz",
    "the-plant-cell": "./styles/c23.json.gz",
    "the-plant-genome": "./styles/c24.json.gz",
    "the-plant-journal": "./styles/c25.json.gz",
    "the-quarterly-journal-of-economics": "./styles/c01.json.gz",
    "the-rockefeller-university-press": "./styles/c02.json.gz",
    "the-saudi-journal-for-dental-research": "./styles/c03.json.gz",
    "the-scandinavian-journal-of-clinical-and-laboratory-investigation": "./styles/c04.json.gz",
    "the-university-of-tokyo-law-review": "./styles/c05.json.gz",
    "the-university-of-western-australia-harvard": "./styles/c06.json.gz",
    "the-university-of-winchester-harvard": "./styles/c07.json.gz",
    "the-world-journal-of-biological-psychiatry": "./styles/c08.json.gz",
    "theologie-und-philosophie": "./styles/c09.json.gz",
    "theory-culture-and-society": "./styles/c10.json.gz",
    "theranostics": "./styles/c11.json.gz",
    "theses-de-sorbonne-universite": "./styles/c12.json.gz",
    "thieme-german": "./styles/c13.json.gz",
    "thomson-reuters-legal-tax-and-accounting-australia": "./styles/c14.json.gz",
    "thrombosis-and-haemostasis": "./styles/c15.json.gz",
    "tijdschrift-voor-economische-en-sociale-geografie": "./styles/c16.json.gz",
    "tijdschrift-voor-geneeskunde": "./styles/c17.json.gz",
    "topoi-orient-occident-auteur-date": "./styles/c18.json.gz",
    "topoi-orient-occident-classique": "./styles/c19.json.gz",
    "trabajos-de-prehistoria": "./styles/c20.json.gz",
    "traces": "./styles/c21.json.gz",
    "traffic-injury-prevention": "./styles/c22.json.gz",
    "traffic": "./styles/c23.json.gz",
    "tramas-y-redes-revista-del-consejo-latinoamericano-de-ciencias-sociales": "./styles/c24.json.gz",
    "trames": "./styles/c25.json.gz",
    "transactions-of-the-american-philological-association": "./styles/c01.json.gz",
    "transactions-of-the-materials-research-society-of-japan": "./styles/c02.json.gz",
    "transactions-of-the-philological-society": "./styles/c03.json.gz",
    "transactions-on-maritime-science": "./styles/c04.json.gz",
    "transboundary-and-emerging-diseases": "./styles/c05.json.gz",
    "transnational-environmental-law": "./styles/c06.json.gz",
    "transplantation": "./styles/c07.json.gz",
    "transport": "./styles/c08.json.gz",
    "transportation-research-record": "./styles/c09.json.gz",
    "transposition": "./styles/c10.json.gz",
    "transversalites": "./styles/c11.json.gz",
    "travail-et-emploi": "./styles/c12.json.gz",
    "trends-in-glycoscience-and-glycotechnology": "./styles/c13.json.gz",
    "trends-journals": "./styles/c14.json.gz",
    "triangle": "./styles/c15.json.gz",
    "trinity-college-dublin-zoology-botany-environmental-sciences-harvard": "./styles/c16.json.gz",
    "tropical-animal-health-and-production": "./styles/c17.json.gz",
    "tsaqafah": "./styles/c18.json.gz",
    "turcica": "./styles/c19.json.gz",
    "turkiye-bilimsel-ve-teknolojik-arastirma-kurumu": "./styles/c20.json.gz",
    "tyndale-bulletin": "./styles/c21.json.gz",
    "u-schylku-starozytnosci": "./styles/c22.json.gz",
    "ucl-institute-of-education-harvard": "./styles/c23.json.gz",
    "ucl-press-note": "./styles/c24.json.gz",
    "ucl-university-college-apa": "./styles/c25.json.gz",
    "ucl-university-college-harvard": "./styles/c01.json.gz",
    "ucl-university-college-vancouver": "./styles/c02.json.gz",
    "uclouvain-centre-charles-de-visscher-pour-le-droit-international-et-europeen": "./styles/c03.json.gz",
    "ugent-geschiedenis-nederlands": "./styles/c04.json.gz",
    "ugeskrift-for-laeger": "./styles/c05.json.gz",
    "ultrasound-in-medicine-and-biology": "./styles/c06.json.gz",
    "ulua-revista-de-historia-sociedad-y-cultura": "./styles/c07.json.gz",
    "uludag-universitesi-sosyal-bilimler-enstitusu-author-date": "./styles/c08.json.gz",
    "uludag-universitesi-sosyal-bilimler-enstitusu-full-note-with-ibid": "./styles/c09.json.gz",
    "uludag-universitesi-sosyal-bilimler-enstitusu-full-note": "./styles/c10.json.gz",
    "uludag-universitesi-sosyal-bilimler-enstitusu-ilahiyat-fakultesi-full-note-with-ibid": "./styles/c11.json.gz",
    "uludag-universitesi-sosyal-bilimler-enstitusu-ilahiyat-fakultesi-full-note": "./styles/c12.json.gz",
    "umea-university-harvard": "./styles/c13.json.gz",
    "umea-university-oxford": "./styles/c14.json.gz",
    "undergraduate-journal-of-experimental-microbiology-and-immunology": "./styles/c15.json.gz",
    "unesco-international-institute-for-educational-planning": "./styles/c16.json.gz",
    "uni-fribourg-theologie": "./styles/c17.json.gz",
    "unified-style-sheet-for-linguistics-de-gruyter-literature": "./styles/c18.json.gz",
    "unified-style-sheet-for-linguistics": "./styles/c19.json.gz",
    "united-nations-conference-on-trade-and-development": "./styles/c20.json.gz",
    "united-nations-development-programme-icca-legal-review": "./styles/c21.json.gz",
    "united-nations-framework-convention-on-climate-change": "./styles/c22.json.gz",
    "united-states-international-trade-commission": "./styles/c23.json.gz",
    "universidad-autonoma-cidudad-juarez-estilo-latino-humanistico": "./styles/c24.json.gz",
    "universidad-de-leon-harvard": "./styles/c25.json.gz",
    "universidad-evangelica-del-paraguay": "./styles/c01.json.gz",
    "universidad-nacional-autonoma-de-mexico-instituto-de-investigaciones-juridicas": "./styles/c02.json.gz",
    "universidade-de-sao-paulo-escola-de-comunicacoes-e-artes-abnt": "./styles/c03.json.gz",
    "universidade-de-sao-paulo-instituto-de-matematica-e-estatistica": "./styles/c04.json.gz",
    "universidade-do-estado-do-rio-de-janeiro-abnt": "./styles/c05.json.gz",
    "universidade-do-porto-faculdade-de-engenharia-chicago-pt": "./styles/c06.json.gz",
    "universidade-do-porto-faculdade-de-engenharia-chicago": "./styles/c07.json.gz",
    "universidade-do-porto-faculdade-de-psicologia-e-de-ciencias-da-educacao": "./styles/c08.json.gz",
    "universidade-estadual-de-alagoas-abnt": "./styles/c09.json.gz",
    "universidade-estadual-do-oeste-do-parana-programa-institucional-de-bolsas-de-iniciacao-cientifica": "./styles/c10.json.gz",
    "universidade-estadual-paulista-campus-de-dracena-abnt": "./styles/c11.json.gz",
    "universidade-estadual-paulista-faculdade-de-engenharia-de-guaratingueta-abnt": "./styles/c12.json.gz",
    "universidade-federal-de-goias-escola-de-veterinaria-e-zootecnia": "./styles/c13.json.gz",
    "universidade-federal-de-juiz-de-fora": "./styles/c14.json.gz",
    "universidade-federal-de-pernambuco-abnt": "./styles/c15.json.gz",
    "universidade-federal-de-sergipe-departamento-de-engenharia-de-producao-abnt": "./styles/c16.json.gz",
    "universidade-federal-do-espirito-santo-abnt-initials": "./styles/c17.json.gz",
    "universidade-federal-do-espirito-santo-abnt": "./styles/c18.json.gz",
    "universidade-federal-do-rio-de-janeiro-instituto-alberto-luiz-coimbra-de-pos-graduacao-e-pesquisa-de-engenharia-abnt": "./styles/c19.json.gz",
    "universita-cattolica-del-sacro-cuore": "./styles/c20.json.gz",
    "universita-di-bologna-lettere": "./styles/c21.json.gz",
    "universita-pontificia-salesiana-it": "./styles/c22.json.gz",
    "universita-pontificia-salesiana": "./styles/c23.json.gz",
    "universitas-brawijaya-fakultas-teknologi-pertanian": "./styles/c24.json.gz",
    "universitas-gadjah-mada-departemen-sejarah": "./styles/c25.json.gz",
    "universitas-gadjah-mada-doctoral-program-in-pharmaceutical-sciences": "./styles/c01.json.gz",
    "universitas-negeri-semarang-fakultas-matematika-dan-ilmu-pengetahuan-alam": "./styles/c02.json.gz",
    "universitas-negeri-yogyakarta-program-pascasarjana": "./styles/c03.json.gz",
    "universitat-basel-deutsche-sprachwissenschaft": "./styles/c04.json.gz",
    "universitat-basel-iberoromanistik": "./styles/c05.json.gz",
    "universitat-bern-institut-fur-musikwissenschaft-note": "./styles/c06.json.gz",
    "universitat-bern-institut-fur-sozialanthropologie": "./styles/c07.json.gz",
    "universitat-bern-institut-fur-theaterwissenschaft": "./styles/c08.json.gz",
    "universitat-bremen-frankoromanistik-literaturwissenschaft": "./styles/c09.json.gz",
    "universitat-bremen-institut-fur-politikwissenschaft": "./styles/c10.json.gz",
    "universitat-bremen-lehrstuhl-fur-innovatives-markenmanagement": "./styles/c11.json.gz",
    "universitat-freiburg-geschichte": "./styles/c12.json.gz",
    "universitat-graz-geographie": "./styles/c13.json.gz",
    "universitat-heidelberg-historisches-seminar": "./styles/c14.json.gz",
    "universitat-heidelberg-medizinische-fakultat-mannheim-numeric": "./styles/c15.json.gz",
    "universitat-mainz-geographisches-institut": "./styles/c16.json.gz",
    "universitat-mannheim-germanistische-linguistik": "./styles/c17.json.gz",
    "universitat-stuttgart-planung-und-partizipation": "./styles/c18.json.gz",
    "universitat-vechta-katholische-theologie": "./styles/c19.json.gz",
    "universitat-wien-institut-fur-geschichte": "./styles/c20.json.gz",
    "universitat-wurzburg-institut-fur-deutsche-philologie-museologie": "./styles/c21.json.gz",
    "universitat-zu-koln-seminar-fur-abwl-und-finanzierungslehre": "./styles/c22.json.gz",
    "universitatsmedizin-gottingen": "./styles/c23.json.gz",
    "universite-catholique-de-louvain-fial": "./styles/c24.json.gz",
    "universite-catholique-de-louvain-histoire": "./styles/c25.json.gz",
    "universite-cheikh-anta-diop-faculte-de-medecine-de-pharmacie-et-dodontologie": "./styles/c01.json.gz",
    "universite-de-bordeaux-ecole-doctorale-de-droit": "./styles/c02.json.gz",
    "universite-de-geneve-departement-de-langue-et-de-litterature-francaises-modernes": "./styles/c03.json.gz",
    "universite-de-lausanne-histoire": "./styles/c04.json.gz",
    "universite-de-lausanne-institut-d-archeologie-et-des-sciences-de-l-antiquite": "./styles/c05.json.gz",
    "universite-de-liege-droit-par-categorie": "./styles/c06.json.gz",
    "universite-de-liege-droit": "./styles/c07.json.gz",
    "universite-de-liege-histoire": "./styles/c08.json.gz",
    "universite-de-montreal-apa": "./styles/c09.json.gz",
    "universite-de-montreal-faculte-de-musique": "./styles/c10.json.gz",
    "universite-de-montreal-nlm-fr-ca": "./styles/c11.json.gz",
    "universite-de-picardie-jules-verne-ufr-de-medecine": "./styles/c12.json.gz",
    "universite-de-sherbrooke-departement-de-geomatique": "./styles/c13.json.gz",
    "universite-de-sherbrooke-faculte-d-education": "./styles/c14.json.gz",
    "universite-de-sherbrooke-histoire": "./styles/c15.json.gz",
    "universite-du-quebec-a-montreal-departement-dhistoire": "./styles/c16.json.gz",
    "universite-du-quebec-a-montreal-etudes-litteraires-et-semiologie": "./styles/c17.json.gz",
    "universite-du-quebec-a-montreal-prenoms": "./styles/c18.json.gz",
    "universite-du-quebec-a-montreal": "./styles/c19.json.gz",
    "universite-gustave-eiffel-arts-numeriques-et-cultures-visuelles": "./styles/c20.json.gz",
    "universite-laval-departement-des-sciences-historiques": "./styles/c21.json.gz",
    "universite-laval-departement-dinformation-et-de-communication": "./styles/c22.json.gz",
    "universite-laval-faculte-de-theologie-et-de-sciences-religieuses": "./styles/c23.json.gz",
    "universite-libre-de-bruxelles-histoire": "./styles/c24.json.gz",
    "universite-nangui-abrogoua-sciences-de-la-nature-apa": "./styles/c25.json.gz",
    "universiteit-utrecht-onderzoeksgids-geschiedenis": "./styles/c01.json.gz",
    "universitetet-i-oslo-rettsvitenskap": "./styles/c02.json.gz",
    "universiti-kebangsaan-malaysia": "./styles/c03.json.gz",
    "university-college-dublin-school-of-history-and-archives": "./styles/c04.json.gz",
    "university-college-lillebaelt-apa": "./styles/c05.json.gz",
    "university-of-aberdeen-school-of-education-harvard": "./styles/c06.json.gz",
    "university-of-aleppo-faculty-of-medicine": "./styles/c07.json.gz",
    "university-of-auckland-history": "./styles/c08.json.gz",
    "university-of-bradford-harvard": "./styles/c09.json.gz",
    "university-of-bucharest-faculty-of-law": "./styles/c10.json.gz",
    "university-of-cambridge-faculty-of-history": "./styles/c11.json.gz",
    "university-of-gothenburg-apa-7th-edition-swedish-legislations": "./styles/c12.json.gz",
    "university-of-gothenburg-apa-swedish-legislations": "./styles/c13.json.gz",
    "university-of-helsinki-faculty-of-theology": "./styles/c14.json.gz",
    "university-of-hull-harvard": "./styles/c15.json.gz",
    "university-of-lincoln-harvard": "./styles/c16.json.gz",
    "university-of-new-england-australia-note": "./styles/c17.json.gz",
    "university-of-new-south-wales-notes": "./styles/c18.json.gz",
    "university-of-pretoria-harvard-theology-religion": "./styles/c19.json.gz",
    "university-of-roehampton-harvard": "./styles/c20.json.gz",
    "university-of-south-africa-harvard": "./styles/c21.json.gz",
    "university-of-south-australia-2017-harvard": "./styles/c22.json.gz",
    "university-of-south-australia-harvard-2011": "./styles/c23.json.gz",
    "university-of-south-australia-harvard-2013": "./styles/c24.json.gz",
    "university-of-south-wales-harvard": "./styles/c25.json.gz",
    "university-of-tasmania-simplified-author-date": "./styles/c01.json.gz",
    "university-of-york-harvard-archaeology": "./styles/c02.json.gz",
    "university-of-york-harvard-environment": "./styles/c03.json.gz",
    "university-of-york-harvard": "./styles/c04.json.gz",
    "university-of-zabol-fa": "./styles/c05.json.gz",
    "university-of-zabol": "./styles/c06.json.gz",
    "univerza-na-primorskem-fakulteta-za-vede-o-zdravju-apa": "./styles/c07.json.gz",
    "univerza-v-ljubljani-fakulteta-za-gradbenistvo-in-geodezijo-apa-7": "./styles/c08.json.gz",
    "univerza-v-ljubljani-fakulteta-za-kemijo-in-kemijsko-tehnologijo": "./styles/c09.json.gz",
    "uniwersytet-gdanski-kulturoznawstwo-autor-rok": "./styles/c10.json.gz",
    "uniwersytet-gdanski-kulturoznawstwo-przypis": "./styles/c11.json.gz",
    "uniwersytet-im-adama-mickiewicza-w-poznaniu-wydzial-anglistyki": "./styles/c12.json.gz",
    "uniwersytet-kardynala-stefana-wyszynskiego-w-warszawie-autor-rok": "./styles/c13.json.gz",
    "uniwersytet-kardynala-stefana-wyszynskiego-w-warszawie-przypis": "./styles/c14.json.gz",
    "uppsala-universitet-historia": "./styles/c15.json.gz",
    "uppsala-universitet-institutionen-for-biologisk-grundutbildning": "./styles/c16.json.gz",
    "uppsala-university-library-harvard": "./styles/c17.json.gz",
    "urad-rs-za-makroekonomske-analize-in-razvoj": "./styles/c18.json.gz",
    "urban-geography": "./styles/c19.json.gz",
    "urban-habitats": "./styles/c20.json.gz",
    "urban-studies": "./styles/c21.json.gz",
    "urbani-izziv-en": "./styles/c22.json.gz",
    "urbani-izziv": "./styles/c23.json.gz",
    "urological-science": "./styles/c24.json.gz",
    "us-geological-survey": "./styles/c25.json.gz",
    "usda-forest-service-pacific-northwest-research-station": "./styles/c01.json.gz",
    "user-modeling-and-user-adapted-interaction": "./styles/c02.json.gz",
    "uspekhi-gerontologii": "./styles/c03.json.gz",
    "utah-geological-survey": "./styles/c04.json.gz",
    "van-yuzuncu-yil-universitesi-fen-bilimleri-enstitusu": "./styles/c05.json.gz",
    "veterinaria-italiana": "./styles/c06.json.gz",
    "veterinary-anaesthesia-analgesia": "./styles/c07.json.gz",
    "veterinary-clinical-pathology": "./styles/c08.json.gz",
    "veterinary-medicine-austria": "./styles/c09.json.gz",
    "veterinary-microbiology": "./styles/c10.json.gz",
    "veterinary-pathology": "./styles/c11.json.gz",
    "veterinary-radiology-and-ultrasound": "./styles/c12.json.gz",
    "veterinary-record-open": "./styles/c13.json.gz",
    "veterinary-record": "./styles/c14.json.gz",
    "victoria-university-harvard": "./styles/c15.json.gz",
    "vienna-legal": "./styles/c16.json.gz",
    "vietnam-journal-of-science-and-technology": "./styles/c17.json.gz",
    "vietnam-ministry-of-education-and-training-en": "./styles/c18.json.gz",
    "vietnam-ministry-of-education-and-training-vi": "./styles/c19.json.gz",
    "vigiliae-christianae": "./styles/c20.json.gz",
    "vingtieme-siecle": "./styles/c21.json.gz",
    "vita-latina-auteurs-anciens": "./styles/c22.json.gz",
    "vita-latina": "./styles/c23.json.gz",
    "vitis-journal-of-grapevine-research": "./styles/c24.json.gz",
    "vodohospodarske-technicko-ekonomicke-informace-en": "./styles/c25.json.gz",
    "vodohospodarske-technicko-ekonomicke-informace": "./styles/c01.json.gz",
    "vox-sanguinis": "./styles/c02.json.gz",
    "wader-study": "./styles/c03.json.gz",
    "water-alternatives": "./styles/c04.json.gz",
    "water-environment-research": "./styles/c05.json.gz",
    "water-sa": "./styles/c06.json.gz",
    "water-science-and-technology": "./styles/c07.json.gz",
    "waterbirds": "./styles/c08.json.gz",
    "weed-research": "./styles/c09.json.gz",
    "weed-science-society-of-america": "./styles/c10.json.gz",
    "west-european-politics": "./styles/c11.json.gz",
    "western-journal-of-emergency-medicine": "./styles/c12.json.gz",
    "westfalische-wilhelms-universitat-munster-medizinische-fakultat": "./styles/c13.json.gz",
    "wetlands": "./styles/c14.json.gz",
    "wheaton-college-phd-in-biblical-and-theological-studies": "./styles/c15.json.gz",
    "who-europe-harvard": "./styles/c16.json.gz",
    "who-europe-numeric": "./styles/c17.json.gz",
    "wiener-digitale-revue": "./styles/c18.json.gz",
    "wiesbaden-business-school": "./styles/c19.json.gz",
    "wikipedia-fr-templates": "./styles/c20.json.gz",
    "wikipedia-templates": "./styles/c21.json.gz",
    "wiley-vch-books": "./styles/c22.json.gz",
    "wiley-was": "./styles/c23.json.gz",
    "wireless-communications-and-mobile-computing": "./styles/c24.json.gz",
    "wirtschaftsuniversitat-wien-abteilung-fur-bildungswissenschaft": "./styles/c25.json.gz",
    "wirtschaftsuniversitat-wien-author-date": "./styles/c01.json.gz",
    "wirtschaftsuniversitat-wien-handel-und-marketing": "./styles/c02.json.gz",
    "wirtschaftsuniversitat-wien-health-care-management": "./styles/c03.json.gz",
    "wirtschaftsuniversitat-wien-institut-fur-bwl-des-aussenhandels": "./styles/c04.json.gz",
    "wirtschaftsuniversitat-wien-institut-fur-transportwirtschaft-und-logistik": "./styles/c05.json.gz",
    "wirtschaftsuniversitat-wien-unternehmensrechnung-und-controlling": "./styles/c06.json.gz",
    "wirtschaftsuniversitat-wien-wirtschaftspadagogik": "./styles/c07.json.gz",
    "wissenschaftlicher-industrielogistik-dialog": "./styles/c08.json.gz",
    "wolters-kluwerbrede-schrijfwijzer-author-date": "./styles/c09.json.gz",
    "world-applied-sciences-journal": "./styles/c10.json.gz",
    "world-congress-on-engineering-asset-management": "./styles/c11.json.gz",
    "world-mycotoxin-journal": "./styles/c12.json.gz",
    "world-organisation-for-animal-health-scientific-and-technical-review": "./styles/c13.json.gz",
    "world-politics": "./styles/c14.json.gz",
    "worlds-poultry-science-journal": "./styles/c15.json.gz",
    "worlds-veterinary-journal": "./styles/c16.json.gz",
    "xenotransplantation": "./styles/c17.json.gz",
    "yeast": "./styles/c18.json.gz",
    "yozgat-bozok-universitesi-fen-bilimleri-enstitusu": "./styles/c19.json.gz",
    "zastosowania-komputerow-w-elektrotechnice": "./styles/c20.json.gz",
    "zdfm-zeitschrift-fur-diversitatsforschung-und-management": "./styles/c21.json.gz",
    "zdravniski-vestnik": "./styles/c22.json.gz",
    "zeitgeschichte": "./styles/c23.json.gz",
    "zeithistorische-forschungen": "./styles/c24.json.gz",
    "zeitschrift-fur-allgemeinmedizin": "./styles/c25.json.gz",
    "zeitschrift-fur-antikes-christentum": "./styles/c01.json.gz",
    "zeitschrift-fur-deutsche-philologie": "./styles/c02.json.gz",
    "zeitschrift-fur-die-geschichte-des-oberrheins": "./styles/c03.json.gz",
    "zeitschrift-fur-digitale-geisteswissenschaften": "./styles/c04.json.gz",
    "zeitschrift-fur-fantastikforschung": "./styles/c05.json.gz",
    "zeitschrift-fur-geschichtsdidaktik": "./styles/c06.json.gz",
    "zeitschrift-fur-internationale-beziehungen": "./styles/c07.json.gz",
    "zeitschrift-fur-kunstgeschichte": "./styles/c08.json.gz",
    "zeitschrift-fur-medien-und-kulturforschung": "./styles/c09.json.gz",
    "zeitschrift-fur-medienwissenschaft": "./styles/c10.json.gz",
    "zeitschrift-fur-ostmitteleuropa-forschung": "./styles/c11.json.gz",
    "zeitschrift-fur-padagogik": "./styles/c12.json.gz",
    "zeitschrift-fur-papyrologie-und-epigraphik": "./styles/c13.json.gz",
    "zeitschrift-fur-parlamentsfragen": "./styles/c14.json.gz",
    "zeitschrift-fur-politik": "./styles/c15.json.gz",
    "zeitschrift-fur-qualitative-forschung": "./styles/c16.json.gz",
    "zeitschrift-fur-religionswissenschaft-author-date": "./styles/c17.json.gz",
    "zeitschrift-fur-religionswissenschaft-note": "./styles/c18.json.gz",
    "zeitschrift-fur-soziologie": "./styles/c19.json.gz",
    "zeitschrift-fur-theologie-und-kirche": "./styles/c20.json.gz",
    "zeitschrift-fur-theologie-und-philosophie": "./styles/c21.json.gz",
    "zeitschrift-fur-zahnarztliche-implantologie": "./styles/c22.json.gz",
    "zeszyty-prawnicze-bas": "./styles/c23.json.gz",
    "zilsel": "./styles/c24.json.gz",
    "zitierguide-leitfaden-zum-fachgerechten-zitieren-in-rechtswissenschaftlichen-arbeiten": "./styles/c25.json.gz",
    "zoological-journal-of-the-linnean-society": "./styles/c01.json.gz",
    "zoological-science": "./styles/c02.json.gz",
    "zootaxa": "./styles/c03.json.gz",
    "zurcher-hochschule-fur-angewandte-wissenschaften-soziale-arbeit": "./styles/c04.json.gz",
    "zwitscher-maschine": "./styles/c05.json.gz"
}

export const styles = {
    "aci-materials-journal": "ACI Materials Journal",
    "acm-sig-proceedings-long-author-list": "ACM SIG Proceedings (\"et al.\" for 15+ authors)",
    "acm-sig-proceedings": "ACM SIG Proceedings (\"et al.\" for 3+ authors)",
    "acm-sigchi-proceedings": "ACM SIGCHI Proceedings (2016)",
    "acm-sigchi-proceedings-extended-abstract-format": "ACM SIGCHI Proceedings - Extended Abstract Format",
    "acm-siggraph": "ACM SIGGRAPH",
    "acme-an-international-journal-for-critical-geographies": "ACME: An International Journal for Critical Geographies",
    "american-chemical-society": "ACS Guide 2022 revision",
    "aib-studi": "AIB studi (Italiano)",
    "aids": "AIDS",
    "aims-press": "AIMS Press",
    "american-institute-of-physics": "AIP Style Manual 4th edition",
    "american-medical-association-10th-edition": "AMA Manual of Style 10th edition",
    "american-medical-association": "AMA Manual of Style 11th edition",
    "american-medical-association-brackets": "AMA Manual of Style 11th edition (brackets)",
    "american-medical-association-no-et-al": "AMA Manual of Style 11th edition (no \"et al.\")",
    "american-medical-association-parentheses": "AMA Manual of Style 11th edition (parentheses)",
    "american-medical-association-alphabetical": "AMA Manual of Style 11th edition (sorted alphabetically)",
    "american-medical-association-no-url-alphabetical": "AMA Manual of Style 11th edition (sorted alphabetically, without URLs)",
    "american-medical-association-no-url": "AMA Manual of Style 11th edition (without URLs)",
    "ambio": "AMBIO",
    "associacao-nacional-de-pesquisa-e-ensino-em-transportes": "ANPET - Congresso de Pesquisa e Ensino em Transportes (Português - Brasil)",
    "apa-6th-edition": "APA Style 6th edition",
    "apa-fr-provost": "APA Style 6th edition (Provost) (Français - Canada)",
    "apa-tr": "APA Style 6th edition (Türkçe)",
    "apa": "APA Style 7th edition",
    "apa-eu": "APA Style 7th edition (Basque/Euskara)",
    "apa-annotated-bibliography": "APA Style 7th edition (annotated bibliography)",
    "apa-cv": "APA Style 7th edition (curriculum vitae, sorted by descending date)",
    "apa-no-ampersand": "APA Style 7th edition (no ampersand)",
    "apa-no-initials": "APA Style 7th edition (no initials)",
    "apa-numeric-superscript": "APA Style 7th edition (numeric, superscript)",
    "apa-numeric-superscript-brackets": "APA Style 7th edition (numeric, superscript, brackets)",
    "apa-single-spaced": "APA Style 7th edition (single-spaced bibliography)",
    "apa-with-abstract": "APA Style 7th edition (with abstract)",
    "american-political-science-association": "APSA Style Manual revised 2018 edition",
    "american-sociological-association": "ASA Style Guide 6th/7th edition",
    "asaio-journal": "ASAIO Journal (American Society for Artificial Internal Organs)",
    "azr-abkurzungs-und-zitierregeln-der-osterreichischen-rechtssprache-und-europarechtlicher-rechtsquellen": "AZR - Abkürzungs- und Zitierregeln der österreichischen Rechtssprache und europarechtlicher Rechtsquellen (Deutsch - Österreich)",
    "academy-of-management-perspectives": "Academy of Management Perspectives",
    "academy-of-management-review": "Academy of Management Review",
    "accident-analysis-and-prevention": "Accident Analysis and Prevention",
    "acta-adriatica": "Acta Adriatica",
    "acta-amazonica": "Acta Amazonica",
    "acta-anaesthesiologica-scandinavica": "Acta Anaesthesiologica Scandinavica",
    "acta-anaesthesiologica-taiwanica": "Acta Anaesthesiologica Taiwanica",
    "acta-botanica-croatica": "Acta Botanica Croatica",
    "acta-chiropterologica": "Acta Chiropterologica",
    "acta-medica-peruana": "Acta Médica Peruana",
    "acta-medica-portuguesa": "Acta Médica Portuguesa",
    "acta-naturae": "Acta Naturae",
    "acta-neurobiologiae-experimentalis": "Acta Neurobiologiae Experimentalis",
    "acta-neurochirurgica": "Acta Neurochirurgica",
    "acta-ophthalmologica": "Acta Ophthalmologica",
    "acta-ornithologica": "Acta Ornithologica",
    "acta-orthopaedica": "Acta Orthopaedica",
    "acta-orthopaedica-belgica": "Acta Orthopædica Belgica",
    "acta-paediatrica": "Acta Paediatrica",
    "acta-palaeontologica-polonica": "Acta Palaeontologica Polonica",
    "acta-pharmaceutica": "Acta Pharmaceutica",
    "acta-pharmaceutica-sinica-b": "Acta Pharmaceutica Sinica B",
    "acta-philosophica": "Acta Philosophica",
    "acta-physica-sinica": "Acta Physica Sinica (物理学报)",
    "acta-physiologica": "Acta Physiologica",
    "acta-polytechnica": "Acta Polytechnica",
    "acta-radiologica": "Acta Radiologica",
    "acta-scientiae-veterinariae": "Acta Scientiae Veterinariae",
    "acta-societatis-botanicorum-poloniae": "Acta Societatis Botanicorum Poloniae",
    "acta-universitatis-agriculturae-sueciae": "Acta Universitatis Agriculturae Sueciae (Swedish University of Agricultural Sciences)",
    "acta-universitatis-agriculturae-et-silviculturae-mendelianae-brunensis": "Acta Universitatis Agriculturae et Silviculturae Mendelianae Brunensis",
    "auci": "Acta Universitatis Carolinae Iuridica (Čeština)",
    "acta-zoologica-academiae-scientiarum-hungaricae": "Acta Zoologica Academiae Scientiarum Hungaricae",
    "acta-chirurgiae-orthopaedicae-et-traumatologiae-cechoslovaca": "Acta chirurgiae orthopaedicae et traumatologiae Čechoslovaca",
    "acta-hydrotechnica": "Acta hydrotechnica",
    "administrative-science-quarterly": "Administrative Science Quarterly",
    "advanced-engineering-materials": "Advanced Engineering Materials",
    "advanced-functional-materials": "Advanced Functional Materials",
    "advanced-healthcare-materials": "Advanced Healthcare Materials",
    "advanced-materials": "Advanced Materials",
    "advanced-optical-materials": "Advanced Optical Materials",
    "advanced-pharmaceutical-bulletin": "Advanced Pharmaceutical Bulletin",
    "advanced-science": "Advanced Science",
    "advances-in-alzheimers-disease": "Advances in Alzheimer's Disease",
    "advances-in-complex-systems": "Advances in Complex Systems",
    "aerosol-science-and-technology": "Aerosol Science and Technology",
    "aerosol-and-air-quality-research": "Aerosol and Air Quality Research",
    "aerospace-medicine-and-human-performance": "Aerospace Medicine and Human Performance",
    "african-journal-of-marine-science": "African Journal of Marine Science",
    "african-online-scientific-information-systems-harvard": "African Online Scientific Information Systems (author-date/Harvard)",
    "african-online-scientific-information-systems-vancouver": "African Online Scientific Information Systems - NLM/Vancouver",
    "african-zoology": "African Zoology",
    "afro-asia": "Afro-Ásia (Português - Brasil)",
    "ageing-and-society": "Ageing & Society",
    "aging": "Aging",
    "aging-cell": "Aging Cell",
    "aging-and-disease": "Aging and Disease",
    "agora": "Agora",
    "agriculturae-conspectus-scientificus": "Agriculturae Conspectus Scientificus",
    "aix-marseille-universite-departement-d-etudes-asiatiques": "Aix-Marseille Université - Département d'études asiatiques (Français)",
    "al-jamiah-journal-of-islamic-studies": "Al-Jami'ah - Journal of Islamic Studies",
    "universitat-freiburg-geschichte": "Albert-Ludwigs-Universität Freiburg - Geschichte (Deutsch)",
    "alcohol-and-alcoholism": "Alcohol and Alcoholism",
    "alcoholism-clinical-and-experimental-research": "Alcoholism: Clinical and Experimental Research",
    "alkoholizmus-a-drogove-zavislosti": "Alkoholizmus a drogové závislosti",
    "allergology-international": "Allergology International",
    "allergy": "Allergy",
    "alternatif-politika": "Alternatif Politika",
    "alternatives-to-animal-experimentation": "Alternatives to Animal Experimentation",
    "ameghiniana": "Ameghiniana",
    "american-anthropological-association": "American Anthropological Association",
    "american-association-for-cancer-research": "American Association for Cancer Research",
    "american-association-of-petroleum-geologists": "American Association of Petroleum Geologists",
    "american-college-of-clinical-pharmacy": "American College of Clinical Pharmacy",
    "american-fisheries-society": "American Fisheries Society",
    "american-geophysical-union": "American Geophysical Union",
    "american-heart-association": "American Heart Association",
    "american-institute-of-aeronautics-and-astronautics": "American Institute of Aeronautics and Astronautics",
    "american-journal-of-archaeology": "American Journal of Archaeology",
    "american-journal-of-botany": "American Journal of Botany",
    "american-journal-of-cancer-research": "American Journal of Cancer Research",
    "american-journal-of-climate-change": "American Journal of Climate Change",
    "american-journal-of-clinical-pathology": "American Journal of Clinical Pathology",
    "american-journal-of-enology-and-viticulture": "American Journal of Enology and Viticulture",
    "american-journal-of-health-behavior": "American Journal of Health Behavior",
    "american-journal-of-medical-genetics": "American Journal of Medical Genetics",
    "american-journal-of-neuroradiology": "American Journal of Neuroradiology",
    "american-journal-of-orthodontics-and-dentofacial-orthopedics": "American Journal of Orthodontics & Dentofacial Orthopedics",
    "american-journal-of-plant-sciences": "American Journal of Plant Sciences",
    "american-journal-of-political-science": "American Journal of Political Science",
    "american-journal-of-respiratory-and-critical-care-medicine": "American Journal of Respiratory and Critical Care Medicine",
    "american-journal-of-roentgenology": "American Journal of Roentgenology",
    "american-journal-of-science": "American Journal of Science",
    "american-journal-of-sociology": "American Journal of Sociology",
    "american-journal-of-sonography": "American Journal of Sonography",
    "american-journal-of-surgical-pathology": "American Journal of Surgical Pathology",
    "american-journal-of-translational-research": "American Journal of Translational Research",
    "american-marketing-association": "American Marketing Association",
    "american-mathematical-society-label": "American Mathematical Society (label)",
    "american-mathematical-society-numeric": "American Mathematical Society (numeric)",
    "american-meteorological-society": "American Meteorological Society",
    "american-mineralogist": "American Mineralogist",
    "american-nuclear-society": "American Nuclear Society",
    "american-physics-society": "American Physical Society",
    "american-physics-society-without-titles": "American Physical Society (without titles)",
    "american-physical-society-et-al": "American Physical Society - et al. (if more than 3 authors)",
    "american-physiological-society": "American Physiological Society",
    "american-phytopathological-society": "American Phytopathological Society",
    "american-school-of-classical-studies-at-athens": "American School of Classical Studies at Athens",
    "american-society-for-horticultural-science": "American Society for Horticultural Science",
    "american-society-for-microbiology": "American Society for Microbiology",
    "american-society-for-pharmacology-and-experimental-therapeutics": "American Society for Pharmacology and Experimental Therapeutics",
    "american-society-of-agricultural-and-biological-engineers": "American Society of Agricultural and Biological Engineers",
    "asa-cssa-sssa": "American Society of Agronomy, Crop Science Society of America, Soil Science Society of America",
    "american-society-of-civil-engineers": "American Society of Civil Engineers",
    "american-society-of-mechanical-engineers": "American Society of Mechanical Engineers",
    "american-statistical-association": "American Statistical Association",
    "american-veterinary-medical-association": "American Veterinary Medical Association",
    "amerindia": "Amerindia",
    "amphibia-reptilia": "Amphibia-Reptilia",
    "anabases": "Anabases",
    "anaesthesia": "Anaesthesia",
    "anais-da-academia-brasileira-de-ciencias": "Anais da Academia Brasileira de Ciências",
    "analytical-sciences": "Analytical Sciences",
    "anatomical-sciences-education": "Anatomical Sciences Education",
    "ancilla-iuris": "Ancilla Iuris",
    "andean-geology": "Andean Geology",
    "anesthesia-and-analgesia": "Anesthesia and Analgesia",
    "anesthesiology": "Anesthesiology",
    "angewandte-chemie": "Angewandte Chemie International Edition",
    "angiologia": "Angiologia (Español)",
    "angiology": "Angiology",
    "anglia": "Anglia",
    "harvard-anglia-ruskin-university": "Anglia Ruskin University (author-date/Harvard)",
    "animal-conservation": "Animal Conservation",
    "animal-migration": "Animal Migration",
    "animal-welfare": "Animal Welfare",
    "ankara-universitesi-sosyal-bilimler-enstitusu-hukuk-fakultesi": "Ankara Üniversitesi - Sosyal Bilimler Enstitüsü - Hukuk Fakültesi (Türkçe)",
    "annalen-des-naturhistorischen-museums-in-wien": "Annalen des Naturhistorischen Museums in Wien",
    "annales-de-demographie-historique": "Annales de démographie historique",
    "annales": "Annales. Histoire, Sciences sociales (Français)",
    "annals-of-allergy-asthma-and-immunology": "Annals of Allergy, Asthma & Immunology",
    "annals-of-applied-biology": "Annals of Applied Biology",
    "annals-of-behavioral-medicine": "Annals of Behavioral Medicine",
    "annals-of-biomedical-engineering": "Annals of Biomedical Engineering",
    "annals-of-botany": "Annals of Botany",
    "annals-of-eye-science": "Annals of Eye Science",
    "annals-of-joint": "Annals of Joint",
    "annals-of-laboratory-medicine": "Annals of Laboratory Medicine",
    "annals-of-neurology": "Annals of Neurology",
    "annals-of-oncology": "Annals of Oncology",
    "annals-of-public-and-cooperative-economics": "Annals of Public and Cooperative Economics",
    "annals-of-surgery": "Annals of Surgery",
    "annals-of-the-association-of-american-geographers": "Annals of the Association of American Geographers",
    "annals-of-the-new-york-academy-of-sciences": "Annals of the New York Academy of Sciences",
    "annual-review-of-astronomy-and-astrophysics": "Annual Review of Astronomy and Astrophysics",
    "annual-review-of-linguistics": "Annual Review of Linguistics",
    "annual-review-of-medicine": "Annual Review of Medicine",
    "annual-review-of-nuclear-and-particle-science": "Annual Review of Nuclear and Particle Science",
    "annual-reviews-author-date": "Annual Reviews (author-date)",
    "annual-reviews-alphabetical": "Annual Reviews (sorted alphabetically)",
    "annual-reviews": "Annual Reviews (sorted by order of appearance)",
    "annual-reviews-without-titles": "Annual Reviews (sorted by order of appearance, without titles)",
    "antarctic-science": "Antarctic Science",
    "anthropologie-et-societes": "Anthropologie et Sociétés (Français)",
    "anti-trafficking-review": "Anti-Trafficking Review",
    "anticancer-research": "Anticancer Research",
    "antipode": "Antipode",
    "antiquity": "Antiquity",
    "antiquites-africaines": "Antiquités africaines",
    "aporia-the-nursing-journal": "Aporia: The Nursing Journal",
    "applications-in-plant-sciences": "Applications in Plant Sciences",
    "applied-clay-science": "Applied Clay Science",
    "applied-spectroscopy": "Applied Spectroscopy",
    "applied-spectroscopy-reviews": "Applied Spectroscopy Reviews",
    "aquatic-conservation": "Aquatic Conservation: Marine and Freshwater Ecosystems",
    "aquatic-invasions": "Aquatic Invasions",
    "aquatic-living-resources": "Aquatic Living Resources",
    "aquitania": "Aquitania (Français)",
    "arachne": "Arachne",
    "arachnologische-mitteilungen": "Arachnologische Mitteilungen",
    "arachnology": "Arachnology",
    "arcadia-science": "Arcadia Science",
    "archaeologia-austriaca": "Archaeologia Austriaca",
    "archaeometry": "Archaeometry",
    "archaeonautica": "Archaeonautica",
    "archeosciences": "ArcheoSciences (Français)",
    "archeologia-classica": "Archeologia Classica (Italiano)",
    "archeologia-e-calcolatori": "Archeologia e Calcolatori",
    "archeologicke-rozhledy": "Archeologické rozhledy",
    "archimede-archeologie-et-histoire-ancienne": "Archimède. Archéologie et histoire ancienne (French)",
    "archiv-fur-geschichte-der-philosophie": "Archiv für Geschichte der Philosophie",
    "archiv-fur-die-civilistische-praxis": "Archiv für die civilistische Praxis (Deutsch)",
    "archives-of-hand-and-microsurgery": "Archives of Hand and Microsurgery",
    "archives-of-medical-research": "Archives of Medical Research",
    "archives-of-physical-medicine-and-rehabilitation": "Archives of Physical Medicine and Rehabilitation",
    "archivos-peruanos-de-cardiologia-y-cirugia-cardiovascular": "Archivos Peruanos de Cardiología y Cirugía Cardiovascular",
    "archivos-de-bronconeumologia": "Archivos de Bronconeumología",
    "archivos-de-la-sociedad-espanola-de-oftalmologia": "Archivos de la Sociedad Española de Oftalmología (Español)",
    "archivum-latinitatis-medii-aevi": "Archivum Latinitatis Medii Aevi (Français)",
    "archeologie-medievale": "Archéologie médiévale (Français)",
    "archeologies-et-sciences-de-lantiquite": "Archéologies et Sciences de l'Antiquité (Français)",
    "arctic": "Arctic",
    "arctic-antarctic-and-alpine-research": "Arctic, Antarctic, and Alpine Research",
    "arhiv-za-higijenu-rada-i-toksikologiju": "Arhiv za higijenu rada i toksikologiju (Archives of Industrial Hygiene and Toxicology)",
    "arkivoc": "Arkivoc",
    "art-history": "Art History",
    "art-libraries-society-of-north-america-arlisna-reviews": "Art Libraries Society of North America: ARLIS/NA Reviews",
    "artery-research": "Artery Research",
    "arthritis-and-rheumatism": "Arthritis & Rheumatism",
    "arthropod-systematics-and-phylogeny": "Arthropod Systematics & Phylogeny",
    "arts-university-bournemouth": "Arts University Bournemouth",
    "arzneimitteltherapie": "Arzneimitteltherapie",
    "asia-and-the-pacific-policy-studies": "Asia & the Pacific Policy Studies",
    "asia-pacific-journal-of-human-resources": "Asia Pacific Journal of Human Resources",
    "asian-journal-of-neurosurgery": "Asian Journal of Neurosurgery",
    "asian-myrmecology": "Asian Myrmecology",
    "asian-studies-review": "Asian Studies Review",
    "association-de-science-regionale-de-langue-francaise": "Association de Science Régionale de Langue Française (Français)",
    "association-for-computational-linguistics": "Association for Computational Linguistics - Conference Proceedings",
    "association-for-computing-machinery": "Association for Computing Machinery",
    "associacao-brasileira-de-normas-tecnicas": "Associação Brasileira de Normas Técnicas (Português - Brasil)",
    "associacao-brasileira-de-normas-tecnicas-note": "Associação Brasileira de Normas Técnicas (note, Português - Brasil)",
    "associacao-brasileira-de-normas-tecnicas-numerico": "Associação Brasileira de Normas Técnicas (numérico, Português - Brasil)",
    "atlande": "Atlande (author-date, Français)",
    "atlas-of-genetics-and-cytogenetics-in-oncology-and-haematology": "Atlas of Genetics and Cytogenetics in Oncology and Haematology",
    "ausonius-editions": "Ausonius Éditions",
    "austral-ecology": "Austral Ecology",
    "austral-entomology": "Austral Entomology",
    "australasian-journal-of-philosophy": "Australasian Journal of Philosophy",
    "australian-archaeology": "Australian Archaeology",
    "australian-critical-care": "Australian Critical Care",
    "australian-dental-journal": "Australian Dental Journal",
    "australian-guide-to-legal-citation-3rd-edition": "Australian Guide to Legal Citation 3rd edition",
    "australian-guide-to-legal-citation": "Australian Guide to Legal Citation 4th edition",
    "australian-historical-studies": "Australian Historical Studies",
    "australian-journal-of-earth-sciences": "Australian Journal of Earth Sciences",
    "australian-journal-of-grape-and-wine-research": "Australian Journal of Grape and Wine Research",
    "australian-road-research-board": "Australian Road Research Board",
    "australian-veterinary-journal": "Australian Veterinary Journal",
    "austrian-journal-of-development-studies": "Austrian Journal of Development Studies (Journal für Entwicklungspolitik)",
    "austrian-legal": "Austrian Legal (Deutsch - Österreich)",
    "aves": "Aves (Français)",
    "avian-conservation-and-ecology": "Avian Conservation and Ecology",
    "avian-diseases": "Avian Diseases",
    "avian-pathology": "Avian Pathology",
    "avocetta-journal-of-ornithology": "Avocetta Journal of Ornithology",
    "ayer": "Ayer (Español)",
    "babesch-annual-papers-on-mediterranean-archaeology": "BABESCH - Annual Papers on Mediterranean Archaeology",
    "bmj": "BMJ",
    "byzantina-symmeikta": "BYZANTINA SYMMEIKTA",
    "babes-bolyai-university-faculty-of-orthodox-theology": "Babes-Bolyai University - Faculty of Orthodox Theology (no ibid., Română)",
    "baghdad-science-journal": "Baghdad Science Journal",
    "baishideng-publishing-group": "Baishideng Publishing Group",
    "bakhtiniana-journal-of-discourse-studies": "Bakhtiniana: Journal of Discourse Studies",
    "barbara-budrich": "Barbara Budrich (Deutsch)",
    "begell-house-apa": "Begell House - APA",
    "begell-house-chicago-author-date": "Begell House - Chicago Manual of Style",
    "behaviour": "Behaviour",
    "beilstein-journal-of-organic-chemistry": "Beilstein Journal of Organic Chemistry",
    "beltz-padagogik": "Beltz - Pädagogik (Deutsch)",
    "berghahn-books-author-date-en-gb": "Berghahn Books (author-date, English - UK)",
    "berlin-school-of-economics-and-law-international-marketing-management": "Berlin School of Economics and Law - International Marketing Management",
    "bern-university-of-applied-sciences-school-of-agricultural-forest-and-food-sciences-hafl": "Bern University of Applied Sciences - School of Agricultural, Forest and Food Sciences HAFL (author-date)",
    "betriebswirtschaftliche-forschung-und-praxis": "Betriebswirtschaftliche Forschung und Praxis (Deutsch)",
    "bibtex": "BibTeX generic citation style",
    "biblio-3w": "Biblio 3W (Español)",
    "bibliotheca-hertziana-max-planck-institute-for-art-history": "Bibliotheca Hertziana - Max Planck Institute for Art History",
    "bibliothecae-it": "Bibliothecae.it (Italiano)",
    "bibliothek-fur-bildungsgeschichtliche-forschung": "Bibliothek für Bildungsgeschichtliche Forschung (BBF) (Deutsch)",
    "bibliothek-forschung-und-praxis": "Bibliothek – Forschung und Praxis",
    "bibliotheque-d-archeologie-mediterraneenne-et-africaine-biama": "Bibliothèque d'archéologie méditerranéenne et africaine (BiAMA) (Français)",
    "bibliotheque-universitaire-de-medecine-vancouver": "Bibliothèque universitaire de médecine - NLM/Vancouver",
    "biens-symboliques-symbolic-goods": "Biens symboliques / Symbolic Goods",
    "bio-protocol": "Bio-protocol",
    "biomed-central": "BioMed Central",
    "biomed-research-international": "BioMed Research International",
    "bioresources": "BioResources",
    "bioscience": "BioScience",
    "biosocieties": "BioSocieties",
    "biotechniques": "BioTechniques",
    "bioarchaeology-international": "Bioarchaeology International",
    "bioarchaeology-of-the-near-east": "Bioarchaeology of the Near East",
    "biochemical-journal": "Biochemical Journal",
    "biochemical-society-transactions": "Biochemical Society Transactions",
    "biochemistry": "Biochemistry",
    "biochemistry-and-molecular-biology-education": "Biochemistry and Molecular Biology Education",
    "biochimica-et-biophysica-acta": "Biochimica et Biophysica Acta",
    "bioelectromagnetics": "Bioelectromagnetics",
    "bioethics": "Bioethics",
    "biofuel-research-journal": "Biofuel Research Journal",
    "biologia": "Biologia",
    "biological-journal-of-the-linnean-society": "Biological Journal of the Linnean Society",
    "biological-psychiatry": "Biological Psychiatry",
    "biological-reviews": "Biological Reviews",
    "biological-and-pharmaceutical-bulletin": "Biological and Pharmaceutical Bulletin",
    "biology-of-reproduction": "Biology of Reproduction",
    "biomarkers": "Biomarkers",
    "biometrics": "Biometrics",
    "biomolecular-concepts": "Biomolecular Concepts",
    "biophysical-journal": "Biophysical Journal",
    "biophysics-and-physicobiology": "Biophysics and Physicobiology",
    "biopolymers": "Biopolymers",
    "biostatistics": "Biostatistics",
    "biota-neotropica": "Biota Neotropica",
    "biotechnology-and-bioengineering": "Biotechnology and Bioengineering",
    "biotechnology-and-bioprocess-engineering": "Biotechnology and Bioprocess Engineering",
    "biotropica": "Biotropica",
    "biuletyn-polskiego-towarzystwa-jezykoznawczego": "Biuletyn Polskiego Towarzystwa Językoznawczego (Polski)",
    "bloomsbury-academic": "Bloomsbury Academic",
    "bluebook-inline": "Bluebook Inline",
    "bluebook-law-review": "Bluebook Law Review",
    "bluebook-law-review-with-abstract": "Bluebook Law Review (with abstract)",
    "body-and-society": "Body & Society",
    "boletin-de-pediatria": "Boletín de Pediatría (Español)",
    "boletin-de-la-sociedad-geologica-mexicana": "Boletín de la Sociedad Geológica Mexicana (Español - Mexico)",
    "bollettino-d-archeologia-online": "Bollettino d'archeologia online (Italiano)",
    "bollettino-della-societa-italiana-di-paleontologia": "Bollettino della Società Italiana di Paleontologia",
    "boreal-environment-research": "Boreal Environment Research",
    "boreas": "Boreas",
    "botanical-journal-of-the-linnean-society": "Botanical Journal of the Linnean Society",
    "bourgogne-franche-comte-nature": "Bourgogne-Franche-Comté Nature (Français)",
    "harvard-bournemouth-university": "Bournemouth University (author-date/Harvard)",
    "brachytherapy": "Brachytherapy",
    "brain-behavior-and-evolution": "Brain, Behavior and Evolution",
    "brazilian-journal-of-experimental-design-data-analysis-and-inferential-statistics": "Brazilian Journal of Experimental Design, Data Analysis and Inferential Statistics",
    "brazilian-journal-of-infectious-diseases": "Brazilian Journal of Infectious Diseases",
    "brazilian-journal-of-psychiatry": "Brazilian Journal of Psychiatry",
    "brazilian-journal-of-veterinary-research-and-animal-science": "Brazilian Journal of Veterinary Research and Animal Science",
    "brazilian-oral-research": "Brazilian Oral Research",
    "brewingscience": "BrewingScience",
    "bristol-university-press": "Bristol University Press",
    "british-journal-of-anaesthesia": "British Journal of Anaesthesia",
    "british-journal-of-cancer": "British Journal of Cancer",
    "british-journal-of-dermatology": "British Journal of Dermatology",
    "british-journal-of-haematology": "British Journal of Haematology",
    "british-journal-of-industrial-relations": "British Journal of Industrial Relations",
    "british-journal-of-nutrition": "British Journal of Nutrition",
    "british-journal-of-pharmacology": "British Journal of Pharmacology",
    "british-journal-of-political-science": "British Journal of Political Science",
    "british-journal-of-surgery": "British Journal of Surgery",
    "british-psychological-society": "British Psychological Society",
    "brumaire-verlag": "Brumaire Verlag (Deutsch)",
    "budownictwo-i-architektura-pl": "Budownictwo i Architektura",
    "building-structure": "Building Structure (中文)",
    "buletin-agrohorti": "Buletin Agrohorti",
    "bulletin-de-correspondance-hellenique": "Bulletin de correspondance hellénique",
    "bulletin-de-la-societe-entomologique-de-france": "Bulletin de la Société Entomologique de France",
    "bulletin-de-la-societe-prehistorique-francaise": "Bulletin de la Société préhistorique française (Français)",
    "bulletin-du-centre-detudes-medievales-dauxerre": "Bulletin du Centre d’études médiévales d’Auxerre (Français)",
    "bulletin-of-applied-glycoscience": "Bulletin of Applied Glycoscience",
    "bulletin-of-geosciences": "Bulletin of Geosciences",
    "bulletin-of-insectology": "Bulletin of Insectology",
    "bulletin-of-marine-science": "Bulletin of Marine Science",
    "bulletin-of-the-american-schools-of-oriental-research": "Bulletin of the American Schools of Oriental Research",
    "bulletin-of-the-seismological-society-of-america": "Bulletin of the Seismological Society of America",
    "bursa-uludag-universitesi-egitim-bilimleri-enstitusu": "Bursa Uludağ Üniversitesi - Eğitim Bilimleri Enstitüsü",
    "bursa-uludag-universitesi-saglik-bilimleri-enstitusu": "Bursa Uludağ Üniversitesi - Sağlık Bilimleri Enstitüsü",
    "business-ethics-a-european-review": "Business Ethics: A European Review",
    "business-and-human-rights-journal": "Business and Human Rights Journal",
    "byzantine-and-modern-greek-studies": "Byzantine and Modern Greek Studies",
    "borgyogyaszati-es-venerologiai-szemle": "Bőrgyógyászati és Venerológiai Szemle (Magyar)",
    "chimia": "CHIMIA",
    "clara-architecture-recherche": "CLARA Architecture/Recherche (Français)",
    "cns-and-neurological-disorders-drug-targets": "CNS & Neurological Disorders - Drug Targets",
    "cns-spectrums": "CNS Spectrums",
    "cse-citation-name-8th-edition": "CSE Manual: Scientific Style and Format 8th edition (citation-name)",
    "cse-citation-sequence-8th-edition": "CSE Manual: Scientific Style and Format 8th edition (citation-sequence)",
    "cse-citation-sequence-brackets-8th-edition": "CSE Manual: Scientific Style and Format 8th edition (citation-sequence, brackets)",
    "cse-name-year-8th-edition": "CSE Manual: Scientific Style and Format 8th edition (name-year)",
    "cse-citation-name": "CSE Manual: Scientific Style and Format 9th edition (citation-name)",
    "cse-citation-sequence": "CSE Manual: Scientific Style and Format 9th edition (citation-sequence)",
    "cse-name-year": "CSE Manual: Scientific Style and Format 9th edition (name-year)",
    "cahiers-mondes-anciens": "Cahiers Mondes Anciens (Français)",
    "cahiers-d-ethnomusicologie": "Cahiers d'ethnomusicologie (Français)",
    "cahiers-du-centre-gustave-glotz": "Cahiers du Centre Gustave-Glotz (Français)",
    "california-agriculture": "California Agriculture",
    "cambridge-journal-of-economics": "Cambridge Journal of Economics",
    "cambridge-quarterly-of-healthcare-ethics": "Cambridge Quarterly of Healthcare Ethics",
    "cambridge-university-press-note": "Cambridge University Press (note)",
    "cambridge-university-press-numeric": "Cambridge University Press (numeric)",
    "cambridge-university-press-law-note": "Cambridge University Press - Law (note)",
    "cambridge-university-press-author-date-cambridge-a": "Cambridge University Press, CambridgeA (author-date)",
    "cambridge-university-press-author-date": "Cambridge University Press, CambridgeB (author-date)",
    "campus-adventiste-du-saleve-faculte-adventiste-de-theologie": "Campus adventiste du Salève - Faculté adventiste de théologie (Français)",
    "canadian-biosystems-engineering": "Canadian Biosystems Engineering",
    "canadian-geotechnical-journal": "Canadian Geotechnical Journal",
    "mcgill-en": "Canadian Guide to Uniform Legal Citation 10th edition (McGill Guide)",
    "canadian-journal-of-chemistry": "Canadian Journal of Chemistry",
    "canadian-journal-of-criminology-and-criminal-justice": "Canadian Journal of Criminology and Criminal Justice",
    "canadian-journal-of-dietetic-practice-and-research": "Canadian Journal of Dietetic Practice and Research",
    "canadian-journal-of-earth-sciences": "Canadian Journal of Earth Sciences",
    "canadian-journal-of-economics": "Canadian Journal of Economics",
    "canadian-journal-of-fisheries-and-aquatic-sciences": "Canadian Journal of Fisheries and Aquatic Sciences",
    "canadian-journal-of-mineralogy-and-petrology": "Canadian Journal of Mineralogy and Petrology",
    "canadian-journal-of-physics": "Canadian Journal of Physics",
    "canadian-journal-of-public-health": "Canadian Journal of Public Health",
    "canadian-journal-of-remote-sensing": "Canadian Journal of Remote Sensing",
    "canadian-journal-of-soil-science": "Canadian Journal of Soil Science",
    "canadian-public-policy": "Canadian Public Policy",
    "canadian-urological-association-journal": "Canadian Urological Association Journal",
    "cancer-biomarkers": "Cancer Biomarkers",
    "cancer-drug-resistance": "Cancer Drug Resistance",
    "cancer-translational-medicine": "Cancer Translational Medicine",
    "harvard-cape-peninsula-university-of-technology": "Cape Peninsula University of Technology (author-date/Harvard)",
    "cardiff-university-harvard": "Cardiff University (author-date/Harvard)",
    "cardiff-university-vancouver": "Cardiff University - NLM/Vancouver",
    "cardiocore": "Cardiocore (Español)",
    "cath-lab-digest": "Cath Lab Digest",
    "catholic-biblical-association": "Catholic Biblical Association (full note)",
    "cell": "Cell",
    "cell-research": "Cell Research",
    "cell-structure-and-function": "Cell Structure and Function",
    "cell-transplantation": "Cell Transplantation",
    "cell-numeric": "Cell journals (numeric)",
    "cellular-and-molecular-bioengineering": "Cellular and Molecular Bioengineering",
    "cellular-and-molecular-gastroenterology-and-hepatology": "Cellular and Molecular Gastroenterology and Hepatology",
    "centaurus": "Centaurus",
    "centre-de-recherche-sur-les-civilisations-de-l-asie-orientale": "Centre de recherche sur les civilisations de l'Asie orientale (Français - note)",
    "centre-de-recherche-sur-les-civilisations-de-l-asie-orientale-auteur-date": "Centre de recherche sur les civilisations de l’Asie orientale (Français - Auteur, Date)",
    "centro-regional-de-estudios-teologicos-de-aragon": "Centro Regional de Estudios Teológicos de Aragón (Español)",
    "changer-d-epoque": "Changer d'époque (Français)",
    "chemical-biology-and-drug-design": "Chemical Biology & Drug Design",
    "chemical-engineering-technology": "Chemical Engineering & Technology",
    "chemical-engineering-progress": "Chemical Engineering Progress",
    "chemical-and-pharmaceutical-bulletin": "Chemical and Pharmaceutical Bulletin",
    "chemie-ingenieur-technik": "Chemie Ingenieur Technik",
    "chemistry-education-research-and-practice": "Chemistry Education Research and Practice",
    "chest": "Chest",
    "chicago-author-date-16th-edition": "Chicago Manual of Style 16th edition (author-date)",
    "chicago-author-date-de": "Chicago Manual of Style 16th edition (author-date, Deutsch)",
    "chicago-author-date-basque": "Chicago Manual of Style 16th edition (author-date, Euskara)",
    "chicago-notes-bibliography-16th-edition": "Chicago Manual of Style 16th edition (notes and bibliography)",
    "chicago-shortened-notes-bibliography-16th-edition": "Chicago Manual of Style 16th edition (shortened notes and bibliography)",
    "chicago-author-date-17th-edition": "Chicago Manual of Style 17th edition (author-date)",
    "chicago-author-date-fr": "Chicago Manual of Style 17th edition (author-date, Français)",
    "chicago-notes-bibliography-17th-edition": "Chicago Manual of Style 17th edition (notes and bibliography)",
    "chicago-notes-bibliography-fr": "Chicago Manual of Style 17th edition (notes and bibliography, Français)",
    "chicago-notes-bibliography-subsequent-author-title-17th-edition": "Chicago Manual of Style 17th edition (notes and bibliography, subsequent author-title)",
    "chicago-notes-bibliography-subsequent-ibid-17th-edition": "Chicago Manual of Style 17th edition (notes and bibliography, subsequent ibid.)",
    "chicago-shortened-notes-bibliography-17th-edition": "Chicago Manual of Style 17th edition (shortened notes and bibliography)",
    "chicago-shortened-notes-bibliography-subsequent-author-title-17th-edition": "Chicago Manual of Style 17th edition (shortened notes and bibliography, subsequent author-title)",
    "chicago-shortened-notes-bibliography-subsequent-ibid-17th-edition": "Chicago Manual of Style 17th edition (shortened notes and bibliography, subsequent ibid.)",
    "chicago-author-date": "Chicago Manual of Style 18th edition (author-date)",
    "chicago-author-date-access-dates": "Chicago Manual of Style 18th edition (author-date, access dates)",
    "chicago-author-date-archive-place-first": "Chicago Manual of Style 18th edition (author-date, archival references with place first)",
    "chicago-author-date-archive-place-first-no-url": "Chicago Manual of Style 18th edition (author-date, archival references with place first, without URLs)",
    "chicago-author-date-classic": "Chicago Manual of Style 18th edition (author-date, classic variants)",
    "chicago-author-date-classic-no-url": "Chicago Manual of Style 18th edition (author-date, classic variants, without URLs)",
    "chicago-author-date-no-url": "Chicago Manual of Style 18th edition (author-date, without URLs)",
    "chicago-in-text-full": "Chicago Manual of Style 18th edition (in-text full citations)",
    "chicago-in-text-full-no-url": "Chicago Manual of Style 18th edition (in-text full citations, without URLs)",
    "chicago-in-text-shortened-author": "Chicago Manual of Style 18th edition (in-text shortened author-only citations)",
    "chicago-in-text-shortened-author-no-url": "Chicago Manual of Style 18th edition (in-text shortened author-only citations, without URLs)",
    "chicago-in-text-shortened-author-title": "Chicago Manual of Style 18th edition (in-text shortened author-title citations)",
    "chicago-in-text-shortened-author-title-no-url": "Chicago Manual of Style 18th edition (in-text shortened author-title citations, without URLs)",
    "chicago-notes-bibliography-annotated-abstract": "Chicago Manual of Style 18th edition (notes and annotated bibliography with abstract)",
    "chicago-notes-bibliography-annotated": "Chicago Manual of Style 18th edition (notes and annotated bibliography)",
    "chicago-notes-bibliography": "Chicago Manual of Style 18th edition (notes and bibliography)",
    "chicago-notes-bibliography-access-dates": "Chicago Manual of Style 18th edition (notes and bibliography, access dates)",
    "chicago-notes-bibliography-archive-place-first": "Chicago Manual of Style 18th edition (notes and bibliography, archival references with place first)",
    "chicago-notes-bibliography-archive-place-first-no-url": "Chicago Manual of Style 18th edition (notes and bibliography, archival references with place first, without URLs)",
    "chicago-notes-bibliography-classic": "Chicago Manual of Style 18th edition (notes and bibliography, classic variants)",
    "chicago-notes-bibliography-classic-archive-place-first": "Chicago Manual of Style 18th edition (notes and bibliography, classic variants, archival references with place first)",
    "chicago-notes-bibliography-classic-archive-place-first-no-url": "Chicago Manual of Style 18th edition (notes and bibliography, classic variants, archival references with place first, without URLs)",
    "chicago-notes-bibliography-classic-no-url": "Chicago Manual of Style 18th edition (notes and bibliography, classic variants, without URLs)",
    "chicago-notes-bibliography-subsequent-author": "Chicago Manual of Style 18th edition (notes and bibliography, subsequent author-only citations)",
    "chicago-notes-bibliography-subsequent-author-classic": "Chicago Manual of Style 18th edition (notes and bibliography, subsequent author-only citations, classic variants)",
    "chicago-notes-bibliography-subsequent-author-classic-no-url": "Chicago Manual of Style 18th edition (notes and bibliography, subsequent author-only citations, classic variants, without URLs)",
    "chicago-notes-bibliography-subsequent-author-no-url": "Chicago Manual of Style 18th edition (notes and bibliography, subsequent author-only citations, without URLs)",
    "chicago-notes-bibliography-subsequent-ibid": "Chicago Manual of Style 18th edition (notes and bibliography, subsequent ibid.)",
    "chicago-notes-bibliography-subsequent-ibid-classic": "Chicago Manual of Style 18th edition (notes and bibliography, subsequent ibid., classic variants)",
    "chicago-notes-bibliography-subsequent-ibid-classic-no-url": "Chicago Manual of Style 18th edition (notes and bibliography, subsequent ibid., classic variants, without URLs)",
    "chicago-notes-bibliography-subsequent-ibid-no-url": "Chicago Manual of Style 18th edition (notes and bibliography, subsequent ibid., without URLs)",
    "chicago-notes-bibliography-subsequent-title": "Chicago Manual of Style 18th edition (notes and bibliography, subsequent title-only citations)",
    "chicago-notes-bibliography-subsequent-title-no-url": "Chicago Manual of Style 18th edition (notes and bibliography, subsequent title-only citations, without URLs)",
    "chicago-notes-bibliography-no-url": "Chicago Manual of Style 18th edition (notes and bibliography, without URLs)",
    "chicago-notes": "Chicago Manual of Style 18th edition (notes without bibliography)",
    "chicago-notes-archive-place-first": "Chicago Manual of Style 18th edition (notes without bibliography, archival references with place first)",
    "chicago-notes-archive-place-first-no-url": "Chicago Manual of Style 18th edition (notes without bibliography, archival references with place first, without URLs)",
    "chicago-notes-classic": "Chicago Manual of Style 18th edition (notes without bibliography, classic variants)",
    "chicago-notes-classic-archive-place-first": "Chicago Manual of Style 18th edition (notes without bibliography, classic variants, archival references with place first)",
    "chicago-notes-classic-archive-place-first-no-url": "Chicago Manual of Style 18th edition (notes without bibliography, classic variants, archival references with place first, without URLs)",
    "chicago-notes-classic-no-url": "Chicago Manual of Style 18th edition (notes without bibliography, classic variants, without URLs)",
    "chicago-notes-publisher-place": "Chicago Manual of Style 18th edition (notes without bibliography, place of publication substituted for publisher)",
    "chicago-notes-publisher-place-archive-place-first": "Chicago Manual of Style 18th edition (notes without bibliography, place of publication substituted for publisher, archival references with place first)",
    "chicago-notes-publisher-place-archive-place-first-no-url": "Chicago Manual of Style 18th edition (notes without bibliography, place of publication substituted for publisher, archival references with place first, without URLs)",
    "chicago-notes-publisher-place-label-page-archive-place-first": "Chicago Manual of Style 18th edition (notes without bibliography, place of publication substituted for publisher, page abbreviations, archival references with place first)",
    "chicago-notes-publisher-place-label-page-archive-place-first-no-url": "Chicago Manual of Style 18th edition (notes without bibliography, place of publication substituted for publisher, page abbreviations, archival references with place first, without URLs)",
    "chicago-notes-publisher-place-no-url": "Chicago Manual of Style 18th edition (notes without bibliography, place of publication substituted for publisher, without URLs)",
    "chicago-notes-no-url": "Chicago Manual of Style 18th edition (notes without bibliography, without URLs)",
    "chicago-shortened-notes-bibliography": "Chicago Manual of Style 18th edition (shortened notes and bibliography)",
    "chicago-shortened-notes-bibliography-access-dates": "Chicago Manual of Style 18th edition (shortened notes and bibliography, access dates)",
    "chicago-shortened-notes-bibliography-archive-place-first": "Chicago Manual of Style 18th edition (shortened notes and bibliography, archival references with place first)",
    "chicago-shortened-notes-bibliography-archive-place-first-no-url": "Chicago Manual of Style 18th edition (shortened notes and bibliography, archival references with place first, without URLs)",
    "chicago-shortened-notes-bibliography-classic": "Chicago Manual of Style 18th edition (shortened notes and bibliography, classic variants)",
    "chicago-shortened-notes-bibliography-classic-archive-place-first": "Chicago Manual of Style 18th edition (shortened notes and bibliography, classic variants, archival references with place first)",
    "chicago-shortened-notes-bibliography-classic-archive-place-first-no-url": "Chicago Manual of Style 18th edition (shortened notes and bibliography, classic variants, archival references with place first, without URLs)",
    "chicago-shortened-notes-bibliography-classic-no-url": "Chicago Manual of Style 18th edition (shortened notes and bibliography, classic variants, without URLs)",
    "chicago-shortened-notes-bibliography-subsequent-author": "Chicago Manual of Style 18th edition (shortened notes and bibliography, subsequent author-only citations)",
    "chicago-shortened-notes-bibliography-subsequent-author-classic": "Chicago Manual of Style 18th edition (shortened notes and bibliography, subsequent author-only citations, classic variants)",
    "chicago-shortened-notes-bibliography-subsequent-author-classic-no-url": "Chicago Manual of Style 18th edition (shortened notes and bibliography, subsequent author-only citations, classic variants, without URLs)",
    "chicago-shortened-notes-bibliography-subsequent-author-no-url": "Chicago Manual of Style 18th edition (shortened notes and bibliography, subsequent author-only citations, without URLs)",
    "chicago-shortened-notes-bibliography-subsequent-ibid": "Chicago Manual of Style 18th edition (shortened notes and bibliography, subsequent ibid.)",
    "chicago-shortened-notes-bibliography-subsequent-ibid-classic": "Chicago Manual of Style 18th edition (shortened notes and bibliography, subsequent ibid., classic variants)",
    "chicago-shortened-notes-bibliography-subsequent-ibid-classic-no-url": "Chicago Manual of Style 18th edition (shortened notes and bibliography, subsequent ibid., classic variants, without URLs)",
    "chicago-shortened-notes-bibliography-subsequent-ibid-no-url": "Chicago Manual of Style 18th edition (shortened notes and bibliography, subsequent ibid., without URLs)",
    "chicago-shortened-notes-bibliography-subsequent-title": "Chicago Manual of Style 18th edition (shortened notes and bibliography, subsequent title-only citations)",
    "chicago-shortened-notes-bibliography-subsequent-title-no-url": "Chicago Manual of Style 18th edition (shortened notes and bibliography, subsequent title-only citations, without URLs)",
    "chicago-shortened-notes-bibliography-no-url": "Chicago Manual of Style 18th edition (shortened notes and bibliography, without URLs)",
    "china-information": "China Information",
    "chinese-gb7714-1987-numeric": "China National Standard GB/T 7714-1987 (numeric, 中文)",
    "chinese-gb7714-2005-author-date": "China National Standard GB/T 7714-2005 (author-date, 中文)",
    "chinese-gb7714-2005-numeric": "China National Standard GB/T 7714-2005 (numeric, 中文)",
    "china-national-standard-gb-t-7714-2015-author-date": "China National Standard GB/T 7714-2015 (author-date, 中文)",
    "china-national-standard-gb-t-7714-2015-note": "China National Standard GB/T 7714-2015 (note, 中文)",
    "china-national-standard-gb-t-7714-2015-numeric": "China National Standard GB/T 7714-2015 (numeric, 中文)",
    "china-national-standard-gb-t-7714-2025-author-date": "China National Standard GB/T 7714-2025 (author-date, 中文)",
    "china-national-standard-gb-t-7714-2025-note": "China National Standard GB/T 7714-2025 (note, 中文)",
    "china-national-standard-gb-t-7714-2025-numeric": "China National Standard GB/T 7714-2025 (numeric, 中文)",
    "chinese-journal-of-aeronautics": "Chinese Journal of Aeronautics",
    "chinese-medical-journal": "Chinese Medical Journal",
    "chinese-science-bulletin": "Chinese Science Bulletin",
    "chroniques-des-activites-archeologiques-de-l-ecole-francaise-de-rome": "Chroniques des activités archéologiques de l'Ecole française de Rome",
    "chungara-revista-de-antropologia-chilena": "Chungara Revista de Antropología Chilena (Español - Chile)",
    "circulation-journal": "Circulation Journal",
    "cirugia-cardiovascular": "Cirugia Cardiovascular (Español)",
    "citation-compass-apa-note": "Citation Compass (Kildekompasset) - APA (note)",
    "harvard-cite-them-right-10th-edition": "Cite Them Right 10th edition (author-date/Harvard)",
    "harvard-cite-them-right-11th-edition": "Cite Them Right 11th edition (author-date/Harvard)",
    "harvard-cite-them-right": "Cite Them Right 12th edition (author-date/Harvard)",
    "harvard-cite-them-right-no-et-al": "Cite Them Right 12th edition (author-date/Harvard, no \"et al.\")",
    "citizen-science-theory-and-practice": "Citizen Science: Theory and Practice",
    "civil-engineering-journal": "Civil Engineering Journal",
    "civilta-italiana": "Civiltà Italiana (Italiano)",
    "civitas-revista-de-ciencias-sociais": "Civitas: Revista de Ciências Sociais",
    "cladistics": "Cladistics",
    "clay-minerals": "Clay Minerals",
    "clays-and-clay-minerals": "Clays and Clay Minerals",
    "climate-change-economics": "Climate Change Economics",
    "clinical-anatomy": "Clinical Anatomy",
    "clinical-dysmorphology": "Clinical Dysmorphology",
    "clinical-gastroenterology-and-hepatology": "Clinical Gastroenterology and Hepatology",
    "clinical-hemorheology-and-microcirculation": "Clinical Hemorheology and Microcirculation",
    "clinical-infectious-diseases": "Clinical Infectious Diseases",
    "clinical-journal-of-sport-medicine": "Clinical Journal of Sport Medicine",
    "clinical-journal-of-the-american-society-of-nephrology": "Clinical Journal of the American Society of Nephrology",
    "clinical-management-issues": "Clinical Management Issues",
    "clinical-nuclear-medicine": "Clinical Nuclear Medicine",
    "clinical-oral-implants-research": "Clinical Oral Implants Research",
    "clinical-orthopaedics-and-related-research": "Clinical Orthopaedics and Related Research",
    "clinical-otolaryngology": "Clinical Otolaryngology",
    "clinical-pharmacology-and-therapeutics": "Clinical Pharmacology & Therapeutics",
    "clinical-physiology-and-functional-imaging": "Clinical Physiology and Functional Imaging",
    "clinical-radiology": "Clinical Radiology",
    "clinical-spine-surgery": "Clinical Spine Surgery",
    "clio-medica": "Clio Medica",
    "clinica-e-investigacion-en-arteriosclerosis": "Clínica e Investigación en Arteriosclerosis (Español)",
    "cold-spring-harbor-laboratory-press": "Cold Spring Harbor Laboratory Press",
    "collection-de-l-ecole-francaise-de-rome-full-note": "Collection de l'Ecole française de Rome (full note, Français)",
    "collection-de-l-ecole-francaise-de-rome-note": "Collection de l'Ecole française de Rome (note, Français)",
    "collection-du-centre-jean-berard": "Collection du Centre Jean-Bérard (Français)",
    "collections-electroniques-de-l-inha-author-date": "Collections électroniques de l'INHA (author-date, Français)",
    "collections-electroniques-de-l-inha-full-note": "Collections électroniques de l'INHA (full note, Français)",
    "college-of-naturopathic-medicine": "College of Naturopathic Medicine",
    "college-montmorency": "Collège Montmorency (note, Français - Canada)",
    "colombian-journal-of-anesthesiology": "Colombian Journal of Anesthesiology",
    "colorado-state-university-school-of-biomedical-engineering": "Colorado State University - School of Biomedical Engineering",
    "comision-economica-para-america-latina-y-el-caribe": "Comisión Económica para América Latina y el Caribe (Español)",
    "common-market-law-review": "Common Market Law Review",
    "communication-et-langages": "Communication et Langages",
    "comparativ": "Comparativ",
    "comparative-parasitology": "Comparative Parasitology",
    "comparative-politics": "Comparative Politics",
    "comparative-population-studies": "Comparative Population Studies",
    "comptes-rendus-author-date": "Comptes Rendus (author-date)",
    "comptes-rendus-numeric": "Comptes Rendus (numeric)",
    "computer-supported-cooperative-work": "Computer Supported Cooperative Work",
    "computer-und-recht": "Computer und Recht (Deutsch)",
    "conservation-and-society": "Conservation & Society",
    "conservation-biology": "Conservation Biology",
    "conservation-letters": "Conservation Letters",
    "conservation-physiology": "Conservation Physiology",
    "constructivist-foundations": "Constructivist Foundations",
    "contemporary-accounting-research": "Contemporary Accounting Research",
    "continuity-and-change": "Continuity and Change",
    "contributions-to-the-archaeology-of-egypt-nubia-and-the-levant": "Contributions to the Archaeology of Egypt, Nubia and the Levant",
    "copeia": "Copeia",
    "copenhagen-university-legal-proper-attribution": "Copenhagen University Legal Proper Attribution (Dansk)",
    "copernicus-publications": "Copernicus Publications",
    "coral-reefs": "Coral Reefs",
    "cornea": "Cornea",
    "corrosion": "Corrosion",
    "harvard-coventry-university": "Coventry University (author-date/Harvard)",
    "harvard-cranfield-university": "Cranfield University (author-date/Harvard)",
    "cranfield-university-numeric": "Cranfield University (numeric)",
    "creativity-and-innovation-management": "Creativity and Innovation Management",
    "critical-care-medicine": "Critical Care Medicine",
    "critical-reviews-in-plant-sciences": "Critical Reviews in Plant Sciences",
    "critical-reviews-in-solid-state-and-materials-sciences": "Critical Reviews in Solid State and Materials Sciences",
    "cronache-di-archeologia": "Cronache di Archeologia (Italiano)",
    "crop-breeding-and-applied-biotechnology": "Crop Breeding and Applied Biotechnology",
    "crustaceana": "Crustaceana",
    "cuadernos-de-filologia-clasica": "Cuadernos de Filología Clásica. Estudios Griegos e Indoeuropeos (autor-año, Español)",
    "cultivos-tropicales": "Cultivos Tropicales (Español)",
    "cultural-studies-of-science-education": "Cultural Studies of Science Education",
    "culture-medicine-and-psychiatry": "Culture, Medicine, and Psychiatry",
    "cumhuriyet-universitesi-fen-bilimleri-enstitusu": "Cumhuriyet Üniversitesi - Fen Bilimleri Enstitüsü (Türkçe)",
    "cureus": "Cureus",
    "current-alzheimer-research": "Current Alzheimer Research",
    "current-gene-therapy": "Current Gene Therapy",
    "current-neurology-aktualnosci-neurologiczne": "Current Neurology - Aktualności Neurologiczne",
    "current-opinion-in-endocrinology-diabetes-and-obesity": "Current Opinion in Endocrinology, Diabetes and Obesity",
    "current-opinion": "Current Opinion journals",
    "current-organic-synthesis": "Current Organic Synthesis",
    "current-pharmaceutical-design": "Current Pharmaceutical Design",
    "current-proteomics": "Current Proteomics",
    "current-protocols": "Current Protocols journals",
    "current-science": "Current Science",
    "current-topics-in-medicinal-chemistry": "Current Topics in Medicinal Chemistry",
    "currents-in-biblical-research": "Currents in Biblical Research",
    "cybium": "Cybium",
    "cytometry": "Cytometry",
    "czech-journal-of-international-relations": "Czech Journal of International Relations",
    "din-1505-2-alphanumeric": "DIN 1505-2 (alphanumeric, Deutsch) - standard superseded by ISO-690",
    "din-1505-2": "DIN 1505-2 (author-date, Deutsch) - standard superseded by ISO-690",
    "din-1505-2-numeric": "DIN 1505-2 (numeric, Deutsch) - standard superseded by ISO-690",
    "din-1505-2-numeric-alphabetical": "DIN 1505-2 (numeric, sorted alphabetically, Deutsch) - standard superseded by ISO-690",
    "data-science-journal": "Data Science Journal",
    "database": "Database",
    "de-buck": "De Buck (Nederlands)",
    "degruyter-american-chemical-society": "De Gruyter - American Chemical Society",
    "harvard-deakin-university": "Deakin University (author-date/Harvard)",
    "decision-sciences": "Decision Sciences",
    "demographic-research": "Demographic Research",
    "dermatology-online-journal": "Dermatology Online Journal",
    "deutsche-gesellschaft-fur-psychologie": "Deutsche Gesellschaft für Psychologie 5. Auflage (Deutsch)",
    "deutsche-sprache": "Deutsche Sprache (Deutsch)",
    "deutsche-zeitschrift-fur-sportmedizin": "Deutsche Zeitschrift für Sportmedizin",
    "deutsches-archaologisches-institut": "Deutsches Archäologisches Institut",
    "deutsches-archaologisches-institut-romisch-germanische-kommission-author-date": "Deutsches Archäologisches Institut - Römisch-Germanische Kommission (author-date, Deutsch)",
    "deutsches-arzteblatt": "Deutsches Ärzteblatt",
    "developing-world-bioethics": "Developing World Bioethics",
    "development-policy-review": "Development Policy Review",
    "development-and-change": "Development and Change",
    "developmental-dynamics": "Developmental Dynamics",
    "developmental-medicine-and-child-neurology": "Developmental Medicine & Child Neurology",
    "developmental-neurobiology": "Developmental Neurobiology",
    "diabetologia": "Diabetologia",
    "diagnostico-prenatal": "Diagnóstico Prenatal (Español)",
    "dialisis-y-trasplante": "Dialisis y Trasplante (Español)",
    "diatom-research": "Diatom Research",
    "die-bachelorarbeit-samac-et-al-in-text": "Die Bachelorarbeit (Samac et al.) (in-text, Deutsch)",
    "die-bachelorarbeit-samac-et-al-note": "Die Bachelorarbeit (Samac et al.) (note, Deutsch)",
    "digestive-and-liver-disease": "Digestive and Liver Disease",
    "digital-humanities-im-deutschsprachigen-raum": "Digital Humanities im deutschsprachigen Raum (Deutsch)",
    "diplo": "Diplo",
    "disability-and-rehabilitation": "Disability and Rehabilitation",
    "discover-food": "Discover Food",
    "discovery-medicine": "Discovery Medicine",
    "documents-d-archeologie-francaise": "Documents d'archéologie française (Français)",
    "donau-universitat-krems-department-fur-e-governance-in-wirthschaft-und-verwaltung": "Donau-Universität Krems - Department für E-Governance in Wirtschaft und Verwaltung (Deutsch - Österreich)",
    "drug-development-research": "Drug Development Research",
    "drug-testing-and-analysis": "Drug Testing and Analysis",
    "drugs-of-today": "Drugs of Today",
    "duale-hochschule-baden-wurttemberg-department-of-international-business": "Duale Hochschule Baden-Württemberg - Department of International Business",
    "duale-hochschule-baden-wurttemberg-villingen-schwenningen-roter-grubert-mattern": "Duale Hochschule Baden-Württemberg Villingen-Schwenningen - Roter Grubert/Mattern (Deutsch)",
    "harvard-dundalk-institute-of-technology": "Dundalk Institute of Technology (author-date/Harvard)",
    "durban-university-of-technology-harvard": "Durban University of Technology (author-date/Harvard)",
    "harvard-durham-university-business-school": "Durham University Business School (author-date/Harvard)",
    "e3s-web-of-conferences": "E3S Web of Conferences",
    "em-normandie-business-school-harvard-english": "EM Normandie Business School (author-date/Harvard, English)",
    "embo-press": "EMBO Press",
    "embnet-journal": "EMBnet.journal",
    "ens-de-lyon-centre-d-ingenierie-documentaire": "ENS de Lyon - Centre d'ingénierie documentaire (Français)",
    "entecho": "ENTECHO (Čeština)",
    "etri-journal": "ETRI Journal",
    "eu-interinstitutional-style": "EU Interinstitutional Style (author-date)",
    "eunomia-revista-en-cultura-de-la-legalidad": "EUNOMÍA. Revista en Cultura de la Legalidad (Español)",
    "eva-berlin-konferenz": "EVA Berlin Konferenz (Deutsch)",
    "excli-journal": "EXCLI Journal",
    "ear-and-hearing": "Ear and Hearing",
    "early-christianity": "Early Christianity",
    "early-medieval-europe": "Early Medieval Europe",
    "earth-surface-processes-and-landforms": "Earth Surface Processes and Landforms",
    "earthquake-engineering-and-structural-dynamics": "Earthquake Engineering & Structural Dynamics",
    "earthquake-spectra": "Earthquake Spectra",
    "ecclesial-practices": "Ecclesial Practices",
    "ecological-entomology": "Ecological Entomology",
    "ecological-restoration": "Ecological Restoration",
    "ecology": "Ecology",
    "ecology-letters": "Ecology Letters",
    "ecology-and-society": "Ecology and Society",
    "ecology-of-freshwater-fish": "Ecology of Freshwater Fish",
    "econometrica": "Econometrica",
    "economic-commission-for-latin-america-and-the-caribbean": "Economic Commission for Latin America and the Caribbean",
    "economic-geology": "Economic Geology",
    "economia-y-politica": "Economía y Política (Español - Chile)",
    "ecosistemas": "Ecosistemas (Español)",
    "ecosystems": "Ecosystems",
    "harvard-edge-hill-university": "Edge Hill University (author-date/Harvard)",
    "edward-elgar-business-and-social-sciences": "Edward Elgar Publishing - Business and Social Sciences",
    "effective-altruism-wiki": "Effective Altruism Wiki",
    "egretta": "Egretta (Deutsch - Österreich)",
    "einaudi": "Einaudi (Italiano)",
    "eksploatacja-i-niezawodnosc": "Eksploatacja i Niezawodnosc - Maintenance and Reliability",
    "electrophoresis": "Electrophoresis",
    "elementa": "Elementa",
    "elsevier-harvard2": "Elsevier (author-date/Harvard, capitalized In)",
    "elsevier-harvard": "Elsevier (author-date/Harvard, with titles)",
    "elsevier-harvard-without-titles": "Elsevier (author-date/Harvard, without titles)",
    "elsevier-with-titles": "Elsevier (numeric, with titles)",
    "elsevier-with-titles-alphabetical": "Elsevier (numeric, with titles, sorted alphabetically)",
    "elsevier-without-titles": "Elsevier (numeric, without titles)",
    "elsevier-american-chemical-society": "Elsevier - American Chemical Society",
    "elsevier-vancouver": "Elsevier - NLM/Vancouver (citation-sequence)",
    "elsevier-vancouver-short-author-list": "Elsevier - NLM/Vancouver (citation-sequence, \"et al.\" for 3+ authors)",
    "elsevier-vancouver-no-et-al": "Elsevier - NLM/Vancouver (citation-sequence, no \"et al.\")",
    "elsevier-vancouver-author-date": "Elsevier - NLM/Vancouver (name-year)",
    "elsevier-vancouver-author-date-alphabetical": "Elsevier - NLM/Vancouver (name-year; sorted alphabetically)",
    "emerald-harvard": "Emerald (author-date/Harvard)",
    "emu-austral-ornithology": "Emu - Austral Ornithology",
    "endocrine-connections": "Endocrine Connections",
    "endocrine-journal": "Endocrine Journal",
    "endocrine-press": "Endocrine Press",
    "endoscopia": "Endoscopia (Español)",
    "energy-research-and-social-science": "Energy Research & Social Science",
    "enfances-familles-generations": "Enfances Familles Générations (Français)",
    "enfermeria-clinica": "Enfermería Clínica (Español)",
    "enfermeria-intensiva": "Enfermería Intensiva (Español)",
    "engineered-regeneration": "Engineered Regeneration",
    "engineering-in-life-sciences": "Engineering in Life Sciences",
    "engineering-technology-and-applied-science-research": "Engineering, Technology & Applied Science Research",
    "entomologia-experimentalis-et-applicata": "Entomologia Experimentalis et Applicata",
    "entomological-review": "Entomological Review",
    "entomological-society-of-america": "Entomological Society of America",
    "environment-and-planning": "Environment and Planning",
    "environment-and-urbanization": "Environment and Urbanization",
    "environmental-and-engineering-geoscience": "Environmental & Engineering Geoscience",
    "environmental-chemistry": "Environmental Chemistry",
    "environmental-conservation": "Environmental Conservation",
    "environmental-health-perspectives": "Environmental Health Perspectives",
    "environmental-microbiology": "Environmental Microbiology",
    "environmental-values": "Environmental Values",
    "environnement-risques-et-sante": "Environnement, Risques & Santé",
    "ephemerides-theologicae-lovanienses": "Ephemerides Theologicae Lovanienses",
    "epidemiology-and-infection": "Epidemiology & Infection",
    "epidemiology-psychiatric-sciences": "Epidemiology & Psychiatric Sciences",
    "epilepsia": "Epilepsia",
    "equine-veterinary-education": "Equine Veterinary Education",
    "equine-veterinary-journal": "Equine Veterinary Journal",
    "ergo": "Ergo",
    "errata": "Errata: Publicação sobre processos editoriais (Português - Brasil)",
    "associacao-brasileira-de-normas-tecnicas-eceme": "Escola de Comando e Estado-Maior do Exército - ABNT (Português - Brasil)",
    "associacao-brasileira-de-normas-tecnicas-instituto-meira-mattos": "Escola de Comando e Estado-Maior do Exército - Instituto Meira Mattos - ABNT (Português - Brasil)",
    "escuela-nacional-de-antropologia-e-historia-author-date": "Escuela Nacional de Antropología e Historia (autor-fecha, Español - México)",
    "escuela-nacional-de-antropologia-e-historia-full-note": "Escuela Nacional de Antropología e Historia (nota completa, Español - México)",
    "escuela-nacional-de-antropologia-e-historia-short-note": "Escuela Nacional de Antropología e Historia (nota corta, Español - México)",
    "estonian-journal-of-archaeology": "Estonian Journal of Archaeology",
    "estonian-journal-of-earth-sciences": "Estonian Journal of Earth Sciences",
    "estudios-hispanicos": "Estudios Hispánicos (Español)",
    "estudios-de-cultura-maya": "Estudios de Cultura Maya (Español - México)",
    "estudios-de-fonetica-experimental": "Estudios de Fonética Experimental",
    "ethics-book-reviews": "Ethics (for book reviews)",
    "ethnobiology-letters": "Ethnobiology Letters",
    "ethnobiology-and-conservation": "Ethnobiology and Conservation",
    "ethnologie-francaise": "Ethnologie française (Français)",
    "ethnomusicology": "Ethnomusicology",
    "eurasian-journal-of-medical-investigation": "Eurasian Journal of Medical Investigation",
    "eurasian-journal-of-medicine-and-oncology": "Eurasian Journal of Medicine and Oncology",
    "eurointervention": "EuroIntervention",
    "europace": "Europace",
    "harvard-european-archaeology": "European Archaeology (author-date/Harvard)",
    "european-cells-and-materials": "European Cells & Materials",
    "european-environment-agency": "European Environment Agency",
    "european-environment-agency-numeric": "European Environment Agency (numeric)",
    "european-journal-physical-medicine-and-rehabilitation": "European Journal Physical Medicine and Rehabilitation",
    "european-journal-for-philosophy-of-religion": "European Journal for Philosophy of Religion",
    "european-journal-of-anaesthesiology": "European Journal of Anaesthesiology",
    "european-journal-of-clinical-microbiology-and-infectious-diseases": "European Journal of Clinical Microbiology & Infectious Diseases",
    "european-journal-of-emergency-medicine": "European Journal of Emergency Medicine",
    "european-journal-of-endocrinology": "European Journal of Endocrinology",
    "european-journal-of-entomology": "European Journal of Entomology",
    "european-journal-of-human-genetics": "European Journal of Human Genetics",
    "european-journal-of-immunology": "European Journal of Immunology",
    "european-journal-of-information-systems": "European Journal of Information Systems",
    "european-journal-of-international-law": "European Journal of International Law",
    "european-journal-of-lipid-science-and-technology": "European Journal of Lipid Science and Technology",
    "european-journal-of-microbiology-and-immunology": "European Journal of Microbiology & Immunology",
    "european-journal-of-neuroscience": "European Journal of Neuroscience",
    "european-journal-of-ophthalmology": "European Journal of Ophthalmology",
    "european-journal-of-paediatric-neurology": "European Journal of Paediatric Neurology",
    "european-journal-of-pain": "European Journal of Pain",
    "european-journal-of-political-research": "European Journal of Political Research",
    "european-journal-of-public-health": "European Journal of Public Health",
    "european-journal-of-soil-science": "European Journal of Soil Science",
    "european-journal-of-taxonomy": "European Journal of Taxonomy",
    "european-journal-of-theology": "European Journal of Theology",
    "european-journal-of-ultrasound": "European Journal of Ultrasound (Ultraschall in der Medizin)",
    "european-journal-of-vascular-and-endovascular-surgery": "European Journal of Vascular and Endovascular Surgery",
    "european-respiratory-journal": "European Respiratory Journal",
    "european-retail-research": "European Retail Research",
    "european-review-of-agricultural-economics": "European Review of Agricultural Economics",
    "european-review-of-international-studies": "European Review of International Studies",
    "european-society-of-cardiology": "European Society of Cardiology",
    "european-union-interinstitutional-style-guide-author-date": "European Union - Interinstitutional Style Guide (author-date)",
    "european-union-interinstitutional-style-guide": "European Union - Interinstitutional Style Guide (note)",
    "evangelikus-hittudomanyi-egyetem": "Evangélikus Hittudományi Egyetem (Magyar)",
    "evidence-based-complementary-and-alternative-medicine": "Evidence-Based Complementary and Alternative Medicine",
    "evolution": "Evolution",
    "evolution-and-development": "Evolution & Development",
    "evolution-letters": "Evolution Letters",
    "evolutionary-anthropology": "Evolutionary Anthropology",
    "evolutionary-ecology-research": "Evolutionary Ecology Research",
    "experimental-biology-and-medicine": "Experimental Biology and Medicine",
    "experimental-biomedical-research": "Experimental Biomedical Research",
    "expert-reviews-in-molecular-medicine": "Expert Reviews in Molecular Medicine",
    "exploration-of-targeted-anti-tumor-therapy": "Exploration of Targeted Anti-tumor Therapy",
    "extracellular-vesicles-and-circulating-nucleic-acids": "Extracellular Vesicles and Circulating Nucleic Acids",
    "eye": "Eye",
    "facets": "FACETS",
    "fh-joanneum-institute-of-software-design-and-security": "FH JOANNEUM - Institute of Software Design and Security",
    "fold-and-r": "FOLD&R (Fasti On Line Documents & Research)",
    "fachhochschule-kiel-fachbereich-medien": "Fachhochschule Kiel - Fachbereich Medien (Deutsch)",
    "harvard-fachhochschule-salzburg": "Fachhochschule Salzburg (author-date/Harvard)",
    "fachhochschule-sudwestfalen": "Fachhochschule Südwestfalen (Deutsch)",
    "fachhochschule-vorarlberg-author-date": "Fachhochschule Vorarlberg (author-date)",
    "fachhochschule-vorarlberg-note": "Fachhochschule Vorarlberg (note)",
    "facial-plastic-surgery-clinics-of-north-america": "Facial Plastic Surgery Clinics of North America",
    "facolta-teologica-dell-italia-settentrionale-milano": "Facoltà Teologica dell'Italia Settentrionale - Milano (titoli di riviste non abbreviati, Italiano)",
    "harvard-falmouth-university": "Falmouth University (author-date/Harvard)",
    "family-business-review": "Family Business Review",
    "farmeconomia": "Farmeconomia. Health Economics and Therapeutic Pathways",
    "fatigue-and-fracture-of-engineering-materials-and-structures": "Fatigue & Fracture of Engineering Materials & Structures",
    "feminist-economics": "Feminist Economics",
    "feminist-theory": "Feminist Theory",
    "ferdinand-porsche-fernfh-betriebswirtschaft-und-wirtschaftspsychologie-dgps": "Ferdinand Porsche FERNFH - Betriebswirtschaft und Wirtschaftspsychologie - DGPS (Deutsch)",
    "ferdinand-porsche-fern-fachhochschule": "Ferdinand Porsche Fernfachhochschule (Deutsch - Österreich)",
    "fertility-and-sterility": "Fertility and Sterility",
    "finance-and-society": "Finance and Society",
    "finanzarchiv": "FinanzArchiv - Public Finance Analysis",
    "fine-focus": "Fine Focus",
    "firephyschem": "FirePhysChem",
    "first-break": "First Break",
    "first-monday": "First Monday",
    "fishery-bulletin": "Fishery Bulletin",
    "fizyoloji-medical-journal": "Fizyoloji Medical Journal",
    "flavour-and-fragrance-journal": "Flavour and Fragrance Journal",
    "florida-entomologist": "Florida Entomologist",
    "flux": "Flux (Français)",
    "focaal-journal-of-global-and-historical-anthropology": "Focaal—Journal of Global and Historical Anthropology",
    "folia-amazonica": "Folia Amazonica",
    "folia-biologica": "Folia Biologica",
    "folia-malacologica": "Folia Malacologica",
    "folia-morphologia": "Folia Morphologia",
    "food-science-and-biotechnology": "Food Science and Biotechnology",
    "food-and-agriculture-organization-of-the-united-nations": "Food and Agriculture Organization of the United Nations",
    "food-and-agriculture-organization-of-the-united-nations-numeric": "Food and Agriculture Organization of the United Nations (numeric)",
    "forensic-anthropology": "Forensic Anthropology",
    "forensic-science-review": "Forensic Science Review",
    "forest-science": "Forest Science",
    "forestry": "Forestry",
    "forschungsjournal-soziale-bewegungen-fjsb": "Forschungsjournal Soziale Bewegungen FJSB(German)",
    "forum-qualitative-social-research": "Forum: Qualitative Social Research (English)",
    "forum-qualitative-sozialforschung": "Forum: Qualitative Sozialforschung (Deutsch)",
    "french4": "France (auteurs et al., auteur-date, Français)",
    "french2": "France (auteurs et al., numérotation, Français)",
    "french3": "France (tous les auteurs, auteur-date, Français)",
    "french1": "France (tous les auteurs, numérotation, Français)",
    "frattura-ed-integrita-strutturale-fracture-and-structural-integrity": "Frattura ed Integrità Strutturale - Fracture and Structural Integrity",
    "free-radical-research": "Free Radical Research",
    "freie-hochschule-stuttgart": "Freie Hochschule Stuttgart (Deutsch)",
    "freie-universitat-berlin-geographische-wissenschaften": "Freie Universität Berlin - Geographische Wissenschaften (Deutsch)",
    "french-politics": "French Politics",
    "freshwater-biology": "Freshwater Biology",
    "freshwater-crayfish": "Freshwater Crayfish",
    "freshwater-science": "Freshwater Science",
    "friedrich-schiller-universitat-jena-medizinische-fakultat": "Friedrich-Schiller-Universität Jena - Medizinische Fakultät (Deutsch)",
    "frontiers-in-bioscience": "Frontiers in Bioscience",
    "frontiers-in-ecology-and-the-environment": "Frontiers in Ecology and the Environment",
    "frontiers-in-optics": "Frontiers in Optics",
    "frontiers-in-physics": "Frontiers in Physics",
    "frontiers": "Frontiers journals",
    "frontiers-medical-journals": "Frontiers medical journals",
    "fundamental-and-applied-limnology": "Fundamental and Applied Limnology",
    "future-medicine": "Future Medicine journals",
    "future-science-group": "Future Science Group",
    "g-giappichelli-editore": "G. Giappichelli Editore (Italiano)",
    "gaia": "GAIA",
    "gender-zeitschrift-fur-geschlecht-kultur-und-gesellschaft": "GENDER. Zeitschrift für Geschlecht, Kultur und Gesellschaft (Deutsch)",
    "gaceta-sanitaria": "Gaceta Sanitaria",
    "gait-and-posture": "Gait & Posture",
    "galatasaray-universitesi-sosyal-bilimler-enstitusu": "Galatasaray Üniversitesi Sosyal Bilimler Enstitüsü (Türkçe)",
    "gallia": "Gallia (Français)",
    "gallia-prehistoire": "Gallia Préhistoire (Français)",
    "gastroenterology": "Gastroenterology",
    "gastrointestinal-endoscopy-clinics-of-north-america": "Gastrointestinal Endoscopy Clinics of North America",
    "gastrointestinal-intervention": "Gastrointestinal Intervention",
    "gayana": "Gayana",
    "gayana-botanica": "Gayana Botánica",
    "gazeta-medica": "Gazeta Médica",
    "geistes-und-kulturwissenschaften-heilmann": "Geistes- und Kulturwissenschaften (Heilmann) (Deutsch)",
    "gender-and-society": "Gender & Society",
    "generic-style-rules-for-linguistics": "Generic Style Rules for Linguistics",
    "genes-to-cells": "Genes to Cells",
    "genes-brain-and-behavior": "Genes, Brain and Behavior",
    "genetics-and-molecular-biology": "Genetics and Molecular Biology",
    "gengo-kenkyu-journal-of-the-linguistic-society-of-japan": "Gengo Kenkyu, Journal of the Linguistic Society of Japan",
    "genomics-and-informatics": "Genomics & Informatics",
    "geneses": "Genèses: Sciences sociales et histoire (Français)",
    "geoarchaeology": "Geoarchaeology",
    "geobiology": "Geobiology",
    "geochemical-perspectives-letters": "Geochemical Perspectives Letters",
    "geochimica-et-cosmochimica-acta": "Geochimica et Cosmochimica Acta",
    "geochronometria": "Geochronometria",
    "geografia-fisica-e-dinamica-quaternaria": "Geografia Fisica e Dinamica Quaternaria",
    "geografie-sbornik-cgs": "Geografie Sborník ČGS",
    "geographical-analysis": "Geographical Analysis",
    "geographische-zeitschrift": "Geographische Zeitschrift",
    "geological-magazine": "Geological Magazine",
    "geophysical-journal-international": "Geophysical Journal International",
    "geophysics": "Geophysics",
    "geopolitics": "Geopolitics",
    "georg-august-universitat-gottingen-institut-fur-ethnologie-und-ethnologische-sammlung": "Georg-August-Universität Göttingen - Institut für Ethnologie und Ethnologische Sammlung (Deutsch)",
    "geriatrics-and-gerontology-international": "Geriatrics & Gerontology International",
    "german-council-of-economic-experts": "German Council of Economic Experts",
    "german-journal-of-agricultural-economics": "German Journal of Agricultural Economics",
    "german-yearbook-of-international-law": "German Yearbook of International Law",
    "geschichte-und-gesellschaft": "Geschichte und Gesellschaft",
    "gesellschaft-fur-popularmusikforschung": "Gesellschaft fur Popularmusikforschung (Deutsch)",
    "harvard-gesellschaft-fur-bildung-und-forschung-in-europa": "Gesellschaft für Bildung und Forschung in Europa (author-date/Harvard, Deutsch)",
    "gewerblicher-rechtsschutz-und-urheberrecht": "Gewerblicher Rechtsschutz und Urheberrecht (Deutsch)",
    "gigascience": "GigaScience",
    "global-ecology-and-biogeography": "Global Ecology and Biogeography",
    "glossa": "Glossa",
    "gnosis-journal-of-gnostic-studies": "Gnosis: Journal of Gnostic Studies",
    "government-and-opposition": "Government and Opposition",
    "grasas-y-aceites": "Grasas y Aceites",
    "greek-and-roman-musical-studies": "Greek and Roman Musical Studies",
    "griffith-college-harvard": "Griffith College (author-date/Harvard)",
    "groundwater": "Groundwater",
    "groupe-danthropologie-et-darcheologie-funeraire": "Groupe d'anthropologie et d'archéologie funéraire (Français)",
    "guide-des-citations-references-et-abreviations-juridiques": "Guide des citations, références et abréviations juridiques 6e édition (Français)",
    "lluelles": "Guide des références pour la rédaction juridique 7e édition (Guide Lluelles, Français - Canada)",
    "lluelles-no-ibid": "Guide des références pour la rédaction juridique 7e édition (Notes complètes) (Guide Lluelles, no Ibid., Français - Canada)",
    "guide-pour-la-redaction-et-la-presentation-des-theses-a-lusage-des-doctorants": "Guide pour la rédaction et la présentation des thèses à l'usage des doctorants (Français)",
    "geographie-et-cultures": "Géographie et cultures (Français)",
    "geriatrie-et-psychologie-neuropsychiatrie-du-vieillissement": "Gériatrie et Psychologie Neuropsychiatrie du Vieillissement",
    "hand": "HAND",
    "hpb": "HPB",
    "haaga-helia-university-of-applied-sciences-harvard": "Haaga-Helia ammattikorkeakoulu (author-date/Harvard)",
    "haematologica": "Haematologica",
    "haemophilia": "Haemophilia",
    "haffner-style-manual": "Haffner Style Manual",
    "hainan-medical-university-journal-publisher": "Hainan Medical University Journal Publisher",
    "hamburg-school-of-food-science": "Hamburg School of Food Science (diploma, Deutsch)",
    "handbook-of-clinical-neurology": "Handbook of Clinical Neurology",
    "harvard-review-of-psychiatry": "Harvard Review of Psychiatry",
    "haute-ecole-pedagogique-fribourg": "Haute Ecole pédagogique Fribourg (Français)",
    "haute-ecole-de-gestion-de-geneve-iso-690": "Haute école de gestion de Genève (ISO 690)",
    "hawaii-international-conference-on-system-sciences-proceedings": "Hawaii International Conference on System Sciences Proceedings",
    "health-and-social-care-in-the-community": "Health & Social Care in the Community",
    "health-economics": "Health Economics",
    "health-economics-policy-and-law": "Health Economics, Policy and Law",
    "health-education-england-harvard": "Health Education England (author-date/Harvard)",
    "health-education-research": "Health Education Research",
    "health-physics": "Health Physics",
    "health-reform-observer-observatoire-des-reformes-de-sante": "Health Reform Observer - Observatoire des Réformes de Santé",
    "health-sciences-university-uco-school-of-osteopathy": "Health Sciences University - UCO School of Osteopathy",
    "health-and-human-rights-journal": "Health and Human Rights Journal",
    "health-sports-and-rehabilitation-medicine": "Health, Sports & Rehabilitation Medicine",
    "heart-failure-clinics": "Heart Failure Clinics",
    "heart-rhythm": "Heart Rhythm",
    "heidelberg-university-faculty-of-medicine": "Heidelberg University - Faculty of Medicine (Universität Heidelberg - Medizinische Fakultät Heidelberg)",
    "heiliger-dienst": "Heiliger Dienst (Deutsch)",
    "university-of-helsinki-faculty-of-theology": "Helsingin yliopisto - Teologinen tiedekunta (Suomi)",
    "helvetica-chimica-acta": "Helvetica Chimica Acta",
    "hematology-oncology-clinics-of-north-america": "Hematology/Oncology Clinics of North America",
    "hemijska-industrija": "Hemijska industrija",
    "henoch": "Henoch",
    "hepatology": "Hepatology",
    "heredity": "Heredity",
    "herpetologica": "Herpetologica",
    "hiob-ludolf-centre-for-ethiopian-studies": "Hiob Ludolf Centre for Ethiopian Studies",
    "hiob-ludolf-centre-for-ethiopian-studies-long-names": "Hiob Ludolf Centre for Ethiopian Studies (long names)",
    "hiob-ludolf-centre-for-ethiopian-studies-with-url-doi": "Hiob Ludolf Centre for Ethiopian Studies (with URL/DOI)",
    "hipertension-y-riesgo-vascular": "Hipertensión y Riesgo Vascular (Español)",
    "histoire-et-mesure": "Histoire & Mesure (Français)",
    "histoire-at-politique": "Histoire@Politique. Politique, culture, société (Français)",
    "histopathology": "Histopathology",
    "historical-materialism": "Historical Materialism",
    "history-and-theory": "History and Theory",
    "history-of-the-human-sciences": "History of the Human Sciences",
    "hochschule-bonn-rhein-sieg": "Hochschule Bonn-Rhein-Sieg - Fachbereich Wirtschaftswissenschaften (Harvard, Deutsch)",
    "hochschule-hannover-soziale-arbeit": "Hochschule Hannover - Soziale Arbeit (Deutsch)",
    "hochschule-munchen-fakultat-fur-angewandte-sozialwissenschaften": "Hochschule München - Fakultät für Angewandte Sozialwissenschaften (Deutsch)",
    "hochschule-osnabruck-fakultat-agrarwissenschaften-und-landschaftsarchitektur": "Hochschule Osnabrück - Fakultät Agrarwissenschaften und Landschaftsarchitektur (Deutsch)",
    "hochschule-pforzheim-fakultat-fur-wirtschaft-und-recht": "Hochschule Pforzheim - Fakultät für Wirtschaft und Recht (Deutsch)",
    "hochschule-rheinmain-wiesbaden-business-school-gesundheitsokonomie": "Hochschule RheinMain - Wiesbaden Business School - Gesundheitsökonomie (Deutsch)",
    "hochschule-der-kunste-bern-musikforschung": "Hochschule der Künste Bern - Musikforschung",
    "stuttgart-media-university": "Hochschule der Medien Stuttgart (Deutsch)",
    "hochschule-fur-soziale-arbeit-fhnw": "Hochschule für Soziale Arbeit FHNW (Deutsch - Schweiz)",
    "hochschule-fur-wirtschaft-und-recht-berlin": "Hochschule für Wirtschaft und Recht Berlin (Deutsch)",
    "homeopathy-thieme": "Homeopathy Thieme",
    "hong-kong-journal-of-radiology": "Hong Kong Journal of Radiology",
    "hospital-a-domicilio": "Hospital a Domicilio",
    "housing-studies": "Housing Studies",
    "howard-hughes-medical-institute": "Howard Hughes Medical Institute",
    "hue-university-of-medicine-and-pharmacy": "Hue University of Medicine and Pharmacy",
    "human-brain-mapping": "Human Brain Mapping",
    "human-ecology": "Human Ecology",
    "human-molecular-genetics": "Human Molecular Genetics",
    "human-mutation": "Human Mutation",
    "human-reproduction": "Human Reproduction",
    "human-reproduction-update": "Human Reproduction Update",
    "human-resource-management-journal": "Human Resource Management Journal",
    "human-rights-law-review": "Human Rights Law Review",
    "human-wildlife-interactions": "Human-Wildlife Interactions",
    "humboldt-state-university-environmental-resources-engineering": "Humboldt State University - Environmental Resources Engineering",
    "hydrobiologia": "Hydrobiologia",
    "hydrological-processes": "Hydrological Processes",
    "hydrological-sciences-journal": "Hydrological Sciences Journal",
    "hypertension-research": "Hypertension Research",
    "hypotheses-in-the-life-sciences": "Hypotheses in the Life Sciences",
    "hystrix-the-italian-journal-of-mammalogy": "Hystrix, the Italian Journal of Mammalogy",
    "ib-tauris-note": "I.B. Tauris (note)",
    "iainutuban": "IAINU Tuban (Bahasa Indonesia)",
    "iawa-journal": "IAWA Journal",
    "ie-comunicaciones": "IE Comunicaciones",
    "ieee": "IEEE Reference Guide version 11.29.2023",
    "ieee-transactions-on-medical-imaging": "IEEE Transactions on Medical Imaging",
    "iica-catie": "IICA-CATIE (Español)",
    "incontext-studies-in-translation-and-interculturalism": "INContext: Studies in Translation and Interculturalism",
    "indiana": "INDIANA",
    "instap-academic-press": "INSTAP Academic Press",
    "inter-ro": "INTER: Romanian Review for Theological and Religious Studies",
    "ios-press-books": "IOS Press (books)",
    "ipag-business-school-apa": "IPAG Business School - APA",
    "iso690-author-date-cat": "ISO-690 (author-date, Catalan)",
    "iso690-author-date-de": "ISO-690 (author-date, Deutsch)",
    "iso690-author-date-en": "ISO-690 (author-date, English)",
    "iso690-author-date-es": "ISO-690 (author-date, Español)",
    "iso690-author-date-fr": "ISO-690 (author-date, Français)",
    "iso690-author-date-pt-br": "ISO-690 (author-date, Português - Brasil)",
    "iso690-author-date-sk": "ISO-690 (author-date, Slovenčina)",
    "iso690-author-date-fr-no-abstract": "ISO-690 (author-date, no abstract, Français)",
    "iso690-author-date-cs": "ISO-690 (author-date, Čeština)",
    "iso690-full-note-en": "ISO-690 (full note, English)",
    "iso690-full-note-es": "ISO-690 (full note, Español)",
    "iso690-full-note-sk": "ISO-690 (full note, Slovenčina)",
    "iso690-full-note-with-ibid-ro": "ISO-690 (full note, with Ibid., Română)",
    "iso690-full-note-cs": "ISO-690 (full note, Čeština)",
    "iso690-note-fr": "ISO-690 (note, no abstract, Français)",
    "iso690-note-cs": "ISO-690 (note, without bibliography, Čeština)",
    "iso690-numeric-cat": "ISO-690 (numeric, Catalan)",
    "iso690-numeric-en": "ISO-690 (numeric, English)",
    "iso690-numeric-fr": "ISO-690 (numeric, Français)",
    "iso690-numeric-lt": "ISO-690 (numeric, Lietuvių kalba)",
    "iso690-numeric-sk": "ISO-690 (numeric, Slovenčina)",
    "iso690-numeric-brackets-cs": "ISO-690 (numeric, brackets, Čeština)",
    "iso690-numeric-cs": "ISO-690 (numeric, parentheses, Čeština)",
    "iubmb-life": "IUBMB Life",
    "ibis": "Ibis",
    "idojaras-quarterly-journal-of-the-hungarian-meteorological-service": "Időjárás - Quarterly Journal of the Hungarian Meteorological Service",
    "igaku-toshokan": "Igaku Toshokan (日本語)",
    "ilahiyat-studies": "Ilahiyat Studies (full note)",
    "im-gesprach": "Im Gespräch - Hefte der Martin Buber-Gesellschaft (Deutsch)",
    "imperial-college-london-author-date": "Imperial College London (author-date/Harvard)",
    "imperial-college-london-numerical": "Imperial College London (numerical/Vancouver)",
    "invisu": "InVisu",
    "indian-dermatology-online-journal": "Indian Dermatology Online Journal",
    "indian-journal-of-agricultural-sciences": "Indian Journal of Agricultural Sciences",
    "indian-journal-of-medical-research": "Indian Journal of Medical Research",
    "indian-journal-of-orthopaedics": "Indian Journal of Orthopaedics",
    "indian-journal-of-physics": "Indian Journal of Physics",
    "indian-journal-of-traditional-knowledge": "Indian Journal of Traditional Knowledge",
    "indian-journal-of-veterinary-and-animal-sciences-research": "Indian Journal of Veterinary and Animal Sciences Research",
    "indoor-air": "Indoor Air",
    "infectio": "Infectio (Español)",
    "infectious-disease-clinics-of-north-america": "Infectious Disease Clinics of North America",
    "inflammatory-bowel-diseases": "Inflammatory Bowel Diseases",
    "influenza-and-other-respiratory-viruses": "Influenza and Other Respiratory Viruses",
    "infomin": "Infomin",
    "informal-logic": "Informal Logic",
    "informationswissenschaft-theorie-methode-praxis": "Informationswissenschaft: Theorie, Methode und Praxis / Sciences de l’information: théorie, méthode et pratique",
    "ingenieria-agricola": "Ingeniería Agrícola (Español)",
    "innovations-therapeutiques-en-oncologie": "Innovations & Thérapeutiques en Oncologie",
    "institut-pertanian-bogor": "Institut Pertanian Bogor: Pedoman Penulisan Karya Ilmiah Edisi ke-3 (Bahasa Indonesia)",
    "institut-teknologi-bandung-sekolah-pascasarjana": "Institut Teknologi Bandung - Sekolah Pascasarjana",
    "institut-francais-darcheologie-orientale-arab-studies": "Institut français d'archéologie orientale - Arab Studies (English)",
    "institut-francais-darcheologie-orientale-en": "Institut français d'archéologie orientale - Egyptology (English)",
    "institut-francais-darcheologie-orientale": "Institut français d'archéologie orientale - archéologie et égyptologie (Français)",
    "institut-francais-darcheologie-orientale-etudes-arabes": "Institut français d'archéologie orientale - études arabes (Français)",
    "institut-fur-geschichte-des-landlichen-raums": "Institut für Geschichte des ländlichen Raums (Deutsch)",
    "harvard-institut-fur-praxisforschung-de": "Institut für Praxisforschung (author-date/Harvard, Bahr & Frackmann) (Deutsch)",
    "institut-national-de-la-recherche-scientifique-sciences-sociales": "Institut national de la recherche scientifique - Sciences sociales (author-date, Français)",
    "institut-national-de-recherches-archeologiques-preventives": "Institut national de recherches archéologiques préventives (Français)",
    "institut-national-de-sante-publique-du-quebec-napp": "Institut national de santé publique du Québec - NAPP (Français - Canada)",
    "institut-national-de-sante-publique-du-quebec-topo": "Institut national de santé publique du Québec - TOPO (Français - Canada)",
    "institute-for-operations-research-and-the-management-sciences": "Institute for Operations Research and the Management Sciences",
    "institute-of-mathematical-statistics": "Institute of Mathematical Statistics journals",
    "institute-of-mathematics-and-its-applications": "Institute of Mathematics and its Applications",
    "institute-of-physics-harvard": "Institute of Physics (author-date/Harvard)",
    "institute-of-physics-numeric": "Institute of Physics (numeric)",
    "instituto-brasileiro-de-informacao-em-ciencia-e-tecnologia-abnt-initials": "Instituto Brasileiro de Informação em Ciência e Tecnologia - ABNT (autoria abreviada)",
    "instituto-brasileiro-de-informacao-em-ciencia-e-tecnologia-abnt": "Instituto Brasileiro de Informação em Ciência e Tecnologia - ABNT (autoria completa)",
    "instituto-superior-de-teologia-de-las-islas-canarias": "Instituto Superior de Teología de las Islas Canarias (Español)",
    "instituto-universitario-militar": "Instituto Universitário Militar",
    "instituto-de-investigaciones-sobre-la-universidad-y-la-educacion-moderno": "Instituto de Investigaciones sobre la Universidad y la Educación - Moderno (autor-fecha, Español)",
    "associacao-brasileira-de-normas-tecnicas-ipea": "Instituto de Pesquisa Econômica Aplicada - ABNT (Português - Brasil)",
    "instituto-de-pesquisas-energeticas-e-nucleares": "Instituto de Pesquisas Energéticas e Nucleares (Português - Brasil)",
    "instituto-de-pesquisas-tecnologicas": "Instituto de Pesquisas Tecnológicas (Português - Brasil)",
    "instrumenta-patristica-et-mediaevalia": "Instrumenta Patristica et Mediaevalia",
    "integrated-science-publishing-journals": "Integrated Science Publishing journals",
    "integrative-and-comparative-biology": "Integrative & Comparative Biology",
    "intellect-newgen-books": "Intellect Newgen Books",
    "inter-research-science-center": "Inter-Research Science Center",
    "interaction-design-and-architectures": "Interaction Design & Architecture(s)",
    "interactive-cardiovascular-and-thoracic-surgery": "Interactive CardioVascular and Thoracic Surgery",
    "interdisziplinare-anthropologie": "Interdisziplinäre Anthropologie (Deutsch)",
    "interdisziplinare-zeitschrift-fur-technologie-und-lernen": "Interdisziplinäre Zeitschrift für Technologie und Lernen (Deutsch)",
    "interkulturelle-germanistik-gottingen": "Interkulturelle Germanistik Göttingen (Deutsch)",
    "international-affairs": "International Affairs",
    "international-atomic-energy-agency": "International Atomic Energy Agency",
    "international-biodeterioration-and-biodegradation": "International Biodeterioration & Biodegradation",
    "international-brazilian-journal-of-urology": "International Brazilian Journal Of Urology",
    "international-conference-on-information-systems-development": "International Conference on Information Systems Development",
    "international-development-policy": "International Development Policy",
    "international-energy-agency-organisation-for-economic-co-operation-and-development": "International Energy Agency - Organisation for Economic Co-operation and Development",
    "international-islamic-university-malaysia-ahmad-ibrahim-kulliyyah-of-laws": "International Islamic University Malaysia - Ahmad Ibrahim Kulliyyah of Laws",
    "international-journal-for-numerical-methods-in-biomedical-engineering": "International Journal for Numerical Methods in Biomedical Engineering",
    "international-journal-of-audiology": "International Journal of Audiology",
    "international-journal-of-automotive-technology": "International Journal of Automotive Technology",
    "international-journal-of-cancer": "International Journal of Cancer",
    "international-journal-of-circuit-theory-and-applications": "International Journal of Circuit Theory and Applications",
    "international-journal-of-climatology": "International Journal of Climatology",
    "international-journal-of-clinical-research": "International Journal of Clinical Research",
    "international-journal-of-cosmetic-science": "International Journal of Cosmetic Science",
    "international-journal-of-electrochemical-science": "International Journal of Electrochemical Science",
    "international-journal-of-electronic-commerce": "International Journal of Electronic Commerce",
    "international-journal-of-epidemiology": "International Journal of Epidemiology",
    "international-journal-of-exercise-science": "International Journal of Exercise Science",
    "international-journal-of-food-science-and-technology": "International Journal of Food Science & Technology",
    "international-journal-of-geriatric-psychiatry": "International Journal of Geriatric Psychiatry",
    "international-journal-of-humanoid-robotics": "International Journal of Humanoid Robotics",
    "international-journal-of-language-and-communication-disorders": "International Journal of Language & Communication Disorders",
    "international-journal-of-management-reviews": "International Journal of Management Reviews",
    "international-journal-of-nuclear-security": "International Journal of Nuclear Security",
    "international-journal-of-obstetric-anesthesia": "International Journal of Obstetric Anesthesia",
    "international-journal-of-occupational-medicine-and-environmental-health": "International Journal of Occupational Medicine and Environmental Health",
    "international-journal-of-oral-and-maxillofacial-surgery": "International Journal of Oral and Maxillofacial Surgery",
    "international-journal-of-osteoarchaeology": "International Journal of Osteoarchaeology",
    "international-journal-of-plant-sciences": "International Journal of Plant Sciences",
    "international-journal-of-polymer-analysis-and-characterization": "International Journal of Polymer Analysis and Characterization",
    "international-journal-of-polymeric-materials-and-polymeric-biomaterials": "International Journal of Polymeric Materials and Polymeric Biomaterials",
    "international-journal-of-population-data-science": "International Journal of Population Data Science",
    "international-journal-of-quantum-chemistry": "International Journal of Quantum Chemistry",
    "international-journal-of-radiation-oncology-biology-physics": "International Journal of Radiation Oncology, Biology, Physics",
    "international-journal-of-research-in-exercise-physiology": "International Journal of Research in Exercise Physiology",
    "international-journal-of-simulation-modelling": "International Journal of Simulation Modelling",
    "international-journal-of-spatial-data-infrastructures-research": "International Journal of Spatial Data Infrastructures Research",
    "international-journal-of-sports-medicine": "International Journal of Sport Medicine",
    "international-journal-of-urban-and-regional-research": "International Journal of Urban and Regional Research",
    "international-journal-of-wildland-fire": "International Journal of Wildland Fire",
    "international-microbiology": "International Microbiology",
    "international-organization": "International Organization",
    "international-pig-veterinary-society-congress-proceedings": "International Pig Veterinary Society Congress Proceedings",
    "international-relations": "International Relations",
    "international-review-of-the-red-cross": "International Review of the Red Cross",
    "international-security": "International Security",
    "international-studies-association": "International Studies Association",
    "international-union-of-crystallography": "International Union of Crystallography journals",
    "international-union-of-forest-research-organizations-headquarters": "International Union of Forest Research Organizations - Headquarters",
    "internet-archaeology": "Internet Archaeology",
    "interpreting": "Interpreting",
    "inventaire-general-du-patrimoine-culturel-iso-690-full-note": "Inventaire général du patrimoine culturel - ISO-690 (full note, Français)",
    "inventaire-general-du-patrimoine-culturel-iso-690-full-note-with-ibid": "Inventaire général du patrimoine culturel - ISO-690 (full note, with Ibid., Français)",
    "inventaire-general-du-patrimoine-culturel-iso-690-note": "Inventaire général du patrimoine culturel - ISO-690 (note, Français)",
    "invertebrate-biology": "Invertebrate Biology",
    "investigative-radiology": "Investigative Radiology",
    "iran-manual-of-style": "Iran Manual of Style - شیوه‌نامه ایران (فارسی)",
    "iranian-journal-of-basic-medical-sciences": "Iranian Journal of Basic Medical Sciences",
    "iranian-journal-of-pharmaceutical-research": "Iranian Journal of Pharmaceutical Research",
    "irish-historical-studies": "Irish Historical Studies",
    "isabella-stewart-gardner-museum": "Isabella Stewart Gardner Museum",
    "isara-iso-690": "Isara - ISO-690 (auteur-date, français)",
    "israel-medical-association-journal": "Israel Medical Association Journal",
    "istanus-journal-on-applied-and-biological-sciences": "Istanus Journal on Applied and Biological Sciences",
    "italian-journal-of-agronomy": "Italian Journal of Agronomy",
    "italus-hortus": "Italus Hortus",
    "ithaque": "Ithaque (Français - Canada)",
    "ius-ecclesiae": "Ius Ecclesiae",
    "jacc-cardiovascular-imaging": "JACC: Cardiovascular Imaging",
    "jacc-cardiovascular-interventions": "JACC: Cardiovascular Interventions",
    "jbi-evidence-synthesis": "JBI Evidence Synthesis",
    "jcom-journal-of-science-communication": "JCOM: Journal of Science Communication",
    "jahrbuch-der-osterreichischen-byzantinischen-gesellschaft": "Jahrbuch der Österreichischen Byzantinischen Gesellschaft",
    "jahrbuch-fur-evangelikale-theologie": "Jahrbuch für evangelikale Theologie (Deutsch)",
    "japanese-journal-of-applied-physics": "Japanese Journal of Applied Physics",
    "javnost-the-public": "Javnost - The Public",
    "john-benjamins-publishing-company-iconicity-in-language-and-literature": "John Benjamins Publishing Company - Iconicity in Language and Literature",
    "john-benjamins-publishing-company-linguistik-aktuell-linguistics-today": "John Benjamins Publishing Company - Linguistik Aktuell/Linguistics Today",
    "johnson-matthey-technology-review": "Johnson Matthey Technology Review",
    "journal-of-magnetic-resonance-imaging": "Journal Of Magnetic Resonance Imaging",
    "journal-and-proceedings-of-the-royal-society-of-new-south-wales": "Journal and Proceedings of the Royal Society of New South Wales",
    "journal-de-la-societe-des-oceanistes": "Journal de la Société des Océanistes",
    "journal-de-la-societe-des-americanistes": "Journal de la Société des américanistes",
    "journal-der-deutschen-dermatologischen-gesellschaft": "Journal der Deutschen Dermatologischen Gesellschaft",
    "journal-for-veterinary-medicine-biotechnology-and-biosafety": "Journal for Veterinary Medicine, Biotechnology and Biosafety",
    "journal-for-the-history-of-astronomy": "Journal for the History of Astronomy",
    "journal-for-the-study-of-the-new-testament": "Journal for the Study of the New Testament",
    "journal-fur-kulturpflanzen-journal-of-cultivated-plants": "Journal für Kulturpflanzen - Journal of Cultivated Plants",
    "journal-fur-kunstgeschichte": "Journal für Kunstgeschichte",
    "journal-fur-medienlinguistik": "Journal für Medienlinguistik (Deutsch)",
    "journal-of-aoac-international": "Journal of AOAC International",
    "journal-of-accounting-research": "Journal of Accounting Research",
    "journal-of-acoustics": "Journal of Acoustics",
    "journal-of-adolescent-health": "Journal of Adolescent Health",
    "journal-of-advanced-ceramics": "Journal of Advanced Ceramics",
    "journal-of-applied-engineering-sciences-technology": "Journal of Advanced Engineering & Science Technology",
    "journal-of-advertising-research": "Journal of Advertising Research",
    "journal-of-agricultural-and-applied-economics": "Journal of Agricultural and Applied Economics",
    "journal-of-agricultural-and-resource-economics": "Journal of Agricultural and Resource Economics",
    "journal-of-alzheimers-disease": "Journal of Alzheimer's Disease",
    "journal-of-anatomy": "Journal of Anatomy",
    "journal-of-animal-physiology-and-animal-nutrition": "Journal of Animal Physiology and Animal Nutrition",
    "journal-of-animal-science": "Journal of Animal Science",
    "journal-of-animal-and-feed-sciences": "Journal of Animal and Feed Sciences",
    "journal-of-antimicrobial-chemotherapy": "Journal of Antimicrobial Chemotherapy",
    "journal-of-applied-animal-science": "Journal of Applied Animal Science",
    "journal-of-applied-clinical-medical-physics": "Journal of Applied Clinical Medical Physics",
    "journal-of-applied-entomology": "Journal of Applied Entomology",
    "journal-of-applied-glycoscience": "Journal of Applied Glycoscience",
    "journal-of-applied-pharmaceutical-research": "Journal of Applied Pharmaceutical Research",
    "journal-of-applied-philosophy": "Journal of Applied Philosophy",
    "journal-of-applied-polymer-science": "Journal of Applied Polymer Science",
    "journal-of-archaeological-research": "Journal of Archaeological Research",
    "journal-of-atrial-fibrillation": "Journal of Atrial Fibrillation",
    "journal-of-australian-strength-and-conditioning": "Journal of Australian Strength & Conditioning",
    "journal-of-avian-biology": "Journal of Avian Biology",
    "journal-of-basic-microbiology": "Journal of Basic Microbiology",
    "journal-of-behavioral-health-and-psychology": "Journal of Behavioral Health and Psychology",
    "journal-of-biological-regulators-and-homeostatic-agents": "Journal of Biological Regulators & Homeostatic Agents",
    "journal-of-biomedical-materials-research-part-a": "Journal of Biomedical Materials Research Part A",
    "journal-of-bioscience-and-bioengineering": "Journal of Bioscience and Bioengineering",
    "journal-of-biosciences": "Journal of Biosciences",
    "journal-of-bone-and-mineral-research": "Journal of Bone and Mineral Research",
    "journal-of-brachial-plexus-and-peripheral-nerve-injury": "Journal of Brachial Plexus and Peripheral Nerve Injury",
    "journal-of-breast-cancer": "Journal of Breast Cancer",
    "journal-of-burn-care-and-research": "Journal of Burn Care & Research",
    "journal-of-business-logistics": "Journal of Business Logistics",
    "journal-of-cachexia-sarcopenia-and-muscle": "Journal of Cachexia, Sarcopenia and Muscle",
    "journal-of-cardiothoracic-and-vascular-anesthesia": "Journal of Cardiothoracic and Vascular Anesthesia",
    "journal-of-cellular-biochemistry": "Journal of Cellular Biochemistry",
    "journal-of-cellular-and-molecular-medicine": "Journal of Cellular and Molecular Medicine",
    "journal-of-chemistry-and-chemical-engineering": "Journal of Chemistry and Chemical Engineering",
    "journal-of-chemometrics": "Journal of Chemometrics",
    "journal-of-clinical-neurology": "Journal of Clinical Neurology",
    "journal-of-clinical-neurophysiology": "Journal of Clinical Neurophysiology",
    "journal-of-clinical-oncology": "Journal of Clinical Oncology",
    "journal-of-clinical-rheumatology": "Journal of Clinical Rheumatology",
    "journal-of-clinical-sleep-medicine": "Journal of Clinical Sleep Medicine",
    "journal-of-clinical-and-translational-science": "Journal of Clinical and Translational Science",
    "journal-of-combinatorics": "Journal of Combinatorics",
    "journal-of-common-market-studies": "Journal of Common Market Studies",
    "journal-of-comparative-pathology": "Journal of Comparative Pathology",
    "journal-of-computational-chemistry": "Journal of Computational Chemistry",
    "journal-of-computer-applications-in-archaeology": "Journal of Computer Applications in Archaeology",
    "journal-of-computer-assisted-tomography": "Journal of Computer Assisted Tomography",
    "journal-of-computer-information-systems": "Journal of Computer Information Systems",
    "journal-of-conchology": "Journal of Conchology",
    "journal-of-consumer-research": "Journal of Consumer Research",
    "journal-of-contemporary-medicine": "Journal of Contemporary Medicine",
    "journal-of-contemporary-water-research-and-education": "Journal of Contemporary Water Research and Education",
    "journal-of-crohns-and-colitis": "Journal of Crohn's and Colitis",
    "journal-of-crohns-and-colitis-supplements": "Journal of Crohn's and Colitis Supplements",
    "journal-of-dairy-research": "Journal of Dairy Research",
    "journal-of-dairy-science": "Journal of Dairy Science",
    "journal-of-demographic-economics": "Journal of Demographic Economics",
    "journal-of-dental-research": "Journal of Dental Research",
    "journal-of-dental-traumatology": "Journal of Dental Traumatology",
    "journal-of-early-christian-studies": "Journal of Early Christian Studies",
    "journal-of-economic-impact": "Journal of Economic Impact",
    "journal-of-egyptian-history": "Journal of Egyptian History",
    "journal-of-elections-public-opinion-and-parties": "Journal of Elections, Public Opinion & Parties",
    "journal-of-emerging-investigators": "Journal of Emerging Investigators",
    "journal-of-endodontics": "Journal of Endodontics",
    "journal-of-environmental-science-and-health-part-b": "Journal of Environmental Science and Health, Part B",
    "journal-of-ethnobiology": "Journal of Ethnobiology",
    "journal-of-european-public-policy": "Journal of European Public Policy",
    "journal-of-evolution-and-health": "Journal of Evolution and Health",
    "journal-of-evolutionary-biology": "Journal of Evolutionary Biology",
    "journal-of-experimental-botany": "Journal of Experimental Botany",
    "journal-of-field-ornithology": "Journal of Field Ornithology",
    "journal-of-finance": "Journal of Finance",
    "journal-of-financial-and-quantitative-analysis": "Journal of Financial and Quantitative Analysis",
    "journal-of-fish-biology": "Journal of Fish Biology",
    "journal-of-food-protection": "Journal of Food Protection",
    "journal-of-foraminiferal-research": "Journal of Foraminiferal Research",
    "journal-of-forensic-sciences": "Journal of Forensic Sciences",
    "journal-of-frailty-and-aging": "Journal of Frailty & Aging",
    "journal-of-geriatric-psychiatry-and-neurology": "Journal of Geriatric Psychiatry and Neurology",
    "journal-of-glaciology": "Journal of Glaciology",
    "journal-of-global-health": "Journal of Global Health",
    "journal-of-hazardous-materials": "Journal of Hazardous Materials",
    "journal-of-health-care-for-the-poor-and-underserved": "Journal of Health Care for the Poor and Underserved",
    "journal-of-hearing-science": "Journal of Hearing Science",
    "journal-of-historical-linguistics": "Journal of Historical Linguistics",
    "journal-of-human-evolution": "Journal of Human Evolution",
    "journal-of-human-nutrition-and-dietetics": "Journal of Human Nutrition and Dietetics",
    "journal-of-human-rights": "Journal of Human Rights",
    "journal-of-hypertension": "Journal of Hypertension",
    "journal-of-industrial-ecology": "Journal of Industrial Ecology",
    "journal-of-industrial-and-engineering-chemistry": "Journal of Industrial and Engineering Chemistry",
    "journal-of-infection": "Journal of Infection",
    "journal-of-infectious-diseases": "Journal of Infectious Diseases",
    "journal-of-information-technology": "Journal of Information Technology",
    "journal-of-innovation-economics-and-management": "Journal of Innovation Economics and Management",
    "journal-of-institutional-and-theoretical-economics": "Journal of Institutional and Theoretical Economics",
    "journal-of-instrumentation": "Journal of Instrumentation",
    "journal-of-integrated-omics": "Journal of Integrated OMICS",
    "journal-of-interactive-marketing": "Journal of Interactive Marketing",
    "journal-of-interactive-media-in-education-harvard": "Journal of Interactive Media in Education (author-date/Harvard)",
    "journal-of-intercultural-studies": "Journal of Intercultural Studies",
    "journal-of-internal-medicine": "Journal of Internal Medicine",
    "journal-of-international-business-studies": "Journal of International Business Studies",
    "journal-of-international-peacekeeping": "Journal of International Peacekeeping",
    "journal-of-international-relations-and-development": "Journal of International Relations and Development",
    "journal-of-investigative-dermatology": "Journal of Investigative Dermatology",
    "journal-of-jewish-studies": "Journal of Jewish Studies",
    "journal-of-juridical-sciences": "Journal of Juridical Sciences",
    "journal-of-korean-neurosurgical-society": "Journal of Korean Neurosurgical Society",
    "journal-of-law-medicine-ethics": "Journal of Law, Medicine & Ethics",
    "journal-of-leukocyte-biology": "Journal of Leukocyte Biology",
    "journal-of-limnology": "Journal of Limnology",
    "journal-of-linguistics": "Journal of Linguistics",
    "journal-of-lipid-research": "Journal of Lipid Research",
    "journal-of-lithic-studies": "Journal of Lithic Studies",
    "journal-of-mammalogy": "Journal of Mammalogy",
    "journal-of-management": "Journal of Management",
    "journal-of-management-information-systems": "Journal of Management Information Systems",
    "journal-of-management-studies": "Journal of Management Studies",
    "journal-of-materials-research": "Journal of Materials Research",
    "journal-of-mechanical-science-and-technology": "Journal of Mechanical Science and Technology",
    "journal-of-medical-genetics": "Journal of Medical Genetics",
    "journal-of-medical-internet-research": "Journal of Medical Internet Research",
    "journal-of-microbiology": "Journal of Microbiology",
    "journal-of-microbiology-and-biotechnology": "Journal of Microbiology and Biotechnology",
    "journal-of-microscopy": "Journal of Microscopy",
    "journal-of-midwifery-science": "Journal of Midwifery Science",
    "journal-of-minimally-invasive-gynecology": "Journal of Minimally Invasive Gynecology",
    "journal-of-molecular-cell-biology": "Journal of Molecular Cell Biology",
    "journal-of-molecular-endocrinology": "Journal of Molecular Endocrinology",
    "journal-of-molecular-recognition": "Journal of Molecular Recognition",
    "journal-of-molecular-signaling": "Journal of Molecular Signaling",
    "journal-of-move-and-therapeutic-science": "Journal of Move and Therapeutic Science",
    "journal-of-multidisciplinary-applied-natural-science": "Journal of Multidisciplinary Applied Natural Science",
    "journal-of-musculoskeletal-research": "Journal of Musculoskeletal Research",
    "journal-of-music-technology-and-education": "Journal of Music Technology and Education",
    "journal-of-nanoscience-and-nanotechnology": "Journal of Nanoscience and Nanotechnology",
    "journal-of-natural-history": "Journal of Natural History",
    "journal-of-neolithic-archaeology": "Journal of Neolithic Archaeology",
    "journal-of-neurochemistry": "Journal of Neurochemistry",
    "journal-of-neuroendocrinology": "Journal of Neuroendocrinology",
    "journal-of-neuroimaging": "Journal of Neuroimaging",
    "journal-of-neurological-disorders": "Journal of Neurological Disorders",
    "journal-of-neurophysiology": "Journal of Neurophysiology",
    "journal-of-neuroscience-and-neuroengineering": "Journal of Neuroscience and Neuroengineering",
    "journal-of-new-zealand-grasslands": "Journal of New Zealand Grasslands",
    "journal-of-nutrition": "Journal of Nutrition",
    "journal-of-obstetrics-and-gynaecology-canada": "Journal of Obstetrics and Gynaecology Canada",
    "journal-of-occupational-and-environmental-medicine": "Journal of Occupational and Environmental Medicine",
    "journal-of-oil-palm-research": "Journal of Oil Palm Research",
    "journal-of-open-research-software": "Journal of Open Research Software",
    "journal-of-oral-and-maxillofacial-surgery": "Journal of Oral and Maxillofacial Surgery",
    "journal-of-orthopaedic-research": "Journal of Orthopaedic Research",
    "journal-of-orthopaedic-trauma": "Journal of Orthopaedic Trauma",
    "journal-of-orthopaedics-trauma-and-rehabilitation": "Journal of Orthopaedics, Trauma and Rehabilitation",
    "journal-of-pain-and-symptom-management": "Journal of Pain and Symptom Management",
    "journal-of-paleontology": "Journal of Paleontology",
    "journal-of-peace-research": "Journal of Peace Research",
    "journal-of-pediatric-gastroenterology-and-nutrition": "Journal of Pediatric Gastroenterology and Nutrition",
    "journal-of-pediatric-surgery": "Journal of Pediatric Surgery",
    "journal-of-peptide-science": "Journal of Peptide Science",
    "journal-of-perinatal-medicine": "Journal of Perinatal Medicine",
    "journal-of-periodontal-research": "Journal of Periodontal Research",
    "journal-of-pharmacy-and-pharmacology": "Journal of Pharmacy and Pharmacology",
    "journal-of-phycology": "Journal of Phycology",
    "journal-of-physical-therapy-science": "Journal of Physical Therapy Science",
    "journal-of-plankton-research": "Journal of Plankton Research",
    "journal-of-plant-ecology": "Journal of Plant Ecology",
    "journal-of-plant-nutrition-and-soil-science": "Journal of Plant Nutrition and Soil Science",
    "journal-of-plant-protection-research": "Journal of Plant Protection Research",
    "journal-of-political-ideologies": "Journal of Political Ideologies",
    "journal-of-political-philosophy": "Journal of Political Philosophy",
    "journal-of-pollination-ecology": "Journal of Pollination Ecology",
    "journal-of-polymer-science-part-a-polymer-chemistry": "Journal of Polymer Science Part A: Polymer Chemistry",
    "journal-of-porphyrins-and-phthalocyanines": "Journal of Porphyrins and Phthalocyanines",
    "journal-of-product-innovation-management": "Journal of Product Innovation Management",
    "journal-of-prosthodontics": "Journal of Prosthodontics",
    "journal-of-psychiatric-and-mental-health-nursing": "Journal of Psychiatric and Mental Health Nursing",
    "journal-of-psychiatry-and-neuroscience": "Journal of Psychiatry & Neuroscience",
    "journal-of-raman-spectroscopy": "Journal of Raman Spectroscopy",
    "journal-of-reconstructive-microsurgery": "Journal of Reconstructive Microsurgery",
    "journal-of-refugee-studies": "Journal of Refugee Studies",
    "journal-of-rehabilitation-medicine": "Journal of Rehabilitation Medicine",
    "journal-of-remote-sensing": "Journal of Remote Sensing",
    "journal-of-retailing": "Journal of Retailing",
    "journal-of-rheumatology": "Journal of Rheumatology",
    "journal-of-roman-archaeology-a": "Journal of Roman Archaeology (A)",
    "journal-of-roman-archaeology-b": "Journal of Roman Archaeology (B)",
    "journal-of-science-and-medicine-in-sport": "Journal of Science and Medicine in Sport",
    "journal-of-separation-science": "Journal of Separation Science",
    "journal-of-shoulder-and-elbow-surgery": "Journal of Shoulder and Elbow Surgery",
    "journal-of-simulation": "Journal of Simulation",
    "journal-of-sleep-research": "Journal of Sleep Research",
    "journal-of-small-animal-practice": "Journal of Small Animal Practice",
    "journal-of-small-business-management": "Journal of Small Business Management",
    "journal-of-social-archaeology": "Journal of Social Archaeology",
    "journal-of-social-philosophy": "Journal of Social Philosophy",
    "journal-of-soil-science-and-plant-nutrition": "Journal of Soil Science and Plant Nutrition",
    "journal-of-soil-and-water-conservation": "Journal of Soil and Water Conservation",
    "journal-of-sport-and-health-science": "Journal of Sport and Health Science",
    "journal-of-sports-science-and-medicine": "Journal of Sports Science & Medicine",
    "journal-of-strength-and-conditioning-research": "Journal of Strength and Conditioning Research",
    "journal-of-stroke": "Journal of Stroke",
    "journal-of-structural-geology": "Journal of Structural Geology",
    "journal-of-studies-on-alcohol-and-drugs": "Journal of Studies on Alcohol and Drugs",
    "journal-of-surgery-and-medicine": "Journal of Surgery and Medicine",
    "journal-of-surgical-oncology": "Journal of Surgical Oncology",
    "journal-of-systematic-palaeontology": "Journal of Systematic Palaeontology",
    "journal-of-systematics-and-evolution": "Journal of Systematics and Evolution",
    "journal-of-the-electrochemical-society": "Journal of The Electrochemical Society",
    "journal-of-thermal-spray-technology": "Journal of Thermal Spray Technology",
    "journal-of-threatened-taxa": "Journal of Threatened Taxa",
    "journal-of-thrombosis-and-haemostasis": "Journal of Thrombosis and Haemostasis",
    "journal-of-tropical-ecology": "Journal of Tropical Ecology",
    "journal-of-tropical-life-science": "Journal of Tropical Life Science",
    "journal-of-universal-computer-science": "Journal of Universal Computer Science",
    "journal-of-urban-technology": "Journal of Urban Technology",
    "journal-of-urban-and-environmental-engineering": "Journal of Urban and Environmental Engineering",
    "journal-of-vegetation-science": "Journal of Vegetation Science",
    "journal-of-vertebrate-biology": "Journal of Vertebrate Biology",
    "journal-of-vertebrate-paleontology": "Journal of Vertebrate Paleontology",
    "journal-of-vestibular-research": "Journal of Vestibular Research",
    "journal-of-veterinary-diagnostic-investigation": "Journal of Veterinary Diagnostic Investigation",
    "journal-of-visualized-experiments": "Journal of Visualized Experiments",
    "journal-of-water-sanitation-and-hygiene-for-development": "Journal of Water Sanitation and Hygiene for Development",
    "journal-of-wildlife-diseases": "Journal of Wildlife Diseases",
    "journal-of-zoo-biology": "Journal of Zoo Biology",
    "journal-of-zoo-and-wildlife-medicine": "Journal of Zoo and Wildlife Medicine",
    "journal-of-zoology": "Journal of Zoology",
    "journal-of-the-air-and-waste-management-association": "Journal of the Air & Waste Management Association",
    "journal-of-the-american-academy-of-audiology": "Journal of the American Academy of Audiology",
    "journal-of-the-american-academy-of-orthopaedic-surgeons": "Journal of the American Academy of Orthopaedic Surgeons",
    "journal-of-the-american-animal-hospital-association": "Journal of the American Animal Hospital Association",
    "journal-of-the-american-association-of-laboratory-animal-science": "Journal of the American Association of Laboratory Animal Science",
    "journal-of-the-american-ceramic-society": "Journal of the American Ceramic Society",
    "journal-of-the-american-college-of-cardiology": "Journal of the American College of Cardiology",
    "journal-of-the-american-college-of-surgeons": "Journal of the American College of Surgeons",
    "journal-of-the-american-heart-association": "Journal of the American Heart Association",
    "journal-of-the-american-philosophical-association": "Journal of the American Philosophical Association",
    "journal-of-the-american-society-of-brewing-chemists": "Journal of the American Society of Brewing Chemists",
    "journal-of-the-american-society-of-nephrology": "Journal of the American Society of Nephrology",
    "journal-of-the-american-water-resources-association": "Journal of the American Water Resources Association",
    "journal-of-the-association-for-information-systems": "Journal of the Association for Information Systems",
    "journal-of-the-association-of-environmental-and-resource-economists": "Journal of the Association of Environmental and Resource Economists",
    "journal-of-the-botanical-research-institute-of-texas": "Journal of the Botanical Research Institute of Texas",
    "journal-of-the-brazilian-chemical-society": "Journal of the Brazilian Chemical Society",
    "journal-of-the-european-academy-of-dermatology-and-venereology": "Journal of the European Academy of Dermatology and Venereology",
    "journal-of-the-history-of-collections": "Journal of the History of Collections",
    "journal-of-the-indian-law-institute": "Journal of the Indian Law Institute",
    "journal-of-the-korean-society-of-civil-engineers": "Journal of the Korean Society of Civil Engineers",
    "journal-of-the-marine-biological-association-of-the-united-kingdom": "Journal of the Marine Biological Association of the United Kingdom",
    "journal-of-the-royal-anthropological-institute": "Journal of the Royal Anthropological Institute",
    "journal-of-the-royal-society-of-western-australia": "Journal of the Royal Society of Western Australia",
    "journal-of-the-royal-statistical-society": "Journal of the Royal Statistical Society",
    "journal-of-the-science-of-food-and-agriculture": "Journal of the Science of Food and Agriculture",
    "journal-of-the-serbian-chemical-society": "Journal of the Serbian Chemical Society",
    "journal-of-the-warburg-and-courtauld-institutes": "Journal of the Warburg and Courtauld Institutes",
    "journal-on-efficiency-and-responsibility-in-education-and-science": "Journal on Efficiency and Responsibility in Education and Science",
    "journalistica": "Journalistica (Dansk)",
    "jurisprudence": "Jurisprudence (Čeština)",
    "juristische-schulung": "Juristische Schulung (Deutsch)",
    "juristische-zitierweise": "Juristische Zitierweise (Stüber) (Deutsch)",
    "juristische-zitierweise-offentliches-recht": "Juristische Zitierweise - Öffentliches Recht (Deutsch)",
    "juristische-zitierweise-schweizer": "Juristische Zitierweise Schweizer (Ryser Büschi et al.) (Deutsch - Schweiz)",
    "jurnal-ilmu-dan-teknologi-hasil-ternak": "Jurnal Ilmu dan Teknologi Hasil Ternak",
    "jurnal-pangan-dan-agroindustri": "Jurnal Pangan dan Agroindustri (Bahasa Indonesia)",
    "jurnal-sains-farmasi-dan-klinis": "Jurnal Sains Farmasi & Klinis",
    "jurnal-teknik-mesin-indonesia": "Jurnal Teknik Mesin Indonesia (Bahasa Indonesia)",
    "jyvaskylan-yliopisto-kemian-laitos": "Jyväskylän yliopisto - Kemian laitos (Suomi)",
    "kit-karlsruher-institut-fur-technologie-germanistik-ndl-neuere-deutsche-literaturwissenschaft": "KIT Karlsruher Institut für Technologie Germanistik NDL Neuere Deutsche Literaturwissenschaft (German)",
    "kona-powder-and-particle-journal": "KONA Powder and Particle Journal",
    "ksce-journal-of-civil-engineering": "KSCE Journal of Civil Engineering",
    "kth-royal-institute-of-technology-school-of-computer-science-and-communication": "KTH Royal Institute of Technology - School of Computer Science and Communication",
    "kth-royal-institute-of-technology-school-of-computer-science-and-communication-sv": "KTH Royal Institute of Technology - School of Computer Science and Communication (Svenska)",
    "karabuk-university-graduate-school-of-natural-and-applied-sciences": "Karabuk University - Graduate School of Natural and Applied Sciences",
    "karger-journals": "Karger journals",
    "karger-journals-author-date": "Karger journals (author-date)",
    "karlstad-universitet-harvard": "Karlstad Universitet (author-date/Harvard, Svenska)",
    "karstenia": "Karstenia",
    "keel-ja-kirjandus": "Keel ja Kirjandus (Eesti keel)",
    "keele-university-school-of-allied-health-professions": "Keele University - School of Allied Health Professions",
    "kidney-research-and-clinical-practice": "Kidney Research and Clinical Practice",
    "kindheit-und-entwicklung": "Kindheit und Entwicklung",
    "harvard-kings-college-london": "King's College London (author-date/Harvard)",
    "klinische-padiatrie": "Klinische Pädiatrie",
    "knee-surgery-and-related-research": "Knee Surgery & Related Research",
    "knee-surgery-sports-traumatology-arthroscopy": "Knee Surgery, Sports Traumatology, Arthroscopy",
    "knowledge-and-management-of-aquatic-ecosystems": "Knowledge & Management of Aquatic Ecosystems",
    "kommunikation-und-recht": "Kommunikation und Recht (Deutsch)",
    "korean-journal-of-anesthesiology": "Korean Journal of Anesthesiology",
    "korean-journal-of-radiology": "Korean Journal of Radiology",
    "kritische-ausgabe": "Kritische Ausgabe (Deutsch)",
    "kunstakademie-munster": "Kunstakademie Münster (Deutsch)",
    "kolner-zeitschrift-fur-soziologie-und-sozialpsychologie": "Kölner Zeitschrift für Soziologie und Sozialpsychologie (Deutsch)",
    "l-homme-english": "L'homme – Revue française d'anthropologie (English)",
    "l-homme": "L'homme – Revue française d'anthropologie (Français)",
    "lcgc": "LCGC",
    "la-revue-des-sciences-de-gestion": "La Revue des Sciences de Gestion (Français)",
    "la-trobe-university-harvard": "La Trobe University (author-date/Harvard)",
    "la-trobe-university-apa": "La Trobe University - APA 6th edition",
    "laboratory-animal-science-professional": "Laboratory Animal Science Professional",
    "lancaster-university-harvard": "Lancaster University (author-date/Harvard)",
    "land-degradation-and-development": "Land Degradation & Development",
    "landes-bioscience-journals": "Landes Bioscience Journals",
    "language": "Language",
    "language-in-society": "Language in Society",
    "latin-american-perspectives": "Latin American Perspectives",
    "latin-american-research-review": "Latin American Research Review",
    "lauterbornia": "Lauterbornia - Internationale Zeitschrift für Faunistik und Floristik des Süßwassers (Deutsch)",
    "law-and-society-review": "Law & Society Review",
    "law-technology-and-humans": "Law, Technology and Humans",
    "le-mouvement-social": "Le Mouvement Social (Français)",
    "le-tapuscrit-author-date": "Le tapuscrit (École des hautes études en sciences sociales) (author-date, Français)",
    "le-tapuscrit-note": "Le tapuscrit (École des hautes études en sciences sociales) (note, Français)",
    "harvard-leeds-beckett-university": "Leeds Beckett University (author-date/Harvard)",
    "harvard-leeds-metropolitan-university": "Leeds Metropolitan University (author-date/Harvard)",
    "leiden-journal-of-international-law": "Leiden Journal of International Law",
    "leidraad-voor-juridische-auteurs": "Leidraad voor juridische auteurs 2019 (Nederlands)",
    "leonardo": "Leonardo",
    "les-cahiers-du-journalisme": "Les Cahiers du journalisme (Français)",
    "les-journees-de-la-recherche-avicole": "Les Journées de la Recherche Avicole (Français)",
    "les-journees-de-la-recherche-porcine": "Les Journées de la Recherche Porcine (Français)",
    "les-mondes-du-travail": "Les Mondes du travail (Français)",
    "les-nouvelles-de-l-archeologie": "Les nouvelles de l'archéologie (Français)",
    "lethaia": "Lethaia",
    "letters-in-applied-microbiology": "Letters in Applied Microbiology",
    "lettres-et-sciences-humaines-fr": "Lettres et Sciences Humaines (biblio et notes, Français)",
    "leuphana-universitaet-lueneburg-institut-fuer-produktionstechnik-und-systeme": "Leuphana Universität Lüneburg - Institut für Produktionstechnik und -systeme (Deutsch)",
    "leviathan": "Leviathan (Deutsch)",
    "lien-social-et-politiques": "Lien social et Politiques (Français)",
    "life-science-alliance": "Life Science Alliance",
    "limnetica": "Limnetica",
    "limnology-and-oceanography": "Limnology and Oceanography",
    "linguistica-uralica": "Linguistica Uralica",
    "literatura": "Literatūra",
    "liver-international": "Liver International",
    "liverpool-john-moores-university-harvard": "Liverpool John Moores University (author-date/Harvard)",
    "london-review-of-international-law": "London Review of International Law",
    "harvard-london-south-bank-university": "London South Bank University (author-date/Harvard)",
    "london-south-bank-university-numeric": "London South Bank University (numeric)",
    "lund-university-school-of-economics-and-management": "Lund University School of Economics and Management",
    "lannee-sociologique": "L’Année sociologique (Français)",
    "mhra-author-date": "MHRA Style Guide 4th edition (author-date)",
    "mhra-author-date-publisher-place": "MHRA Style Guide 4th edition (author-date, place of publication)",
    "mhra-author-date-publisher-place-no-url": "MHRA Style Guide 4th edition (author-date, place of publication, without URLs)",
    "mhra-author-date-no-url": "MHRA Style Guide 4th edition (author-date, without URLs)",
    "mhra-notes": "MHRA Style Guide 4th edition (notes)",
    "mhra-notes-publisher-place": "MHRA Style Guide 4th edition (notes, place of publication)",
    "mhra-notes-publisher-place-no-url": "MHRA Style Guide 4th edition (notes, place of publication, without URLs)",
    "mhra-notes-subsequent-ibid": "MHRA Style Guide 4th edition (notes, subsequent ibid.)",
    "mhra-notes-subsequent-ibid-no-url": "MHRA Style Guide 4th edition (notes, subsequent ibid., without URLs)",
    "mhra-notes-no-url": "MHRA Style Guide 4th edition (notes, without URLs)",
    "mhra-shortened-notes": "MHRA Style Guide 4th edition (shortened notes)",
    "mhra-shortened-notes-publisher-place": "MHRA Style Guide 4th edition (shortened notes, place of publication)",
    "mhra-shortened-notes-publisher-place-no-url": "MHRA Style Guide 4th edition (shortened notes, place of publication, without URLs)",
    "mhra-shortened-notes-no-url": "MHRA Style Guide 4th edition (shortened notes, without URLs)",
    "mis-quarterly": "MIS Quarterly",
    "modern-language-association": "MLA Handbook 9th edition (in-text citations)",
    "modern-language-association-annotated-bibliography": "MLA Handbook 9th edition (in-text citations, annotated bibliography)",
    "modern-language-association-no-url": "MLA Handbook 9th edition (in-text citations, without URLs)",
    "modern-language-association-notes": "MLA Handbook 9th edition (notes)",
    "modern-language-association-notes-no-url": "MLA Handbook 9th edition (notes, without URLs)",
    "mrs-bulletin": "MRS Bulletin",
    "macromolecular-reaction-engineering": "Macromolecular Reaction Engineering",
    "magnetic-resonance-materials-in-physics-biology-and-medicine": "Magnetic Resonance Materials in Physics, Biology and Medicine",
    "magnetic-resonance-in-medical-sciences": "Magnetic Resonance in Medical Sciences",
    "maison-de-l-orient-et-de-la-mediterranee-en": "Maison de l'Orient et de la Méditerranée (English)",
    "maison-de-l-orient-et-de-la-mediterranee": "Maison de l'Orient et de la Méditerranée (Français)",
    "malaysian-orthopaedic-journal": "Malaysian Orthopaedic Journal",
    "mammal-review": "Mammal Review",
    "mammalia": "Mammalia",
    "mammalogy-notes": "Mammalogy Notes",
    "management-et-avenir": "Management & Avenir (Français)",
    "management-international": "Management international",
    "management-of-biological-invasions": "Management of Biological Invasions",
    "harvard-manchester-business-school": "Manchester Business School (author-date/Harvard)",
    "harvard-manchester-metropolitan-university": "Manchester Metropolitan University (author-date/Harvard)",
    "manchester-university-press-author-date": "Manchester University Press monographs (author-date)",
    "manchester-university-press": "Manchester University Press monographs (note)",
    "law-citation-manual": "Manual of Legal Citation (法学注引手册, 中文)",
    "mcgill-fr": "Manuel canadien de la référence juridique 10e édition (Guide McGill, Français - Canada)",
    "marine-biology": "Marine Biology",
    "marine-mammal-science": "Marine Mammal Science",
    "marine-ornithology": "Marine Ornithology",
    "marine-turtle-newsletter": "Marine Turtle Newsletter",
    "marmara-universitesi-turkiyat-arastirmalari-enstitusu": "Marmara Üniversitesi - Türkiyat Araştırmaları Enstitüsü (Türkçe)",
    "mary-ann-liebert-harvard": "Mary Ann Liebert (author-date/Harvard)",
    "mary-ann-liebert-vancouver": "Mary Ann Liebert - NLM/Vancouver",
    "masarykova-univerzita-pravnicka-fakulta": "Masarykova univerzita - Právnická fakulta",
    "mastozoologia-neotropical": "Mastozoologia Neotropical",
    "materials-express": "Materials Express",
    "mathematical-geosciences": "Mathematical Geosciences",
    "mathematics-and-computers-in-simulation": "Mathematics and Computers in Simulation",
    "mcdonald-institute-monographs": "McDonald Institute Monographs",
    "media-culture-and-society": "Media, Culture & Society",
    "medical-dosimetry": "Medical Dosimetry",
    "medical-education-and-clinical-practice": "Medical Education & Clinical Practice",
    "medical-history": "Medical History",
    "medicina-clinica": "Medicina Clínica (Español)",
    "medicina-delle-dipendenze-italian-journal-of-the-addictions": "Medicina delle Dipendenze - Italian Journal of the Addictions (Italiano)",
    "medicinal-research-reviews": "Medicinal Research Reviews",
    "medicine-and-science-in-sports-and-exercise": "Medicine & Science in Sports & Exercise",
    "medicine-publishing": "Medicine Publishing",
    "medicinski-razgledi": "Medicinski razgledi",
    "medicinskiy-akademicheskiy-zhurnal": "Medicinskiy Akademicheskiy Zhurnal",
    "mediterranean-journal-of-chemistry": "Mediterranean Journal of Chemistry",
    "mediterranean-journal-of-infection-microbes-and-antimicrobials": "Mediterranean Journal of Infection, Microbes and Antimicrobials",
    "mediterranean-politics": "Mediterranean Politics",
    "medizinische-hochschule-hannover": "Medizinische Hochschule Hannover",
    "medizinische-universitat-innsbruck-vancouver": "Medizinische Universität Innsbruck - NLM/Vancouver (Deutsch)",
    "harvard-melbourne-polytechnic": "Melbourne Polytechnic (author-date/Harvard)",
    "melbourne-school-of-theology": "Melbourne School of Theology",
    "memorias-do-instituto-oswaldo-cruz": "Memórias do Instituto Oswaldo Cruz",
    "mercator-institut-fur-sprachforderung-und-deutsch-als-zweitsprache": "Mercator-Institut für Sprachförderung und Deutsch als Zweitsprache (Deutsch)",
    "mercatus-center": "Mercatus Center",
    "meta": "Meta",
    "metaaltijden": "Metaaltijden (Nederlands)",
    "metallurgical-and-materials-transactions": "Metallurgical and Materials Transactions",
    "metallurgical-and-materials-transactions-a": "Metallurgical and Materials Transactions A",
    "meteoritics-and-planetary-science": "Meteoritics & Planetary Science",
    "meteorological-applications": "Meteorological Applications",
    "method-and-theory-in-the-study-of-religion": "Method & Theory in the Study of Religion",
    "methods-of-information-in-medicine": "Methods of Information in Medicine",
    "metropol-verlag": "Metropol Verlag (German)",
    "metropolia-university-of-applied-sciences-harvard": "Metropolia Ammattikorkeakoulu (author-date/Harvard, Suomi)",
    "metropolia-university-of-applied-sciences-harvard-english": "Metropolia University of Applied Sciences (author-date/Harvard, English)",
    "mexicon": "Mexicon - The Journal of Mesoamerican Studies",
    "microbial-cell": "Microbial Cell",
    "microbiology-society": "Microbiology Society",
    "microbiome-research-reports": "Microbiome Research Reports",
    "microcirculation": "Microcirculation",
    "microscopy-and-microanalysis": "Microscopy and Microanalysis",
    "middle-east-critique": "Middle East Critique",
    "midwestern-baptist-theological-seminary": "Midwestern Baptist Theological Seminary",
    "mimbar-hukum": "Mimbar Hukum",
    "mimesis-edizioni": "Mimesis Edizioni (Italiano)",
    "mind-and-language": "Mind & Language",
    "mineralogical-magazine": "Mineralogical Magazine",
    "modern-chinese-literature-and-culture": "Modern Chinese Literature and Culture",
    "modern-pathology": "Modern Pathology",
    "modern-phytomorphology": "Modern Phytomorphology",
    "mohr-siebeck-recht": "Mohr Siebeck - Recht (Deutsch - Österreich)",
    "molecular-and-cellular-proteomics": "Molecular & Cellular Proteomics",
    "molecular-biology": "Molecular Biology",
    "molecular-biology-and-evolution": "Molecular Biology and Evolution",
    "molecular-biology-of-the-cell": "Molecular Biology of the Cell",
    "molecular-metabolism": "Molecular Metabolism",
    "molecular-microbiology": "Molecular Microbiology",
    "molecular-nutrition-and-food-research": "Molecular Nutrition & Food Research",
    "molecular-oncology": "Molecular Oncology",
    "molecular-plant": "Molecular Plant",
    "molecular-plant-pathology": "Molecular Plant Pathology",
    "molecular-plant-microbe-interactions": "Molecular Plant-Microbe Interactions",
    "molecular-psychiatry": "Molecular Psychiatry",
    "molecular-psychiatry-letters": "Molecular Psychiatry (letters to the editor)",
    "monash-university-csiro": "Monash University - CSIRO",
    "mondes-en-developpement": "Mondes en développement (Français)",
    "monographs-of-the-palaeontographical-society": "Monographs of the Palaeontographical Society",
    "moorlands-college": "Moorlands College",
    "mots": "Mots (French)",
    "movement-disorders": "Movement Disorders",
    "multidisciplinary-digital-publishing-institute": "Multidisciplinary Digital Publishing Institute",
    "multilingual-matters": "Multilingual Matters",
    "multimed": "Multimed (Español)",
    "multiple-sclerosis-journal": "Multiple Sclerosis Journal",
    "muscle-and-nerve": "Muscle & Nerve",
    "museum-national-dhistoire-naturelle": "Muséum national d'Histoire naturelle",
    "mutagenesis": "Mutagenesis",
    "mycobiology": "Mycobiology",
    "mycologia": "Mycologia",
    "myrmecological-news": "Myrmecological News",
    "medecine-intensive-reanimation": "Médecine Intensive Réanimation",
    "melanges-de-linstitut-dominicain-detudes-orientales-en": "Mélanges de l'Institut dominicain d'études orientales (English)",
    "melanges-de-linstitut-dominicain-detudes-orientales-fr": "Mélanges de l'Institut dominicain d'études orientales (Français)",
    "metropolitiques": "Métropolitiques (Français)",
    "nccr-mediality": "NCCR Mediality. Medienwandel - Medienwechsel - Medienwissen (Deutsch)",
    "nejm-catalyst-innovations-in-care-delivery": "NEJM Catalyst Innovations in Care Delivery",
    "nist-technical-publication-journal-of-research-of-nist": "NIST Technical Publications - Journal of Research of NIST",
    "nlm-citation-name": "NLM/Vancouver: Citing Medicine 2nd edition (citation-name)",
    "nlm-citation-sequence": "NLM/Vancouver: Citing Medicine 2nd edition (citation-sequence)",
    "nlm-citation-sequence-brackets": "NLM/Vancouver: Citing Medicine 2nd edition (citation-sequence, brackets)",
    "nlm-citation-sequence-brackets-no-et-al": "NLM/Vancouver: Citing Medicine 2nd edition (citation-sequence, brackets, no \"et al.\")",
    "nlm-citation-sequence-brackets-year-only-no-issue": "NLM/Vancouver: Citing Medicine 2nd edition (citation-sequence, brackets, year-only dates, no issue numbers)",
    "nlm-citation-sequence-superscript": "NLM/Vancouver: Citing Medicine 2nd edition (citation-sequence, superscript)",
    "nlm-citation-sequence-superscript-brackets-year-only": "NLM/Vancouver: Citing Medicine 2nd edition (citation-sequence, superscript, brackets, year-only dates)",
    "nlm-citation-sequence-superscript-year-only-no-issue": "NLM/Vancouver: Citing Medicine 2nd edition (citation-sequence, superscript, year-only dates, no issue numbers)",
    "nlm-name-year": "NLM/Vancouver: Citing Medicine 2nd edition (name-year)",
    "nano-biomedicine-and-engineering": "Nano Biomedicine and Engineering",
    "national-archives-of-australia": "National Archives of Australia",
    "national-institute-of-health-research": "National Institute of Health Research",
    "national-institute-of-organisation-dynamics-australia-harvard": "National Institute of Organisation Dynamics Australia (author-date/Harvard)",
    "national-institute-of-technology-karnataka": "National Institute of Technology Karnataka",
    "national-institute-of-technology-tiruchirappalli": "National Institute of Technology, Tiruchirappalli",
    "national-marine-fisheries-service-national-environmental-policy-act": "National Marine Fisheries Service - National Environmental Policy Act",
    "national-natural-science-foundation-of-china": "National Natural Science Foundation of China (中文)",
    "national-science-foundation-grant-proposals": "National Science Foundation (grant proposals)",
    "national-university-of-singapore-department-of-geography-harvard": "National University of Singapore - Department of Geography (author-date/Harvard)",
    "nations-and-nationalism": "Nations and Nationalism",
    "natur-und-landschaft": "Natur und Landschaft (Deutsch)",
    "natura-croatica": "Natura Croatica",
    "nature": "Nature",
    "nature-brackets": "Nature (brackets, no superscript)",
    "nature-no-et-al": "Nature (no \"et al.\")",
    "nature-neuroscience-brief-communications": "Nature Neuroscience (brief communications)",
    "nature-publishing-group-vancouver": "Nature Publishing Group - NLM/Vancouver",
    "natures-sciences-societes": "Natures Sciences Sociétés",
    "nauplius": "Nauplius",
    "navigation": "Navigation",
    "nehet": "NeHeT (Français)",
    "necmettin-erbakan-universitesi-fen-ve-muhendislik-bilimleri-dergisi": "Necmettin Erbakan Üniversitesi Fen ve Mühendislik Bilimleri Dergisi (Türkçe)",
    "nephrology-dialysis-transplantation": "Nephrology Dialysis Transplantation",
    "netherlands-journal-of-geosciences-geologie-en-mijnbouw": "Netherlands Journal of Geosciences - Geologie en Mijnbouw",
    "neue-juristische-wochenschrift": "Neue Juristische Wochenschrift (Deutsch)",
    "neue-kriminalpolitik": "Neue Kriminalpolitik (Deutsch)",
    "neues-jahrbuch-fur-geologie-und-palaontologie": "Neues Jahrbuch für Geologie und Paläontologie",
    "neural-plasticity": "Neural Plasticity",
    "neuroreport": "NeuroReport",
    "neuroendocrinology-letters": "Neuroendocrinology Letters",
    "neuroimaging-clinics-of-north-america": "Neuroimaging Clinics of North America",
    "neurology": "Neurology",
    "neurology-india": "Neurology India",
    "neurologia": "Neurología (Español)",
    "neurologia-argentina": "Neurología Argentina (Español)",
    "neuropsychopharmacology": "Neuropsychopharmacology",
    "neurorehabilitation-and-neural-repair": "Neurorehabilitation and Neural Repair",
    "neurospine": "Neurospine",
    "neurosurgery-clinics-of-north-america": "Neurosurgery Clinics of North America",
    "new-harts-rules-author-date": "New Hart's Rules: The Oxford Style Guide 2nd edition (author-date, bracketed date with comma)",
    "new-harts-rules-author-date-space-publisher": "New Hart's Rules: The Oxford Style Guide 2nd edition (author-date, bracketed date with space, publisher)",
    "new-harts-rules-author-date-publisher": "New Hart's Rules: The Oxford Style Guide 2nd edition (author-date, publisher)",
    "new-harts-rules-notes": "New Hart's Rules: The Oxford Style Guide 2nd edition (notes)",
    "new-harts-rules-notes-initials": "New Hart's Rules: The Oxford Style Guide 2nd edition (notes, author initials)",
    "new-harts-rules-notes-initials-bracket-role-page-range": "New Hart's Rules: The Oxford Style Guide 2nd edition (notes, author initials, bracket roles, page range)",
    "new-harts-rules-notes-initials-bracket-role-page-range-no-url": "New Hart's Rules: The Oxford Style Guide 2nd edition (notes, author initials, bracket roles, page ranges, without URLs)",
    "new-harts-rules-notes-initials-label-page": "New Hart's Rules: The Oxford Style Guide 2nd edition (notes, author initials, page abbreviations)",
    "new-harts-rules-notes-initials-label-page-no-url": "New Hart's Rules: The Oxford Style Guide 2nd edition (notes, author initials, page abbreviations, without URLs)",
    "new-harts-rules-notes-initials-publisher": "New Hart's Rules: The Oxford Style Guide 2nd edition (notes, author initials, publisher)",
    "new-harts-rules-notes-initials-publisher-no-url": "New Hart's Rules: The Oxford Style Guide 2nd edition (notes, author initials, publisher, without URLs)",
    "new-harts-rules-notes-initials-no-url": "New Hart's Rules: The Oxford Style Guide 2nd edition (notes, author initials, without URLs)",
    "new-harts-rules-notes-label-page": "New Hart's Rules: The Oxford Style Guide 2nd edition (notes, page abbreviations)",
    "new-harts-rules-notes-label-page-no-url": "New Hart's Rules: The Oxford Style Guide 2nd edition (notes, page abbreviations, without URLs)",
    "new-harts-rules-notes-publisher": "New Hart's Rules: The Oxford Style Guide 2nd edition (notes, publisher)",
    "new-harts-rules-notes-publisher-no-url": "New Hart's Rules: The Oxford Style Guide 2nd edition (notes, publisher, without URLs)",
    "new-harts-rules-notes-no-url": "New Hart's Rules: The Oxford Style Guide 2nd edition (notes, without URLs)",
    "new-harts-rules-numbered": "New Hart's Rules: The Oxford Style Guide 2nd edition (numbered)",
    "new-harts-rules-short-notes": "New Hart's Rules: The Oxford Style Guide 2nd edition (shortened notes)",
    "new-harts-rules-short-notes-no-url": "New Hart's Rules: The Oxford Style Guide 2nd edition (shortened notes, without URLs)",
    "new-phytologist": "New Phytologist",
    "new-solutions": "New Solutions",
    "new-testament-studies": "New Testament Studies",
    "new-zealand-dental-journal": "New Zealand Dental Journal",
    "new-zealand-journal-of-forestry-science": "New Zealand Journal of Forestry Science",
    "new-zealand-journal-of-history": "New Zealand Journal of History",
    "new-zealand-plant-protection": "New Zealand Plant Protection",
    "new-zealand-veterinary-journal": "New Zealand Veterinary Journal",
    "harvard-newcastle-university": "Newcastle University (author-date/Harvard)",
    "nordic-pulp-and-paper-research-journal": "Nordic Pulp & Paper Research Journal",
    "norma-portuguesa-405": "Norma Portuguesa 405 (Português)",
    "norois": "Norois (Français)",
    "norsk-apa-manual": "Norsk APA-manual - APA 7th edition (author-date)",
    "norsk-apa-manual-note": "Norsk APA-manual - APA 7th edition (note)",
    "norsk-henvisningsstandard-for-rettsvitenskapelige-tekster-full-firstnote": "Norsk henvisningsstandard for rettsvitenskapelige tekster – fullstendig førstenote (Norsk - Bokmål | Norsk - Nynorsk)",
    "norsk-henvisningsstandard-for-rettsvitenskapelige-tekster": "Norsk henvisningsstandard for rettsvitenskapelige tekster – kortnoter (Norsk - Bokmål | Norsk - Nynorsk)",
    "north-pacific-anadromous-fish-commission-bulletin": "North Pacific Anadromous Fish Commission Bulletin",
    "harvard-north-west-university": "North-West University (author-date/Harvard)",
    "northeastern-naturalist": "Northeastern Naturalist",
    "nottingham-trent-university-library-harvard": "Nottingham Trent University Library (author-date/Harvard)",
    "nouvelles-perspectives-en-sciences-sociales": "Nouvelles perspectives en sciences sociales (Français - Canada)",
    "nova-univerza": "Nova univerza (Slovenščina)",
    "novasinergia": "Novasinergia",
    "nowa-audiofonologia": "Nowa Audiofonologia (Polski)",
    "nuclear-receptor-signaling": "Nuclear Receptor Signaling",
    "nucleic-acids-research": "Nucleic Acids Research",
    "nucleic-acids-research-web-server-issue": "Nucleic Acids Research - Web Server Issue",
    "nueva-norma-estudios-de-la-humanidad": "Nueva Norma Estudios de la Humanidad (with titles)",
    "nutrition-research-reviews": "Nutrition Research Reviews",
    "nys-nydanske-sprogstudier": "NyS - Nydanske Sprogstudier (Dansk)",
    "owbarth-verlag": "O.W. Barth Verlag (Deutsch)",
    "oscola": "OSCOLA 4th edition",
    "oscola-journal-abbreviations": "OSCOLA 4th edition (journal abbreviations)",
    "oscola-no-ibid": "OSCOLA 4th edition (no ibid.)",
    "obafemi-awolowo-university-faculty-of-technology": "Obafemi Awolowo University - Faculty of Technology",
    "obesity": "Obesity",
    "obstetrics-and-gynecology-science": "Obstetrics & Gynecology Science",
    "occupational-medicine": "Occupational Medicine",
    "ocean-and-coastal-research": "Ocean and Coastal Research",
    "oceanography": "Oceanography",
    "oecologia-australis": "Oecologia Australis",
    "offa": "Offa - Berichte und Mitteilungen zur Archäologie",
    "oikos": "Oikos",
    "oil-shale": "Oil Shale",
    "oncoimmunology": "OncoImmunology",
    "oncotarget": "Oncotarget",
    "open-gender-journal": "Open Gender Journal",
    "open-theology": "Open Theology",
    "open-window": "Open Window (author-date/Harvard)",
    "operative-dentistry": "Operative Dentistry",
    "ophthalmic-genetics": "Ophthalmic Genetics",
    "ophthalmic-plastic-and-reconstructive-surgery": "Ophthalmic Plastic and Reconstructive Surgery",
    "ophthalmology": "Ophthalmology",
    "ophthalmology-retina": "Ophthalmology Retina",
    "optics-express": "Optics Express",
    "optics-letters": "Optics Letters",
    "opto-electronic-advances": "Opto-Electronic Advances",
    "optometry-and-vision-science": "Optometry & Vision Science",
    "opuscula": "Opuscula",
    "oral-diseases": "Oral Diseases",
    "organic-geochemistry": "Organic Geochemistry",
    "organised-sound": "Organised Sound",
    "organization": "Organization",
    "organization-studies": "Organization Studies",
    "organon": "Organon",
    "ornitologia-neotropical": "Ornitología Neotropical",
    "orthopedic-clinics-of-north-america": "Orthopedic Clinics of North America",
    "oryx": "Oryx",
    "otto-von-guricke-universitat-magdeburg-medizinische-fakultat-numeric": "Otto-von-Guericke-Universität Magdeburg - Medizinische Fakultät (numeric)",
    "oxford-art-journal": "Oxford Art Journal",
    "oxford-guide-to-style-notes": "Oxford Guide to Style (notes)",
    "oxford-guide-to-style-notes-roman-volume-archive-first": "Oxford Guide to Style (notes, Roman volume numbers, archival references with institution first)",
    "oxford-guide-to-style-notes-roman-volume-archive-first-no-url": "Oxford Guide to Style (notes, Roman volume numbers, archival references with institution first, without URLs)",
    "oxford-guide-to-style-notes-initials": "Oxford Guide to Style (notes, author initials)",
    "oxford-guide-to-style-notes-initials-article-sentence-case-roman-volume-label-page": "Oxford Guide to Style (notes, author initials, article titles in sentence case, Roman volume numbers, page abbreviations)",
    "oxford-guide-to-style-notes-initials-label-page": "Oxford Guide to Style (notes, author initials, page abbreviations)",
    "oxford-guide-to-style-notes-initials-label-page-no-url": "Oxford Guide to Style (notes, author initials, page abbreviations, without URLs)",
    "oxford-guide-to-style-notes-initials-no-url": "Oxford Guide to Style (notes, author initials, without URLs)",
    "oxford-guide-to-style-notes-no-url": "Oxford Guide to Style (notes, without URLs)",
    "oxford-studies-on-the-roman-economy": "Oxford Studies on the Roman Economy",
    "oxford-journals-scimed-author-date": "Oxford University Press - Science and Medicine Journals (author-date)",
    "oxford-journals-scimed-numeric-parentheses": "Oxford University Press - Science and Medicine Journals (numbered, parentheses)",
    "oxford-journals-scimed-numeric": "Oxford University Press - Science and Medicine Journals (numbered, square brackets)",
    "oxford-journals-scimed-numeric-superscript": "Oxford University Press - Science and Medicine Journals (numbered, superscript)",
    "oxidation-of-metals": "Oxidation of Metals",
    "pain": "PAIN",
    "proteomics": "PROTEOMICS",
    "pacific-conservation-biology": "Pacific Conservation Biology",
    "pacific-science": "Pacific Science",
    "paediatric-and-perinatal-epidemiology": "Paediatric and Perinatal Epidemiology",
    "pain-medicine": "Pain Medicine",
    "pain-physician": "Pain Physician",
    "pakistan-journal-of-agricultural-sciences": "Pakistan Journal of Agricultural Sciences",
    "pakistani-veterinary-journal": "Pakistan Veterinary Journal",
    "palaeodiversity": "Palaeodiversity",
    "palaeontographica-abteilung-b-palaeobotany-palaeophytology": "Palaeontographica Abteilung B: Palaeobotany - Palaeophytology",
    "palaeontologia-electronica": "Palaeontologia Electronica",
    "palaeontology": "Palaeontology",
    "palaeovertebrata": "Palaeovertebrata",
    "palaios": "Palaios",
    "paleobiology": "Paleobiology",
    "pallas": "Pallas (French)",
    "pamukkale-universitesi-fen-bilimleri-enstitusu": "Pamukkale Üniversitesi - Fen Bilimleri Enstitüsü (Türkçe)",
    "parasite": "Parasite",
    "parasitology": "Parasitology",
    "pathogens-and-immunity": "Pathogens and Immunity",
    "pediatric-allergy-and-immunology": "Pediatric Allergy and Immunology",
    "pediatric-anesthesia": "Pediatric Anesthesia",
    "pediatric-blood-and-cancer": "Pediatric Blood & Cancer",
    "pediatric-infectious-disease-journal": "Pediatric Infectious Disease Journal",
    "pediatric-physical-therapy": "Pediatric Physical Therapy",
    "pediatric-practice-and-research": "Pediatric Practice and Research",
    "pediatric-pulmonology": "Pediatric Pulmonology",
    "pediatric-research": "Pediatric Research",
    "pediatric-urology-case-reports": "Pediatric Urology Case Reports",
    "pedosphere": "Pedosphere",
    "peerj": "PeerJ",
    "pensoft-journals": "Pensoft Journals",
    "periodicum-biologorum": "Periodicum Biologorum",
    "periodontology-2000": "Periodontology 2000",
    "permafrost-and-periglacial-processes": "Permafrost and Periglacial Processes",
    "perspectives-on-sexual-and-reproductive-health": "Perspectives on Sexual and Reproductive Health",
    "pesquisa-agropecuaria-brasileira": "Pesquisa Agropecuária Brasileira (Português - Brasil)",
    "pest-management-science": "Pest Management Science",
    "peter-lang-social-sciences": "Peter Lang Social Sciences",
    "petit-chicago-author-date": "Petit Chicago (author-date, Français - Canada)",
    "pharmacoepidemiology-and-drug-safety": "Pharmacoepidemiology and Drug Safety",
    "philippika": "Philippika (Deutsch)",
    "philippine-journal-of-natural-sciences": "Philippine Journal of Natural Sciences",
    "philipps-universitat-marburg-note": "Philipps-Universität Marburg - Erziehungswissenschaften (note, Deutsch)",
    "philosophia-scientiae": "Philosophia Scientiæ (English)",
    "philosophiques": "Philosophiques (Français)",
    "philosophy-and-public-affairs": "Philosophy & Public Affairs",
    "photochemistry-and-photobiology": "Photochemistry and Photobiology",
    "photogrammetric-engineering-and-remote-sensing": "Photogrammetric Engineering and Remote Sensing",
    "photosynthetica": "Photosynthetica",
    "phycological-research": "Phycological Research",
    "phyllomedusa": "Phyllomedusa",
    "physiologia-plantarum": "Physiologia Plantarum",
    "physiological-and-biochemical-zoology": "Physiological and Biochemical Zoology",
    "physiotherapy-theory-and-practice": "Physiotherapy Theory and Practice",
    "phytopathologia-mediterranea": "Phytopathologia Mediterranea",
    "phytotaxa": "Phytotaxa",
    "pisa-university-press": "Pisa University Press",
    "planning-practice-and-research": "Planning Practice & Research",
    "plant-and-cell-physiology": "Plant & Cell Physiology",
    "plant-biology": "Plant Biology",
    "plant-biotechnology-journal": "Plant Biotechnology Journal",
    "plant-genetic-resources-characterization-and-utilization": "Plant Genetic Resources - Characterization and Utilization",
    "plant-pathology": "Plant Pathology",
    "plant-physiology": "Plant Physiology",
    "plant-species-biology": "Plant Species Biology",
    "plant-cell-and-environment": "Plant, Cell & Environment",
    "podzemna-voda": "Podzemná voda (Slovenčina)",
    "polar-research": "Polar Research",
    "polish-archives-of-internal-medicine": "Polish Archives of Internal Medicine",
    "polish-legal": "Polish Legal (Polski)",
    "politechnika-opolska-wydzial-wychowania-fizycznego-i-fizjoterapii": "Politechnika Opolska - Wydział Wychowania Fizycznego i Fizjoterapii (Polski)",
    "politeknik-negeri-manado-jurnal-p3m": "Politeknik Negeri Manado - Jurnal Pusat Penelitian dan Pengabdian Kepada Masyarakat (Bahasa Indonesia)",
    "politica-tidsskrift-for-politisk-videnskab": "Politica - Tidsskrift for politisk videnskab (Danish)",
    "political-studies": "Political Studies",
    "politique-europeenne": "Politique Européenne",
    "politische-vierteljahresschrift": "Politische Vierteljahresschrift",
    "politix": "Politix (Français)",
    "polygraphia": "Polygraphia (Italiano)",
    "polymer-reviews": "Polymer Reviews",
    "polytechnique-montreal-apa": "Polytechnique Montréal - APA 7th edition (Français - Canada)",
    "polytechnique-montreal-ieee": "Polytechnique Montréal - IEEE (Français)",
    "pontifical-athenaeum-regina-apostolorum": "Pontifical Athenaeum Regina Apostolorum",
    "pontifical-biblical-institute": "Pontifical Biblical Institute",
    "pontifical-gregorian-university": "Pontifical Gregorian University (Italiano)",
    "harvard-pontificia-universidad-catolica-del-ecuador": "Pontificia Universidad Católica del Ecuador (author-date/Harvard, Español)",
    "pontificia-universidade-catolica-do-parana-abnt": "Pontificia Universidade Catolica do Parana - ABNT (Portuguese - Brazil)",
    "population": "Population (Français)",
    "population-space-and-place": "Population, Space and Place",
    "postepy-higieny-i-medycyny-doswiadczalnej": "Postępy Higieny i Medycyny Doświadczalnej (Polski)",
    "poultry-science": "Poultry Science",
    "pour-reussir-note": "Pour Réussir de Dionne 6ème édition (note, Français - Canada)",
    "praxis": "Praxis (Deutsch - Schweiz)",
    "prehospital-emergency-care": "Prehospital Emergency Care",
    "prehospital-and-disaster-medicine": "Prehospital and Disaster Medicine",
    "preslia": "Preslia - The Journal of the Czech Botanical Society",
    "presses-universitaires-de-rennes": "Presses Universitaires de Rennes (Français)",
    "presses-universitaires-de-rennes-author-date": "Presses Universitaires de Rennes (author-date, Français)",
    "presses-universitaires-de-rennes-archeologie-et-culture": "Presses Universitaires de Rennes - Archéologie et Culture (Français)",
    "presses-universitaires-de-paris-nanterre": "Presses universitaires de Paris Nanterre (note, Français)",
    "presses-universitaires-de-strasbourg-note": "Presses universitaires de Strasbourg (note, Français)",
    "preventive-nutrition-and-food-science": "Preventive Nutrition and Food Science",
    "primary-care-clinics-in-office-practice": "Primary Care: Clinics in Office Practice",
    "proinflow": "ProInflow (note, Čeština)",
    "proceedings-of-the-estonian-academy-of-sciences-author-date": "Proceedings of the Estonian Academy of Sciences (author-date)",
    "proceedings-of-the-estonian-academy-of-sciences-numeric": "Proceedings of the Estonian Academy of Sciences (numeric)",
    "proceedings-of-the-joint-international-grassland-and-international-rangeland-congress-2021": "Proceedings of the Joint International Grassland & International Rangeland Congress 2021",
    "pnas": "Proceedings of the National Academy of Sciences of the United States of America",
    "proceedings-of-the-royal-society-b": "Proceedings of the Royal Society B",
    "processing-and-application-of-ceramics": "Processing and Application of Ceramics",
    "production-and-operations-management": "Production and Operations Management",
    "el-profesional-de-la-informacion": "Profesional de la información (Español)",
    "progress-on-chemistry-and-application-of-chitin-and-its-derivatives": "Progress on Chemistry and Application of Chitin and its Derivatives",
    "protein-engineering-design-and-selection": "Protein Engineering Design and Selection",
    "protein-science": "Protein Science",
    "pravny-obzor": "Právny obzor",
    "pravnik": "Právník (Čeština)",
    "prehistoires-mediterraneennes": "Préhistoires méditerranéennes",
    "psychiatric-clinics-of-north-america": "Psychiatric Clinics of North America",
    "psychiatric-services": "Psychiatric Services",
    "psychiatry-and-clinical-neurosciences": "Psychiatry and Clinical Neurosciences",
    "psychosomatic-medicine": "Psychosomatic Medicine",
    "psychosomatics": "Psychosomatics",
    "public-health-nutrition": "Public Health Nutrition",
    "plos": "Public Library of Science",
    "publicatiewijzer-voor-de-archeologie": "Publicatiewijzer voor de Archeologie (Nederlands)",
    "pure-and-applied-geophysics": "Pure and Applied Geophysics",
    "padagogische-hochschule-bern-institut-vorschulstufe-und-primarstufe": "Pädagogische Hochschule Bern - Institut Vorschulstufe und Primarstufe",
    "padagogische-hochschule-fachhochschule-nordwestschweiz": "Pädagogische Hochschule Fachhochschule Nordwestschweiz (Deutsch - Schweiz)",
    "padagogische-hochschule-heidelberg": "Pädagogische Hochschule Heidelberg (Deutsch)",
    "padagogische-hochschule-vorarlberg": "Pädagogische Hochschule Vorarlberg (Deutsch)",
    "qeios": "Qeios",
    "quaderni": "Quaderni (Italiano)",
    "quaderni-materialisti": "Quaderni Materialisti (Italiano)",
    "quaderni-degli-avogadro-colloquia": "Quaderni degli Avogadro Colloquia",
    "quaternaire": "Quaternaire (Français)",
    "quaternary-international": "Quaternary International",
    "queen-margaret-university-harvard": "Queen Margaret University (author-date/Harvard)",
    "r-and-d-management": "R&D Management",
    "rever-revista-de-estudos-da-religiao": "REVER - Revista de Estudos da Religião",
    "rmit-university-harvard": "RMIT University (author-date/Harvard)",
    "roots-monograph-series": "ROOTS monograph series",
    "rose-school": "ROSE School",
    "rtf-scan": "RTF Scan",
    "radiation-protection-dosimetry": "Radiation Protection Dosimetry",
    "radiation-research": "Radiation Research",
    "radiographics": "RadioGraphics",
    "radiochimica-acta": "Radiochimica Acta",
    "radiography": "Radiography",
    "radiologic-clinics-of-north-america": "Radiologic Clinics of North America",
    "radiology": "Radiology",
    "radiopaedia": "Radiopaedia.org",
    "raffles-bulletin-of-zoology": "Raffles Bulletin of Zoology",
    "raptor-journal": "Raptor Journal",
    "rassegna-degli-archivi-di-stato-bibliografia-generale": "Rassegna degli Archivi di Stato (bibliografia generale o ragionata commentata, sorted chronological, italiano)",
    "rassegna-degli-archivi-di-stato": "Rassegna degli Archivi di Stato (citazioni estese, italiano)",
    "recent-patents-on-drug-delivery-and-formulation": "Recent Patents on Drug Delivery & Formulation",
    "recherches-en-sciences-de-gestion": "Recherches en Sciences de Gestion (Français)",
    "refugee-survey-quarterly": "Refugee Survey Quarterly",
    "register-studies": "Register Studies",
    "religion-in-the-roman-empire": "Religion in the Roman Empire",
    "renewable-agriculture-and-food-systems": "Renewable Agriculture and Food Systems",
    "reports-of-practical-oncology-and-radiotherapy": "Reports of Practical Oncology and Radiotherapy",
    "representation": "Representation",
    "reproduction": "Reproduction",
    "reproduction-fertility-and-development": "Reproduction, Fertility and Development",
    "research-institute-for-nature-and-forest": "Research Institute for Nature and Forest (Instituut voor Natuur- en Bosonderzoek)",
    "research-and-education-promotion-association": "Research and Education Promotion Association",
    "research-in-plant-disease": "Research in Plant Disease",
    "research-on-biomedical-engineering": "Research on Biomedical Engineering",
    "respiratory-care-journal": "Respiratory Care Journal",
    "respirology": "Respirology",
    "restoration-ecology": "Restoration Ecology",
    "retina": "Retina",
    "review-of-international-studies": "Review of International Studies",
    "review-of-political-economy": "Review of Political Economy",
    "reviews-of-modern-physics-with-titles": "Reviews of Modern Physics (with titles)",
    "revista-argentina-de-antropologia-biologica": "Revista Argentina de Antropologia Biologica (Español)",
    "revista-brasileira-de-ciencia-do-solo": "Revista Brasileira de Ciência do Solo",
    "revista-biblica": "Revista Bíblica (Español)",
    "revista-chilena-de-derecho-y-tecnologia": "Revista Chilena de Derecho y Tecnología (Español - Chile)",
    "revista-ciencias-tecnicas-agropecuarias": "Revista Ciencias Técnicas Agropecuarias (Español)",
    "revista-cubana-de-meteorologia": "Revista Cubana de Meteorologia",
    "revista-espanola-de-nutricion-humana-y-dietetica": "Revista Espanola de Nutricion Humana y Dietetica (Español)",
    "revista-fave-seccion-ciencias-agrarias": "Revista FAVE - Sección Ciencias Agrarias (Español)",
    "revista-ladinia": "Revista Ladinia",
    "revista-latinoamericana-de-metalurgia-y-materiales": "Revista Latinoamericana de Metalurgia y Materiales",
    "revista-latinoamericana-de-recursos-naturales": "Revista Latinoamericana de Recursos Naturales",
    "revista-materia": "Revista Matéria",
    "revista-medica-del-instituto-mexicano-del-seguro-social": "Revista Médica del Instituto Mexicano del Seguro Social (Español)",
    "revista-noesis": "Revista Nóesis",
    "revista-peruana-de-medicina-experimental-y-salud-publica": "Revista Peruana de Medicina Experimental y Salud Pública (Español)",
    "revista-portuguesa-de-arqueologia": "Revista Portuguesa de Arqueologia",
    "revista-portuguesa-de-musicologia-author-date": "Revista Portuguesa de Musicologia (author-date)",
    "revista-virtual-de-quimica": "Revista Virtual de Química (Português - Brasil)",
    "revista-da-sociedade-brasileira-de-medicina-tropical": "Revista da Sociedade Brasileira de Medicina Tropical",
    "revista-de-biologia-marina-y-oceanografia": "Revista de Biología Marina y Oceanografía",
    "revista-de-biologia-tropical": "Revista de Biología Tropical (International Journal of Tropical Biology and Conservation)",
    "revista-de-derecho-de-la-universidad-austral-de-chile": "Revista de Derecho de la Universidad Austral de Chile (Español)",
    "revista-de-filologia-espanola": "Revista de Filología Española (Español)",
    "revista-do-instituto-de-medicina-tropical-de-sao-paulo": "Revista do Instituto de Medicina Tropical de São Paulo",
    "revue-archeologique": "Revue Archéologique (Français)",
    "revue-europeenne-des-migrations-internationales": "Revue Européenne des Migrations Internationales",
    "revue-internationale-durbanisme": "Revue Internationale d'Urbanisme (Français)",
    "revue-metis": "Revue Mètis (français)",
    "revue-archeologique-de-narbonnaise": "Revue archéologique de Narbonnaise (French)",
    "revue-archeologique-de-lest": "Revue archéologique de l’Est (Français)",
    "revue-archeologique-du-centre-de-la-france": "Revue archéologique du Centre de la France (Français)",
    "revue-d-anthropologie-des-connaissances": "Revue d'anthropologie des connaissances (Français)",
    "revue-dhistoire-des-sciences": "Revue d'histoire des sciences (Français)",
    "revue-dhistoire-des-sciences-humaines": "Revue d'histoire des sciences humaines (Français)",
    "revue-dhistoire-moderne-et-contemporaine": "Revue d'histoire moderne et contemporaine (Français)",
    "revue-d-elevage-et-de-medecine-veterinaire-des-pays-tropicaux": "Revue d'élevage et de médecine vétérinaire des pays tropicaux (Français)",
    "revue-de-medecine-veterinaire": "Revue de Médecine Vétérinaire (Français)",
    "revue-de-qumran": "Revue de Qumrân",
    "revue-des-nouvelles-technologies-de-l-information": "Revue des Nouvelles Technologies de l'Information (Français)",
    "revue-des-etudes-byzantines": "Revue des Études Byzantines",
    "revue-forestiere-francaise": "Revue forestière française (Français)",
    "revue-francaise-dhistotechnologie": "Revue francaise d'histotechnologie (Français)",
    "revue-francaise-d-administration-publique": "Revue française d'administration publique (Français)",
    "revue-francaise-de-gestion": "Revue française de gestion (Français)",
    "revue-francaise-de-pedagogie": "Revue française de pédagogie (Français)",
    "revue-francaise-de-sociologie": "Revue française de sociologie (Français)",
    "rhinology": "Rhinology",
    "rhodora": "Rhodora",
    "risk-analysis": "Risk Analysis",
    "ritid": "Ritið: tímarit Hugvísindastofnunar (Íslenska)",
    "rivista-italiana-di-paleontologia-e-stratigrafia": "Rivista Italiana di Paleontologia e Stratigrafia",
    "harvard-robert-gordon-university": "Robert Gordon University (author-date/Harvard)",
    "romanian-humanities": "Romanian Humanities (Română)",
    "royal-college-of-nursing-harvard": "Royal College of Nursing (author-date/Harvard)",
    "royal-college-of-surgeons-in-ireland-medical-university-of-bahrain-harvard": "Royal College of Surgeons in Ireland - Medical University of Bahrain (author-date/Harvard)",
    "royal-entomological-society": "Royal Entomological Society",
    "royal-society-of-chemistry": "Royal Society of Chemistry",
    "royal-society-of-chemistry-with-titles": "Royal Society of Chemistry (with titles)",
    "ruhr-universitat-bochum-lehrstuhl-fur-industrial-sales-and-service-engineering": "Ruhr-Universität Bochum - Lehrstuhl für Industrial Sales and Service Engineering",
    "ruhr-universitat-bochum-medizinische-fakultat-numeric": "Ruhr-Universität Bochum - Medizinische Fakultät (numerisch, Deutsch)",
    "gost-r-7-0-5-2008-numeric": "Russian GOST R 7.0.5-2008 (numeric)",
    "gost-r-7-0-5-2008-numeric-alphabetical": "Russian GOST R 7.0.5-2008 (numeric, sorted alphabetically, Ру́сский)",
    "gost-r-7-0-5-2008": "Russian GOST R 7.0.5-2008 (Ру́сский)",
    "rofo": "RöFo: Fortschritte auf dem Gebiet der Röntgenstrahlen und bildgebenden Verfahren",
    "sage-harvard": "SAGE (author-date/Harvard)",
    "sage-vancouver": "SAGE - NLM/Vancouver",
    "sage-vancouver-brackets": "SAGE - NLM/Vancouver (brackets)",
    "society-of-biblical-literature-author-date": "SBL Handbook of Style 2nd edition (author-date)",
    "society-of-biblical-literature-fullnote-bibliography": "SBL Handbook of Style 2nd edition (notes)",
    "science-china-earth-sciences": "SCIENCE CHINA Earth Sciences",
    "science-china-life-sciences": "SCIENCE CHINA Life Sciences",
    "science-china-materials": "SCIENCE CHINA Materials",
    "sist02": "SIST02 (日本語)",
    "skuast-journal-of-research": "SKUAST Journal of Research",
    "sn-computer-science": "SN Computer Science",
    "spie-bios": "SPIE BiOS",
    "spie-proceedings": "SPIE Conference Proceedings",
    "spie-journals": "SPIE journals",
    "spip-cite": "SPIP - Cite plugin",
    "spiritual-care": "SPIRITUAL CARE (Deutsch)",
    "saint-paul-university-faculty-of-canon-law": "Saint Paul University - Faculty of Canon Law",
    "san-francisco-estuary-and-watershed-science": "San Francisco Estuary & Watershed Science",
    "sanamed": "Sanamed",
    "foerster-geisteswissenschaft": "Sascha Foerster - Geisteswissenschaft (Deutsch)",
    "saglik-bilimleri-universitesi": "Sağlık Bilimleri Üniversitesi",
    "scandinavian-journal-of-infectious-diseases": "Scandinavian Journal of Infectious Diseases",
    "scandinavian-journal-of-information-systems": "Scandinavian Journal of Information Systems",
    "scandinavian-journal-of-medicine-and-science-in-sports": "Scandinavian Journal of Medicine & Science in Sports",
    "scandinavian-journal-of-rheumatology": "Scandinavian Journal of Rheumatology",
    "scandinavian-journal-of-work-environment-and-health": "Scandinavian Journal of Work, Environment & Health",
    "scandinavian-political-studies": "Scandinavian Political Studies",
    "schweizerische-zeitschrift-fur-geschichte": "Schweizerische Zeitschrift für Geschichte",
    "science": "Science",
    "science-without-titles": "Science (without titles)",
    "science-china-chemistry": "Science China Chemistry",
    "science-translational-medicine": "Science Translational Medicine",
    "science-and-technology-for-the-built-environment": "Science and Technology for the Built Environment",
    "scienceasia": "ScienceAsia",
    "sciences-po-ecole-doctorale-author-date": "Sciences Po - Ecole de la recherche (author-date, Français)",
    "sciences-po-ecole-doctorale-note-french": "Sciences Po - École de la recherche (note)",
    "scientia-agriculturae-bohemica": "Scientia Agriculturae Bohemica",
    "scientia-iranica": "Scientia Iranica",
    "scientific-online-letters-on-the-atmosphere": "Scientific Online Letters on the Atmosphere",
    "scientific-review-engineering-and-environmental-sciences": "Scientific Review Engineering and Environmental Sciences (Przegląd Naukowy Inżynieria i Kształtowanie Środowiska)",
    "scrinium": "Scrinium",
    "sedimentology": "Sedimentology",
    "seed-science-research": "Seed Science Research",
    "seed-science-and-technology": "Seed Science and Technology",
    "seismological-research-letters": "Seismological Research Letters",
    "sekolah-tinggi-meteorologi-klimatologi-dan-geofisika": "Sekolah Tinggi Meteorologi Klimatologi dan Geofisika (Bahasa Indonesia)",
    "seminars-in-pediatric-neurology": "Seminars in Pediatric Neurology",
    "serbian-archives-of-medicine": "Serbian Archives of Medicine",
    "serdica-journal-of-computing": "Serdica Journal of Computing",
    "service-medical-de-l-assurance-maladie": "Service Médical de l'Assurance Maladie (Français)",
    "sexual-development": "Sexual Development",
    "sexual-health": "Sexual Health",
    "sheffield-hallam-university-history": "Sheffield Hallam University - History",
    "shock": "Shock",
    "silva-fennica": "Silva Fennica",
    "sinergie-italian-journal-of-management": "Sinergie Italian Journal of Management",
    "skene-journal-of-theatre-and-drama-studies": "Skenè. Journal of Theatre and Drama Studies",
    "slovensko-drustvo-za-medicinsko-informatiko": "Slovensko društvo za medicinsko informatiko",
    "small": "Small",
    "smithsonian-institution-scholarly-press-author-date": "Smithsonian Institution Scholarly Press (author-date)",
    "smithsonian-institution-scholarly-press-note": "Smithsonian Institution Scholarly Press (note)",
    "smithsonian-institution-scholarly-press-botany": "Smithsonian Institution Scholarly Press - Botany (author-date)",
    "smyrna-tip-dergisi": "Smyrna Tıp Dergisi (Türkçe)",
    "social-anthropology": "Social Anthropology/Anthropologie Sociale",
    "social-cognitive-and-affective-neuroscience": "Social Cognitive and Affective Neuroscience",
    "social-history": "Social History",
    "social-history-of-medicine": "Social History of Medicine",
    "social-science-history": "Social Science History",
    "sociedade-brasileira-de-computacao": "Sociedade Brasileira de Computação",
    "society-for-american-archaeology": "Society for American Archaeology",
    "society-for-historical-archaeology": "Society for Historical Archaeology",
    "society-for-laboratory-automation-and-screening": "Society for Laboratory Automation and Screening",
    "society-of-automotive-engineers-technical-papers-numeric": "Society of Automotive Engineers Technical Papers (numeric)",
    "sociologia-ruralis": "Sociologia Ruralis",
    "sociologia-urbana-e-rurale": "Sociologia Urbana e Rurale (Italian)",
    "sociologie": "Sociologie (Français)",
    "sociology-of-health-and-illness": "Sociology of Health & Illness",
    "societe-archeologique-de-bordeaux": "Société Archéologique de Bordeaux (Français)",
    "societe-francaise-detude-de-la-ceramique-antique-en-gaule": "Société Française d’Étude de la Céramique Antique en Gaule (Français)",
    "societe-nationale-des-groupements-techniques-veterinaires": "Société Nationale des Groupements Techniques Vétérinaires (Français)",
    "societe-francaise-degyptologie": "Société française d'égyptologie",
    "societes-contemporaines": "Sociétés Contemporaines",
    "soil-biology-and-biochemistry": "Soil Biology and Biochemistry",
    "soil-science-and-plant-nutrition": "Soil Science and Plant Nutrition",
    "solent-university-harvard": "Solent University (author-date/Harvard)",
    "solutions": "Solutions",
    "sophiahemmet-hogskola": "Sophiahemmet Högskola (Swedish)",
    "sorbonne-student-law-review": "Sorbonne Student Law Review - Revue juridique des étudiants de la Sorbonne",
    "south-african-actuarial-journal": "South African Actuarial Journal",
    "south-african-journal-of-animal-science": "South African Journal of Animal Science",
    "south-african-journal-of-enology-and-viticulture": "South African Journal of Enology and Viticulture",
    "south-african-journal-of-geology": "South African Journal of Geology",
    "south-african-law-journal": "South African Law Journal",
    "south-african-medical-journal": "South African Medical Journal",
    "south-african-theological-seminary": "South African Theological Seminary",
    "southeastern-geographer": "Southeastern Geographer",
    "southern-african-journal-of-critical-care": "Southern African Journal of Critical Care",
    "soziale-welt": "Soziale Welt (Deutsch)",
    "sozialpadagogisches-institut-berlin-walter-may": "Sozialpädagogisches Institut Berlin - Walter May (Deutsch)",
    "sozialwissenschaften-heilmann": "Sozialwissenschaften (Heilmann) (Deutsch)",
    "soziologie": "Soziologie (Deutsch)",
    "soziologiemagazin": "Soziologiemagazin (Deutsch)",
    "spandidos-publications": "Spandidos Publications",
    "spanish-legal": "Spanish Legal (Español)",
    "spectroscopy-letters": "Spectroscopy Letters",
    "spine": "Spine",
    "sports-health": "Sports Health",
    "springer-basic-author-date": "Springer - Basic (author-date)",
    "springer-basic-author-date-no-et-al": "Springer - Basic (author-date, no \"et al.\")",
    "springer-basic-author-date-no-et-al-with-issue": "Springer - Basic (author-date, no \"et al.\", with issue numbers)",
    "springer-basic-note": "Springer - Basic (note)",
    "springer-basic-brackets": "Springer - Basic (numeric, brackets)",
    "springer-basic-brackets-no-et-al": "Springer - Basic (numeric, brackets, no \"et al.\")",
    "springer-basic-brackets-no-et-al-alphabetical": "Springer - Basic (numeric, brackets, no \"et al.\", alphabetical)",
    "springer-fachzeitschriften-medizin-psychologie": "Springer - Fachzeitschriften Medizin Psychologie (Deutsch)",
    "springer-humanities-author-date": "Springer - Humanities (author-date)",
    "springer-humanities-brackets": "Springer - Humanities (numeric, brackets)",
    "springer-imis-series-migrationsgesellschaften": "Springer - IMIS Series Migrationsgesellschaften",
    "springer-lecture-notes-in-computer-science": "Springer - Lecture Notes in Computer Science",
    "springer-lecture-notes-in-computer-science-alphabetical": "Springer - Lecture Notes in Computer Science (sorted alphabetically)",
    "springer-mathphys-author-date": "Springer - MathPhys (author-date)",
    "springer-mathphys-brackets": "Springer - MathPhys (numeric, brackets)",
    "springer-vancouver": "Springer - NLM/Vancouver (citation-sequence)",
    "springer-vancouver-brackets": "Springer - NLM/Vancouver (citation-sequence, brackets)",
    "springer-vancouver-author-date": "Springer - NLM/Vancouver (name-year)",
    "springer-physics-author-date": "Springer - Physics (author-date)",
    "springer-physics-brackets": "Springer - Physics (numeric, brackets)",
    "springer-socpsych-author-date": "Springer - SocPsych (author-date)",
    "springer-socpsych-brackets": "Springer - SocPsych (numeric, brackets)",
    "springer-vs-author-date": "Springer VS (author-date, Deutsch)",
    "springerprotocols": "SpringerProtocols",
    "st-patricks-college": "St Patrick's College",
    "harvard-staffordshire-university": "Staffordshire University (author-date/Harvard)",
    "stanovnistvo": "Stanovništvo",
    "statistika-statistics-and-economy-journal": "Statistika: Statistics and Economy Journal",
    "stavebni-obzor": "Stavební obzor (Čeština)",
    "steel-research-international": "Steel Research International",
    "steinbeis-hochschule-school-of-management-and-innovation": "Steinbeis-Hochschule - School of Management & Innovation (Deutsch)",
    "stellenbosch-law-review": "Stellenbosch Law Review",
    "harvard-stellenbosch-university": "Stellenbosch University (author-date/Harvard)",
    "stem-cell-reports": "Stem Cell Reports",
    "stem-cells": "Stem Cells",
    "strategic-design-research-journal": "Strategic Design Research Journal",
    "strategic-entrepreneurship-journal": "Strategic Entrepreneurship Journal",
    "strategic-management-journal": "Strategic Management Journal",
    "stroke": "Stroke",
    "structural-control-and-health-monitoring": "Structural Control and Health Monitoring",
    "studi-slavistici-rivista-dellassociazione-italiana-degli-slavisti": "Studi Slavistici Rivista dell’Associazione Italiana degli Slavisti",
    "studi-e-materiali-di-storia-delle-religioni": "Studi e materiali di storia delle religioni (Italiano)",
    "studia-bas": "Studia BAS (Polski)",
    "studia-historiae-scientiarum": "Studia Historiae Scientiarum",
    "studia-theologica": "Studia Theologica (Czech)",
    "studies-in-the-history-of-gardens-and-designed-landscapes": "Studies in the History of Gardens & Designed Landscapes",
    "studii-teologice": "Studii Teologice",
    "em-normandie-business-school-harvard-francais": "Style Harvard Ecole de Management de Normandie (Français)",
    "style-manual-australian-government": "Style Manual - Australian Government (author-date)",
    "style-manual-australian-government-note": "Style Manual - Australian Government (note)",
    "style-manual-for-authors-editors-and-printers-6th-edition-snooks-co": "Style manual for authors, editors and printers 6th edition (Snooks & Co.) (author-date)",
    "sunway-college-johor-bahru": "Sunway College Johor Bahru (author-date/Harvard)",
    "suomen-antropologi-journal-of-the-finnish-anthropological-society": "Suomen antropologi: Journal of the Finnish Anthropological Society",
    "surgical-clinics-of-north-america": "Surgical Clinics of North America",
    "surgical-neurology-international": "Surgical Neurology International",
    "surgical-pathology-clinics": "Surgical Pathology Clinics",
    "survey-of-ophthalmology": "Survey of Ophthalmology",
    "svensk-exegetisk-arsbok": "Svensk exegetisk årsbok (full note)",
    "swedish-legal": "Swedish Legal (Svenska)",
    "harvard-swinburne-university-of-technology": "Swinburne University of Technology (author-date/Harvard)",
    "swiss-political-science-review": "Swiss Political Science Review",
    "sylwan": "Sylwan (Polski)",
    "synthesis": "Synthesis",
    "system-dynamics-review": "System Dynamics Review",
    "systematic-biology": "Systematic Biology",
    "systematic-and-applied-microbiology": "Systematic and Applied Microbiology",
    "szociologiai-szemle": "Szociológiai Szemle (Magyar)",
    "seminaire-saint-sulpice-ecole-theologie": "Séminaire Saint-Sulpice - Ecole Théologie (Français)",
    "sodertorns-hogskola-harvard": "Södertörns högskola (author-date/Harvard)",
    "sodertorns-hogskola-harvard-ibid": "Södertörns högskola (author-date/Harvard, with Ibid.)",
    "sodertorns-hogskola-oxford": "Södertörns högskola - Oxford",
    "suleyman-demirel-universitesi-fen-bilimleri-enstitusu": "Süleyman Demirel Üniversitesi - Fen Bi̇li̇mleri̇ Ensti̇tüsü",
    "tatup-zeitschrift-fur-technikfolgenabschatzung-in-theorie-und-praxis": "TATuP - Zeitschrift für Technikfolgenabschätzung in Theorie und Praxis",
    "tgm-wien-diplom": "TGM Wien Diplomarbeit (Deutsch)",
    "tgm-wien-diplomarbeit-onorm": "TGM Wien Diplomarbeit ÖNORM (Deutsch - Österreich)",
    "tagungsberichte-der-historischen-kommission-fur-ost-und-westpreussische-landesforschung": "Tagungsberichte der Historischen Kommission für ost- und westpreußische Landesforschung (Deutsch)",
    "tapir-conservation": "Tapir Conservation",
    "targetome": "Targetome",
    "taxon": "Taxon",
    "taylor-and-francis-harvard-x": "Taylor & Francis (author-date/Harvard) X",
    "taylor-and-francis-ama": "Taylor & Francis - AMA",
    "taylor-and-francis-acs": "Taylor & Francis - American Chemical Society",
    "taylor-and-francis-aip": "Taylor & Francis - American Institute of Physics",
    "taylor-and-francis-chicago-f": "Taylor & Francis - Chicago F",
    "taylor-and-francis-council-of-science-editors-author-date": "Taylor & Francis - Council of Science Editors (author-date)",
    "taylor-and-francis-council-of-science-editors-numeric": "Taylor & Francis - Council of Science Editors (numeric)",
    "taylor-and-francis-national-library-of-medicine": "Taylor & Francis - NLM/Vancouver (citation-sequence, brackets)",
    "taylor-and-francis-vancouver-national-library-of-medicine": "Taylor & Francis - NLM/Vancouver (citation-sequence, parentheses)",
    "taylor-and-francis-numeric-q": "Taylor & Francis - Numeric Q",
    "taylor-and-francis-chicago-b-author-date": "Taylor & Francis - US Chicago Manual of Style B (author-date)",
    "taylor-and-francis-chicago-author-date": "Taylor & Francis Journals Standard Reference Style Guide: Chicago author-date version 2.0",
    "techniques-et-culture": "Techniques&Culture (Français)",
    "technische-universitat-dortmund-ag-virtual-machining": "Technische Universität Dortmund - AG Virtual Machining (Deutsch)",
    "technische-universitat-dresden-betriebswirtschaftslehre-logistik-author-date": "Technische Universität Dresden - Betriebswirtschaftslehre/Logistik (author-date)",
    "technische-universitat-dresden-betriebswirtschaftslehre-marketing": "Technische Universität Dresden - Betriebswirtschaftslehre/Marketing (author-date)",
    "technische-universitat-dresden-betriebswirtschaftslehre-rechnungswesen-controlling": "Technische Universität Dresden - Betriebswirtschaftslehre/Rechnungswesen/Controlling (Deutsch)",
    "technische-universitat-dresden-erziehungswissenschaften-author-date": "Technische Universität Dresden - Erziehungswissenschaften (author-date)",
    "technische-universitat-dresden-finanzwirtschaft-und-finanzdienstleistungen-author-date": "Technische Universität Dresden - Finanzwirtschaft und Finanzdienstleistungen (author-date)",
    "technische-universitat-dresden-finanzwirtschaft-und-finanzdienstleistungen-author-date-with-short-titles": "Technische Universität Dresden - Finanzwirtschaft und Finanzdienstleistungen (author-date, with short titles)",
    "technische-universitat-dresden-finanzwirtschaft-und-finanzdienstleistungen-note": "Technische Universität Dresden - Finanzwirtschaft und Finanzdienstleistungen (note)",
    "technische-universitat-dresden-forstwissenschaft": "Technische Universität Dresden - Forstwissenschaft (author-date, Deutsch)",
    "technische-universitat-dresden-historische-musikwissenschaft-note": "Technische Universität Dresden - Historische Musikwissenschaft (note, Deutsch)",
    "technische-universitat-dresden-kunstgeschichte-note": "Technische Universität Dresden - Kunstgeschichte (note, Deutsch)",
    "technische-universitat-dresden-linguistik": "Technische Universität Dresden - Linguistik (Deutsch)",
    "technische-universitat-dresden-medienwissenschaft-und-neuere-deutsche-literatur-note": "Technische Universität Dresden - Medienwissenschaft und Neuere Deutsche Literatur (note, Deutsch)",
    "technische-universitat-dresden-wirtschaftswissenschaften": "Technische Universität Dresden - Wirtschaftswissenschaften (Deutsch)",
    "technische-universitat-hamburg-institut-fur-smarte-entwicklung-und-maschinenelemente": "Technische Universität Hamburg – Institut für Smarte Entwicklung und Maschinenelemente (Deutsch)",
    "technische-universitat-munchen-controlling": "Technische Universität München - Controlling (Deutsch)",
    "technische-universitat-munchen-unternehmensfuhrung": "Technische Universität München - Unternehmensführung (Deutsch)",
    "technische-universitat-wien": "Technische Universität Wien (dissertation) (Deutsch)",
    "teologia-catalunya": "Teologia Catalunya",
    "termedia-neuropsychiatria-i-neuropsychologia-neuropsychiatry-and-neuropsychology": "Termedia Neuropsychiatria i Neuropsychologia/Neuropsychiatry and Neuropsychology",
    "terra-nova": "Terra Nova",
    "tetrahedron-letters": "Tetrahedron Letters",
    "textual-cultures": "Textual Cultures",
    "textual-practice": "Textual Practice",
    "thai-endodontic-journal": "Thai Endodontic Journal",
    "the-accounting-review": "The Accounting Review",
    "african-journal-of-food-agriculture-nutrition-development": "The African Journal of Food, Agriculture, Nutrition and Development",
    "the-american-journal-of-bioethics": "The American Journal of Bioethics",
    "the-american-journal-of-cardiology": "The American Journal of Cardiology",
    "the-american-journal-of-dermatopathology": "The American Journal of Dermatopathology",
    "the-american-journal-of-gastroenterology": "The American Journal of Gastroenterology",
    "the-american-journal-of-geriatric-psychiatry": "The American Journal of Geriatric Psychiatry",
    "the-american-journal-of-pathology": "The American Journal of Pathology",
    "the-american-journal-of-psychiatry": "The American Journal of Psychiatry",
    "the-american-journal-of-tropical-medicine-and-hygiene": "The American Journal of Tropical Medicine and Hygiene",
    "the-american-midland-naturalist": "The American Midland Naturalist",
    "the-american-naturalist": "The American Naturalist",
    "the-angle-orthodontist": "The Angle Orthodontist",
    "the-astrophysical-journal": "The Astrophysical Journal",
    "the-auk": "The Auk",
    "the-australian-journal-of-agricultural-and-resource-economics": "The Australian Journal of Agricultural and Resource Economics",
    "the-biological-bulletin": "The Biological Bulletin",
    "the-bone-and-joint-journal": "The Bone & Joint Journal",
    "the-botanical-review": "The Botanical Review",
    "the-bovine-practitioner": "The Bovine Practitioner",
    "the-british-journal-for-the-history-of-science": "The British Journal for the History of Science",
    "the-british-journal-for-the-philosophy-of-science": "The British Journal for the Philosophy of Science",
    "the-british-journal-of-cardiology": "The British Journal of Cardiology",
    "the-british-journal-of-criminology": "The British Journal of Criminology",
    "the-british-journal-of-psychiatry": "The British Journal of Psychiatry",
    "the-british-journal-of-social-work": "The British Journal of Social Work",
    "the-british-journal-of-sociology": "The British Journal of Sociology",
    "the-canadian-geographer": "The Canadian Geographer (Le Géographe canadien)",
    "the-canadian-journal-of-chemical-engineering": "The Canadian Journal of Chemical Engineering",
    "the-canadian-journal-of-psychiatry": "The Canadian Journal of Psychiatry",
    "the-cancer-journal": "The Cancer Journal",
    "the-chemical-society-of-japan": "The Chemical Society of Japan",
    "the-chinese-journal-of-international-politics": "The Chinese Journal of International Politics",
    "the-coleopterists-bulletin": "The Coleopterists Bulletin",
    "the-company-of-biologists": "The Company of Biologists",
    "the-depositional-record": "The Depositional Record",
    "the-design-journal": "The Design Journal",
    "the-economic-history-review": "The Economic History Review",
    "the-european-research-journal": "The European Research Journal",
    "the-faseb-journal": "The FASEB Journal",
    "the-febs-journal": "The FEBS Journal",
    "the-geological-society-of-america": "The Geological Society of America",
    "the-geological-society-of-london": "The Geological Society of London",
    "the-hastings-center-report": "The Hastings Center Report",
    "the-historical-journal": "The Historical Journal",
    "the-holocene": "The Holocene",
    "the-horticulture-journal": "The Horticulture Journal",
    "the-isme-journal": "The ISME Journal",
    "the-institute-of-electronics-information-and-communication-engineers": "The Institute of Electronics, Information and Communication Engineers (電子情報通信学会)",
    "the-institution-of-engineering-and-technology": "The Institution of Engineering and Technology",
    "the-international-journal-of-developmental-biology": "The International Journal of Developmental Biology",
    "the-international-journal-of-psychoanalysis": "The International Journal of Psychoanalysis",
    "the-international-journal-of-tuberculosis-and-lung-disease": "The International Journal of Tuberculosis and Lung Disease",
    "the-international-spectator": "The International Spectator",
    "the-journal-of-adhesive-dentistry": "The Journal of Adhesive Dentistry",
    "the-journal-of-agricultural-science": "The Journal of Agricultural Science",
    "journal-of-biological-chemistry": "The Journal of Biological Chemistry",
    "the-journal-of-bone-and-joint-surgery": "The Journal of Bone & Joint Surgery",
    "the-journal-of-clinical-ethics": "The Journal of Clinical Ethics",
    "the-journal-of-clinical-investigation": "The Journal of Clinical Investigation",
    "the-journal-of-comparative-law": "The Journal of Comparative Law",
    "the-journal-of-comparative-neurology": "The Journal of Comparative Neurology",
    "the-journal-of-ecclesiastical-history": "The Journal of Ecclesiastical History",
    "the-journal-of-egyptian-archaeology": "The Journal of Egyptian Archaeology",
    "the-journal-of-eukaryotic-microbiology": "The Journal of Eukaryotic Microbiology",
    "the-journal-of-foot-and-ankle-surgery": "The Journal of Foot & Ankle Surgery",
    "the-journal-of-hand-surgery-european-volume": "The Journal of Hand Surgery (European Volume)",
    "the-journal-of-hand-surgery-asian-pacific-volume": "The Journal of Hand Surgery Asian-Pacific Volume",
    "the-journal-of-hellenic-studies": "The Journal of Hellenic Studies",
    "the-journal-of-immunology": "The Journal of Immunology",
    "the-journal-of-infection-in-developing-countries": "The Journal of Infection in Developing Countries",
    "the-journal-of-juristic-papyrology": "The Journal of Juristic Papyrology",
    "the-journal-of-laryngology-and-otology": "The Journal of Laryngology and Otology",
    "the-journal-of-molecular-diagnostics": "The Journal of Molecular Diagnostics",
    "the-journal-of-nervous-and-mental-disease": "The Journal of Nervous and Mental Disease",
    "the-journal-of-neuropsychiatry-and-clinical-neurosciences": "The Journal of Neuropsychiatry and Clinical Neurosciences",
    "the-journal-of-neuroscience": "The Journal of Neuroscience",
    "the-journal-of-nuclear-medicine": "The Journal of Nuclear Medicine",
    "the-journal-of-nutrition-health-and-aging": "The Journal of Nutrition, Health & Aging",
    "the-journal-of-pain": "The Journal of Pain",
    "the-journal-of-parasitology": "The Journal of Parasitology",
    "the-journal-of-pathology": "The Journal of Pathology",
    "the-journal-of-peasant-studies": "The Journal of Peasant Studies",
    "the-journal-of-physiology": "The Journal of Physiology",
    "the-journal-of-pure-and-applied-chemistry-research": "The Journal of Pure and Applied Chemistry Research",
    "the-journal-of-roman-studies": "The Journal of Roman Studies",
    "the-journal-of-transport-history": "The Journal of Transport History",
    "the-journal-of-trauma-and-acute-care-surgery": "The Journal of Trauma and Acute Care Surgery",
    "the-journal-of-urology": "The Journal of Urology",
    "journal-of-value-inquiry": "The Journal of Value Inquiry",
    "the-journal-of-veterinary-medical-science": "The Journal of Veterinary Medical Science",
    "the-journal-of-wildlife-management": "The Journal of Wildlife Management",
    "the-journal-of-the-acoustical-society-of-america": "The Journal of the Acoustical Society of America (author-date)",
    "the-journal-of-the-acoustical-society-of-america-numeric": "The Journal of the Acoustical Society of America (numeric)",
    "the-journal-of-the-torrey-botanical-society": "The Journal of the Torrey Botanical Society",
    "the-korean-journal-of-gastroenterology": "The Korean Journal of Gastroenterology",
    "the-korean-journal-of-internal-medicine": "The Korean Journal of Internal Medicine",
    "the-korean-journal-of-mycology": "The Korean Journal of Mycology",
    "the-lancet": "The Lancet",
    "the-lichenologist": "The Lichenologist",
    "the-national-medical-journal-of-india": "The National Medical Journal of India",
    "the-neuroscientist": "The Neuroscientist",
    "the-new-england-journal-of-medicine": "The New England Journal of Medicine",
    "the-oncologist": "The Oncologist",
    "the-open-university-harvard": "The Open University (author-date/Harvard)",
    "the-open-university-numeric": "The Open University (numeric)",
    "the-open-university-numeric-superscript": "The Open University (numeric, superscript)",
    "the-open-university-a251": "The Open University - A251 - Arts Course",
    "the-open-university-m801": "The Open University - M801 - Research Project and Dissertation",
    "the-open-university-s390": "The Open University - S390",
    "the-optical-society": "The Optical Society",
    "the-pan-african-medical-journal": "The Pan African Medical Journal",
    "the-plant-cell": "The Plant Cell",
    "the-plant-genome": "The Plant Genome",
    "the-plant-journal": "The Plant Journal",
    "the-quarterly-journal-of-economics": "The Quarterly Journal of Economics",
    "the-rockefeller-university-press": "The Rockefeller University Press",
    "the-saudi-journal-for-dental-research": "The Saudi Journal for Dental Research",
    "the-scandinavian-journal-of-clinical-and-laboratory-investigation": "The Scandinavian Journal of Clinical & Laboratory Investigation",
    "harvard-the-university-of-northampton": "The University of Northampton (author-date/Harvard)",
    "harvard-the-university-of-sheffield-school-of-east-asian-studies": "The University of Sheffield - School of East Asian Studies (author-date/Harvard)",
    "harvard-the-university-of-sheffield-town-and-regional-planning": "The University of Sheffield - Town and Regional Planning (author-date/Harvard)",
    "the-university-of-western-australia-harvard": "The University of Western Australia (author-date/Harvard)",
    "the-university-of-winchester-harvard": "The University of Winchester (author-date/Harvard)",
    "the-world-journal-of-biological-psychiatry": "The World Journal of Biological Psychiatry",
    "theologie-und-philosophie": "Theologie und Philosophie (Deutsch)",
    "harvard-theologisches-seminar-adelshofen": "Theologisches Seminar Adelshofen (author-date/Harvard, Deutsch)",
    "theory-culture-and-society": "Theory, Culture & Society",
    "theranostics": "Theranostics",
    "thieme-german": "Thieme-German (Deutsch)",
    "thomson-reuters-legal-tax-and-accounting-australia": "Thomson Reuters - Legal, Tax & Accounting Australia",
    "thrombosis-and-haemostasis": "Thrombosis and Haemostasis",
    "theses-de-sorbonne-universite": "Thèse de Sorbonne Université (Sciences Humaines et Sociales, Français)",
    "tijdschrift-voor-geneeskunde": "Tijdschrift voor Geneeskunde en Gezondheidszorg (Nederlands)",
    "tijdschrift-voor-economische-en-sociale-geografie": "Tijdschrift voor economische en sociale geografie",
    "topoi-orient-occident-auteur-date": "Topoi Orient-Occident (auteur-date, Français)",
    "topoi-orient-occident-classique": "Topoi Orient-Occident (classique, Français)",
    "trabajos-de-prehistoria": "Trabajos de Prehistoria (Español)",
    "traces": "Tracés: Revue de Sciences Humaines (Français)",
    "traffic": "Traffic",
    "traffic-injury-prevention": "Traffic Injury Prevention",
    "tramas-y-redes-revista-del-consejo-latinoamericano-de-ciencias-sociales": "Tramas y Redes - Revista del Consejo Latinoamericano de Ciencias Sociales (Español)",
    "trames": "Trames",
    "transactions-of-the-american-philological-association": "Transactions of the American Philological Association",
    "transactions-of-the-materials-research-society-of-japan": "Transactions of the Materials Research Society of Japan",
    "transactions-of-the-philological-society": "Transactions of the Philological Society",
    "transactions-on-maritime-science": "Transactions on Maritime Science",
    "transboundary-and-emerging-diseases": "Transboundary and Emerging Diseases",
    "transnational-environmental-law": "Transnational Environmental Law",
    "transplantation": "Transplantation",
    "transport": "Transport",
    "transportation-research-record": "Transportation Research Record: Journal of the Transportation Research Board",
    "transposition": "Transposition. Musique et sciences sociales",
    "transversalites": "Transversalités (Français)",
    "travail-et-emploi": "Travail et Emploi (Français)",
    "trends-in-glycoscience-and-glycotechnology": "Trends in Glycoscience and Glycotechnology",
    "trends-journals": "Trends journals",
    "triangle": "Triangle (Français)",
    "trinity-college-dublin-zoology-botany-environmental-sciences-harvard": "Trinity College Dublin - Zoology Botany Environmental Sciences (author-date/Harvard)",
    "tropical-animal-health-and-production": "Tropical Animal Health and Production",
    "tsaqafah": "Tsaqafah",
    "turcica": "Turcica",
    "tyndale-bulletin": "Tyndale Bulletin",
    "turkiye-bilimsel-ve-teknolojik-arastirma-kurumu": "TÜBİTAK (Türkiye Bilimsel ve Teknolojik Araştırma Kurumu) (Türkçe)",
    "tabula": "Tábula (Español)",
    "u-schylku-starozytnosci": "U Schyłku Starożytności (Polski)",
    "us-geological-survey": "U.S. Geological Survey",
    "ucl-institute-of-education-harvard": "UCL Institute of Education (author-date/Harvard)",
    "ucl-press-note": "UCL Press (note)",
    "ucl-university-college-harvard": "UCL University College (author-date/Harvard, Dansk)",
    "ucl-university-college-apa": "UCL University College - APA (Dansk)",
    "ucl-university-college-vancouver": "UCL University College - NLM/Vancouver",
    "uclouvain-centre-charles-de-visscher-pour-le-droit-international-et-europeen": "UCLouvain - Centre Charles De Visscher pour le droit international et européen (French)",
    "unesco-international-institute-for-educational-planning": "UNESCO International Institute for Educational Planning",
    "associacao-brasileira-de-normas-tecnicas-unirio-eipp": "UNIRIO - Educação Infantil e Políticas Públicas - ABNT (Português - Brasil)",
    "usda-forest-service-pacific-northwest-research-station": "USDA Forest Service - Pacific Northwest Research Station",
    "ugeskrift-for-laeger": "Ugeskrift for Læger (Dansk)",
    "ultrasound-in-medicine-and-biology": "Ultrasound in Medicine and Biology",
    "uludag-universitesi-sosyal-bilimler-enstitusu-author-date": "Uludağ Üniversitesi - Sosyal Bilimler Enstitüsü (author-date, Türkçe)",
    "uludag-universitesi-sosyal-bilimler-enstitusu-full-note": "Uludağ Üniversitesi - Sosyal Bilimler Enstitüsü (full note, Türkçe)",
    "uludag-universitesi-sosyal-bilimler-enstitusu-full-note-with-ibid": "Uludağ Üniversitesi - Sosyal Bilimler Enstitüsü (full note, with Ibid., Türkçe)",
    "uludag-universitesi-sosyal-bilimler-enstitusu-ilahiyat-fakultesi-full-note": "Uludağ Üniversitesi - Sosyal Bilimler Enstitüsü - İlahiyat Fakültesi (full note, Türkçe)",
    "uludag-universitesi-sosyal-bilimler-enstitusu-ilahiyat-fakultesi-full-note-with-ibid": "Uludağ Üniversitesi - Sosyal Bilimler Enstitüsü - İlahiyat Fakültesi (full note, with Ibid., Türkçe)",
    "ulua-revista-de-historia-sociedad-y-cultura": "Ulúa. Revista de Historia, Sociedad y Cultura",
    "umea-university-harvard": "Umeå University (author-date/Harvard)",
    "umea-university-oxford": "Umeå University - Oxford",
    "undergraduate-journal-of-experimental-microbiology-and-immunology": "Undergraduate Journal of Experimental Microbiology and Immunology",
    "uni-fribourg-theologie": "Uni Fribourg Theologie (Deutsch)",
    "unified-style-sheet-for-linguistics-de-gruyter-literature": "Unified Stylesheet for Linguistics (de Gruyter Literature)",
    "unified-style-sheet-for-linguistics": "Unified style sheet for linguistics",
    "united-nations-conference-on-trade-and-development": "United Nations Conference on Trade and Development",
    "united-nations-development-programme-icca-legal-review": "United Nations Development Programme ICCA Legal Review",
    "united-nations-framework-convention-on-climate-change": "United Nations Framework Convention on Climate Change",
    "united-states-international-trade-commission": "United States International Trade Commission",
    "universidad-autonoma-cidudad-juarez-estilo-latino-humanistico": "Universidad Autónoma de Ciudad Juárez - Estilo Latino Humanístico",
    "universidad-evangelica-del-paraguay": "Universidad Evangélica del Paraguay (Español)",
    "universidad-nacional-autonoma-de-mexico-instituto-de-investigaciones-juridicas": "Universidad Nacional Autónoma de México - Instituto de Investigaciones Jurídicas (Español)",
    "universidad-de-leon-harvard": "Universidad de León (España) (author-date/Harvard)",
    "universidade-estadual-paulista-campus-de-dracena-abnt": "Universidade Estadual Paulista - Campus de Dracena - ABNT (autoria abreviada) (Português - Brasil)",
    "universidade-estadual-paulista-faculdade-de-engenharia-de-guaratingueta-abnt": "Universidade Estadual Paulista - Faculdade de Engenharia de Guaratingueta - ABNT (Português - Brasil)",
    "universidade-estadual-de-alagoas-abnt": "Universidade Estadual de Alagoas - UNEAL [ABNT] (Portuguese - Brazil)",
    "universidade-estadual-do-oeste-do-parana-programa-institucional-de-bolsas-de-iniciacao-cientifica": "Universidade Estadual do Oeste do Paraná - Programa Institucional de Bolsas de Iniciação Científica (Português - Brasil)",
    "universidade-federal-de-goias-escola-de-veterinaria-e-zootecnia": "Universidade Federal de Goiás - Escola de Veterinária e Zootecnia (Português - Brasil)",
    "universidade-federal-de-juiz-de-fora": "Universidade Federal de Juiz de Fora (Português - Brasil)",
    "associacao-brasileira-de-normas-tecnicas-ufmg-face-initials": "Universidade Federal de Minas Gerais - Faculdade de Ciências Econômicas - ABNT (autoria abreviada) (Português - Brasil)",
    "associacao-brasileira-de-normas-tecnicas-ufmg-face-full": "Universidade Federal de Minas Gerais - Faculdade de Ciências Econômicas - ABNT (autoria completa) (Português - Brasil)",
    "universidade-federal-de-pernambuco-abnt": "Universidade Federal de Pernambuco - ABNT (Português - Brasil)",
    "associacao-brasileira-de-normas-tecnicas-ufs": "Universidade Federal de Sergipe - ABNT (Português - Brasil)",
    "universidade-federal-de-sergipe-departamento-de-engenharia-de-producao-abnt": "Universidade Federal de Sergipe - Departamento de Engenharia de Produção - ABNT (Português - Brasil)",
    "universidade-federal-do-espirito-santo-abnt-initials": "Universidade Federal do Espírito Santo - ABNT (autoria abreviada) (Português - Brasil)",
    "universidade-federal-do-espirito-santo-abnt": "Universidade Federal do Espírito Santo - ABNT (autoria completa) (Português - Brasil)",
    "associacao-brasileira-de-normas-tecnicas-ufpr": "Universidade Federal do Paraná - ABNT (Português - Brasil)",
    "associacao-brasileira-de-normas-tecnicas-ufrgs-initials": "Universidade Federal do Rio Grande do Sul - ABNT (autoria abreviada) (Português - Brasil)",
    "associacao-brasileira-de-normas-tecnicas-ufrgs-note-initials-with-ibid": "Universidade Federal do Rio Grande do Sul - ABNT (autoria abreviada, nota, com Ibid.) (Português - Brasil)",
    "associacao-brasileira-de-normas-tecnicas-ufrgs": "Universidade Federal do Rio Grande do Sul - ABNT (autoria completa) (Português - Brasil)",
    "universidade-federal-do-rio-de-janeiro-instituto-alberto-luiz-coimbra-de-pos-graduacao-e-pesquisa-de-engenharia-abnt": "Universidade Federal do Rio de Janeiro - Instituto Alberto Luiz Coimbra de Pós-Graduação e Pesquisa de Engenharia - ABNT (Português - Brasil)",
    "universidade-de-sao-paulo-escola-de-comunicacoes-e-artes-abnt": "Universidade de São Paulo - Escola de Comunicações e Artes - ABNT (Português - Brasil)",
    "associacao-brasileira-de-normas-tecnicas-usp-fmvz": "Universidade de São Paulo - Faculdade de Medicina Veterinária e Zootecnia - ABNT (Português - Brasil)",
    "universidade-de-sao-paulo-instituto-de-matematica-e-estatistica": "Universidade de São Paulo - Instituto de Matemática e Estatística",
    "universidade-do-estado-do-rio-de-janeiro-abnt": "Universidade do Estado do Rio de Janeiro - ABNT (Português - Brasil)",
    "universidade-do-porto-faculdade-de-engenharia-chicago": "Universidade do Porto - Faculdade de Engenharia - Chicago Manual of Style 17th (author-date)",
    "universidade-do-porto-faculdade-de-engenharia-chicago-pt": "Universidade do Porto - Faculdade de Engenharia - Chicago Manual of Style 17th (author-date) (Português - Portugal)",
    "universidade-do-porto-faculdade-de-psicologia-e-de-ciencias-da-educacao": "Universidade do Porto - Faculdade de Psicologia e de Ciências da Educação - APA",
    "universitas-brawijaya-fakultas-teknologi-pertanian": "Universitas Brawijaya - Fakultas Teknologi Pertanian (Bahasa Indonesia)",
    "universitas-gadjah-mada-departemen-sejarah": "Universitas Gadjah Mada - Departemen Sejarah (Bahasa Indonesia)",
    "universitas-gadjah-mada-doctoral-program-in-pharmaceutical-sciences": "Universitas Gadjah Mada - Doctoral Program in Pharmaceutical Sciences (Bahasa Indonesia)",
    "universitas-negeri-semarang-fakultas-matematika-dan-ilmu-pengetahuan-alam": "Universitas Negeri Semarang - Fakultas Matematika dan Ilmu Pengetahuan Alam (Bahasa Indonesia)",
    "universitas-negeri-yogyakarta-program-pascasarjana": "Universitas Negeri Yogyakarta - Program Pascasarjana (Bahasa Indonesia)",
    "ugent-geschiedenis-nederlands": "Universiteit Gent Geschiedenis (Nederlands)",
    "universiteit-utrecht-onderzoeksgids-geschiedenis": "Universiteit Utrecht - Onderzoeksgids Geschiedenis",
    "universitetet-i-oslo-rettsvitenskap": "Universitetet i Oslo - Rettsvitenskap (Norsk - Bokmål)",
    "universiti-kebangsaan-malaysia": "Universiti Kebangsaan Malaysia (Malay)",
    "harvard-universiti-teknologi-malaysia": "Universiti Teknologi Malaysia (author-date/Harvard)",
    "harvard-universiti-tunku-abdul-rahman": "Universiti Tunku Abdul Rahman (author-date/Harvard)",
    "university-college-dublin-school-of-history-and-archives": "University College Dublin - School of History & Archives",
    "university-college-lillebaelt-apa": "University College Lillebælt - APA (Dansk)",
    "harvard-university-for-the-creative-arts": "University for the Creative Arts (author-date/Harvard)",
    "university-of-aberdeen-school-of-education-harvard": "University of Aberdeen - School of Education (author-date/Harvard)",
    "harvard-university-of-abertay-dundee": "University of Abertay Dundee (author-date/Harvard)",
    "university-of-aleppo-faculty-of-medicine": "University of Aleppo - Faculty of Medicine",
    "university-of-auckland-history": "University of Auckland - History",
    "harvard-university-of-bath": "University of Bath (author-date/Harvard)",
    "harvard-university-of-birmingham": "University of Birmingham (author-date/Harvard)",
    "universita-di-bologna-lettere": "University of Bologna - Liberal Arts College (Università di Bologna - Facoltà di Lettere e Filosofia) (Italiano)",
    "university-of-bradford-harvard": "University of Bradford (author-date/Harvard)",
    "harvard-university-of-brighton-school-of-environment-and-technology": "University of Brighton School of Environment & Technology (author-date/Harvard)",
    "university-of-bucharest-faculty-of-law": "University of Bucharest - Faculty of Law (Română)",
    "university-of-cambridge-faculty-of-history": "University of Cambridge - Faculty of History",
    "harvard-university-of-cape-town": "University of Cape Town (author-date/Harvard)",
    "harvard-university-of-exeter-geography": "University of Exeter - Geography (author-date/Harvard)",
    "university-of-gothenburg-apa-swedish-legislations": "University of Gothenburg - APA 6th edition (Swedish legislations)",
    "university-of-gothenburg-apa-7th-edition-swedish-legislations": "University of Gothenburg - APA 7th edition (Swedish legislations)",
    "harvard-university-of-greenwich": "University of Greenwich (author-date/Harvard)",
    "university-of-hull-harvard": "University of Hull Harvard",
    "harvard-university-of-kent": "University of Kent (author-date/Harvard)",
    "harvard-university-of-leeds": "University of Leeds (author-date/Harvard)",
    "harvard-limerick": "University of Limerick (Cite it Right) (author-date/Harvard)",
    "university-of-lincoln-harvard": "University of Lincoln (author-date/Harvard)",
    "university-of-new-england-australia-note": "University of New England, Australia (note)",
    "university-of-new-south-wales-notes": "University of New South Wales (notes and bibliography)",
    "university-of-pretoria-harvard-theology-religion": "University of Pretoria (author-date/Harvard, Theology and Religion)",
    "university-of-roehampton-harvard": "University of Roehampton (author-date/Harvard)",
    "university-of-south-africa-harvard": "University of South Africa (author-date/Harvard)",
    "university-of-south-australia-harvard-2011": "University of South Australia 2011 (author-date/Harvard)",
    "university-of-south-australia-harvard-2013": "University of South Australia 2013 (author-date/Harvard)",
    "university-of-south-australia-2017-harvard": "University of South Australia 2017 (author-date/Harvard)",
    "university-of-south-wales-harvard": "University of South Wales (author-date/Harvard)",
    "university-of-tasmania-simplified-author-date": "University of Tasmania - Simplified Author-date",
    "harvard-university-of-technology-sydney": "University of Technology Sydney (author-date/Harvard)",
    "harvard-university-of-westminster": "University of Westminster (author-date/Harvard)",
    "harvard-university-of-wolverhampton": "University of Wolverhampton (author-date/Harvard)",
    "university-of-york-harvard": "University of York (author-date/Harvard)",
    "university-of-york-harvard-archaeology": "University of York - Department of Archaeology (author-date/Harvard)",
    "university-of-york-harvard-environment": "University of York - Department of Environment and Geography (author-date/Harvard)",
    "university-of-zabol": "University of Zabol (English)",
    "university-of-zabol-fa": "University of Zabol (فارسی)",
    "harvard-university-of-the-west-of-england": "University of the West of England (Bristol) (author-date/Harvard)",
    "harvard-university-of-the-west-of-scotland": "University of the West of Scotland (author-date/Harvard)",
    "universita-cattolica-del-sacro-cuore": "Università Cattolica del Sacro Cuore (note, Italiano)",
    "universita-pontificia-salesiana": "Università Pontificia Salesiana",
    "universita-pontificia-salesiana-it": "Università Pontificia Salesiana (Italiano)",
    "universitat-basel-deutsche-sprachwissenschaft": "Universität Basel - Deutsche Sprachwissenschaft",
    "universitat-basel-iberoromanistik": "Universität Basel - Iberoromanistik (Español)",
    "universitat-bern-institut-fur-musikwissenschaft-note": "Universität Bern - Institut für Musikwissenschaft (note, Deutsch)",
    "universitat-bern-institut-fur-sozialanthropologie": "Universität Bern - Institut für Sozialanthropologie (Deutsch - Schweiz)",
    "universitat-bern-institut-fur-theaterwissenschaft": "Universität Bern - Institut für Theaterwissenschaft (note, Deutsch)",
    "universitat-bremen-frankoromanistik-literaturwissenschaft": "Universität Bremen - Frankoromanistik - Literaturwissenschaft",
    "universitat-bremen-institut-fur-politikwissenschaft": "Universität Bremen - Institut für Politikwissenschaft (Deutsch)",
    "universitat-bremen-lehrstuhl-fur-innovatives-markenmanagement": "Universität Bremen - Lehrstuhl für innovatives Markenmanagement (Deutsch)",
    "universitat-graz-geographie": "Universität Graz - Geographie",
    "universitat-heidelberg-historisches-seminar": "Universität Heidelberg - Historisches Seminar (Deutsch)",
    "universitat-heidelberg-medizinische-fakultat-mannheim-numeric": "Universität Heidelberg - Medizinische Fakultät Mannheim (numerisch, Deutsch)",
    "universitat-mainz-geographisches-institut": "Universität Mainz - Geographisches Institut (Deutsch)",
    "universitat-mannheim-germanistische-linguistik": "Universität Mannheim - Germanistische Linguistik (Deutsch)",
    "universitat-stuttgart-planung-und-partizipation": "Universität Stuttgart - Planung und Partizipation (Deutsch)",
    "universitat-vechta-katholische-theologie": "Universität Vechta - Katholische Theologie (Deutsch)",
    "universitat-wien-institut-fur-geschichte": "Universität Wien - Institut für Geschichte",
    "universitat-wurzburg-institut-fur-deutsche-philologie-museologie": "Universität Würzburg - Institut für deutsche Philologie - Museologie (Deutsch)",
    "universitat-zu-koln-seminar-fur-abwl-und-finanzierungslehre": "Universität zu Köln - Seminar für ABWL und Finanzierungslehre (Deutsch)",
    "universitatsmedizin-gottingen": "Universitätsmedizin Göttingen (Deutsch)",
    "universite-catholique-de-louvain-histoire": "Université Catholique de Louvain - Histoire (Français)",
    "universite-cheikh-anta-diop-faculte-de-medecine-de-pharmacie-et-dodontologie": "Université Cheikh Anta Diop - Faculté de Médecine de Pharmacie et d'Odontologie (Français)",
    "universite-gustave-eiffel-arts-numeriques-et-cultures-visuelles": "Université Gustave Eiffel - Arts Numériques et Cultures Visuelles (Français)",
    "universite-laval-departement-dinformation-et-de-communication": "Université Laval - Département d'information et de communication (Français - Canada)",
    "universite-laval-departement-des-sciences-historiques": "Université Laval - Département des sciences historiques (Français - Canada)",
    "universite-laval-faculte-de-theologie-et-de-sciences-religieuses": "Université Laval - Faculté de théologie et de sciences religieuses (Français - Canada)",
    "universite-nangui-abrogoua-sciences-de-la-nature-apa": "Université Nangui Abrogoua - Sciences de la Nature - APA (Français)",
    "universite-catholique-de-louvain-fial": "Université catholique de Louvain - FIAL (Français)",
    "universite-de-bordeaux-ecole-doctorale-de-droit": "Université de Bordeaux - École doctorale de droit (Français)",
    "universite-de-geneve-departement-de-langue-et-de-litterature-francaises-modernes": "Université de Genève - Département de langue et de littérature françaises modernes (Français)",
    "universite-de-lausanne-histoire": "Université de Lausanne - Histoire (Français)",
    "universite-de-lausanne-institut-d-archeologie-et-des-sciences-de-l-antiquite": "Université de Lausanne - Institut d'archéologie et des sciences de l'antiquité (Français)",
    "universite-de-liege-droit": "Université de Liège - Droit (Français)",
    "universite-de-liege-droit-par-categorie": "Université de Liège - Droit (classement par catégorie, Français)",
    "universite-de-liege-histoire": "Université de Liège - Histoire (Français)",
    "universite-de-montreal-apa": "Université de Montréal - APA (Français - Canada)",
    "universite-de-montreal-faculte-de-musique": "Université de Montréal - Faculté de musique (Français - Canada)",
    "universite-de-montreal-nlm-fr-ca": "Université de Montréal - NLM/Vancouver (Français - Canada)",
    "universite-de-picardie-jules-verne-ufr-de-medecine": "Université de Picardie Jules Verne (Amiens) - Thèse de UFR de Médecine",
    "universite-de-sherbrooke-departement-de-geomatique": "Université de Sherbrooke - Département de géomatique (Français - Canada)",
    "universite-de-sherbrooke-faculte-d-education": "Université de Sherbrooke - Faculté d'éducation (Français - Canada)",
    "universite-de-sherbrooke-histoire": "Université de Sherbrooke - Histoire (Français - Canada)",
    "universite-du-quebec-a-montreal": "Université du Québec à Montréal - APA (Français - Canada)",
    "universite-du-quebec-a-montreal-prenoms": "Université du Québec à Montréal - APA - prénoms (Français - Canada)",
    "universite-du-quebec-a-montreal-departement-dhistoire": "Université du Québec à Montréal - Département d’histoire (Français - Canada)",
    "universite-du-quebec-a-montreal-etudes-litteraires-et-semiologie": "Université du Québec à Montréal - Études littéraires et sémiologie (Français - Canada)",
    "universite-libre-de-bruxelles-histoire": "Université libre de Bruxelles - Histoire (Français)",
    "univerza-na-primorskem-fakulteta-za-vede-o-zdravju-apa": "Univerza na Primorskem - Fakulteta za vede o zdravju - APA 7 (Slovenščina)",
    "univerza-v-ljubljani-fakulteta-za-gradbenistvo-in-geodezijo-apa-7": "Univerza v Ljubljani - Fakulteta za gradbeništvo in geodezijo - APA 7 (Slovenščina)",
    "univerza-v-ljubljani-fakulteta-za-kemijo-in-kemijsko-tehnologijo": "Univerza v Ljubljani - Fakulteta za kemijo in kemijsko tehnologijo (Slovenščina)",
    "uniwersytet-gdanski-kulturoznawstwo-autor-rok": "Uniwersytet Gdański - Kulturoznawstwo - autor, rok (Polski)",
    "uniwersytet-gdanski-kulturoznawstwo-przypis": "Uniwersytet Gdański - Kulturoznawstwo - przypis (Polski)",
    "uniwersytet-kardynala-stefana-wyszynskiego-w-warszawie-autor-rok": "Uniwersytet Kardynała Stefana Wyszyńskiego w Warszawie (autor-rok, Polski)",
    "uniwersytet-kardynala-stefana-wyszynskiego-w-warszawie-przypis": "Uniwersytet Kardynała Stefana Wyszyńskiego w Warszawie (przypis, Polski)",
    "uniwersytet-im-adama-mickiewicza-w-poznaniu-wydzial-anglistyki": "Uniwersytet im. Adama Mickiewicza w Poznaniu - Wydział Anglistyki (English)",
    "uppsala-university-library-harvard": "Uppsala University Library (author-date/Harvard)",
    "uppsala-universitet-historia": "Uppsala universitet - Historia",
    "uppsala-universitet-institutionen-for-biologisk-grundutbildning": "Uppsala universitet, Institutionen för biologisk grundutbildning",
    "urad-rs-za-makroekonomske-analize-in-razvoj": "Urad RS za makroekonomske analize in razvoj (Slovenščina)",
    "urban-geography": "Urban Geography",
    "urban-habitats": "Urban Habitats",
    "urban-studies": "Urban Studies",
    "urbani-izziv-en": "Urbani izziv (Urban Challenge) (English)",
    "urbani-izziv": "Urbani izziv (Urban Challenge) (Slovenščina)",
    "urological-science": "Urological Science",
    "user-modeling-and-user-adapted-interaction": "User Modeling and User-Adapted Interaction",
    "utah-geological-survey": "Utah Geological Survey",
    "vitis-journal-of-grapevine-research": "VITIS - Journal of Grapevine Research",
    "van-yuzuncu-yil-universitesi-fen-bilimleri-enstitusu": "Van Yüzüncü Yıl Üniversitesi Fen Bilimleri Enstitüsü - Tez Yazım Stili (Türkçe)",
    "veterinaria-italiana": "Veterinaria Italiana",
    "veterinary-anaesthesia-analgesia": "Veterinary Anaesthesia Analgesia",
    "veterinary-clinical-pathology": "Veterinary Clinical Pathology",
    "veterinary-medicine-austria": "Veterinary Medicine Austria (Wiener Tierärztliche Monatsschrift)",
    "veterinary-microbiology": "Veterinary Microbiology",
    "veterinary-pathology": "Veterinary Pathology",
    "veterinary-radiology-and-ultrasound": "Veterinary Radiology & Ultrasound",
    "veterinary-record": "Veterinary Record",
    "veterinary-record-open": "Veterinary Record Open",
    "victoria-university-harvard": "Victoria University (author-date/Harvard)",
    "vienna-legal": "Vienna Legal",
    "vietnam-journal-of-science-and-technology": "Vietnam Journal of Science and Technology",
    "vietnam-ministry-of-education-and-training-en": "Vietnam Ministry of Education and Training (English)",
    "vietnam-ministry-of-education-and-training-vi": "Vietnam Ministry of Education and Training (Tiếng Việt)",
    "vigiliae-christianae": "Vigiliae Christianae",
    "vingtieme-siecle": "Vingtième Siècle. Revue d'histoire (Français)",
    "vita-latina": "Vita Latina (Français)",
    "vita-latina-auteurs-anciens": "Vita Latina (auteurs anciens, Français)",
    "vodohospodarske-technicko-ekonomicke-informace-en": "Vodohospodářské technicko-ekonomické informace (English)",
    "vodohospodarske-technicko-ekonomicke-informace": "Vodohospodářské technicko-ekonomické informace (Čeština)",
    "vox-sanguinis": "Vox Sanguinis",
    "who-europe-harvard": "WHO Regional Office for Europe (author-date/Harvard)",
    "who-europe-numeric": "WHO Regional Office for Europe (numeric)",
    "wader-study": "Wader Study",
    "water-alternatives": "Water Alternatives",
    "water-environment-research": "Water Environment Research",
    "water-sa": "Water SA",
    "water-science-and-technology": "Water Science & Technology",
    "waterbirds": "Waterbirds",
    "weed-research": "Weed Research",
    "weed-science-society-of-america": "Weed Science Society of America",
    "west-european-politics": "West European Politics",
    "western-journal-of-emergency-medicine": "Western Journal of Emergency Medicine",
    "westfalische-wilhelms-universitat-munster-medizinische-fakultat": "Westfälische Wilhelms-Universität Münster - Medizinische Fakultät (Deutsch)",
    "wetlands": "Wetlands",
    "wheaton-college-phd-in-biblical-and-theological-studies": "Wheaton College - Ph.D. in Biblical and Theological Studies",
    "wiener-digitale-revue": "Wiener digitale Revue (Deutsch)",
    "wiesbaden-business-school": "Wiesbaden Business School",
    "wikipedia-templates": "Wikipedia Templates",
    "wikipedia-fr-templates": "Wikipedia-fr templates (français)",
    "wiley-was": "Wiley Analytical Science",
    "wiley-vch-books": "Wiley-VCH books",
    "wireless-communications-and-mobile-computing": "Wireless Communications and Mobile Computing",
    "wirtschaftsuniversitat-wien-author-date": "Wirtschaftsuniversität Wien (author-date)",
    "wirtschaftsuniversitat-wien-abteilung-fur-bildungswissenschaft": "Wirtschaftsuniversität Wien - Abteilung für Bildungswissenschaft (Deutsch - Österreich)",
    "wirtschaftsuniversitat-wien-handel-und-marketing": "Wirtschaftsuniversität Wien - Handel und Marketing (Deutsch - Österreich)",
    "wirtschaftsuniversitat-wien-health-care-management": "Wirtschaftsuniversität Wien - Health Care Management",
    "wirtschaftsuniversitat-wien-institut-fur-bwl-des-aussenhandels": "Wirtschaftsuniversität Wien - Institut für BWL des Außenhandels (Deutsch - Österreich)",
    "wirtschaftsuniversitat-wien-institut-fur-transportwirtschaft-und-logistik": "Wirtschaftsuniversität Wien - Institut für Transportwirtschaft und Logistik (Deutsch - Österreich)",
    "wirtschaftsuniversitat-wien-unternehmensrechnung-und-controlling": "Wirtschaftsuniversität Wien - Unternehmensrechnung und Controlling",
    "wirtschaftsuniversitat-wien-wirtschaftspadagogik": "Wirtschaftsuniversität Wien - Wirtschaftspädagogik (Deutsch - Österreich)",
    "wissenschaftlicher-industrielogistik-dialog": "Wissenschaftlicher Industrielogistik-Dialog (Deutsch - Österreich)",
    "wolters-kluwerbrede-schrijfwijzer-author-date": "Wolters Kluwerbrede Schrijfwijzer (author-date, Nederlands)",
    "world-applied-sciences-journal": "World Applied Sciences Journal",
    "world-congress-on-engineering-asset-management": "World Congress on Engineering Asset Management 2010",
    "world-mycotoxin-journal": "World Mycotoxin Journal",
    "world-organisation-for-animal-health-scientific-and-technical-review": "World Organisation for Animal Health - Scientific and Technical Review",
    "world-politics": "World Politics",
    "worlds-poultry-science-journal": "World's Poultry Science Journal",
    "worlds-veterinary-journal": "World's Veterinary Journal",
    "xenotransplantation": "Xenotransplantation",
    "harvard-xi-an-jiaotong-liverpool-university": "Xi'an Jiaotong-Liverpool University (XJTLU) (author-date/Harvard)",
    "yeast": "Yeast",
    "harvard-york-st-john-university": "York St John University (author-date/Harvard, pre September 2019 entry)",
    "yozgat-bozok-universitesi-fen-bilimleri-enstitusu": "Yozgat Bozok Üniversitesi - Fen Bilimleri Enstitüsü (Türkçe)",
    "zdfm-zeitschrift-fur-diversitatsforschung-und-management": "ZDfm – Zeitschrift für Diversitätsforschung und -management (Deutsch - Österreich)",
    "zastosowania-komputerow-w-elektrotechnice": "Zastosowania Komputerów w Elektrotechnice",
    "zdravniski-vestnik": "Zdravniški Vestnik (Slovenian Medical Journal)",
    "zeitgeschichte": "Zeitgeschichte (Deutsch)",
    "zeithistorische-forschungen": "Zeithistorische Forschungen/Studies in Contemporary History",
    "zeitschrift-fur-allgemeinmedizin": "Zeitschrift für Allgemeinmedizin",
    "zeitschrift-fur-antikes-christentum": "Zeitschrift für Antikes Christentum (Journal of Ancient Christianity) (English)",
    "zeitschrift-fur-fantastikforschung": "Zeitschrift für Fantastikforschung (Deutsch)",
    "zeitschrift-fur-geschichtsdidaktik": "Zeitschrift für Geschichtsdidaktik (Deutsch)",
    "zeitschrift-fur-internationale-beziehungen": "Zeitschrift für Internationale Beziehungen (Deutsch)",
    "zeitschrift-fur-kunstgeschichte": "Zeitschrift für Kunstgeschichte",
    "zeitschrift-fur-medien-und-kulturforschung": "Zeitschrift für Medien- und Kulturforschung (Deutsch)",
    "zeitschrift-fur-medienwissenschaft": "Zeitschrift für Medienwissenschaft (Deutsch)",
    "zeitschrift-fur-ostmitteleuropa-forschung": "Zeitschrift für Ostmitteleuropa-Forschung (Deutsch)",
    "zeitschrift-fur-papyrologie-und-epigraphik": "Zeitschrift für Papyrologie und Epigraphik",
    "zeitschrift-fur-parlamentsfragen": "Zeitschrift für Parlamentsfragen (Deutsch)",
    "zeitschrift-fur-politik": "Zeitschrift für Politik (German)",
    "zeitschrift-fur-padagogik": "Zeitschrift für Pädagogik (Deutsch)",
    "zeitschrift-fur-qualitative-forschung": "Zeitschrift für Qualitative Forschung (Deutsch)",
    "zeitschrift-fur-religionswissenschaft-author-date": "Zeitschrift für Religionswissenschaft (author-date)",
    "zeitschrift-fur-religionswissenschaft-note": "Zeitschrift für Religionswissenschaft (note)",
    "zeitschrift-fur-soziologie": "Zeitschrift für Soziologie (Deutsch)",
    "zeitschrift-fur-theologie-und-kirche": "Zeitschrift für Theologie und Kirche (Deutsch)",
    "zeitschrift-fur-theologie-und-philosophie": "Zeitschrift für Theologie und Philosophie",
    "zeitschrift-fur-zahnarztliche-implantologie": "Zeitschrift für Zahnärztliche Implantologie (Deutsch)",
    "zeitschrift-fur-deutsche-philologie": "Zeitschrift für deutsche Philologie (Deutsch)",
    "zeitschrift-fur-die-geschichte-des-oberrheins": "Zeitschrift für die Geschichte des Oberrheins (Deutsch)",
    "zeitschrift-fur-digitale-geisteswissenschaften": "Zeitschrift für digitale Geisteswissenschaften (Deutsch)",
    "zeszyty-prawnicze-bas": "Zeszyty Prawnicze BAS (Polski)",
    "zilsel": "Zilsel (Français)",
    "zitierguide-leitfaden-zum-fachgerechten-zitieren-in-rechtswissenschaftlichen-arbeiten": "ZitierGuide: Leitfaden zum fachgerechten Zitieren in rechtswissenschaftlichen Arbeiten (Roger Müller) (Deutsch - Schweiz)",
    "zoological-journal-of-the-linnean-society": "Zoological Journal of the Linnean Society",
    "zoological-science": "Zoological Science",
    "zootaxa": "Zootaxa",
    "zwitscher-maschine": "Zwitscher-Maschine",
    "zurcher-hochschule-fur-angewandte-wissenschaften-soziale-arbeit": "Zürcher Hochschule für Angewandte Wissenschaften - Soziale Arbeit (Deutsch - Schweiz)",
    "animal": "animal",
    "bitonline": "b.i.t.online (note, Deutsch)",
    "carolinea": "carolinea",
    "cultural-geographies": "cultural geographies",
    "der-moderne-staat": "der moderne staat (Deutsch)",
    "elife": "eLife",
    "eneuro": "eNeuro",
    "express-polymer-letters": "eXPRESS Polymer Letters",
    "ergoscience": "ergoscience",
    "ethnographiques-org": "ethnographiques.org (Français)",
    "exercer": "exercer (Français)",
    "historia-scribere": "historia-scribere (Deutsch)",
    "historio-plus": "historioPLUS (Deutsch - Österreich)",
    "iforest": "iForest",
    "infoclio-de": "infoclio.ch (Deutsch - Schweiz)",
    "infoclio-de-kurzbelege": "infoclio.ch (Kurzbelege, Deutsch - Schweiz)",
    "infoclio-fr-smallcaps": "infoclio.ch (petites majuscules, Français)",
    "infoclio-fr-nocaps": "infoclio.ch (sans majuscules, Français)",
    "la-nouvelle-revue-du-travail": "la Nouvelle Revue du Travail (Français)",
    "medecine-sciences": "médecine/sciences",
    "natbib-plainnat-author-date": "natbib - plainnat (author-date)",
    "suburban-zeitschrift-fur-kritische-stadtforschung": "sub\\urban - Zeitschrift für kritische Stadtforschung (Deutsch)",
    "arbok-hins-islenzka-fornleifafelags": "Árbók Hins íslenzka fornleifafélags (Íslenska)",
    "ets-ecole-de-technologie-superieure": "ÉTS - École de technologie supérieure (Français - Canada)",
    "ecole-pratique-des-hautes-etudes-sciences-historiques-et-philologiques": "École Pratique des Hautes Études - Sciences historiques et philologiques (Français)",
    "ecole-de-technologie-superieure-apa": "École de technologie supérieure - APA (Français - Canada)",
    "economie-et-statistique": "Économie et Statistique (Français)",
    "ecoscience": "Écoscience",
    "epidemiologie-et-sante-animale": "Épidémiologie et Santé Animale",
    "etudes-chinoises": "Études chinoises",
    "etudes-francaises": "Études françaises (Français)",
    "osterreichische-zeitschrift-fur-politikwissenschaft": "Österreichische Zeitschrift für Politikwissenschaft (Deutsch - Österreich)",
    "casopis-pro-pravni-vedu-a-praxi": "Časopis pro právní vědu a praxi",
    "ceska-zemedelska-univerzita-v-praze-fakulta-agrobiologie-potravinovych-a-prirodnich-zdroju": "Česká zemědělská univerzita v Praze - Fakulta agrobiologie, potravinových a přírodních zdrojů",
    "isnad": "İSNAD Atıf Sistemi 1. Edisyon (dipnotlu)",
    "isnad-dipnotlu": "İSNAD Atıf Sistemi 2. Edisyon (dipnotlu)",
    "isnad-metinici": "İSNAD Atıf Sistemi 2. Edisyon (metiniçi)",
    "istanbul-bilgi-universitesi-lisansustu-programlar-enstitusu-hukuk": "İstanbul Bilgi Üniversitesi Lisansüstü Programlar Enstitüsü - Hukuk (Türkçe)",
    "istanbul-medical-journal": "İstanbul Medical Journal",
    "istanbul-universitesi-sosyal-bilimler-enstitusu": "İstanbul Üniversitesi Sosyal Bilimler Enstitüsü (Türkçe)",
    "izmir-katip-celebi-universitesi-sosyal-bilimler-enstitusu": "İzmir Katip Çelebi Üniversitesi - Sosyal Bilimler Enstitüsü (Türkçe)",
    "biologiceskie-membrany": "Биологические мембраны",
    "rossiiskii-fiziologicheskii-zhurnal-imeni-i-m-sechenova": "Российский физиологический журнал им. И.М. Сеченова (Ру́сский)",
    "uspekhi-gerontologii": "Успехи геронтологии (Ру́сский)",
    "the-university-of-tokyo-law-review": "東京大学法科大学院ローレビュー (The University of Tokyo Law Review) (日本語)"
}
